{
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2"
    ],
    "superclasses": [],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
    "scientificName": {
      "nolang": "Plantae"
    },
    "vulgarName": [
      {
        "en": "Plant"
      },
      {
        "es": "Planta"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q756",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Plant",
      "es": "https://es.wikipedia.org/wiki/Plantae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg/330px-Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Diversity_of_plants_%28Streptophyta%29_version_2.png/330px-Diversity_of_plants_%28Streptophyta%29_version_2.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Plantae",
    "gbif": "https://www.gbif.org/species/6",
    "extract": {
      "en": "Plants are the eukaryotic organisms that constitute the kingdom Plantae. They are predominantly photosynthetic, meaning that they obtain their energy from sunlight. They do that using the green pigment chlorophyll in their chloroplasts to produce sugars from carbon dioxide and water. Exceptions are parasitic plants that have lost the genes for chlorophyll and photosynthesis, and obtain their energy from other plants or fungi. Most plants are multicellular, except for some green algae.",
      "es": "En biología, se denomina plantas a los organismos con células vegetales que poseen paredes celulares y se componen principalmente de celulosa. En general, son fotosintéticos, sin capacidad locomotora o de desplazamiento, aunque sí presentan movimiento, causado por estímulos externos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 36946
      },
      "ifn3": {
        "count": 44950
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
    "isClass": 1,
    "scientificName": {
      "la": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Frondosas"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      },
      {
        "en": "Angiosperms"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25314",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Flowering_plant",
      "es": "https://es.wikipedia.org/wiki/Magnoliophyta"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Ranunculus_repens_1_%28cropped%29.JPG/330px-Ranunculus_repens_1_%28cropped%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flower_poster_2.jpg/330px-Flower_poster_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Magnoliopsida",
    "extract": {
      "en": "Flowering plants are plants that bear flowers and fruits, and form the clade Angiospermae. The term angiosperm is derived from the Greek words ἀγγεῖον and σπέρμα, meaning that the seeds are enclosed within a fruit. The group was formerly called Magnoliophyta.",
      "es": "Las angiospermas o división Magnoliophyta sensu Cronquist, también llamado taxón Angiospermae,, comúnmente llamadas plantas con flores o plantas florales, son las plantas con semilla cuyas flores tienen verticilos o espirales ordenados de sépalos, pétalos, estambres y carpelos; los carpelos encierran a los óvulos y reciben el polen en su superficie estigmática. Esto las diferencia de las gimnospermas, que reciben el polen directamente en el óvulo y que al madurar el fruto se encuentran sus \"semillas envasadas\", es decir la semilla madura se encuentra encerrada en el fruto, carácter distintivo que le da el nombre al grupo. En algunos textos se considera que únicamente las angiospermas son plantas con flores, ya que la floración de las otras espermatofitas es diferente. El nombre significa semilla vestida, en alusión a la presencia de frutos. En esto difieren de las gimnospermas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 348
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Otras frondosas"
      },
      {
        "es": "Otros árboles ripícolas"
      },
      {
        "es": "Frondosas de pequeño porte (H.t. < 10 m)"
      },
      {
        "es": "Árboles ripícolas"
      },
      {
        "es": "Frondosas de gran porte excepto quercus (H.t. > 10 m)"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      },
      {
        "fr": "Écologie des systèmes lotiques"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q11177275",
      "http://www.wikidata.org/entity/Q25314"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 5
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1321
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 6
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
    "isFamily": 1,
    "scientificName": {
      "la": "Arecaceae"
    },
    "vulgarName": [
      {
        "es": "Palmeras"
      },
      {
        "en": "Palm family"
      },
      {
        "de": "Palmengewächse"
      },
      {
        "fr": "Arecaceae"
      },
      {
        "pt": "Arecaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q14080",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Arecaceae",
      "es": "https://es.wikipedia.org/wiki/Arecaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/1859-Martinique.web.jpg/330px-1859-Martinique.web.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Manila_dwarf_coconut_palm.jpg/330px-Manila_dwarf_coconut_palm.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Arecaceae",
    "gbif": "https://www.gbif.org/species/7681",
    "extract": {
      "en": "The Arecaceae are a family of perennial, flowering plants in the monocot order Arecales. Their growth form can be climbers, shrubs, tree-like and stemless plants, all commonly known as palms. Those having a tree-like form are colloquially called palm trees. Currently, 181 genera with around 2,600 species are known, most of which are restricted to tropical and subtropical climates. Most palms are distinguished by their large, compound, evergreen leaves, known as fronds, arranged at the top of an unbranched stem, except for the Hyphaene genus, which has branched palms. However, palms exhibit an enormous diversity in physical characteristics and inhabit nearly every type of habitat within their range, from rainforests to deserts.",
      "es": "Las arecáceas son una familia de plantas monocotiledóneas del orden Arecales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 159
      },
      "ifn3": {
        "count": 225
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
    "isFamily": 1,
    "scientificName": {
      "la": "Lauraceae"
    },
    "vulgarName": [
      {
        "en": "Laurel family"
      },
      {
        "es": "Lauráceas"
      },
      {
        "de": "Lorbeergewächse"
      },
      {
        "fr": "Lauraceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26538",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Lauraceae",
      "es": "https://es.wikipedia.org/wiki/Lauraceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Lauraceae_sp_Blanco2.360.png/330px-Lauraceae_sp_Blanco2.360.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Illustration_Laurus_nobilis0.jpg/330px-Illustration_Laurus_nobilis0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Lauraceae",
    "gbif": "https://www.gbif.org/species/6688",
    "extract": {
      "en": "Lauraceae, or the laurels, is a plant family that includes the true laurel and its closest relatives. This family comprises about 2850 known species in about 45 genera worldwide. They are dicotyledons, and occur mainly in warm temperate and tropical regions, especially Southeast Asia and South America. Many are aromatic evergreen trees or shrubs, but some, such as Sassafras, are deciduous, or include both deciduous and evergreen trees and shrubs, especially in tropical and temperate climates. The genus Cassytha is unique in the Lauraceae in that its members are parasitic vines. Many species within the laurel family are highly toxic; however, some, such as the avocado, are edible and widely consumed. Members of the laurel family have played a significant role in the spice trade, particularly genera like Cinnamomum, which produce aromatic oils used extensively in cooking, perfumery, and traditional medicine.",
      "es": "Lauraceae, las lauráceas, es una familia de Angiospermas del orden Laurales. Consta de 55 géneros con unas 3500 especies, que se distribuyen por los trópicos del Viejo y Nuevo Mundo y algunas de sus zonas templadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1626
      },
      "ifn3": {
        "count": 5015
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Otras frondosas"
      },
      {
        "es": "Otros árboles ripícolas"
      },
      {
        "es": "Frondosas de pequeño porte (H.t. < 10 m)"
      },
      {
        "es": "Árboles ripícolas"
      },
      {
        "es": "Frondosas de gran porte excepto quercus (H.t. > 10 m)"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      },
      {
        "fr": "Écologie des systèmes lotiques"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q11177275",
      "http://www.wikidata.org/entity/Q25314"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1701
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species50",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Árboles ripícolas"
      },
      {
        "fr": "Écologie des systèmes lotiques"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q11177275",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Riparian_forest"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Prospectcreek.jpg/330px-Prospectcreek.jpg"
    ],
    "extract": {
      "en": "A riparian forest or riparian woodland is a forested or wooded area of land adjacent to a body of water such as a river, stream, pond, lake, marshland, estuary, canal, sink, or reservoir. Due to the broad nature of the definition, riparian woodlands have a huge diversity of characteristics including but not limited to soil composition, microclimates, and vegetative structures. However, among the varied range and landscapes, one factor stays constant: a high rate of primary productivity. This makes riparian forests hugely important centers of nutrient recycling."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species59",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Otros árboles ripícolas"
      },
      {
        "fr": "Écologie des systèmes lotiques"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q11177275",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Riparian_forest"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Prospectcreek.jpg/330px-Prospectcreek.jpg"
    ],
    "extract": {
      "en": "A riparian forest or riparian woodland is a forested or wooded area of land adjacent to a body of water such as a river, stream, pond, lake, marshland, estuary, canal, sink, or reservoir. Due to the broad nature of the definition, riparian woodlands have a huge diversity of characteristics including but not limited to soil composition, microclimates, and vegetative structures. However, among the varied range and landscapes, one factor stays constant: a high rate of primary productivity. This makes riparian forests hugely important centers of nutrient recycling."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 622
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species70",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Frondosas de gran porte excepto quercus (H.t. > 10 m)"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25314",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Flowering_plant",
      "es": "https://es.wikipedia.org/wiki/Magnoliophyta"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Ranunculus_repens_1_%28cropped%29.JPG/330px-Ranunculus_repens_1_%28cropped%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flower_poster_2.jpg/330px-Flower_poster_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Magnoliopsida",
    "extract": {
      "en": "Flowering plants are plants that bear flowers and fruits, and form the clade Angiospermae. The term angiosperm is derived from the Greek words ἀγγεῖον and σπέρμα, meaning that the seeds are enclosed within a fruit. The group was formerly called Magnoliophyta.",
      "es": "Las angiospermas o división Magnoliophyta sensu Cronquist, también llamado taxón Angiospermae,, comúnmente llamadas plantas con flores o plantas florales, son las plantas con semilla cuyas flores tienen verticilos o espirales ordenados de sépalos, pétalos, estambres y carpelos; los carpelos encierran a los óvulos y reciben el polen en su superficie estigmática. Esto las diferencia de las gimnospermas, que reciben el polen directamente en el óvulo y que al madurar el fruto se encuentran sus \"semillas envasadas\", es decir la semilla madura se encuentra encerrada en el fruto, carácter distintivo que le da el nombre al grupo. En algunos textos se considera que únicamente las angiospermas son plantas con flores, ya que la floración de las otras espermatofitas es diferente. El nombre significa semilla vestida, en alusión a la presencia de frutos. En esto difieren de las gimnospermas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 860
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species90",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Frondosas de pequeño porte (H.t. < 10 m)"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25314",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Flowering_plant",
      "es": "https://es.wikipedia.org/wiki/Magnoliophyta"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Ranunculus_repens_1_%28cropped%29.JPG/330px-Ranunculus_repens_1_%28cropped%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flower_poster_2.jpg/330px-Flower_poster_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Magnoliopsida",
    "extract": {
      "en": "Flowering plants are plants that bear flowers and fruits, and form the clade Angiospermae. The term angiosperm is derived from the Greek words ἀγγεῖον and σπέρμα, meaning that the seeds are enclosed within a fruit. The group was formerly called Magnoliophyta.",
      "es": "Las angiospermas o división Magnoliophyta sensu Cronquist, también llamado taxón Angiospermae,, comúnmente llamadas plantas con flores o plantas florales, son las plantas con semilla cuyas flores tienen verticilos o espirales ordenados de sépalos, pétalos, estambres y carpelos; los carpelos encierran a los óvulos y reciben el polen en su superficie estigmática. Esto las diferencia de las gimnospermas, que reciben el polen directamente en el óvulo y que al madurar el fruto se encuentran sus \"semillas envasadas\", es decir la semilla madura se encuentra encerrada en el fruto, carácter distintivo que le da el nombre al grupo. En algunos textos se considera que únicamente las angiospermas son plantas con flores, ya que la floración de las otras espermatofitas es diferente. El nombre significa semilla vestida, en alusión a la presencia de frutos. En esto difieren de las gimnospermas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Angiospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 2447
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species99",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Angiospermae"
    },
    "vulgarName": [
      {
        "es": "Otras frondosas"
      },
      {
        "de": "Bedecktsamer"
      },
      {
        "fr": "Angiosperme"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25314",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Flowering_plant",
      "es": "https://es.wikipedia.org/wiki/Magnoliophyta"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Ranunculus_repens_1_%28cropped%29.JPG/330px-Ranunculus_repens_1_%28cropped%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flower_poster_2.jpg/330px-Flower_poster_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Magnoliopsida",
    "extract": {
      "en": "Flowering plants are plants that bear flowers and fruits, and form the clade Angiospermae. The term angiosperm is derived from the Greek words ἀγγεῖον and σπέρμα, meaning that the seeds are enclosed within a fruit. The group was formerly called Magnoliophyta.",
      "es": "Las angiospermas o división Magnoliophyta sensu Cronquist, también llamado taxón Angiospermae,, comúnmente llamadas plantas con flores o plantas florales, son las plantas con semilla cuyas flores tienen verticilos o espirales ordenados de sépalos, pétalos, estambres y carpelos; los carpelos encierran a los óvulos y reciben el polen en su superficie estigmática. Esto las diferencia de las gimnospermas, que reciben el polen directamente en el óvulo y que al madurar el fruto se encuentran sus \"semillas envasadas\", es decir la semilla madura se encuentra encerrada en el fruto, carácter distintivo que le da el nombre al grupo. En algunos textos se considera que únicamente las angiospermas son plantas con flores, ya que la floración de las otras espermatofitas es diferente. El nombre significa semilla vestida, en alusión a la presencia de frutos. En esto difieren de las gimnospermas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 200
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
    "isFamily": 1,
    "scientificName": {
      "la": "Ulmaceae"
    },
    "vulgarName": [
      {
        "en": "Elm family"
      },
      {
        "es": "Ulmáceas"
      },
      {
        "de": "Ulmengewächse"
      },
      {
        "fr": "Ulmaceae"
      },
      {
        "pt": "Ulmaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156311",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmaceae",
      "es": "https://es.wikipedia.org/wiki/Ulmaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Ulmus_laciniata.jpg/330px-Ulmus_laciniata.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Illustration_Ulmus_carpinifolia0.jpg/330px-Illustration_Ulmus_carpinifolia0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmaceae",
    "gbif": "https://www.gbif.org/species/2382",
    "extract": {
      "en": "The Ulmaceae are a family of flowering plants that includes the elms, and the zelkovas. Members of the family are widely distributed throughout the north temperate zone, and have a scattered distribution elsewhere except for Australasia.",
      "es": "Ulmaceae, las ulmáceas, son una familia del Orden Rosales. Los miembros de la familia están ampliamente distribuidos por toda la Zona templada, y tienen una distribución dispersa en otros lugares excepto en Australasia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 31360
      },
      "ifn3": {
        "count": 37798
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
    "isFamily": 1,
    "scientificName": {
      "la": "Fagaceae"
    },
    "vulgarName": [
      {
        "en": "Beech family"
      },
      {
        "es": "Fagáceas"
      },
      {
        "de": "Buchengewächse"
      },
      {
        "fr": "Fagaceae"
      },
      {
        "pt": "Fagaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145977",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fagaceae",
      "es": "https://es.wikipedia.org/wiki/Fagaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Fagus_sylvatica_020-2.jpg/330px-Fagus_sylvatica_020-2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Quercus_rotundifolia.jpg/330px-Quercus_rotundifolia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fagaceae",
    "gbif": "https://www.gbif.org/species/4689",
    "extract": {
      "en": "The Fagaceae are a family of flowering plants that includes beeches, chestnuts and oaks, and comprises eight genera with around 1,000 or more species. Fagaceae in temperate regions are mostly deciduous, whereas in the tropics, many species occur as evergreen trees and shrubs. They are characterized by alternate simple leaves with pinnate venation, unisexual flowers in the form of catkins, and fruit in the form of cup-like (cupule) nuts. Their leaves are often lobed, and both petioles and stipules are generally present. Their fruits lack endosperm and lie in a scaly or spiny husk that may or may not enclose the entire nut, which may consist of one to seven seeds. In the oaks, genus Quercus, the fruit is a non-valved nut called an acorn. The husk of the acorn in most oaks only forms a cup in which the nut sits. Other members of the family have fully enclosed nuts. Fagaceae is one of the most ecologically important woody plant families in the Northern Hemisphere, as oaks form the backbone of temperate forest in North America, Europe, and Asia, and are one of the most significant sources of wildlife food. Introduced diseases have caused declines in Fagaceae populations.The wood, bark, nuts, and aesthetic value of Fagaceae are also economically valuable. They can contain chemicals such as tannins and antioxidants that have been traditionally used by humans for making medicine and clothing.",
      "es": "Fagaceae, las fagáceas, son una familia de plantas del orden Fagales que reúne unas 670 especies aceptadas de árboles o arbustos propios del hemisferio norte. Las fagáceas en las regiones templadas son en su mayoría caducifolios, mientras que en los trópicos, muchas especies ocurren como árboles y arbustos perennifolios. Se caracterizan por hojas simples alternas con nervadura pinnada, flores unisexuales en forma de amento y frutos de nueces en forma de copa (cúpula). Sus hojas son a menudo lobuladas y tanto pecíolos como estípulas están generalmente presentes. Sus frutos carecen de endospermo y se encuentran en una cáscara escamosa o espinosa que puede o no encerrar toda la nuez, que puede consistir en una a siete semillas. En los robles, género Quercus, el fruto es una nuez sin válvula llamada bellota. La cáscara de la bellota en la mayoría de los robles solo forma una copa en la que se asienta la nuez. Otros miembros de la familia tienen nueces completamente cerradas. Las fagaceae es una de las familias de plantas leñosas más importantes desde el punto de vista ecológico en el hemisferio norte, ya que los robles forman la columna vertebral del bosque templado en América del Norte, Europa y Asia, y son una de las fuentes más importantes de alimento para la vida silvestre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1278
      },
      "ifn3": {
        "count": 1097
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
    "isFamily": 1,
    "scientificName": {
      "la": "Salicaceae"
    },
    "vulgarName": [
      {
        "es": "Salicáceas"
      },
      {
        "en": "Willow family"
      },
      {
        "de": "Weidengewächse"
      },
      {
        "fr": "Salicaceae"
      },
      {
        "pt": "Salicaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158487",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salicaceae",
      "es": "https://es.wikipedia.org/wiki/Salicaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/20110716Salix_alba.jpg/330px-20110716Salix_alba.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Illustration_Populus_nigra0.jpg/330px-Illustration_Populus_nigra0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salicaceae",
    "gbif": "https://www.gbif.org/species/6664",
    "extract": {
      "en": "The Salicaceae are the willow family of flowering plants. The traditional family includes the willows and poplars. Genetic studies summarized by the Angiosperm Phylogeny Group (APG) have greatly expanded the circumscription of the family to contain 56 genera and about 1220 species, including the tropical Scyphostegiaceae and many of the former Flacourtiaceae.",
      "es": "Las salicáceas (Salicaceae), es una familia de plantas perteneciente al orden Malpighiales. La componen árboles o arbustos caducifolios y dioicos. Hojas alternas, simples, estipuladas. Flores inconspicuas, unisexuales, aclamídeas, acompañadas de brácteas y reunidas en amentos péndulos o erectos. Principalmente anemófilos y secundariamente entomófilos (Salix); periantio copiforme o nulo, androceo con 2-10 estambres; gineceo bicarpelar sincárpico de carpelos abiertos; numerosos óvulos; flores acompañadas de brácteas. Frutos en cápsula loculicida, que se abre mediante 2-4 valvas; con semillas numerosas, pequeñas, orladas de pelos, con corto poder germinativo. Reproducción vegetativa importante."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 294
      },
      "ifn3": {
        "count": 458
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
    "isFamily": 1,
    "scientificName": {
      "la": "Leguminosae"
    },
    "vulgarName": [
      {
        "es": "Leguminosas"
      },
      {
        "en": "Pea family"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q44448",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fabaceae",
      "es": "https://es.wikipedia.org/wiki/Fabaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Flowering_kudzu.jpg/330px-Flowering_kudzu.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Vicia_April_2008-1.jpg/330px-Vicia_April_2008-1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fabaceae",
    "gbif": "https://www.gbif.org/species/5386",
    "extract": {
      "en": "Fabaceae or Leguminosae, commonly known as the legume, pea, or bean family, is a large and agriculturally important family of flowering plants. It includes trees, shrubs, and perennial or annual herbaceous plants, which are easily recognized by their fruit (legume) and their compound, stipulate leaves. The family is widely distributed, and is the third-largest land plant family in number of species, behind only the Orchidaceae and Asteraceae, with about 765 genera and nearly 20,000 known species.",
      "es": "Las fabáceas (Fabaceae) o leguminosas (Leguminosae) son una familia del orden de las fabales. Reúne árboles, arbustos y hierbas perennes o anuales, fácilmente reconocibles por su fruto tipo legumbre y sus hojas compuestas y estipuladas. Es una familia de distribución cosmopolita con aproximadamente setecientos treinta géneros y unas diecinueve mil cuatrocientas especies, lo que la convierte en la tercera familia con mayor riqueza de especies después de las compuestas (Asteraceae) y las orquídeas (Orchidaceae). Esta riqueza de especies se halla particularmente concentrada en las ramas de las mimosóideas y las fabóideas, ya que contienen cerca del 9,4 % de la totalidad de las especies de las eudicotiledóneas. Se ha estimado que alrededor del 16 % de todas las especies arbóreas en los bosques lluviosos neotropicales son miembros de esta familia. Asimismo, las fabáceas son la familia más representada en los bosques tropicales lluviosos y en los bosques secos de América y África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 854
      },
      "ifn3": {
        "count": 1112
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
    "isFamily": 1,
    "scientificName": {
      "la": "Ericaceae"
    },
    "vulgarName": [
      {
        "es": "Ericáceas"
      },
      {
        "en": "Heath family"
      },
      {
        "de": "Heidekrautgewächse"
      },
      {
        "fr": "Ericaceae"
      },
      {
        "pt": "Ericaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q975872",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ericaceae",
      "es": "https://es.wikipedia.org/wiki/Ericaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Leptecophylla_juniperina.jpg/330px-Leptecophylla_juniperina.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ericaceae_spp_Sturm48.jpg/330px-Ericaceae_spp_Sturm48.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ericaceae",
    "gbif": "https://www.gbif.org/species/2505",
    "extract": {
      "en": "The Ericaceae are a family of flowering plants, commonly known as the heath or heather family, found most commonly in acidic and infertile growing conditions. The family is large, with about 4,250 known species spread across 124 genera, making it the 14th most speciose family of flowering plants. The many well known and economically important members of the Ericaceae include the cranberry, blueberry, huckleberry, rhododendron, and various common heaths and heathers.",
      "es": "Las ericáceas (Ericaceae) son una familia de plantas perteneciente al orden Ericales. Incluye árboles, arbustos o matas, leñosas y generalmente fruticosas. Es una familia cosmopolita, más abundante en las zonas templadas y frías. Comprende unas 3000 especies, adaptadas a terrenos pobres y ácidos por medio de simbiosis con micorrizas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3655
      },
      "ifn3": {
        "count": 3996
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
    "isFamily": 1,
    "scientificName": {
      "la": "Myrtaceae"
    },
    "vulgarName": [
      {
        "es": "Mirtáceas"
      },
      {
        "en": "Myrtle family"
      },
      {
        "de": "Myrtengewächse"
      },
      {
        "fr": "Myrtaceae"
      },
      {
        "pt": "Myrtaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156563",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrtaceae",
      "es": "https://es.wikipedia.org/wiki/Myrtaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Myrtus_communis.jpg/330px-Myrtus_communis.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Beaufortia_orbifolia1.jpg/330px-Beaufortia_orbifolia1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrtaceae",
    "gbif": "https://www.gbif.org/species/5014",
    "extract": {
      "en": "Myrtaceae, the myrtle family, is a family of dicotyledonous plants placed within the order Myrtales. Myrtle, pōhutukawa, bay rum tree, clove, guava, acca (feijoa), allspice, and eucalyptus are some notable members of this group. All species are woody, contain essential oils, and have flower parts in multiples of four or five. The leaves are evergreen, alternate to mostly opposite, simple, and usually entire. The flowers have a base number of five petals, though in several genera, the petals are minute or absent. The stamens are usually very conspicuous, brightly coloured, and numerous.",
      "es": "Las mirtáceas (Myrtaceae) son una familia de plantas arbóreas o arbustivas, generalmente perennifolias cítrico y aromáticas, perteneciente al orden Myrtales. Consta de unos 130 géneros aceptados —de los cuales 25 son monoespecíficos— y unas 5900 especies admitidas, de las casi 14 000 descritas. Prosperan principalmente en el Hemisferio Sur, con unos pocos representante en otras partes del mundo, incluida Europa. La familia integra plantas excepcionales, tales como las eudicotiledóneas más altas —110-140 m— del planeta (Eucalyptus) y el género específicamente más prolífico —1200‒1800 especies— que existe (Syzygium)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 811
      },
      "ifn3": {
        "count": 805
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
    "isFamily": 1,
    "scientificName": {
      "la": "Sapindaceae"
    },
    "vulgarName": [
      {
        "es": "Sapindáceas"
      },
      {
        "en": "Soapberry family"
      },
      {
        "de": "Seifenbaumgewächse"
      },
      {
        "fr": "Sapindaceae"
      },
      {
        "pt": "Sapindaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27147",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sapindaceae",
      "es": "https://es.wikipedia.org/wiki/Sapindaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Lychee.jpg/330px-Lychee.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Koelreuteria-paniculata-habit2.JPG/330px-Koelreuteria-paniculata-habit2.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sapindaceae",
    "gbif": "https://www.gbif.org/species/6657",
    "extract": {
      "en": "The Sapindaceae are a family of flowering plants in the order Sapindales known as the soapberry family. It contains 138 genera and 1,858 accepted species. Examples include horse chestnut, maples, ackee and lychee.",
      "es": "Las sapindáceas (Sapindaceae) son una familia de plantas perteneciente al orden Sapindales. Comparte con otras familias del orden Sapindales sus hojas creciendo en espiral, su forma pinaticompuesta, con un foliolo en el ápice y las flores tienen un disco nectarífero evidente rodeando al ovario. Hay alrededor de 140-150 géneros con 1400-2000 especies nativas de países cálidos. Entre otros géneros, pertenecen a ella los arces, los castaños de Indias, el litchi y el castañito chino florido."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
    "isFamily": 1,
    "scientificName": {
      "la": "Anacardiaceae"
    },
    "vulgarName": [
      {
        "es": "Anacardiáceas"
      },
      {
        "en": "Sumac family"
      },
      {
        "de": "Sumachgewächse"
      },
      {
        "fr": "Anacardiaceae"
      },
      {
        "pt": "Anacardiaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156589",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Anacardiaceae",
      "es": "https://es.wikipedia.org/wiki/Anacardiaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Cashewnuts_hanging_on_a_Cashew_Tree.jpg/330px-Cashewnuts_hanging_on_a_Cashew_Tree.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Gui1_cashewfruit2.jpg/330px-Gui1_cashewfruit2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Anacardiaceae",
    "gbif": "https://www.gbif.org/species/2398",
    "extract": {
      "en": "The Anacardiaceae, commonly known as the cashew family or sumac family, are a family of flowering plants, including about 83 genera with about 860 known species. Members of the Anacardiaceae bear fruits that are drupes and in some cases produce urushiol, an irritant. The Anacardiaceae include numerous genera, several of which are economically important, notably cashew, mango, Chinese lacquer tree, yellow mombin, Peruvian pepper, sumac, smoke tree, marula, and cuachalalate. The genus Pistacia is now included, but was previously placed in its own family, the Pistaciaceae.",
      "es": "Anacardiaceae es una familia de plantas esencialmente arbóreas y arbustivas perteneciente al orden Sapindales. La constituyen 77 géneros con unas 700 especies aceptadas, de las casi 3000 descritas, propias de países tropicales, cálidos y templados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2086
      },
      "ifn3": {
        "count": 1978
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
    "isFamily": 1,
    "scientificName": {
      "la": "Betulaceae"
    },
    "vulgarName": [
      {
        "es": "Betuláceas"
      },
      {
        "en": "Birch famly"
      },
      {
        "de": "Birkengewächse"
      },
      {
        "fr": "Betulaceae"
      },
      {
        "pt": "Betulaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156064",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Betulaceae",
      "es": "https://es.wikipedia.org/wiki/Betulaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Alnus_glutinosa.jpg/330px-Alnus_glutinosa.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Carpinus_betulus_Sturm33.jpg/330px-Carpinus_betulus_Sturm33.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betulaceae",
    "gbif": "https://www.gbif.org/species/4688",
    "extract": {
      "en": "Betulaceae, the birch family, includes six genera of deciduous nut-bearing trees and shrubs, including the birches, alders, hazels, hornbeams, hazel-hornbeam, and hop-hornbeams, numbering a total of 167 species. They are mostly natives of the temperate Northern Hemisphere, with a few species reaching the Southern Hemisphere in the Andes in South America. Their typical flowers are catkins and often appear before leaves.",
      "es": "Betulaceae, o betuláceas, es una familia del orden Fagales. Está compuesta por árboles o arbustos mesangiospermos caducifolios y monoicos que se encuentran en regiones templadas y zonas de montaña en los trópicos. A ella pertenecen los alisos y los abedules."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
    "isFamily": 1,
    "scientificName": {
      "la": "Adoxaceae"
    },
    "vulgarName": [
      {
        "es": "Adoxáceas"
      },
      {
        "en": "Moschatel family"
      },
      {
        "de": "Moschuskrautgewächse"
      },
      {
        "fr": "Adoxaceae"
      },
      {
        "pt": "Adoxaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156677",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Adoxaceae",
      "es": "https://es.wikipedia.org/wiki/Adoxaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Adoxa_moschatellina01.jpg/330px-Adoxa_moschatellina01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Adoxa_moschatellina_210406a.jpg/330px-Adoxa_moschatellina_210406a.jpg"
    ],
    "gbif": "https://www.gbif.org/species/2510",
    "extract": {
      "en": "Adoxaceae or Viburnaceae, commonly known as the moschatel family, is a small family of flowering plants in the order Dipsacales, which includes three genera – Adoxa, Sambucus, and Viburnum – and 150–200 species. They are characterised by opposite toothed leaves, small five- or, more rarely, four-petalled flowers in cymose inflorescences, and the fruit being a drupe. They are thus similar to many Cornaceae.",
      "es": "Las adoxáceas (Adoxaceae) son una familia de angiospermas perteneciente al orden de las dipsacales.\nComprende 5 géneros aceptados con unas 200 especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 470
      },
      "ifn3": {
        "count": 431
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
    "isFamily": 1,
    "scientificName": {
      "la": "Aquifoliaceae"
    },
    "vulgarName": [
      {
        "es": "Aquifoliáceas"
      },
      {
        "en": "Holly family"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q674593",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Aquifoliaceae",
      "es": "https://es.wikipedia.org/wiki/Aquifoliaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg/330px-Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Illustration_Ilex_aquifolium0.jpg/330px-Illustration_Ilex_aquifolium0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Aquifoliaceae",
    "gbif": "https://www.gbif.org/species/6716",
    "extract": {
      "en": "Ilex or holly is a genus of over 570 species of flowering plants in the family Aquifoliaceae, and the only living genus in that family. Ilex has the most species of any woody dioecious angiosperm genus. The species are evergreen or deciduous trees, shrubs, and climbers from tropics to temperate zones worldwide. The type species is Ilex aquifolium, the common European holly used in Christmas decorations and cards.",
      "es": "Aquifoliaceae, las aquifoliáceas, son una familia perteneciente al orden Aquifoliales. Contiene solo dos géneros de árboles y arbustos perennifolios o caducifolios, ordinariamente dioicos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
    "isFamily": 1,
    "scientificName": {
      "la": "Asparagaceae"
    },
    "vulgarName": [
      {
        "en": "Asparagus family"
      },
      {
        "es": "Asparagáceas"
      },
      {
        "de": "Spargelgewächse"
      },
      {
        "fr": "Asparagaceae"
      },
      {
        "pt": "Asparagaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157167",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Asparagaceae",
      "es": "https://es.wikipedia.org/wiki/Asparagaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Asperge_in_bloei_Asparagus_officinalis.jpg/330px-Asperge_in_bloei_Asparagus_officinalis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Asparagaceae",
    "gbif": "https://www.gbif.org/species/7683",
    "extract": {
      "en": "Asparagaceae, known as the asparagus family, is a family of flowering plants, placed in the order Asparagales of the monocots. The family name is based on the edible garden asparagus, Asparagus officinalis. This family includes both common garden plants as well as common houseplants. The garden plants include asparagus, yucca, bluebell, lily of the valley, and hosta, and the houseplants include snake plant, corn cane, spider plant, and plumosus fern.",
      "es": "Las asparagáceas son una familia de plantas monocotiledóneas perteneciente al orden Asparagales. La familia es reconocida por sistemas de clasificación modernos como el sistema de clasificación APG III."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 10
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
    "isFamily": 1,
    "scientificName": {
      "la": "Buxaceae"
    },
    "vulgarName": [
      {
        "en": "Boxwood family"
      },
      {
        "es": "Buxáceas"
      },
      {
        "de": "Buchsbaumgewächse"
      },
      {
        "fr": "Buxaceae"
      },
      {
        "pt": "Buxaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156680",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Buxaceae",
      "es": "https://es.wikipedia.org/wiki/Buxaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Buxus_sempervirens_IP1204022.JPG/330px-Buxus_sempervirens_IP1204022.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Illustration_Buxus_sempervirens0.jpg/330px-Illustration_Buxus_sempervirens0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Buxaceae",
    "gbif": "https://www.gbif.org/species/6703",
    "extract": {
      "en": "The Buxaceae are a small family of six genera and about 123 known species of flowering plants. They are shrubs and small trees, with a cosmopolitan distribution. A seventh genus, sometimes accepted in the past (Notobuxus), has been shown by genetic studies to be included within Buxus.",
      "es": "Las buxáceas (Buxaceae) son una familia de plantas angiospermas perteneciente al orden de las buxales. Consta de cinco géneros, con unas cien especies, distribuidas por el hemisferio norte, extendiéndose a los Andes sudamericanos, al Caribe, Sudáfrica, Madagascar y al sudeste de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
    "isFamily": 1,
    "scientificName": {
      "la": "Cannabaceae"
    },
    "vulgarName": [
      {
        "es": "Cannabáceas"
      },
      {
        "en": "Hemp family"
      },
      {
        "de": "Hanfgewächse"
      },
      {
        "fr": "Cannabaceae"
      },
      {
        "pt": "Cannabaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156338",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cannabaceae",
      "es": "https://es.wikipedia.org/wiki/Cannabaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Cannabis_01_bgiu.jpg/330px-Cannabis_01_bgiu.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Celtis-caucasica-fruit.JPG/330px-Celtis-caucasica-fruit.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cannabaceae",
    "gbif": "https://www.gbif.org/species/2384",
    "extract": {
      "en": "Cannabaceae is a small family of flowering plants, known as the hemp family. As now circumscribed, the family includes about 170 species grouped in about 11 genera, including Cannabis (hemp), Humulus (hops) and Celtis (hackberries). Celtis is by far the largest genus, containing about 100 species.",
      "es": "En sistemática de plantas, Cannabaceae o cannabáceas es una familia del orden Rosales, filogenéticamente emparentada con la familia Ulmaceae y taxonómicamente hermana del grupo Moraceae más Urticaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
    "isFamily": 1,
    "scientificName": {
      "la": "Celastraceae"
    },
    "vulgarName": [
      {
        "en": "Bittersweet family"
      },
      {
        "es": "Celastráceas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q135336",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Celastraceae",
      "es": "https://es.wikipedia.org/wiki/Celastraceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/b/b0/Celastrus_orbiculatus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Celastraceae",
    "gbif": "https://www.gbif.org/species/6715",
    "extract": {
      "en": "The Celastraceae, also known as the staff-vine or bittersweet family, are a family of 99 genera and 1,350 species of herbs, vines, shrubs and small trees, belonging to the order Celastrales. The great majority of the genera are tropical, with only Celastrus, Euonymus and Maytenus widespread in temperate climates, and Parnassia (bog-stars) found in alpine and arctic climates.",
      "es": "Celastraceae, las celastráceas, es una familia de plantas del orden Celastrales. Agrupa alrededor de 90 a 100 géneros y 1300 especies de trepadoras, arbustos y pequeños árboles. La gran mayoría de géneros son tropicales, excepto Celastrus y Euonymus, ampliamente extendidos por latitudes de clima templado."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
    "isFamily": 1,
    "scientificName": {
      "la": "Cornaceae"
    },
    "vulgarName": [
      {
        "es": "Cornáceas"
      },
      {
        "en": "Dogwood family"
      },
      {
        "de": "Hartriegelgewächse"
      },
      {
        "fr": "Cornaceae"
      },
      {
        "pt": "Cornaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161403",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cornaceae",
      "es": "https://es.wikipedia.org/wiki/Cornaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Cornus_suecica_Ume_River.jpg/330px-Cornus_suecica_Ume_River.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Cornus_suecica.jpg/330px-Cornus_suecica.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cornaceae",
    "gbif": "https://www.gbif.org/species/6713",
    "extract": {
      "en": "The Cornaceae, the dogwood family, are a cosmopolitan family of flowering plants in the order Cornales. The family contains approximately 85 species in two genera, Alangium and Cornus. They are mostly trees and shrubs, which may be deciduous or evergreen, although a few species are perennial herbs. Members of the family usually have opposite or alternate simple leaves, four- or five-parted flowers clustered in inflorescences or pseudanthia, and drupaceous fruits. The family is primarily distributed in northern temperate regions and tropical Asia. In northern temperate areas, Cornaceae are well known from the dogwoods Cornus.",
      "es": "Cornaceae, las cornáceas, son una familia de plantas dicotiledóneas perteneciente al orden Cornales. Se incluye en esta familia el género Nyssa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 36
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
    "isFamily": 1,
    "scientificName": {
      "la": "Juglandaceae"
    },
    "vulgarName": [
      {
        "es": "Juglandáceas"
      },
      {
        "en": "Walnut family"
      },
      {
        "de": "Walnussgewächse"
      },
      {
        "fr": "Juglandaceae"
      },
      {
        "pt": "Juglandaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q216944",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglandaceae",
      "es": "https://es.wikipedia.org/wiki/Juglandaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Juglans_regia_Broadview.jpg/330px-Juglans_regia_Broadview.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Illustration_Juglans_regia0.jpg/330px-Illustration_Juglans_regia0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglandaceae",
    "gbif": "https://www.gbif.org/species/2499",
    "extract": {
      "en": "The Juglandaceae are an angiosperm family known as the walnuts. They are trees, or sometimes shrubs, in the order Fagales. Members of this family are native to the Americas, Eurasia, and Southeast Asia.",
      "es": "Las juglandáceas (Juglandaceae) son una familia del orden Fagales. Agrupa unos 8 géneros de árboles caducifolios, en total, unas 50 especies, la mayoría originarios de regiones templadas del hemisferio norte."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 81
      },
      "ifn3": {
        "count": 33
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
    "isFamily": 1,
    "scientificName": {
      "la": "Malvaceae"
    },
    "vulgarName": [
      {
        "en": "Mallow family"
      },
      {
        "es": "Malváceas"
      },
      {
        "de": "Malvengewächse"
      },
      {
        "fr": "Malvaceae"
      },
      {
        "pt": "Malvaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156551",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Malvaceae",
      "es": "https://es.wikipedia.org/wiki/Malvaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Malva_parviflora_small.jpg/330px-Malva_parviflora_small.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Chinese_hibiscus.jpg/330px-Chinese_hibiscus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Malvaceae",
    "gbif": "https://www.gbif.org/species/6685",
    "extract": {
      "en": "Malvaceae, or the mallows, is a family of flowering plants estimated to contain 244 genera with 4225 known species. Well-known members of economic importance include cacao, cola, cotton, okra, roselle and durian. There are also some genera containing familiar ornamentals, such as Alcea (hollyhock), Malva (mallow), and Tilia. The genera with the largest numbers of species include Hibiscus, Pavonia, Sida, Ayenia, Dombeya, and Sterculia.",
      "es": "Las malváceas (Malvaceae) son una familia de plantas perteneciente al orden de las malvales. Reúne plantas herbáceas, leñosas o arbustos. Incluye, entre otros, los Hibiscus, las malvas y la planta del algodón (Gossypium)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
    "isFamily": 1,
    "scientificName": {
      "la": "Moraceae"
    },
    "vulgarName": [
      {
        "es": "Moráceas"
      },
      {
        "en": "Mulberry family"
      },
      {
        "de": "Maulbeergewächse"
      },
      {
        "fr": "Moraceae"
      },
      {
        "pt": "Moraceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156579",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Moraceae",
      "es": "https://es.wikipedia.org/wiki/Moraceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Castilla_elastica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-174.jpg/330px-Castilla_elastica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-174.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Illustration_Ficus_carica0.jpg/330px-Illustration_Ficus_carica0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Moraceae",
    "gbif": "https://www.gbif.org/species/6640",
    "extract": {
      "en": "Moraceae is a family of flowering plants comprising about 48 genera and over 1100 species, and is commonly known as the mulberry or fig family. Most are widespread in tropical and subtropical regions, less so in temperate climates; however, their distribution is cosmopolitan overall. The only common characteristics within the family are the presence of latex-producing glands in the leaves and stems, and milky sap in the soft tissues; but generally useful field characters include two carpels sometimes with one reduced, compound inconspicuous flowers, and compound fruits. The family includes well-known plants such as the common fig, breadfruit, jackfruit and mulberry. The 'flowers' of Moraceae are often pseudanthia.",
      "es": "Las moráceas (Moraceae) son una familia del orden Rosales. Pueden ser árboles o arbustos, tener la hoja caduca o perenne, y raramente son hierbas (Dorstenia, Humulus), monoicas o dioicas. Sus aproximadamente 1250 especies están distribuidos en unos 40 géneros aceptados divididos en 6 tribus, en su mayoría tropicales y muchas de ellas con gran importancia económica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 202
      },
      "ifn3": {
        "count": 308
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
    "isFamily": 1,
    "scientificName": {
      "la": "Myricaceae"
    },
    "vulgarName": [
      {
        "en": "Bayberry family"
      },
      {
        "es": "Miricáceas"
      },
      {
        "de": "Gagelstrauchgewächse"
      },
      {
        "fr": "Myricaceae"
      },
      {
        "pt": "Myricaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q843892",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myricaceae",
      "es": "https://es.wikipedia.org/wiki/Myricaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/d/d6/Myrica_faya.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Illustration_Myrica_gale0.jpg/330px-Illustration_Myrica_gale0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myricaceae",
    "gbif": "https://www.gbif.org/species/2432",
    "extract": {
      "en": "Myricaceae is a small family of dicotyledonous shrubs and small trees in the order Fagales. Its type genus is Myrica, the sweet gales. There are three genera in the family, although some botanists separate many species from Myrica into a fourth genus Morella. About 55 species are usually accepted in Myrica, one in Canacomyrica, and one in Comptonia.",
      "es": "Myricaceae, las miricáceas, son una pequeña familia del orden Fagales. Reúne arbustos y arbolillos divididos en tres géneros, aunque algunos botánicos separan muchas de las especies de Myrica en un tercer género denominado Morella. Contiene alrededor de 35 especies aceptadas en el género Myrica y 1 en Comptonia, nativas de regiones subtropicales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1290
      },
      "ifn3": {
        "count": 1542
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
    "isFamily": 1,
    "scientificName": {
      "la": "Oleaceae"
    },
    "vulgarName": [
      {
        "es": "Oleáceas"
      },
      {
        "en": "Olive famly"
      },
      {
        "de": "Ölbaumgewächse"
      },
      {
        "fr": "Oleaceae"
      },
      {
        "pt": "Oleaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q155966",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oleaceae",
      "es": "https://es.wikipedia.org/wiki/Oleaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Olive-tree-fruit-august-0.jpg/330px-Olive-tree-fruit-august-0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Olea_europaea1.jpg/330px-Olea_europaea1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Oleaceae",
    "gbif": "https://www.gbif.org/species/6652",
    "extract": {
      "en": "Oleaceae, also known as the olive family or sometimes the lilac family, is a taxonomic family of flowering shrubs, trees, and a few lianas in the order Lamiales. It presently comprises 28 genera, one of which is recently extinct. The extant genera include Cartrema, which was resurrected in 2012. The number of species in the Oleaceae is variously estimated in a wide range around 700. The flowers are often numerous and highly odoriferous. The family has a subcosmopolitan distribution, ranging from the subarctic to the southernmost parts of Africa, Australia, and South America. Notable members include olive, ash, jasmine, and several popular ornamental plants including privet, forsythia, fringetrees, and lilac.",
      "es": "Las oleáceas, son una familia de plantas perteneciente al orden Lamiales. Comprende 24 géneros de plantas leñosas, incluidos arbustos, árboles y vides. Se caracteriza por hojas opuestas que pueden ser simples o pinnadamente compuestas. Sus flores poseen cáliz y corola con cuatro lóbulos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
    "isFamily": 1,
    "scientificName": {
      "la": "Pentaphylacaceae"
    },
    "vulgarName": [
      {
        "es": "Pentafiláceas"
      },
      {
        "en": "Pentaphylaceae"
      },
      {
        "de": "Pentaphylacaceae"
      },
      {
        "fr": "Pentaphylacaceae"
      },
      {
        "pt": "Pentaphylacaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132719",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pentaphylacaceae",
      "es": "https://es.wikipedia.org/wiki/Pentaphylacaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Ternstroemia_gymnanthera1.jpg/330px-Ternstroemia_gymnanthera1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Nachi8448.JPG/330px-Nachi8448.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pentaphylacaceae",
    "gbif": "https://www.gbif.org/species/4259202",
    "extract": {
      "en": "The Pentaphylacaceae are a small family of plants within the order Ericales. In the APG III system of 2009, it includes the former family Ternstroemiaceae.",
      "es": "Pentaphylacaceae es una familia de plantas de flores con 14 géneros; son arbustos o pequeños árboles perennes con hojas alternas. Sus semillas se diseminan con el aire. Las flores tienen cinco pétalos y cinco sépalos, cada uno diferente de los otros con cinco estambres opuestos a los sépalos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 63
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
    "isFamily": 1,
    "scientificName": {
      "la": "Platanaceae"
    },
    "vulgarName": [
      {
        "en": "Plane-tree family"
      },
      {
        "es": "Platanáceas"
      },
      {
        "fr": "Platanaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q171425",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Platanaceae",
      "es": "https://es.wikipedia.org/wiki/Platanaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/London_plane_flower.jpg/330px-London_plane_flower.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanaceae",
    "gbif": "https://www.gbif.org/species/6693",
    "extract": {
      "en": "Platanaceae, the plane family, is a family of flowering plants in the order Proteales. The family consists of only a single extant genus Platanus, with twelve known species. The plants are tall trees, native to temperate and subtropical regions of the Northern Hemisphere. The hybrid London plane is widely planted in cities worldwide.",
      "es": "Las platanáceas (Platanaceae) son una familia de plantas angiospermas perteneciente al orden de las proteales. Consta de un único género viviente, Platanus y varios géneros fósiles. Tiene 7 especies aceptadas, de las más de 40 descritas, que se distribuyen desde Anatolia hasta Laos en Asia y desde Canadá a Guatemala en América."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
    "isFamily": 1,
    "scientificName": {
      "la": "Primulaceae"
    },
    "vulgarName": [
      {
        "en": "Primrose family"
      },
      {
        "es": "Primuláceas"
      },
      {
        "de": "Primelgewächse"
      },
      {
        "fr": "Primulaceae"
      },
      {
        "pt": "Primulaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157115",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Primulaceae",
      "es": "https://es.wikipedia.org/wiki/Primulaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Primula_vulgaris_%27rubra%27_%28Primev%C3%A8re_rouge%29_-_15.jpg/330px-Primula_vulgaris_%27rubra%27_%28Primev%C3%A8re_rouge%29_-_15.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Primula_spp_Sturm62.jpg/330px-Primula_spp_Sturm62.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Primulaceae",
    "gbif": "https://www.gbif.org/species/6674",
    "extract": {
      "en": "The Primulaceae, commonly known as the primrose family, are a family of herbaceous and woody flowering plants including some favourite garden plants and wildflowers. Most are perennial though some species, such as scarlet pimpernel, are annuals.",
      "es": "Primulaceae, las primuláceas, son una familia de plantas espermatófitas anuales o perennes, con 22 géneros que incluyen conocidas plantas de jardín, como las prímulas y flores silvestres. \nUnas 800 especies, cosmopolitas, la mayoría, de las regiones templadas y frías del hemisferio boreal, muchas de montaña otras acuáticas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
    "isFamily": 1,
    "scientificName": {
      "la": "Rhamnaceae"
    },
    "vulgarName": [
      {
        "en": "Buckthorn family"
      },
      {
        "es": "Ramnáceas"
      },
      {
        "de": "Kreuzdorngewächse"
      },
      {
        "fr": "Rhamnaceae"
      },
      {
        "pt": "Rhamnaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156083",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnaceae",
      "es": "https://es.wikipedia.org/wiki/Rhamnaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rhamnus_pumila_Atlas_Alpenflora.jpg/330px-Rhamnus_pumila_Atlas_Alpenflora.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Starr_030222-0098_Alphitonia_ponderosa.jpg/330px-Starr_030222-0098_Alphitonia_ponderosa.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhamnaceae",
    "gbif": "https://www.gbif.org/species/2407",
    "extract": {
      "en": "The Rhamnaceae are a large family of flowering plants, mostly trees, shrubs, and some vines, commonly called the buckthorn family. Rhamnaceae is included in the order Rosales.",
      "es": "Las ramnáceas (Rhamnaceae) son una familia de plantas dicotiledóneas perteneciente al orden de las rosales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 773
      },
      "ifn3": {
        "count": 766
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
    "isFamily": 1,
    "scientificName": {
      "la": "Rosaceae"
    },
    "vulgarName": [
      {
        "en": "Rose family"
      },
      {
        "es": "Rosáceas"
      },
      {
        "de": "Rosengewächse"
      },
      {
        "fr": "Rosaceae"
      },
      {
        "pt": "Rosaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q46299",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rosaceae",
      "es": "https://es.wikipedia.org/wiki/Rosaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Rosa_pouzinii_FlowerCloseup_SierraMadrona.jpg/330px-Rosa_pouzinii_FlowerCloseup_SierraMadrona.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Rose_%27Starion%27_hybride_de_th%C3%A9.jpg/330px-Rose_%27Starion%27_hybride_de_th%C3%A9.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rosaceae",
    "gbif": "https://www.gbif.org/species/5015",
    "extract": {
      "en": "Rosaceae, the rose family, is a family of flowering plants that includes 4,828 known species in 91 genera.",
      "es": "Las rosáceas (Rosaceae) son una familia de plantas dicotiledóneas pertenecientes al orden Rosales. Esta familia incluye la mayor parte de las especies de frutas de consumo masivo: manzana, pera, membrillo, melocotón, ciruela, cereza, fresa, almendra, albaricoque, níspero, zarzamora, frambuesa, etc. También incluye muchas especies ornamentales, principalmente, las rosas, flores por excelencia, con importancia para la jardinería y la industria de la perfumería."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
    "isFamily": 1,
    "scientificName": {
      "la": "Sapotaceae"
    },
    "vulgarName": [
      {
        "en": "Sapodilla family"
      },
      {
        "es": "Sapotáceas"
      },
      {
        "de": "Sapotengewächse"
      },
      {
        "fr": "Sapotaceae"
      },
      {
        "pt": "Sapotaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158981",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sapotaceae",
      "es": "https://es.wikipedia.org/wiki/Sapotaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/2/27/Pouteria_sapota_-_marmalade_tree_-_desc-leaf_cluster_-_from-DC1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sapotaceae",
    "gbif": "https://www.gbif.org/species/8802",
    "extract": {
      "en": "The Sapotaceae are a family of flowering plants belonging to the order Ericales. The family includes approximately 800 species of evergreen trees and shrubs in about 65 genera. Their distribution is pantropical.",
      "es": "Sapotaceae es una familia de fanerógamas, en el orden Ebenales. La familia tiene aproximadamente 800 especies de árboles perennes y arbustos en 65 géneros. La distribución es pantropical."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
    "isFamily": 1,
    "scientificName": {
      "la": "Simaroubaceae"
    },
    "vulgarName": [
      {
        "en": "Quassia family"
      },
      {
        "es": "Simarubáceas"
      },
      {
        "de": "Bittereschengewächse"
      },
      {
        "fr": "Simaroubaceae"
      },
      {
        "pt": "Simaroubaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156679",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Simaroubaceae",
      "es": "https://es.wikipedia.org/wiki/Simaroubaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Ailanthus_altissima2.jpg/330px-Ailanthus_altissima2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Simaroubaceae_distribution.svg/langes-330px-Simaroubaceae_distribution.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Simaroubaceae",
    "gbif": "https://www.gbif.org/species/2395",
    "extract": {
      "en": "The Simaroubaceae, also known as the quassia family, are a small, mostly tropical, family in the order Sapindales. In recent decades, it has been subject to much taxonomic debate, with several small families being split off. A molecular phylogeny of the family was published in 2007, greatly clarifying relationships within the family. Together with chemical characteristics such as the occurrence of petroselinic acid in Picrasma, in contrast to other members of the family such as Ailanthus, this indicates the existence of a subgroup in the family with Picrasma, Holacantha, and Castela.",
      "es": "Simaroubaceae, las simarubáceas, son una familia de árboles del orden Sapindales. Hojas pinanticompuestas, alternas o raramente opuestas. Flores unisexuales, actinomorfas, a menudo pentámeras; agrupadas en panículas o racimos. Frutos drupáceos, capsulares o en plurisámara. Está constituida por unas 200 especies en las regiones cálidas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 20
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
    "isFamily": 1,
    "scientificName": {
      "la": "Tamaricaceae"
    },
    "vulgarName": [
      {
        "es": "Tamaricáceas"
      },
      {
        "en": "Tamarix family"
      },
      {
        "de": "Tamariskengewächse"
      },
      {
        "fr": "Tamaricaceae"
      },
      {
        "pt": "Tamaricaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161244",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamaricaceae",
      "es": "https://es.wikipedia.org/wiki/Tamaricaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/5/50/Saltcedar.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Tamarix_chinensis_SZ71.png/330px-Tamarix_chinensis_SZ71.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tamaricaceae",
    "gbif": "https://www.gbif.org/species/6632",
    "extract": {
      "en": "The Tamaricaceae, the tamarisk family, are a family of plants native to drier areas of Europe, Asia, and Africa. It contains four genera: Tamarix, Reaumuria, Myricaria, and Myrtama.",
      "es": "Tamaricaceae es una pequeña familia de plantas leñosas, arbustos o pequeños árbolillos del orden Caryophyllales. Consta de cinco géneros con alrededor de 100-120 especies, la mayoría de las regiones templadas y cálidas del Viejo Mundo; en terrenos algo húmedos y salinos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 42744
      },
      "ifn3": {
        "count": 45288
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
    "isClass": 1,
    "scientificName": {
      "la": "Gymnospermae"
    },
    "vulgarName": [
      {
        "es": "Coníferas"
      },
      {
        "en": "Gymnosperms"
      },
      {
        "de": "Nacktsamige Pflanzen"
      },
      {
        "fr": "Gymnosperme"
      },
      {
        "pt": "Gimnospérmica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q133712",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Gymnosperm",
      "es": "https://es.wikipedia.org/wiki/Gymnospermae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Gymnospermae.jpg/330px-Gymnospermae.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Araucaria_araucana_ArboretumMT_2.jpg/330px-Araucaria_araucana_ArboretumMT_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Gymnospermae",
    "extract": {
      "en": "The gymnosperms are a group of woody, perennial seed-producing plants, typically lacking the protective outer covering which surrounds the seeds in flowering plants, that include conifers, cycads, gingkos, and gnetophytes, forming the clade Gymnospermae. The name is based on the unenclosed condition of their seeds. The non-encased condition of their seeds contrasts with the seeds and ovules of flowering plants (angiosperms), which are enclosed within an ovary. Gymnosperm seeds develop either on the surface of scales or leaves, which are often modified to form cones, or on their own as in yew, Torreya, and Gingko.",
      "es": "Las gimnospermas (Gymnospermae) son un grupo de plantas vasculares, productoras de semillas (Spermatophyta)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 18
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gymnospermae"
    },
    "vulgarName": [
      {
        "es": "Otras coníferas"
      },
      {
        "es": "Coníferas (excluidos los pinos)"
      },
      {
        "fr": "Pinophyta"
      },
      {
        "pt": "Conífera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132825",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Conifer",
      "es": "https://es.wikipedia.org/wiki/Pinopsida"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Sapins_pectin%C3%A9s.jpg/330px-Sapins_pectin%C3%A9s.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Forests_in_Alberschwende_3.JPG/330px-Forests_in_Alberschwende_3.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinophyta",
    "gbif": "https://www.gbif.org/species/101",
    "extract": {
      "en": "Conifers are a group of vascular plants and a subset of gymnosperms. They are primarily perennial, woody trees and shrubs, mostly evergreen with a regular branching pattern, reproducing with male and female cones, usually on the same tree. They are wind-pollinated and the seeds are usually dispersed by the wind. Taxonomically, they make up the division Pinophyta, also known as Coniferae. All extant conifers, except for the gnetophytes, are perennial woody plants with secondary growth. There are over 600 living species.",
      "es": "Las coníferas son el grupo más importante de gimnospermas desde un punto de vista ecológico y económico. En un momento las coníferas fueron dominantes en las comunidades de plantas en todo el mundo. En la actualidad se encuentran desplazadas en muchos lugares por las angiospermas, pero, todavía son dominantes en muchos bosques."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 67
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gymnospermae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 85
      },
      "ifn3": {
        "count": 283
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gymnospermae"
    },
    "vulgarName": [
      {
        "es": "Otras coníferas"
      },
      {
        "es": "Coníferas (excluidos los pinos)"
      },
      {
        "fr": "Pinophyta"
      },
      {
        "pt": "Conífera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132825",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Conifer",
      "es": "https://es.wikipedia.org/wiki/Pinopsida"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Sapins_pectin%C3%A9s.jpg/330px-Sapins_pectin%C3%A9s.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Forests_in_Alberschwende_3.JPG/330px-Forests_in_Alberschwende_3.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinophyta",
    "gbif": "https://www.gbif.org/species/101",
    "extract": {
      "en": "Conifers are a group of vascular plants and a subset of gymnosperms. They are primarily perennial, woody trees and shrubs, mostly evergreen with a regular branching pattern, reproducing with male and female cones, usually on the same tree. They are wind-pollinated and the seeds are usually dispersed by the wind. Taxonomically, they make up the division Pinophyta, also known as Coniferae. All extant conifers, except for the gnetophytes, are perennial woody plants with secondary growth. There are over 600 living species.",
      "es": "Las coníferas son el grupo más importante de gimnospermas desde un punto de vista ecológico y económico. En un momento las coníferas fueron dominantes en las comunidades de plantas en todo el mundo. En la actualidad se encuentran desplazadas en muchos lugares por las angiospermas, pero, todavía son dominantes en muchos bosques."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 283
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species19",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gymnospermae"
    },
    "vulgarName": [
      {
        "es": "Otras coníferas"
      },
      {
        "fr": "Pinophyta"
      },
      {
        "pt": "Conífera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132825",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Conifer",
      "es": "https://es.wikipedia.org/wiki/Pinopsida"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Sapins_pectin%C3%A9s.jpg/330px-Sapins_pectin%C3%A9s.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Forests_in_Alberschwende_3.JPG/330px-Forests_in_Alberschwende_3.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinophyta",
    "gbif": "https://www.gbif.org/species/101",
    "extract": {
      "en": "Conifers are a group of vascular plants and a subset of gymnosperms. They are primarily perennial, woody trees and shrubs, mostly evergreen with a regular branching pattern, reproducing with male and female cones, usually on the same tree. They are wind-pollinated and the seeds are usually dispersed by the wind. Taxonomically, they make up the division Pinophyta, also known as Coniferae. All extant conifers, except for the gnetophytes, are perennial woody plants with secondary growth. There are over 600 living species.",
      "es": "Las coníferas son el grupo más importante de gimnospermas desde un punto de vista ecológico y económico. En un momento las coníferas fueron dominantes en las comunidades de plantas en todo el mundo. En la actualidad se encuentran desplazadas en muchos lugares por las angiospermas, pero, todavía son dominantes en muchos bosques."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Gymnospermae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species30",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gymnospermae"
    },
    "vulgarName": [
      {
        "es": "Coníferas (excluidos los pinos)"
      },
      {
        "fr": "Pinophyta"
      },
      {
        "pt": "Conífera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132825",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Conifer",
      "es": "https://es.wikipedia.org/wiki/Pinopsida"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Sapins_pectin%C3%A9s.jpg/330px-Sapins_pectin%C3%A9s.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Forests_in_Alberschwende_3.JPG/330px-Forests_in_Alberschwende_3.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinophyta",
    "gbif": "https://www.gbif.org/species/101",
    "extract": {
      "en": "Conifers are a group of vascular plants and a subset of gymnosperms. They are primarily perennial, woody trees and shrubs, mostly evergreen with a regular branching pattern, reproducing with male and female cones, usually on the same tree. They are wind-pollinated and the seeds are usually dispersed by the wind. Taxonomically, they make up the division Pinophyta, also known as Coniferae. All extant conifers, except for the gnetophytes, are perennial woody plants with secondary growth. There are over 600 living species.",
      "es": "Las coníferas son el grupo más importante de gimnospermas desde un punto de vista ecológico y económico. En un momento las coníferas fueron dominantes en las comunidades de plantas en todo el mundo. En la actualidad se encuentran desplazadas en muchos lugares por las angiospermas, pero, todavía son dominantes en muchos bosques."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 41150
      },
      "ifn3": {
        "count": 43525
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
    "isFamily": 1,
    "scientificName": {
      "la": "Pinaceae"
    },
    "vulgarName": [
      {
        "en": "Pine family"
      },
      {
        "es": "Pináceas"
      },
      {
        "de": "Kieferngewächse"
      },
      {
        "fr": "Pinaceae"
      },
      {
        "pt": "Pinaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q101680",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinaceae",
      "es": "https://es.wikipedia.org/wiki/Pinaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Glacier-Lyman-Tamarack.jpg/330px-Glacier-Lyman-Tamarack.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Pinus_sylvestris1.jpg/330px-Pinus_sylvestris1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinaceae",
    "gbif": "https://www.gbif.org/species/3925",
    "extract": {
      "en": "The Pinaceae, or pine family, are conifer trees or shrubs, including many of the well-known conifers of commercial importance such as cedars, firs, hemlocks, larches, pines, and spruces. The family is included in the order Pinales, formerly known as Coniferales. Pinaceae have distinctive cones with woody scales bearing typically two ovules, and are supported as monophyletic by both morphological trait and genetic analysis. They are the largest extant conifer family in species diversity, with between 220 and 250 species in 11 genera, and the second-largest in geographical range, found in most of the Northern Hemisphere, with the majority of the species in temperate climates, but ranging from subarctic to tropical. The family often forms the dominant component of boreal, coastal, and montane forests. One species, Pinus merkusii, grows just south of the equator in Southeast Asia. Major centres of diversity are found in the mountains of southwest China, Mexico, central Japan, and California.",
      "es": "Las pináceas son coníferas que poseen canales de resina en la madera y las hojas. Sus hojas son lineales o en forma de acículas. Son especies monoicas. Los conos con complejos, dispuestos en espiral y aplanados. Las brácteas están libres de la escama, y tienen dos óvulos invertidos, y semillas con un ala larga terminal."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2502
      },
      "ifn3": {
        "count": 2854
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
    "isFamily": 1,
    "scientificName": {
      "la": "Cupressaceae"
    },
    "vulgarName": [
      {
        "es": "Cupresáceas"
      },
      {
        "en": "Cypress family"
      },
      {
        "de": "Zypressengewächse"
      },
      {
        "fr": "Cupressaceae"
      },
      {
        "pt": "Cupressaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146037",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressaceae",
      "es": "https://es.wikipedia.org/wiki/Cupressaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Med_Cypress.jpg/330px-Med_Cypress.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressaceae",
    "gbif": "https://www.gbif.org/species/8144",
    "extract": {
      "en": "Cupressaceae or the cypress family is a family of conifers. The family includes 27–30 genera, which include the junipers and redwoods, with about 130–140 species in total. They are monoecious, subdioecious or (rarely) dioecious trees and shrubs up to 116 m (381 ft) tall. The bark of mature trees is commonly orange- to red-brown and of stringy texture, often flaking or peeling in vertical strips, but smooth, scaly or hard and square-cracked in some species. The family reached its peak of diversity during the Mesozoic era.",
      "es": "Las cupresáceas son una familia de coníferas del orden Cupressales. Son árboles o arbustos con madera y follaje muchas veces aromáticos, con hojas como escamas fuertemente apretadas desde 1 mm a 3 cm de largo. Es una familia cosmopolita de climas cálidos a templado-frescos. Son muy utilizadas por su madera, su fragancia, y como ornamentales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
    "isFamily": 1,
    "scientificName": {
      "la": "Taxaceae"
    },
    "vulgarName": [
      {
        "es": "Taxáceas"
      },
      {
        "en": "Yew family"
      },
      {
        "de": "Eibengewächse"
      },
      {
        "fr": "Taxaceae"
      },
      {
        "pt": "Taxaceae"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q223751",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Taxaceae",
      "es": "https://es.wikipedia.org/wiki/Taxaceae"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Yew_1r.jpg/330px-Yew_1r.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Cleaned-Illustration_Taxus_baccata.jpg/330px-Cleaned-Illustration_Taxus_baccata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Taxaceae",
    "gbif": "https://www.gbif.org/species/4863",
    "extract": {
      "en": "Taxaceae, commonly called the yew family, is a coniferous family which includes six extant and two extinct genera, and about 30 species of plants, or in older interpretations three genera and 7 to 12 species.",
      "es": "Las taxáceas están mayormente compuestas por una capa sólida en la parte exterior de la hoja, son diminutas ya que por su tamaño pueden hacer mayores funciones. Hojas lineales, largas, aplanadas, enteras, agudas en el ápice, son de óvulos solitarios sin conos, y semillas con una sólida y pequeñas cubierta externa dura asociada a un arilo carnoso usualmente brillantemente colorido. Son mayormente del Hemisferio Norte y Sur, ya que por la evolución de estas se han ido dispersando."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 28255
      },
      "ifn3": {
        "count": 34178
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
    "isGenus": 1,
    "scientificName": {
      "la": "Quercus"
    },
    "vulgarName": [
      {
        "en": "Oaks"
      },
      {
        "es": "Robles"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12004",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oak",
      "es": "https://es.wikipedia.org/wiki/Roble"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Illustration_Quercus_robur0.jpg/330px-Illustration_Quercus_robur0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus",
    "gbif": "https://www.gbif.org/species/2877951",
    "extract": {
      "en": "An oak is a hardwood tree or shrub in the genus Quercus of the beech family. They have spirally arranged leaves, often with lobed edges, and a nut called an acorn, borne within a cup. The genus is widely distributed in the Northern Hemisphere, with some 500 species, both deciduous and evergreen. Fossil oaks date back to the Middle Eocene. Molecular phylogeny shows that the genus is divided into Old World and New World clades, but many oak species hybridise freely, making the genus's history difficult to resolve.",
      "es": "El término roble se utiliza para referirse a muchas especies de árboles del género Quercus, nativo del hemisferio norte, y ocasionalmente también a especies de otros géneros de la misma familia (Fagaceae) o incluso de otras familias, como en el caso de algunas especies de Nothofagus. En sentido estricto del término, los robles comprenden las siguientes especies: Quercus faginea Lam., Quercus humilis Miller, Quercus petraea (Mattuschka) Liebl., Quercus pyrenaica Willd., Quercus robur L. y Quercus rubra L."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 18782
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus ilex"
    },
    "vulgarName": [
      {
        "pt": "Azinheira"
      },
      {
        "en": "Holmoak"
      },
      {
        "es": "Encina"
      },
      {
        "de": "Steineiche"
      },
      {
        "fr": "Quercus ilex"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q218155",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_ilex",
      "es": "https://es.wikipedia.org/wiki/Quercus_ilex"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Quercus_ilex_JPG1.jpg/330px-Quercus_ilex_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Carrasca_de_la_Raboseras.JPG/330px-Carrasca_de_la_Raboseras.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_ilex",
    "gbif": "https://www.gbif.org/species/2879098",
    "extract": {
      "en": "The holm oak, also called the holly oak, is a large evergreen oak native to the Mediterranean region. It is a member of the section Ilex of the genus, with acorns that mature in a single summer.",
      "es": "La encina es un árbol de la familia de las fagáceas. Otros nombres comunes con los que se conoce a la encina son encino, carrasca, chaparra, chaparro o bellotero alto. Es un árbol perennifolio nativo de la región mediterránea de talla mediana, aunque puede aparecer en forma arbustiva, condicionado por las características pluviométricas o por el terreno en el que se encuentre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 3697
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus suber"
    },
    "vulgarName": [
      {
        "pt": "Sobreiro"
      },
      {
        "en": "Cork-oak"
      },
      {
        "es": "Alcornoque"
      },
      {
        "de": "Korkeiche"
      },
      {
        "fr": "Chêne-liège"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156137",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_suber",
      "es": "https://es.wikipedia.org/wiki/Quercus_suber"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Cork_oak_%2828864190188%29.jpg/330px-Cork_oak_%2828864190188%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Quercus_suber_JPG1.jpg/330px-Quercus_suber_JPG1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_suber",
    "gbif": "https://www.gbif.org/species/2879411",
    "extract": {
      "en": "Quercus suber, commonly called the cork oak, is a medium-sized, evergreen oak tree in the section Quercus sect. Cerris. It is the primary source of cork for wine bottle stoppers and other uses, such as cork flooring and as the cores of cricket balls. It is native to southwest Europe and northwest Africa. In the Mediterranean basin the tree is an ancient species with fossil remnants dating back to the Tertiary period. It can survive for as long as two centuries. Typically, once it reaches 25 years old, its thick bark can be harvested for cork every 9 to 12 years without causing harm to the tree.",
      "es": "El alcornoque es un árbol de porte medio, de hoja perenne, originario de Europa y del norte de África. Muy extendido antrópicamente por la explotación de su corteza de la que se obtiene el corcho. El Quercus suber se conoce también en algunas comarcas, especialmente los ejemplares jóvenes, como chaparro o roble sobrero."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus"
    },
    "vulgarName": [
      {
        "es": "Otros quercus"
      },
      {
        "en": "Other oaks"
      },
      {
        "es": "Quercus"
      },
      {
        "de": "Eichen"
      },
      {
        "fr": "Chêne"
      },
      {
        "pt": "Carvalho"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12004",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oak",
      "es": "https://es.wikipedia.org/wiki/Roble"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Illustration_Quercus_robur0.jpg/330px-Illustration_Quercus_robur0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus",
    "gbif": "https://www.gbif.org/species/2877951",
    "extract": {
      "en": "An oak is a hardwood tree or shrub in the genus Quercus of the beech family. They have spirally arranged leaves, often with lobed edges, and a nut called an acorn, borne within a cup. The genus is widely distributed in the Northern Hemisphere, with some 500 species, both deciduous and evergreen. Fossil oaks date back to the Middle Eocene. Molecular phylogeny shows that the genus is divided into Old World and New World clades, but many oak species hybridise freely, making the genus's history difficult to resolve.",
      "es": "El término roble se utiliza para referirse a muchas especies de árboles del género Quercus, nativo del hemisferio norte, y ocasionalmente también a especies de otros géneros de la misma familia (Fagaceae) o incluso de otras familias, como en el caso de algunas especies de Nothofagus. En sentido estricto del término, los robles comprenden las siguientes especies: Quercus faginea Lam., Quercus humilis Miller, Quercus petraea (Mattuschka) Liebl., Quercus pyrenaica Willd., Quercus robur L. y Quercus rubra L."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur"
    ],
    "nplots": {
      "ifn2": {
        "count": 3765
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus robur"
    },
    "vulgarName": [
      {
        "en": "Common oak"
      },
      {
        "en": "English oak"
      },
      {
        "en": "European oak"
      },
      {
        "en": "Pedunculate oak"
      },
      {
        "es": "Roble pedunculado"
      },
      {
        "de": "Stieleiche"
      },
      {
        "fr": "Chêne pédonculé"
      },
      {
        "pt": "Carvalho-roble"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165145",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_robur",
      "es": "https://es.wikipedia.org/wiki/Quercus_robur"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Crooked_branches_of_Quercus_robur.jpg/330px-Crooked_branches_of_Quercus_robur.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_robur",
    "gbif": "https://www.gbif.org/species/2878688",
    "extract": {
      "en": "Quercus robur, pedunculate oak, or English oak, is a species of flowering plant in the beech and oak family, Fagaceae. It is a large tree, native to Europe and western Asia, and is widely cultivated in other temperate regions. It grows on soils of near neutral acidity in the lowlands and is notable for its value to natural ecosystems, supporting a diversity of herbivorous insects, acorn eating mammals and birds, and fungi.",
      "es": "El roble común, roble albar, roble carballo, carballo, roble carvallo, carvallo, cajiga o roble fresnal es un árbol robusto, de porte majestuoso, que puede superar los 40 m de altura. Está clasificado en la Sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en seis meses y tienen un sabor dulce y ligeramente amargo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea"
    ],
    "nplots": {
      "ifn2": {
        "count": 1666
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus petraea"
    },
    "vulgarName": [
      {
        "en": "Cornish oak"
      },
      {
        "en": "Durmast oak"
      },
      {
        "en": "Sessile oak"
      },
      {
        "es": "Roble"
      },
      {
        "de": "Traubeneiche"
      },
      {
        "fr": "Quercus petraea"
      },
      {
        "pt": "Quercus petraea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158608",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_petraea",
      "es": "https://es.wikipedia.org/wiki/Quercus_petraea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Quercus_petraea_06.jpg/330px-Quercus_petraea_06.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Sivry-Rance_AR1aJPG.jpg/330px-Sivry-Rance_AR1aJPG.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_petraea",
    "gbif": "https://www.gbif.org/species/2880130",
    "extract": {
      "en": "Quercus petraea, commonly known as the sessile oak, Welsh oak, Cornish oak, Irish oak or durmast oak, is a species of deciduous oak tree native to most of Europe and into Anatolia and Iran. The sessile oak is the national tree of Ireland, and an unofficial emblem in Wales and Cornwall.",
      "es": "Quercus petraea, el roble albar es un árbol de fronda perteneciente a la familia de las fagáceas. Es muy parecido a Quercus robur, que recibe muchas veces el mismo nombre, aunque suele ser menos robusto que este, alcanza más altura en bosque denso creciendo más recto. Está clasificada en la sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en 6 meses y tienen un sabor dulce y ligeramente amargo, el interior de la bellota tiene pelo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "nplots": {
      "ifn2": {
        "count": 4458
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus pyrenaica / Quercus pubescens Willd."
    },
    "vulgarName": [
      {
        "en": "Downy oak"
      },
      {
        "en": "Pubescent oak"
      },
      {
        "en": "Pyrenean oak"
      },
      {
        "es": "Rebollo"
      },
      {
        "es": "Roble pubescente"
      },
      {
        "de": "Flaumeiche"
      },
      {
        "de": "Pyrenäen-Eiche"
      },
      {
        "fr": "Chêne pubescent"
      },
      {
        "fr": "Chêne tauzin"
      },
      {
        "pt": "Quercus pyrenaica"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q161415",
      "http://www.wikidata.org/entity/Q899686"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea"
    ],
    "nplots": {
      "ifn2": {
        "count": 4238
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus faginea"
    },
    "vulgarName": [
      {
        "en": "Portuguese oak"
      },
      {
        "en": "Valencian oak"
      },
      {
        "es": "Quejigo fagínea"
      },
      {
        "de": "Portugiesische Eiche"
      },
      {
        "fr": "Quercus faginea"
      },
      {
        "pt": "Carvalho-português"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2432250",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_faginea",
      "es": "https://es.wikipedia.org/wiki/Quercus_faginea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Quejigo_de_la_Molinera.JPG/330px-Quejigo_de_la_Molinera.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Quercus_faginea_centenario.jpg/330px-Quercus_faginea_centenario.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_faginea",
    "gbif": "https://www.gbif.org/species/2881480",
    "extract": {
      "en": "Quercus faginea, the Portuguese oak, is a species of oak native to the western Mediterranean region in the Iberian Peninsula. Similar trees in the Atlas Mountains of northwest Africa are usually included in this species, or sometimes treated as a distinct species, Quercus tlemcenensis. It occurs in mountains from sea level to 1,900 metres above sea level, and flourishes in a variety of soils and climates. Out of all the oak forests in the Iberian Peninsula, the southern populations of Portuguese oak were found to have the highest diversity and endemism of spider species.",
      "es": "El quejigo, roble carrasqueño o roble valenciano es una especie de árbol marcescente de tamaño medio de hasta 20 m de altura, típico de las zonas de clima mediterráneo del norte de África y la península ibérica. Especie autóctona del bosque mediterráneo. Florece entre abril y mayo, casi siempre antes que la encina; las bellotas maduran y se diseminan hacia septiembre u octubre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex"
    ],
    "nplots": {
      "ifn2": {
        "count": 14885
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus ilex"
    },
    "vulgarName": [
      {
        "pt": "Azinheira"
      },
      {
        "en": "Holmoak"
      },
      {
        "es": "Encina"
      },
      {
        "de": "Steineiche"
      },
      {
        "fr": "Quercus ilex"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q218155",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_ilex",
      "es": "https://es.wikipedia.org/wiki/Quercus_ilex"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Quercus_ilex_JPG1.jpg/330px-Quercus_ilex_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Carrasca_de_la_Raboseras.JPG/330px-Carrasca_de_la_Raboseras.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_ilex",
    "gbif": "https://www.gbif.org/species/2879098",
    "extract": {
      "en": "The holm oak, also called the holly oak, is a large evergreen oak native to the Mediterranean region. It is a member of the section Ilex of the genus, with acorns that mature in a single summer.",
      "es": "La encina es un árbol de la familia de las fagáceas. Otros nombres comunes con los que se conoce a la encina son encino, carrasca, chaparra, chaparro o bellotero alto. Es un árbol perennifolio nativo de la región mediterránea de talla mediana, aunque puede aparecer en forma arbustiva, condicionado por las características pluviométricas o por el terreno en el que se encuentre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber"
    ],
    "nplots": {
      "ifn2": {
        "count": 3479
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus suber"
    },
    "vulgarName": [
      {
        "pt": "Sobreiro"
      },
      {
        "en": "Cork-oak"
      },
      {
        "es": "Alcornoque"
      },
      {
        "de": "Korkeiche"
      },
      {
        "fr": "Chêne-liège"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156137",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_suber",
      "es": "https://es.wikipedia.org/wiki/Quercus_suber"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Cork_oak_%2828864190188%29.jpg/330px-Cork_oak_%2828864190188%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Quercus_suber_JPG1.jpg/330px-Quercus_suber_JPG1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_suber",
    "gbif": "https://www.gbif.org/species/2879411",
    "extract": {
      "en": "Quercus suber, commonly called the cork oak, is a medium-sized, evergreen oak tree in the section Quercus sect. Cerris. It is the primary source of cork for wine bottle stoppers and other uses, such as cork flooring and as the cores of cricket balls. It is native to southwest Europe and northwest Africa. In the Mediterranean basin the tree is an ancient species with fossil remnants dating back to the Tertiary period. It can survive for as long as two centuries. Typically, once it reaches 25 years old, its thick bark can be harvested for cork every 9 to 12 years without causing harm to the tree.",
      "es": "El alcornoque es un árbol de porte medio, de hoja perenne, originario de Europa y del norte de África. Muy extendido antrópicamente por la explotación de su corteza de la que se obtiene el corcho. El Quercus suber se conoce también en algunas comarcas, especialmente los ejemplares jóvenes, como chaparro o roble sobrero."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 218
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus canariensis"
    },
    "vulgarName": [
      {
        "en": "Algerian oak"
      },
      {
        "en": "Mirbeck's oak"
      },
      {
        "es": "Quejigo bética"
      },
      {
        "fr": "Quercus canariensis"
      },
      {
        "pt": "Carvalho-das-canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q638095",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Quercus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg/330px-Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Quercus_canariensis_1.JPG/330px-Quercus_canariensis_1.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_canariensis",
    "gbif": "https://www.gbif.org/species/2880808",
    "extract": {
      "en": "Quercus canariensis, the Algerian oak, Mirbeck's oak or zean oak, is an oak native to southern Portugal, Spain, Tunisia, Algeria and Morocco. Despite the scientific name, it does not occur naturally today in the Canary Islands. It is placed in section Quercus.",
      "es": "El roble andaluz o quejigo andaluz es un árbol robusto, de hasta 30 m de altura cuando crece en buenas condiciones, con copa amplia y densa que proyecta una buena sombra, redondeada o irregular. Está clasificada en la Sección Mesobalanus, junto con el roble húngaro y sus parientes de Europa y Asia. Las hojas son simples, alternas y subpersistentes, pudiendo aguantar más de un ciclo estacional, por lo que la especie se clasifica como marcescente o caducifolia. Tiene los estilos largos; las bellotas maduran en unos seis meses y tiene sabor amargo, el interior de la bellota tiene pelo. La sección Mesobalanus está estrechamente relacionada con la sección Quercus y, a veces, está incluida en la misma."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra"
    ],
    "nplots": {
      "ifn2": {
        "count": 143
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus rubra"
    },
    "vulgarName": [
      {
        "en": "Champion oak"
      },
      {
        "en": "Northern red oak"
      },
      {
        "es": "Roble americano"
      },
      {
        "de": "Roteiche"
      },
      {
        "fr": "Chêne rouge d'Amérique"
      },
      {
        "pt": "Quercus rubra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147525",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_rubra",
      "es": "https://es.wikipedia.org/wiki/Quercus_rubra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Quercus_rubra_%40_Tortworth_Court.jpg/330px-Quercus_rubra_%40_Tortworth_Court.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_rubra",
    "gbif": "https://www.gbif.org/species/2880539",
    "extract": {
      "en": "Quercus rubra, the northern red oak or common red oak, is an oak tree in the red oak group. It is a native of North America, in the eastern and central United States and southeast and south-central Canada. It has been introduced to small areas in Western Europe, where it can frequently be seen cultivated in gardens and parks. It prefers good soil that is slightly acidic. Often simply called red oak, northern red oak is so named to distinguish it from southern red oak (Q. falcata), also known as the Spanish oak.",
      "es": "Quercus rubra, el roble rojo americano, roble boreal rojo americano o roble rojo del norte, es una especie arbórea perteneciente a la familia de las fagáceas oriunda del centro y este de América del Norte, aunque se han encontrado ejemplares en el noreste y centro de México,. Está clasificada en la sección Lobatae; del roble rojo de América del Norte, Centroamérica y el norte de América del Sur que tienen los estilos largos, las bellotas maduran en 18 meses y un sabor muy amargo. Las hojas suelen tener lóbulos terminados en un número variable de puntas agudas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus"
    },
    "vulgarName": [
      {
        "es": "Otros quercus"
      },
      {
        "en": "Other oaks"
      },
      {
        "es": "Quercus"
      },
      {
        "de": "Eichen"
      },
      {
        "fr": "Chêne"
      },
      {
        "pt": "Carvalho"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12004",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oak",
      "es": "https://es.wikipedia.org/wiki/Roble"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Illustration_Quercus_robur0.jpg/330px-Illustration_Quercus_robur0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus",
    "gbif": "https://www.gbif.org/species/2877951",
    "extract": {
      "en": "An oak is a hardwood tree or shrub in the genus Quercus of the beech family. They have spirally arranged leaves, often with lobed edges, and a nut called an acorn, borne within a cup. The genus is widely distributed in the Northern Hemisphere, with some 500 species, both deciduous and evergreen. Fossil oaks date back to the Middle Eocene. Molecular phylogeny shows that the genus is divided into Old World and New World clades, but many oak species hybridise freely, making the genus's history difficult to resolve.",
      "es": "El término roble se utiliza para referirse a muchas especies de árboles del género Quercus, nativo del hemisferio norte, y ocasionalmente también a especies de otros géneros de la misma familia (Fagaceae) o incluso de otras familias, como en el caso de algunas especies de Nothofagus. En sentido estricto del término, los robles comprenden las siguientes especies: Quercus faginea Lam., Quercus humilis Miller, Quercus petraea (Mattuschka) Liebl., Quercus pyrenaica Willd., Quercus robur L. y Quercus rubra L."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 218
      },
      "ifn3": {
        "count": 298
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus canariensis"
    },
    "vulgarName": [
      {
        "en": "Algerian oak"
      },
      {
        "en": "Mirbeck's oak"
      },
      {
        "es": "Quejigo bética"
      },
      {
        "fr": "Quercus canariensis"
      },
      {
        "pt": "Carvalho-das-canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q638095",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Quercus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg/330px-Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Quercus_canariensis_1.JPG/330px-Quercus_canariensis_1.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_canariensis",
    "gbif": "https://www.gbif.org/species/2880808",
    "extract": {
      "en": "Quercus canariensis, the Algerian oak, Mirbeck's oak or zean oak, is an oak native to southern Portugal, Spain, Tunisia, Algeria and Morocco. Despite the scientific name, it does not occur naturally today in the Canary Islands. It is placed in section Quercus.",
      "es": "El roble andaluz o quejigo andaluz es un árbol robusto, de hasta 30 m de altura cuando crece en buenas condiciones, con copa amplia y densa que proyecta una buena sombra, redondeada o irregular. Está clasificada en la Sección Mesobalanus, junto con el roble húngaro y sus parientes de Europa y Asia. Las hojas son simples, alternas y subpersistentes, pudiendo aguantar más de un ciclo estacional, por lo que la especie se clasifica como marcescente o caducifolia. Tiene los estilos largos; las bellotas maduran en unos seis meses y tiene sabor amargo, el interior de la bellota tiene pelo. La sección Mesobalanus está estrechamente relacionada con la sección Quercus y, a veces, está incluida en la misma."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 4238
      },
      "ifn3": {
        "count": 4646
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus faginea"
    },
    "vulgarName": [
      {
        "en": "Portuguese oak"
      },
      {
        "en": "Valencian oak"
      },
      {
        "es": "Quejigo fagínea"
      },
      {
        "de": "Portugiesische Eiche"
      },
      {
        "fr": "Quercus faginea"
      },
      {
        "pt": "Carvalho-português"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2432250",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_faginea",
      "es": "https://es.wikipedia.org/wiki/Quercus_faginea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Quejigo_de_la_Molinera.JPG/330px-Quejigo_de_la_Molinera.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Quercus_faginea_centenario.jpg/330px-Quercus_faginea_centenario.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_faginea",
    "gbif": "https://www.gbif.org/species/2881480",
    "extract": {
      "en": "Quercus faginea, the Portuguese oak, is a species of oak native to the western Mediterranean region in the Iberian Peninsula. Similar trees in the Atlas Mountains of northwest Africa are usually included in this species, or sometimes treated as a distinct species, Quercus tlemcenensis. It occurs in mountains from sea level to 1,900 metres above sea level, and flourishes in a variety of soils and climates. Out of all the oak forests in the Iberian Peninsula, the southern populations of Portuguese oak were found to have the highest diversity and endemism of spider species.",
      "es": "El quejigo, roble carrasqueño o roble valenciano es una especie de árbol marcescente de tamaño medio de hasta 20 m de altura, típico de las zonas de clima mediterráneo del norte de África y la península ibérica. Especie autóctona del bosque mediterráneo. Florece entre abril y mayo, casi siempre antes que la encina; las bellotas maduran y se diseminan hacia septiembre u octubre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species45"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 14885
      },
      "ifn3": {
        "count": 18782
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusIlex",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus ilex"
    },
    "vulgarName": [
      {
        "pt": "Azinheira"
      },
      {
        "en": "Holmoak"
      },
      {
        "es": "Encina"
      },
      {
        "de": "Steineiche"
      },
      {
        "fr": "Quercus ilex"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q218155",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_ilex",
      "es": "https://es.wikipedia.org/wiki/Quercus_ilex"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Quercus_ilex_JPG1.jpg/330px-Quercus_ilex_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Carrasca_de_la_Raboseras.JPG/330px-Carrasca_de_la_Raboseras.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_ilex",
    "gbif": "https://www.gbif.org/species/2879098",
    "extract": {
      "en": "The holm oak, also called the holly oak, is a large evergreen oak native to the Mediterranean region. It is a member of the section Ilex of the genus, with acorns that mature in a single summer.",
      "es": "La encina es un árbol de la familia de las fagáceas. Otros nombres comunes con los que se conoce a la encina son encino, carrasca, chaparra, chaparro o bellotero alto. Es un árbol perennifolio nativo de la región mediterránea de talla mediana, aunque puede aparecer en forma arbustiva, condicionado por las características pluviométricas o por el terreno en el que se encuentre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1666
      },
      "ifn3": {
        "count": 1402
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus petraea"
    },
    "vulgarName": [
      {
        "en": "Cornish oak"
      },
      {
        "en": "Durmast oak"
      },
      {
        "en": "Sessile oak"
      },
      {
        "es": "Roble"
      },
      {
        "de": "Traubeneiche"
      },
      {
        "fr": "Quercus petraea"
      },
      {
        "pt": "Quercus petraea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158608",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_petraea",
      "es": "https://es.wikipedia.org/wiki/Quercus_petraea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Quercus_petraea_06.jpg/330px-Quercus_petraea_06.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Sivry-Rance_AR1aJPG.jpg/330px-Sivry-Rance_AR1aJPG.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_petraea",
    "gbif": "https://www.gbif.org/species/2880130",
    "extract": {
      "en": "Quercus petraea, commonly known as the sessile oak, Welsh oak, Cornish oak, Irish oak or durmast oak, is a species of deciduous oak tree native to most of Europe and into Anatolia and Iran. The sessile oak is the national tree of Ireland, and an unofficial emblem in Wales and Cornwall.",
      "es": "Quercus petraea, el roble albar es un árbol de fronda perteneciente a la familia de las fagáceas. Es muy parecido a Quercus robur, que recibe muchas veces el mismo nombre, aunque suele ser menos robusto que este, alcanza más altura en bosque denso creciendo más recto. Está clasificada en la sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en 6 meses y tienen un sabor dulce y ligeramente amargo, el interior de la bellota tiene pelo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 4458
      },
      "ifn3": {
        "count": 7210
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus pyrenaica / Quercus pubescens Willd."
    },
    "vulgarName": [
      {
        "en": "Downy oak"
      },
      {
        "en": "Pubescent oak"
      },
      {
        "en": "Pyrenean oak"
      },
      {
        "es": "Rebollo"
      },
      {
        "es": "Roble pubescente"
      },
      {
        "de": "Flaumeiche"
      },
      {
        "de": "Pyrenäen-Eiche"
      },
      {
        "fr": "Chêne pubescent"
      },
      {
        "fr": "Chêne tauzin"
      },
      {
        "pt": "Quercus pyrenaica"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q161415",
      "http://www.wikidata.org/entity/Q899686"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3765
      },
      "ifn3": {
        "count": 3770
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus robur"
    },
    "vulgarName": [
      {
        "en": "Common oak"
      },
      {
        "en": "English oak"
      },
      {
        "en": "European oak"
      },
      {
        "en": "Pedunculate oak"
      },
      {
        "es": "Roble pedunculado"
      },
      {
        "de": "Stieleiche"
      },
      {
        "fr": "Chêne pédonculé"
      },
      {
        "pt": "Carvalho-roble"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165145",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_robur",
      "es": "https://es.wikipedia.org/wiki/Quercus_robur"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Crooked_branches_of_Quercus_robur.jpg/330px-Crooked_branches_of_Quercus_robur.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_robur",
    "gbif": "https://www.gbif.org/species/2878688",
    "extract": {
      "en": "Quercus robur, pedunculate oak, or English oak, is a species of flowering plant in the beech and oak family, Fagaceae. It is a large tree, native to Europe and western Asia, and is widely cultivated in other temperate regions. It grows on soils of near neutral acidity in the lowlands and is notable for its value to natural ecosystems, supporting a diversity of herbivorous insects, acorn eating mammals and birds, and fungi.",
      "es": "El roble común, roble albar, roble carballo, carballo, roble carvallo, carvallo, cajiga o roble fresnal es un árbol robusto, de porte majestuoso, que puede superar los 40 m de altura. Está clasificado en la Sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en seis meses y tienen un sabor dulce y ligeramente amargo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 143
      },
      "ifn3": {
        "count": 113
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus rubra"
    },
    "vulgarName": [
      {
        "en": "Champion oak"
      },
      {
        "en": "Northern red oak"
      },
      {
        "es": "Roble americano"
      },
      {
        "de": "Roteiche"
      },
      {
        "fr": "Chêne rouge d'Amérique"
      },
      {
        "pt": "Quercus rubra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147525",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_rubra",
      "es": "https://es.wikipedia.org/wiki/Quercus_rubra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Quercus_rubra_%40_Tortworth_Court.jpg/330px-Quercus_rubra_%40_Tortworth_Court.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_rubra",
    "gbif": "https://www.gbif.org/species/2880539",
    "extract": {
      "en": "Quercus rubra, the northern red oak or common red oak, is an oak tree in the red oak group. It is a native of North America, in the eastern and central United States and southeast and south-central Canada. It has been introduced to small areas in Western Europe, where it can frequently be seen cultivated in gardens and parks. It prefers good soil that is slightly acidic. Often simply called red oak, northern red oak is so named to distinguish it from southern red oak (Q. falcata), also known as the Spanish oak.",
      "es": "Quercus rubra, el roble rojo americano, roble boreal rojo americano o roble rojo del norte, es una especie arbórea perteneciente a la familia de las fagáceas oriunda del centro y este de América del Norte, aunque se han encontrado ejemplares en el noreste y centro de México,. Está clasificada en la sección Lobatae; del roble rojo de América del Norte, Centroamérica y el norte de América del Sur que tienen los estilos largos, las bellotas maduran en 18 meses y un sabor muy amargo. Las hojas suelen tener lóbulos terminados en un número variable de puntas agudas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species46"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3479
      },
      "ifn3": {
        "count": 3697
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusSuber",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus suber"
    },
    "vulgarName": [
      {
        "pt": "Sobreiro"
      },
      {
        "en": "Cork-oak"
      },
      {
        "es": "Alcornoque"
      },
      {
        "de": "Korkeiche"
      },
      {
        "fr": "Chêne-liège"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156137",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_suber",
      "es": "https://es.wikipedia.org/wiki/Quercus_suber"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Cork_oak_%2828864190188%29.jpg/330px-Cork_oak_%2828864190188%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Quercus_suber_JPG1.jpg/330px-Quercus_suber_JPG1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_suber",
    "gbif": "https://www.gbif.org/species/2879411",
    "extract": {
      "en": "Quercus suber, commonly called the cork oak, is a medium-sized, evergreen oak tree in the section Quercus sect. Cerris. It is the primary source of cork for wine bottle stoppers and other uses, such as cork flooring and as the cores of cricket balls. It is native to southwest Europe and northwest Africa. In the Mediterranean basin the tree is an ancient species with fossil remnants dating back to the Tertiary period. It can survive for as long as two centuries. Typically, once it reaches 25 years old, its thick bark can be harvested for cork every 9 to 12 years without causing harm to the tree.",
      "es": "El alcornoque es un árbol de porte medio, de hoja perenne, originario de Europa y del norte de África. Muy extendido antrópicamente por la explotación de su corteza de la que se obtiene el corcho. El Quercus suber se conoce también en algunas comarcas, especialmente los ejemplares jóvenes, como chaparro o roble sobrero."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 2059
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species243",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus pubescens"
    },
    "vulgarName": [
      {
        "en": "Downy oak"
      },
      {
        "en": "Pubescent oak"
      },
      {
        "es": "Roble pubescente"
      },
      {
        "de": "Flaumeiche"
      },
      {
        "fr": "Chêne pubescent"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161415",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_pubescens",
      "es": "https://es.wikipedia.org/wiki/Quercus_humilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Quercus_pubescens_Tuscany.jpg/330px-Quercus_pubescens_Tuscany.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_pubescens",
    "gbif": "https://www.gbif.org/species/2881283",
    "extract": {
      "en": "Quercus pubescens, commonly known as the downy oak, pubescent oak or Italian oak, is a species of white oak native to southern Europe and southwest Asia. It is found from northern Spain (Pyrenees) and France in the West to Turkey and the Caucasus in the East.",
      "es": "Quercus humilis, el roble pubescente, es un árbol de fronda, de tamaño medio, pudiendo llegar a los 25 m, que pertenece a la familia de las fagáceas. Se distribuye por el centro y sur de Europa, Turquía y Crimea. Está catalogado como especie vulnerable por pérdida de hábitat. Este roble muestra una enorme tendencia a hibridarse con otros congéneres, lo que hace difícil reconocer, en determinadas regiones, sus rasgos morfológicos más típicos. Prueba de ello es que se han descrito cruces en el cuadrante nororiental ibérico con muy diversas especies del género. En general, en el eje pirenaico se encuentran las poblaciones más puras, mientras en el Prepirineo dominan los mestos o híbridos, siendo particularmente abundante Quercus x cerrioides."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Dyer's oak"
      },
      {
        "en": "Gall oak"
      },
      {
        "en": "Lusitanian oak"
      },
      {
        "es": "Quejigueta"
      },
      {
        "pt": "Quercus lusitanica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3927703",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Quercus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Quercus_lusitanica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-253.jpg/330px-Quercus_lusitanica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-253.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_lusitanica",
    "gbif": "https://www.gbif.org/species/2881060",
    "extract": {
      "en": "Quercus lusitanica, commonly known as gall oak, Lusitanian oak, or dyer's oak, is a species of oak native to Portugal, Spain and Morocco. Quercus lusitanica is the source of commercial nutgalls. These galls are produced by the infection from the insect Cynips gallae tinctoriae. They are used for dyeing.",
      "es": "Quercus lusitanica es una especie de roble emparentada con los quejigos: de nombre polémico,[¿Por qué?] que habita en Galicia, centro y sur de Portugal y provincias de Cádiz y Málaga y Rif norteafricano; es un arbusto que alcanza a lo sumo 2 m de altura y tiene las hojas como un quejigo, pero con un peciolo muy corto, de menos de 4 mm, que a veces pierden el pelo de la cara posterior, de las hojas. Recibe el nombre de quejigueta y se cría en los matorrales y colinas de clima suave, frecuentemente sobre suelos arenosos y en ambiente de alcornocal."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species40",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus"
    },
    "vulgarName": [
      {
        "es": "Quercus"
      },
      {
        "de": "Eichen"
      },
      {
        "fr": "Chêne"
      },
      {
        "pt": "Carvalho"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12004",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oak",
      "es": "https://es.wikipedia.org/wiki/Roble"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Illustration_Quercus_robur0.jpg/330px-Illustration_Quercus_robur0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus",
    "gbif": "https://www.gbif.org/species/2877951",
    "extract": {
      "en": "An oak is a hardwood tree or shrub in the genus Quercus of the beech family. They have spirally arranged leaves, often with lobed edges, and a nut called an acorn, borne within a cup. The genus is widely distributed in the Northern Hemisphere, with some 500 species, both deciduous and evergreen. Fossil oaks date back to the Middle Eocene. Molecular phylogeny shows that the genus is divided into Old World and New World clades, but many oak species hybridise freely, making the genus's history difficult to resolve.",
      "es": "El término roble se utiliza para referirse a muchas especies de árboles del género Quercus, nativo del hemisferio norte, y ocasionalmente también a especies de otros géneros de la misma familia (Fagaceae) o incluso de otras familias, como en el caso de algunas especies de Nothofagus. En sentido estricto del término, los robles comprenden las siguientes especies: Quercus faginea Lam., Quercus humilis Miller, Quercus petraea (Mattuschka) Liebl., Quercus pyrenaica Willd., Quercus robur L. y Quercus rubra L."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRobur"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 3770
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species41",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus robur"
    },
    "vulgarName": [
      {
        "en": "Common oak"
      },
      {
        "en": "English oak"
      },
      {
        "en": "European oak"
      },
      {
        "en": "Pedunculate oak"
      },
      {
        "es": "Roble pedunculado"
      },
      {
        "de": "Stieleiche"
      },
      {
        "fr": "Chêne pédonculé"
      },
      {
        "pt": "Carvalho-roble"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165145",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_robur",
      "es": "https://es.wikipedia.org/wiki/Quercus_robur"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Crooked_branches_of_Quercus_robur.jpg/330px-Crooked_branches_of_Quercus_robur.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_robur",
    "gbif": "https://www.gbif.org/species/2878688",
    "extract": {
      "en": "Quercus robur, pedunculate oak, or English oak, is a species of flowering plant in the beech and oak family, Fagaceae. It is a large tree, native to Europe and western Asia, and is widely cultivated in other temperate regions. It grows on soils of near neutral acidity in the lowlands and is notable for its value to natural ecosystems, supporting a diversity of herbivorous insects, acorn eating mammals and birds, and fungi.",
      "es": "El roble común, roble albar, roble carballo, carballo, roble carvallo, carvallo, cajiga o roble fresnal es un árbol robusto, de porte majestuoso, que puede superar los 40 m de altura. Está clasificado en la Sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en seis meses y tienen un sabor dulce y ligeramente amargo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPetraea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1402
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species42",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus petraea"
    },
    "vulgarName": [
      {
        "en": "Cornish oak"
      },
      {
        "en": "Durmast oak"
      },
      {
        "en": "Sessile oak"
      },
      {
        "es": "Roble"
      },
      {
        "de": "Traubeneiche"
      },
      {
        "fr": "Quercus petraea"
      },
      {
        "pt": "Quercus petraea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158608",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_petraea",
      "es": "https://es.wikipedia.org/wiki/Quercus_petraea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Quercus_petraea_06.jpg/330px-Quercus_petraea_06.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Sivry-Rance_AR1aJPG.jpg/330px-Sivry-Rance_AR1aJPG.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_petraea",
    "gbif": "https://www.gbif.org/species/2880130",
    "extract": {
      "en": "Quercus petraea, commonly known as the sessile oak, Welsh oak, Cornish oak, Irish oak or durmast oak, is a species of deciduous oak tree native to most of Europe and into Anatolia and Iran. The sessile oak is the national tree of Ireland, and an unofficial emblem in Wales and Cornwall.",
      "es": "Quercus petraea, el roble albar es un árbol de fronda perteneciente a la familia de las fagáceas. Es muy parecido a Quercus robur, que recibe muchas veces el mismo nombre, aunque suele ser menos robusto que este, alcanza más altura en bosque denso creciendo más recto. Está clasificada en la sección Quercus, que son los robles blancos de Europa, Asia y América del Norte. Tienen los estilos cortos; las bellotas maduran en 6 meses y tienen un sabor dulce y ligeramente amargo, el interior de la bellota tiene pelo. Las hojas carecen de una mayoría de cerdas en sus lóbulos, que suelen ser redondeados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusPyrenaicaQuercusPubescensWilld"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 5153
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species43",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus pyrenaica"
    },
    "vulgarName": [
      {
        "en": "Pyrenean oak"
      },
      {
        "es": "Rebollo"
      },
      {
        "de": "Pyrenäen-Eiche"
      },
      {
        "fr": "Chêne tauzin"
      },
      {
        "pt": "Quercus pyrenaica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q899686",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_pyrenaica",
      "es": "https://es.wikipedia.org/wiki/Quercus_pyrenaica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Quercus_pyrenaica_20190708a.jpg/330px-Quercus_pyrenaica_20190708a.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_pyrenaica",
    "gbif": "https://www.gbif.org/species/2878826",
    "extract": {
      "en": "Quercus pyrenaica, also known as Pyrenean oak, or Spanish oak is a tree native to southwestern Europe and northwestern North Africa. Despite its common name, it is rarely found in the Pyrenees Mountains and is more abundant in northern Portugal and north and northwestern Spain.",
      "es": "Quercus pyrenaica, llamado generalmente en España roble marojo o melojo, roble negro y rebollo. En Galicia cerquiño o cerqueiro; en Asturias corcu o corcoxu; en Cantabria tocio o tozo, y en el País Vasco ametz."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusFaginea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 4646
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species44",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus faginea"
    },
    "vulgarName": [
      {
        "en": "Portuguese oak"
      },
      {
        "en": "Valencian oak"
      },
      {
        "es": "Quejigo fagínea"
      },
      {
        "de": "Portugiesische Eiche"
      },
      {
        "fr": "Quercus faginea"
      },
      {
        "pt": "Carvalho-português"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2432250",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_faginea",
      "es": "https://es.wikipedia.org/wiki/Quercus_faginea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Quejigo_de_la_Molinera.JPG/330px-Quejigo_de_la_Molinera.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Quercus_faginea_centenario.jpg/330px-Quercus_faginea_centenario.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_faginea",
    "gbif": "https://www.gbif.org/species/2881480",
    "extract": {
      "en": "Quercus faginea, the Portuguese oak, is a species of oak native to the western Mediterranean region in the Iberian Peninsula. Similar trees in the Atlas Mountains of northwest Africa are usually included in this species, or sometimes treated as a distinct species, Quercus tlemcenensis. It occurs in mountains from sea level to 1,900 metres above sea level, and flourishes in a variety of soils and climates. Out of all the oak forests in the Iberian Peninsula, the southern populations of Portuguese oak were found to have the highest diversity and endemism of spider species.",
      "es": "El quejigo, roble carrasqueño o roble valenciano es una especie de árbol marcescente de tamaño medio de hasta 20 m de altura, típico de las zonas de clima mediterráneo del norte de África y la península ibérica. Especie autóctona del bosque mediterráneo. Florece entre abril y mayo, casi siempre antes que la encina; las bellotas maduran y se diseminan hacia septiembre u octubre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 298
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species47",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus canariensis"
    },
    "vulgarName": [
      {
        "en": "Algerian oak"
      },
      {
        "en": "Mirbeck's oak"
      },
      {
        "es": "Quejigo bética"
      },
      {
        "fr": "Quercus canariensis"
      },
      {
        "pt": "Carvalho-das-canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q638095",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Quercus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg/330px-Quercus_canariensis_Enfoque_2010-10-03_SierraMadrona.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Quercus_canariensis_1.JPG/330px-Quercus_canariensis_1.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_canariensis",
    "gbif": "https://www.gbif.org/species/2880808",
    "extract": {
      "en": "Quercus canariensis, the Algerian oak, Mirbeck's oak or zean oak, is an oak native to southern Portugal, Spain, Tunisia, Algeria and Morocco. Despite the scientific name, it does not occur naturally today in the Canary Islands. It is placed in section Quercus.",
      "es": "El roble andaluz o quejigo andaluz es un árbol robusto, de hasta 30 m de altura cuando crece en buenas condiciones, con copa amplia y densa que proyecta una buena sombra, redondeada o irregular. Está clasificada en la Sección Mesobalanus, junto con el roble húngaro y sus parientes de Europa y Asia. Las hojas son simples, alternas y subpersistentes, pudiendo aguantar más de un ciclo estacional, por lo que la especie se clasifica como marcescente o caducifolia. Tiene los estilos largos; las bellotas maduran en unos seis meses y tiene sabor amargo, el interior de la bellota tiene pelo. La sección Mesobalanus está estrechamente relacionada con la sección Quercus y, a veces, está incluida en la misma."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusRubra"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 113
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species48",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus rubra"
    },
    "vulgarName": [
      {
        "en": "Champion oak"
      },
      {
        "en": "Northern red oak"
      },
      {
        "es": "Roble americano"
      },
      {
        "de": "Roteiche"
      },
      {
        "fr": "Chêne rouge d'Amérique"
      },
      {
        "pt": "Quercus rubra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147525",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_rubra",
      "es": "https://es.wikipedia.org/wiki/Quercus_rubra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Quercus_rubra_%40_Tortworth_Court.jpg/330px-Quercus_rubra_%40_Tortworth_Court.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_rubra",
    "gbif": "https://www.gbif.org/species/2880539",
    "extract": {
      "en": "Quercus rubra, the northern red oak or common red oak, is an oak tree in the red oak group. It is a native of North America, in the eastern and central United States and southeast and south-central Canada. It has been introduced to small areas in Western Europe, where it can frequently be seen cultivated in gardens and parks. It prefers good soil that is slightly acidic. Often simply called red oak, northern red oak is so named to distinguish it from southern red oak (Q. falcata), also known as the Spanish oak.",
      "es": "Quercus rubra, el roble rojo americano, roble boreal rojo americano o roble rojo del norte, es una especie arbórea perteneciente a la familia de las fagáceas oriunda del centro y este de América del Norte, aunque se han encontrado ejemplares en el noreste y centro de México,. Está clasificada en la sección Lobatae; del roble rojo de América del Norte, Centroamérica y el norte de América del Sur que tienen los estilos largos, las bellotas maduran en 18 meses y un sabor muy amargo. Las hojas suelen tener lóbulos terminados en un número variable de puntas agudas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Quercus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species49",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus"
    },
    "vulgarName": [
      {
        "es": "Otros quercus"
      },
      {
        "en": "Other oaks"
      },
      {
        "de": "Eichen"
      },
      {
        "fr": "Chêne"
      },
      {
        "pt": "Carvalho"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12004",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Oak",
      "es": "https://es.wikipedia.org/wiki/Roble"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Quercus_robur.jpg/330px-Quercus_robur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Illustration_Quercus_robur0.jpg/330px-Illustration_Quercus_robur0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus",
    "gbif": "https://www.gbif.org/species/2877951",
    "extract": {
      "en": "An oak is a hardwood tree or shrub in the genus Quercus of the beech family. They have spirally arranged leaves, often with lobed edges, and a nut called an acorn, borne within a cup. The genus is widely distributed in the Northern Hemisphere, with some 500 species, both deciduous and evergreen. Fossil oaks date back to the Middle Eocene. Molecular phylogeny shows that the genus is divided into Old World and New World clades, but many oak species hybridise freely, making the genus's history difficult to resolve.",
      "es": "El término roble se utiliza para referirse a muchas especies de árboles del género Quercus, nativo del hemisferio norte, y ocasionalmente también a especies de otros géneros de la misma familia (Fagaceae) o incluso de otras familias, como en el caso de algunas especies de Nothofagus. En sentido estricto del término, los robles comprenden las siguientes especies: Quercus faginea Lam., Quercus humilis Miller, Quercus petraea (Mattuschka) Liebl., Quercus pyrenaica Willd., Quercus robur L. y Quercus rubra L."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species244"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus121",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/QuercusLusitanica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Quercus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Dyer's oak"
      },
      {
        "en": "Gall oak"
      },
      {
        "en": "Lusitanian oak"
      },
      {
        "es": "Quejigueta"
      },
      {
        "pt": "Quercus lusitanica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3927703",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Quercus_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Quercus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Quercus_lusitanica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-253.jpg/330px-Quercus_lusitanica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-253.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Quercus_lusitanica",
    "gbif": "https://www.gbif.org/species/2881060",
    "extract": {
      "en": "Quercus lusitanica, commonly known as gall oak, Lusitanian oak, or dyer's oak, is a species of oak native to Portugal, Spain and Morocco. Quercus lusitanica is the source of commercial nutgalls. These galls are produced by the infection from the insect Cynips gallae tinctoriae. They are used for dyeing.",
      "es": "Quercus lusitanica es una especie de roble emparentada con los quejigos: de nombre polémico,[¿Por qué?] que habita en Galicia, centro y sur de Portugal y provincias de Cádiz y Málaga y Rif norteafricano; es un arbusto que alcanza a lo sumo 2 m de altura y tiene las hojas como un quejigo, pero con un peciolo muy corto, de menos de 4 mm, que a veces pierden el pelo de la cara posterior, de las hojas. Recibe el nombre de quejigueta y se cría en los matorrales y colinas de clima suave, frecuentemente sobre suelos arenosos y en ambiente de alcornocal."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3655
      },
      "ifn3": {
        "count": 3996
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
    "isGenus": 1,
    "scientificName": {
      "la": "Eucalyptus"
    },
    "vulgarName": [
      {
        "es": "Eucaliptos"
      },
      {
        "de": "Eukalypten"
      },
      {
        "fr": "Eucalyptus"
      },
      {
        "pt": "Eucalyptus"
      },
      {
        "en": "Eucalypts"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q45669",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg/330px-Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus",
    "gbif": "https://www.gbif.org/species/3176176",
    "extract": {
      "en": "Eucalyptus is a genus of more than 700 species of flowering plants in the family Myrtaceae. Most species of Eucalyptus are trees, often mallees, and a few are shrubs. Along with several other genera in the tribe Eucalypteae, including Corymbia and Angophora, they are commonly known as eucalypts or \"gum trees\". Species of Eucalyptus have bark that is either smooth, fibrous, hard, or stringy and leaves that have oil glands. The sepals and petals are fused to form a \"cap\" or operculum over the stamens, hence the name from Greek eû 'well' and kaluptós 'covered'.",
      "es": "Los eucaliptos o eucaliptas, Eucalyptus L'Hér., es un género de árboles de la familia de las mirtáceas. Existen alrededor de setecientas especies, la mayoría oriundas de Australia y Nueva Guinea. En la actualidad, se encuentran distribuidos por gran parte del mundo. Es considerada una Especie exótica en Colombia, México, Chile, Argentina, Estados Unidos, Nicaragua, Sudáfrica y algunos países de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "nplots": {
      "ifn2": {
        "count": 475
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus"
    },
    "vulgarName": [
      {
        "es": "Eucaliptos"
      },
      {
        "es": "Otros eucaliptos"
      },
      {
        "en": "Other eucalypts"
      },
      {
        "de": "Eukalypten"
      },
      {
        "fr": "Eucalyptus"
      },
      {
        "pt": "Eucalyptus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q45669",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg/330px-Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus",
    "gbif": "https://www.gbif.org/species/3176176",
    "extract": {
      "en": "Eucalyptus is a genus of more than 700 species of flowering plants in the family Myrtaceae. Most species of Eucalyptus are trees, often mallees, and a few are shrubs. Along with several other genera in the tribe Eucalypteae, including Corymbia and Angophora, they are commonly known as eucalypts or \"gum trees\". Species of Eucalyptus have bark that is either smooth, fibrous, hard, or stringy and leaves that have oil glands. The sepals and petals are fused to form a \"cap\" or operculum over the stamens, hence the name from Greek eû 'well' and kaluptós 'covered'.",
      "es": "Los eucaliptos o eucaliptas, Eucalyptus L'Hér., es un género de árboles de la familia de las mirtáceas. Existen alrededor de setecientas especies, la mayoría oriundas de Australia y Nueva Guinea. En la actualidad, se encuentran distribuidos por gran parte del mundo. Es considerada una Especie exótica en Colombia, México, Chile, Argentina, Estados Unidos, Nicaragua, Sudáfrica y algunos países de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus"
    ],
    "nplots": {
      "ifn2": {
        "count": 2952
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus globulus"
    },
    "vulgarName": [
      {
        "en": "Southern blue gum"
      },
      {
        "en": "Tasmanian blue gum"
      },
      {
        "es": "Eucalipto globulus"
      },
      {
        "de": "Blauer Eukalyptus"
      },
      {
        "fr": "Eucalyptus globulus"
      },
      {
        "pt": "Eucalyptus globulus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159528",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_globulus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_globulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Eucalyptus_globulus_subsp._maidenii.jpg/330px-Eucalyptus_globulus_subsp._maidenii.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Starr_031214-0076_Eucalyptus_globulus.jpg/330px-Starr_031214-0076_Eucalyptus_globulus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_globulus",
    "gbif": "https://www.gbif.org/species/3176787",
    "extract": {
      "en": "Eucalyptus globulus, commonly known as southern blue gum or blue gum, is a species of flowering plant in the family Myrtaceae. It is a tall, evergreen tree endemic to southeastern Australia. This Eucalyptus species has mostly smooth bark, juvenile leaves that are whitish and waxy on the lower surface, glossy green, lance-shaped adult leaves, glaucous, ribbed flower buds arranged singly or in groups of three or seven in leaf axils, white flowers and woody fruit.",
      "es": "El eucalipto blanco, eucalipto común o eucalipto azul es una especie arbórea de la familia de las mirtáceas, originaria del sureste de Australia y Tasmania."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 236
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus camaldulensis"
    },
    "vulgarName": [
      {
        "en": "River red gum"
      },
      {
        "es": "Eucalipto rostrata"
      },
      {
        "de": "Roter Eukalyptus"
      },
      {
        "fr": "Eucalyptus camaldulensis"
      },
      {
        "pt": "Eucalyptus camaldulensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q162822",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_camaldulensis",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_camaldulensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/700_yr_red_river_gum02.jpg/330px-700_yr_red_river_gum02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_camaldulensis",
    "gbif": "https://www.gbif.org/species/3176197",
    "extract": {
      "en": "Eucalyptus camaldulensis, commonly known as river red gum, is a flowering plant in the family Myrtaceae, and is endemic to Australia. It is a tree with smooth white or cream-coloured bark, lance-shaped or curved adult leaves, flower buds in groups of seven or nine, white flowers and hemispherical fruit with the valves extending beyond the rim. A familiar and iconic tree, it is seen along many watercourses across inland Australia, providing shade in the extreme temperatures of central Australia and elsewhere.",
      "es": "El eucalipto rojo es un árbol del género Eucalyptus. Es una especie plantada en muchas partes del mundo. Es nativa de Australia donde está ampliamente expandida, en especial cerca de cursos de agua."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "nplots": {
      "ifn2": {
        "count": 55
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 530
      },
      "ifn3": {
        "count": 28
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus"
    },
    "vulgarName": [
      {
        "es": "Eucaliptos"
      },
      {
        "es": "Otros eucaliptos"
      },
      {
        "en": "Other eucalypts"
      },
      {
        "de": "Eukalypten"
      },
      {
        "fr": "Eucalyptus"
      },
      {
        "pt": "Eucalyptus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q45669",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg/330px-Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus",
    "gbif": "https://www.gbif.org/species/3176176",
    "extract": {
      "en": "Eucalyptus is a genus of more than 700 species of flowering plants in the family Myrtaceae. Most species of Eucalyptus are trees, often mallees, and a few are shrubs. Along with several other genera in the tribe Eucalypteae, including Corymbia and Angophora, they are commonly known as eucalypts or \"gum trees\". Species of Eucalyptus have bark that is either smooth, fibrous, hard, or stringy and leaves that have oil glands. The sepals and petals are fused to form a \"cap\" or operculum over the stamens, hence the name from Greek eû 'well' and kaluptós 'covered'.",
      "es": "Los eucaliptos o eucaliptas, Eucalyptus L'Hér., es un género de árboles de la familia de las mirtáceas. Existen alrededor de setecientas especies, la mayoría oriundas de Australia y Nueva Guinea. En la actualidad, se encuentran distribuidos por gran parte del mundo. Es considerada una Especie exótica en Colombia, México, Chile, Argentina, Estados Unidos, Nicaragua, Sudáfrica y algunos países de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 236
      },
      "ifn3": {
        "count": 689
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus camaldulensis"
    },
    "vulgarName": [
      {
        "en": "River red gum"
      },
      {
        "es": "Eucalipto rostrata"
      },
      {
        "de": "Roter Eukalyptus"
      },
      {
        "fr": "Eucalyptus camaldulensis"
      },
      {
        "pt": "Eucalyptus camaldulensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q162822",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_camaldulensis",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_camaldulensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/700_yr_red_river_gum02.jpg/330px-700_yr_red_river_gum02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_camaldulensis",
    "gbif": "https://www.gbif.org/species/3176197",
    "extract": {
      "en": "Eucalyptus camaldulensis, commonly known as river red gum, is a flowering plant in the family Myrtaceae, and is endemic to Australia. It is a tree with smooth white or cream-coloured bark, lance-shaped or curved adult leaves, flower buds in groups of seven or nine, white flowers and hemispherical fruit with the valves extending beyond the rim. A familiar and iconic tree, it is seen along many watercourses across inland Australia, providing shade in the extreme temperatures of central Australia and elsewhere.",
      "es": "El eucalipto rojo es un árbol del género Eucalyptus. Es una especie plantada en muchas partes del mundo. Es nativa de Australia donde está ampliamente expandida, en especial cerca de cursos de agua."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2952
      },
      "ifn3": {
        "count": 3262
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus globulus"
    },
    "vulgarName": [
      {
        "en": "Southern blue gum"
      },
      {
        "en": "Tasmanian blue gum"
      },
      {
        "es": "Eucalipto globulus"
      },
      {
        "de": "Blauer Eukalyptus"
      },
      {
        "fr": "Eucalyptus globulus"
      },
      {
        "pt": "Eucalyptus globulus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159528",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_globulus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_globulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Eucalyptus_globulus_subsp._maidenii.jpg/330px-Eucalyptus_globulus_subsp._maidenii.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Starr_031214-0076_Eucalyptus_globulus.jpg/330px-Starr_031214-0076_Eucalyptus_globulus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_globulus",
    "gbif": "https://www.gbif.org/species/3176787",
    "extract": {
      "en": "Eucalyptus globulus, commonly known as southern blue gum or blue gum, is a species of flowering plant in the family Myrtaceae. It is a tall, evergreen tree endemic to southeastern Australia. This Eucalyptus species has mostly smooth bark, juvenile leaves that are whitish and waxy on the lower surface, glossy green, lance-shaped adult leaves, glaucous, ribbed flower buds arranged singly or in groups of three or seven in leaf axils, white flowers and woody fruit.",
      "es": "El eucalipto blanco, eucalipto común o eucalipto azul es una especie arbórea de la familia de las mirtáceas, originaria del sureste de Australia y Tasmania."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus viminalis"
    },
    "vulgarName": [
      {
        "en": "Manna gum"
      },
      {
        "en": "Ribbon gum"
      },
      {
        "en": "Viminalis"
      },
      {
        "en": "White gum"
      },
      {
        "es": "Eucalipto viminalis"
      },
      {
        "de": "Rutenförmiger Eukalyptus"
      },
      {
        "fr": "Eucalyptus viminalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2137116",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_viminalis",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_viminalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Eucalyptus_viminalis_habit.jpg/330px-Eucalyptus_viminalis_habit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Eucalyptus_globulus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-147.jpg/330px-Eucalyptus_globulus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-147.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_viminalis",
    "gbif": "https://www.gbif.org/species/3177112",
    "extract": {
      "en": "Eucalyptus viminalis, commonly known as the manna gum, white gum or ribbon gum, is a species of small to very tall tree that is endemic to south-eastern Australia. It has smooth bark, sometimes with rough bark near the base, lance-shaped to curved adult leaves, flower buds in groups of three or seven, white flowers and cup-shaped or hemispherical fruit.",
      "es": "Eucalyptus viminalis es una especie fanerógama perteneciente a la familia de las mirtáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 60
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus gomphocephala"
    },
    "vulgarName": [
      {
        "en": "Tuart"
      },
      {
        "es": "Eucalipto gonfo"
      },
      {
        "de": "Eucalyptus gomphocephala"
      },
      {
        "fr": "Eucalyptus gomphocephala"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q514995",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_gomphocephala",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_gomphocephala"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Eucalyptus_gomphocephala_in_Kings_Park.jpg/330px-Eucalyptus_gomphocephala_in_Kings_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Eucalyptus_gomphocephala.jpg/330px-Eucalyptus_gomphocephala.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_gomphocephala",
    "gbif": "https://www.gbif.org/species/3176772",
    "extract": {
      "en": "Eucalyptus gomphocephala, known as tuart, is a species of tree and is one of the six forest giants of Southwest Australia.",
      "es": "Eucalyptus gomphocephala comúnmente conocido como árbol tuart es una especie de árbol en el género Eucalyptus. Nativo del sudeste de Australia Occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 28
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species60",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus"
    },
    "vulgarName": [
      {
        "es": "Eucaliptos"
      },
      {
        "de": "Eukalypten"
      },
      {
        "fr": "Eucalyptus"
      },
      {
        "pt": "Eucalyptus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q45669",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg/330px-Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus",
    "gbif": "https://www.gbif.org/species/3176176",
    "extract": {
      "en": "Eucalyptus is a genus of more than 700 species of flowering plants in the family Myrtaceae. Most species of Eucalyptus are trees, often mallees, and a few are shrubs. Along with several other genera in the tribe Eucalypteae, including Corymbia and Angophora, they are commonly known as eucalypts or \"gum trees\". Species of Eucalyptus have bark that is either smooth, fibrous, hard, or stringy and leaves that have oil glands. The sepals and petals are fused to form a \"cap\" or operculum over the stamens, hence the name from Greek eû 'well' and kaluptós 'covered'.",
      "es": "Los eucaliptos o eucaliptas, Eucalyptus L'Hér., es un género de árboles de la familia de las mirtáceas. Existen alrededor de setecientas especies, la mayoría oriundas de Australia y Nueva Guinea. En la actualidad, se encuentran distribuidos por gran parte del mundo. Es considerada una Especie exótica en Colombia, México, Chile, Argentina, Estados Unidos, Nicaragua, Sudáfrica y algunos países de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGlobulus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 3262
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species61",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus globulus"
    },
    "vulgarName": [
      {
        "en": "Southern blue gum"
      },
      {
        "en": "Tasmanian blue gum"
      },
      {
        "es": "Eucalipto globulus"
      },
      {
        "de": "Blauer Eukalyptus"
      },
      {
        "fr": "Eucalyptus globulus"
      },
      {
        "pt": "Eucalyptus globulus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159528",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_globulus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_globulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Eucalyptus_globulus_subsp._maidenii.jpg/330px-Eucalyptus_globulus_subsp._maidenii.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Starr_031214-0076_Eucalyptus_globulus.jpg/330px-Starr_031214-0076_Eucalyptus_globulus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_globulus",
    "gbif": "https://www.gbif.org/species/3176787",
    "extract": {
      "en": "Eucalyptus globulus, commonly known as southern blue gum or blue gum, is a species of flowering plant in the family Myrtaceae. It is a tall, evergreen tree endemic to southeastern Australia. This Eucalyptus species has mostly smooth bark, juvenile leaves that are whitish and waxy on the lower surface, glossy green, lance-shaped adult leaves, glaucous, ribbed flower buds arranged singly or in groups of three or seven in leaf axils, white flowers and woody fruit.",
      "es": "El eucalipto blanco, eucalipto común o eucalipto azul es una especie arbórea de la familia de las mirtáceas, originaria del sureste de Australia y Tasmania."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusCamaldulensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 689
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species62",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus camaldulensis"
    },
    "vulgarName": [
      {
        "en": "River red gum"
      },
      {
        "es": "Eucalipto rostrata"
      },
      {
        "de": "Roter Eukalyptus"
      },
      {
        "fr": "Eucalyptus camaldulensis"
      },
      {
        "pt": "Eucalyptus camaldulensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q162822",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_camaldulensis",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_camaldulensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/700_yr_red_river_gum02.jpg/330px-700_yr_red_river_gum02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_camaldulensis",
    "gbif": "https://www.gbif.org/species/3176197",
    "extract": {
      "en": "Eucalyptus camaldulensis, commonly known as river red gum, is a flowering plant in the family Myrtaceae, and is endemic to Australia. It is a tree with smooth white or cream-coloured bark, lance-shaped or curved adult leaves, flower buds in groups of seven or nine, white flowers and hemispherical fruit with the valves extending beyond the rim. A familiar and iconic tree, it is seen along many watercourses across inland Australia, providing shade in the extreme temperatures of central Australia and elsewhere.",
      "es": "El eucalipto rojo es un árbol del género Eucalyptus. Es una especie plantada en muchas partes del mundo. Es nativa de Australia donde está ampliamente expandida, en especial cerca de cursos de agua."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Eucalyptus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species63",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus"
    },
    "vulgarName": [
      {
        "es": "Otros eucaliptos"
      },
      {
        "en": "Other eucalypts"
      },
      {
        "de": "Eukalypten"
      },
      {
        "fr": "Eucalyptus"
      },
      {
        "pt": "Eucalyptus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q45669",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg/330px-Eucalyptus_tereticornis_flowers%2C_capsules%2C_buds_and_foliage.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus",
    "gbif": "https://www.gbif.org/species/3176176",
    "extract": {
      "en": "Eucalyptus is a genus of more than 700 species of flowering plants in the family Myrtaceae. Most species of Eucalyptus are trees, often mallees, and a few are shrubs. Along with several other genera in the tribe Eucalypteae, including Corymbia and Angophora, they are commonly known as eucalypts or \"gum trees\". Species of Eucalyptus have bark that is either smooth, fibrous, hard, or stringy and leaves that have oil glands. The sepals and petals are fused to form a \"cap\" or operculum over the stamens, hence the name from Greek eû 'well' and kaluptós 'covered'.",
      "es": "Los eucaliptos o eucaliptas, Eucalyptus L'Hér., es un género de árboles de la familia de las mirtáceas. Existen alrededor de setecientas especies, la mayoría oriundas de Australia y Nueva Guinea. En la actualidad, se encuentran distribuidos por gran parte del mundo. Es considerada una Especie exótica en Colombia, México, Chile, Argentina, Estados Unidos, Nicaragua, Sudáfrica y algunos países de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 12
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus nitens"
    },
    "vulgarName": [
      {
        "en": "Shining gum"
      },
      {
        "es": "Eucalipto nitens"
      },
      {
        "fr": "Eucalyptus nitens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2512644",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_nitens",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_nitens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/f/f2/Eucalyptus_nitens_New_England_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/9/9c/Brown_Mountain_old_growth_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_nitens",
    "gbif": "https://www.gbif.org/species/3176336",
    "extract": {
      "en": "Eucalyptus nitens, commonly known as shining gum or silvertop, is a species of tall tree native to Victoria and eastern New South Wales. It has smooth greyish bark, sometimes with thin, rough bark near the base, lance-shaped adult leaves, flower buds in groups of seven or nine, white flowers and cup-shaped, barrel-shaped or cylindrical fruit. It grows in wet forests and rainforest margins on fertile soils in cool, high-rainfall areas.",
      "es": "Eucalyptus nitens, comúnmente conocido como el eucalipto brillante, es una especie nativa de Victoria y el este de Nueva Gales del Sur en Australia. Crece en los bosques húmedos templados y sus márgenes en suelos fértiles de áreas de clima fresco."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species364"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 60
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusGomphocephala",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus gomphocephala"
    },
    "vulgarName": [
      {
        "en": "Tuart"
      },
      {
        "es": "Eucalipto gonfo"
      },
      {
        "de": "Eucalyptus gomphocephala"
      },
      {
        "fr": "Eucalyptus gomphocephala"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q514995",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_gomphocephala",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_gomphocephala"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Eucalyptus_gomphocephala_in_Kings_Park.jpg/330px-Eucalyptus_gomphocephala_in_Kings_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Eucalyptus_gomphocephala.jpg/330px-Eucalyptus_gomphocephala.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_gomphocephala",
    "gbif": "https://www.gbif.org/species/3176772",
    "extract": {
      "en": "Eucalyptus gomphocephala, known as tuart, is a species of tree and is one of the six forest giants of Southwest Australia.",
      "es": "Eucalyptus gomphocephala comúnmente conocido como árbol tuart es una especie de árbol en el género Eucalyptus. Nativo del sudeste de Australia Occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species64"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 12
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusNitens",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus nitens"
    },
    "vulgarName": [
      {
        "en": "Shining gum"
      },
      {
        "es": "Eucalipto nitens"
      },
      {
        "fr": "Eucalyptus nitens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2512644",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_nitens",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_nitens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/f/f2/Eucalyptus_nitens_New_England_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/9/9c/Brown_Mountain_old_growth_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_nitens",
    "gbif": "https://www.gbif.org/species/3176336",
    "extract": {
      "en": "Eucalyptus nitens, commonly known as shining gum or silvertop, is a species of tall tree native to Victoria and eastern New South Wales. It has smooth greyish bark, sometimes with thin, rough bark near the base, lance-shaped adult leaves, flower buds in groups of seven or nine, white flowers and cup-shaped, barrel-shaped or cylindrical fruit. It grows in wet forests and rainforest margins on fertile soils in cool, high-rainfall areas.",
      "es": "Eucalyptus nitens, comúnmente conocido como el eucalipto brillante, es una especie nativa de Victoria y el este de Nueva Gales del Sur en Australia. Crece en los bosques húmedos templados y sus márgenes en suelos fértiles de áreas de clima fresco."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species264"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus162",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EucalyptusViminalis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Eucalyptus viminalis"
    },
    "vulgarName": [
      {
        "en": "Manna gum"
      },
      {
        "en": "Ribbon gum"
      },
      {
        "en": "Viminalis"
      },
      {
        "en": "White gum"
      },
      {
        "es": "Eucalipto viminalis"
      },
      {
        "de": "Rutenförmiger Eukalyptus"
      },
      {
        "fr": "Eucalyptus viminalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2137116",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Eucalyptus_viminalis",
      "es": "https://es.wikipedia.org/wiki/Eucalyptus_viminalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Eucalyptus_viminalis_habit.jpg/330px-Eucalyptus_viminalis_habit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Eucalyptus_globulus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-147.jpg/330px-Eucalyptus_globulus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-147.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Eucalyptus_viminalis",
    "gbif": "https://www.gbif.org/species/3177112",
    "extract": {
      "en": "Eucalyptus viminalis, commonly known as the manna gum, white gum or ribbon gum, is a species of small to very tall tree that is endemic to south-eastern Australia. It has smooth bark, sometimes with rough bark near the base, lance-shaped to curved adult leaves, flower buds in groups of three or seven, white flowers and cup-shaped or hemispherical fruit.",
      "es": "Eucalyptus viminalis es una especie fanerógama perteneciente a la familia de las mirtáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 24
      },
      "ifn3": {
        "count": 37
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
    "isGenus": 1,
    "scientificName": {
      "la": "Acacia"
    },
    "vulgarName": [
      {
        "de": "Acacia"
      },
      {
        "fr": "Acacia (genre)"
      },
      {
        "pt": "Acacia"
      },
      {
        "en": "Acacias"
      },
      {
        "es": "Acacias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q81666",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia",
      "es": "https://es.wikipedia.org/wiki/Acacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Acacia_baileyana_3%2C_Canberra_ACT.JPG/330px-Acacia_baileyana_3%2C_Canberra_ACT.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Acacia_dealbata.jpg/330px-Acacia_dealbata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia",
    "gbif": "https://www.gbif.org/species/2978223",
    "extract": {
      "en": "Acacia, commonly known as wattles or acacias, is a genus of about 1,084 species of shrubs and trees in the subfamily Mimosoideae of the pea family Fabaceae. Initially, it comprised a group of plant species native to Africa, South America, and Australasia, but is now reserved for species mainly from Australia, with others from New Guinea, Southeast Asia, and the Indian Ocean.",
      "es": "Acacia es un género de árboles de la familia Fabaceae. Se conoce con el nombre común de «acacia» muchos árboles leguminosos de este género y también de otros géneros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia"
    ],
    "nplots": {
      "ifn2": {
        "count": 24
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia"
    },
    "vulgarName": [
      {
        "en": "Acacia"
      },
      {
        "es": "Acacia"
      },
      {
        "de": "Acacia"
      },
      {
        "fr": "Acacia (genre)"
      },
      {
        "pt": "Acacia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q81666",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia",
      "es": "https://es.wikipedia.org/wiki/Acacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Acacia_baileyana_3%2C_Canberra_ACT.JPG/330px-Acacia_baileyana_3%2C_Canberra_ACT.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Acacia_dealbata.jpg/330px-Acacia_dealbata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia",
    "gbif": "https://www.gbif.org/species/2978223",
    "extract": {
      "en": "Acacia, commonly known as wattles or acacias, is a genus of about 1,084 species of shrubs and trees in the subfamily Mimosoideae of the pea family Fabaceae. Initially, it comprised a group of plant species native to Africa, South America, and Australasia, but is now reserved for species mainly from Australia, with others from New Guinea, Southeast Asia, and the Indian Ocean.",
      "es": "Acacia es un género de árboles de la familia Fabaceae. Se conoce con el nombre común de «acacia» muchos árboles leguminosos de este género y también de otros géneros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 24
      },
      "ifn3": {
        "count": 37
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia"
    },
    "vulgarName": [
      {
        "en": "Acacia"
      },
      {
        "es": "Acacia"
      },
      {
        "de": "Acacia"
      },
      {
        "fr": "Acacia (genre)"
      },
      {
        "pt": "Acacia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q81666",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia",
      "es": "https://es.wikipedia.org/wiki/Acacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Acacia_baileyana_3%2C_Canberra_ACT.JPG/330px-Acacia_baileyana_3%2C_Canberra_ACT.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Acacia_dealbata.jpg/330px-Acacia_dealbata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia",
    "gbif": "https://www.gbif.org/species/2978223",
    "extract": {
      "en": "Acacia, commonly known as wattles or acacias, is a genus of about 1,084 species of shrubs and trees in the subfamily Mimosoideae of the pea family Fabaceae. Initially, it comprised a group of plant species native to Africa, South America, and Australasia, but is now reserved for species mainly from Australia, with others from New Guinea, Southeast Asia, and the Indian Ocean.",
      "es": "Acacia es un género de árboles de la familia Fabaceae. Se conoce con el nombre común de «acacia» muchos árboles leguminosos de este género y también de otros géneros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia melanoxylon"
    },
    "vulgarName": [
      {
        "en": "Australian blackwood"
      },
      {
        "es": "Acacia melanoxylon"
      },
      {
        "fr": "Mimosa à bois noir"
      },
      {
        "pt": "Acacia melanoxylon"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q386585",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia_melanoxylon",
      "es": "https://es.wikipedia.org/wiki/Acacia_melanoxylon"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Acacia_melanoxylon.jpg/330px-Acacia_melanoxylon.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Acacia_melanoxylon_branch.jpg/330px-Acacia_melanoxylon_branch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia_melanoxylon",
    "gbif": "https://www.gbif.org/species/2979000",
    "extract": {
      "en": "Acacia melanoxylon, commonly known as the Australian blackwood, is an Acacia species native to south-eastern Australia and an invasive species in other regions of the globe. The species is also known as blackwood, hickory, mudgerabah, Tasmanian blackwood, or blackwood acacia. The tree belongs to the Plurinerves section of Acacia and is one of the most wide-ranging tree species in eastern Australia and is quite variable mostly in the size and shape of the phyllodes.",
      "es": "Acacia melanoxylon o también conocida como Racosperma melanoxylon,es una acacia, o acacia negra. Es una especie nativa del este de Australia. Conocida como \"madera negra de Tasmania\",. Los aborígenes la llaman mudgerabah. Este árbol, es de hoja perenne, se caracteriza por su rápido cremiento y puede crecer hasta más de 45 metros. Tiene una amplia tolerancia a la diversidad de ambientes, pero prospera mejor en climas fríos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia dealbata"
    },
    "vulgarName": [
      {
        "en": "Blue wattle"
      },
      {
        "en": "Mimosa"
      },
      {
        "en": "Silver wattle"
      },
      {
        "es": "Acacia dealbata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q757123",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia_dealbata",
      "es": "https://es.wikipedia.org/wiki/Acacia_dealbata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Acacia_dealbata-1.jpg/330px-Acacia_dealbata-1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Acacia_dealbata_tree_2.jpg/330px-Acacia_dealbata_tree_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia_dealbata",
    "gbif": "https://www.gbif.org/species/2979474",
    "extract": {
      "en": "Acacia dealbata, commonly known as silver wattle, blue wattle or mimosa, is a species of flowering plant in the legume family, Fabaceae. It is endemic to south-eastern mainland Australia but it can be found as an introduced or invasive species elsewhere. It is a bushy shrub or spreading tree with smooth bark, bluish grey or silvery and glaucous bipinnate leaves, spherical heads of yellow to bright yellow flowers, and straight to slightly curved pods. The Wiradjuri people of New South Wales use the name giigandul for the species.",
      "es": "Acacia dealbata, mimosa, acacia mimosa,  aromo francés, mimosa común, mimosa fina, mimosa plateada o acacia australiana es un árbol de la familia de las leguminosas (Fabaceae)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acacia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 37
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species7",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia"
    },
    "vulgarName": [
      {
        "en": "Acacia"
      },
      {
        "es": "Acacia"
      },
      {
        "de": "Acacia"
      },
      {
        "fr": "Acacia (genre)"
      },
      {
        "pt": "Acacia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q81666",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia",
      "es": "https://es.wikipedia.org/wiki/Acacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Acacia_baileyana_3%2C_Canberra_ACT.JPG/330px-Acacia_baileyana_3%2C_Canberra_ACT.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Acacia_dealbata.jpg/330px-Acacia_dealbata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia",
    "gbif": "https://www.gbif.org/species/2978223",
    "extract": {
      "en": "Acacia, commonly known as wattles or acacias, is a genus of about 1,084 species of shrubs and trees in the subfamily Mimosoideae of the pea family Fabaceae. Initially, it comprised a group of plant species native to Africa, South America, and Australasia, but is now reserved for species mainly from Australia, with others from New Guinea, Southeast Asia, and the Indian Ocean.",
      "es": "Acacia es un género de árboles de la familia Fabaceae. Se conoce con el nombre común de «acacia» muchos árboles leguminosos de este género y también de otros géneros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species307"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaDealbata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia dealbata"
    },
    "vulgarName": [
      {
        "en": "Blue wattle"
      },
      {
        "en": "Mimosa"
      },
      {
        "en": "Silver wattle"
      },
      {
        "es": "Acacia dealbata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q757123",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia_dealbata",
      "es": "https://es.wikipedia.org/wiki/Acacia_dealbata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Acacia_dealbata-1.jpg/330px-Acacia_dealbata-1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Acacia_dealbata_tree_2.jpg/330px-Acacia_dealbata_tree_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia_dealbata",
    "gbif": "https://www.gbif.org/species/2979474",
    "extract": {
      "en": "Acacia dealbata, commonly known as silver wattle, blue wattle or mimosa, is a species of flowering plant in the legume family, Fabaceae. It is endemic to south-eastern mainland Australia but it can be found as an introduced or invasive species elsewhere. It is a bushy shrub or spreading tree with smooth bark, bluish grey or silvery and glaucous bipinnate leaves, spherical heads of yellow to bright yellow flowers, and straight to slightly curved pods. The Wiradjuri people of New South Wales use the name giigandul for the species.",
      "es": "Acacia dealbata, mimosa, acacia mimosa,  aromo francés, mimosa común, mimosa fina, mimosa plateada o acacia australiana es un árbol de la familia de las leguminosas (Fabaceae)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species207"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus141",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcaciaMelanoxylon",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acacia melanoxylon"
    },
    "vulgarName": [
      {
        "en": "Australian blackwood"
      },
      {
        "es": "Acacia melanoxylon"
      },
      {
        "fr": "Mimosa à bois noir"
      },
      {
        "pt": "Acacia melanoxylon"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q386585",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acacia_melanoxylon",
      "es": "https://es.wikipedia.org/wiki/Acacia_melanoxylon"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Acacia_melanoxylon.jpg/330px-Acacia_melanoxylon.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Acacia_melanoxylon_branch.jpg/330px-Acacia_melanoxylon_branch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acacia_melanoxylon",
    "gbif": "https://www.gbif.org/species/2979000",
    "extract": {
      "en": "Acacia melanoxylon, commonly known as the Australian blackwood, is an Acacia species native to south-eastern Australia and an invasive species in other regions of the globe. The species is also known as blackwood, hickory, mudgerabah, Tasmanian blackwood, or blackwood acacia. The tree belongs to the Plurinerves section of Acacia and is one of the most wide-ranging tree species in eastern Australia and is quite variable mostly in the size and shape of the phyllodes.",
      "es": "Acacia melanoxylon o también conocida como Racosperma melanoxylon,es una acacia, o acacia negra. Es una especie nativa del este de Australia. Conocida como \"madera negra de Tasmania\",. Los aborígenes la llaman mudgerabah. Este árbol, es de hoja perenne, se caracteriza por su rápido cremiento y puede crecer hasta más de 45 metros. Tiene una amplia tolerancia a la diversidad de ambientes, pero prospera mejor en climas fríos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops"
    ],
    "nplots": {
      "ifn2": {
        "count": 6
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phoenix / Chamaerops"
    },
    "vulgarName": [
      {
        "en": "Palm tree"
      },
      {
        "es": "Palmera"
      },
      {
        "de": "Dattelpalmen"
      },
      {
        "fr": "Phoenix (palmier)"
      },
      {
        "pt": "Phoenix (género)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27685",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_(plant)",
      "es": "https://es.wikipedia.org/wiki/Phoenix_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Phoenix_dactylifera100_4209.JPG/330px-Phoenix_dactylifera100_4209.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Phoenix_canariensis.jpg/330px-Phoenix_canariensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix",
    "gbif": "https://www.gbif.org/species/2732076",
    "extract": {
      "en": "Phoenix is a genus of 14 species of palms, native to an area starting from the Canary Islands in the west, across northern and central Africa, to the extreme southeast of Europe (Crete), and continuing throughout southern Asia, from Anatolia east to southern China and Malaysia. The diverse habitats they occupy include swamps, deserts, and mangrove sea coasts. Most Phoenix species originate in semi-arid regions, but usually occur near high groundwater levels, rivers, or springs. The genus is unusual among members of subfamily Coryphoideae in having pinnate, rather than palmate leaves; tribe Caryoteae also have pinnate or bipinnate leaves.\nThe palms were more numerous and widespread in the past than they are at present. Some Phoenix palms have become naturalised in other parts of the world; in particular, the date palm's long history of cultivation means that escaped plants in the past have long-since become ingrained into the native ecosystems of countries far from its original range in the Middle East.",
      "es": "Phoenix es un género con once especies de plantas con flores perteneciente a la familia de las palmeras (Arecaceae), distribuidas desde Canarias, pasando por el norte de África y el Sur de Asia, hasta el Extremo Oriente. Es el único género de la tribu Phoeniceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 6
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phoenix / Chamaerops"
    },
    "vulgarName": [
      {
        "en": "Palm tree"
      },
      {
        "es": "Palmera"
      },
      {
        "de": "Dattelpalmen"
      },
      {
        "fr": "Phoenix (palmier)"
      },
      {
        "pt": "Phoenix (género)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27685",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_(plant)",
      "es": "https://es.wikipedia.org/wiki/Phoenix_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Phoenix_dactylifera100_4209.JPG/330px-Phoenix_dactylifera100_4209.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Phoenix_canariensis.jpg/330px-Phoenix_canariensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix",
    "gbif": "https://www.gbif.org/species/2732076",
    "extract": {
      "en": "Phoenix is a genus of 14 species of palms, native to an area starting from the Canary Islands in the west, across northern and central Africa, to the extreme southeast of Europe (Crete), and continuing throughout southern Asia, from Anatolia east to southern China and Malaysia. The diverse habitats they occupy include swamps, deserts, and mangrove sea coasts. Most Phoenix species originate in semi-arid regions, but usually occur near high groundwater levels, rivers, or springs. The genus is unusual among members of subfamily Coryphoideae in having pinnate, rather than palmate leaves; tribe Caryoteae also have pinnate or bipinnate leaves.\nThe palms were more numerous and widespread in the past than they are at present. Some Phoenix palms have become naturalised in other parts of the world; in particular, the date palm's long history of cultivation means that escaped plants in the past have long-since become ingrained into the native ecosystems of countries far from its original range in the Middle East.",
      "es": "Phoenix es un género con once especies de plantas con flores perteneciente a la familia de las palmeras (Arecaceae), distribuidas desde Canarias, pasando por el norte de África y el Sur de Asia, hasta el Extremo Oriente. Es el único género de la tribu Phoeniceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
    "isGenus": 1,
    "scientificName": {
      "la": "Chamaerops"
    },
    "vulgarName": [
      {
        "de": "Zwergpalme"
      },
      {
        "fr": "Chamaerops humilis"
      },
      {
        "pt": "Chamaerops"
      },
      {
        "en": "Fan palms"
      },
      {
        "es": "Palmas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3666051",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaerops"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Chamaerops_humilis_%28Zingaro%29015.jpg/330px-Chamaerops_humilis_%28Zingaro%29015.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaerops",
    "gbif": "https://www.gbif.org/species/2736624",
    "extract": {
      "en": "Chamaerops is a genus of flowering plants in the family Arecaceae. It contains only one species, Chamaerops humilis, variously called European fan palm or the Mediterranean dwarf palm. It is one of the most cold-hardy palms and is used in landscaping in temperate climates."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
    "isGenus": 1,
    "scientificName": {
      "la": "Phoenix"
    },
    "vulgarName": [
      {
        "de": "Dattelpalmen"
      },
      {
        "fr": "Phoenix (palmier)"
      },
      {
        "pt": "Phoenix (género)"
      },
      {
        "es": "Palmas"
      },
      {
        "en": "Palms"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27685",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_(plant)",
      "es": "https://es.wikipedia.org/wiki/Phoenix_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Phoenix_dactylifera100_4209.JPG/330px-Phoenix_dactylifera100_4209.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Phoenix_canariensis.jpg/330px-Phoenix_canariensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix",
    "gbif": "https://www.gbif.org/species/2732076",
    "extract": {
      "en": "Phoenix is a genus of 14 species of palms, native to an area starting from the Canary Islands in the west, across northern and central Africa, to the extreme southeast of Europe (Crete), and continuing throughout southern Asia, from Anatolia east to southern China and Malaysia. The diverse habitats they occupy include swamps, deserts, and mangrove sea coasts. Most Phoenix species originate in semi-arid regions, but usually occur near high groundwater levels, rivers, or springs. The genus is unusual among members of subfamily Coryphoideae in having pinnate, rather than palmate leaves; tribe Caryoteae also have pinnate or bipinnate leaves.\nThe palms were more numerous and widespread in the past than they are at present. Some Phoenix palms have become naturalised in other parts of the world; in particular, the date palm's long history of cultivation means that escaped plants in the past have long-since become ingrained into the native ecosystems of countries far from its original range in the Middle East.",
      "es": "Phoenix es un género con once especies de plantas con flores perteneciente a la familia de las palmeras (Arecaceae), distribuidas desde Canarias, pasando por el norte de África y el Sur de Asia, hasta el Extremo Oriente. Es el único género de la tribu Phoeniceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Lauraceae"
    },
    "vulgarName": [
      {
        "es": "Laurisilva"
      },
      {
        "es": "Otras laurisilvas"
      },
      {
        "de": "Lorbeerwald"
      },
      {
        "fr": "Laurisylve"
      },
      {
        "pt": "Laurissilva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5971845"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "nplots": {
      "ifn2": {
        "count": 26
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Lauraceae"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
    "isGenus": 1,
    "scientificName": {
      "la": "Apollonias"
    },
    "vulgarName": [
      {
        "en": "Apollonias"
      },
      {
        "es": "Barbuzanos"
      },
      {
        "pt": "Apollonias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q619345"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 130
      },
      "ifn3": {
        "count": 190
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
    "isGenus": 1,
    "scientificName": {
      "la": "Laurus"
    },
    "vulgarName": [
      {
        "es": "Laureles"
      },
      {
        "en": "Laurels"
      },
      {
        "de": "Lorbeeren"
      },
      {
        "fr": "Laurus"
      },
      {
        "pt": "Laurus"
      }
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
    "isGenus": 1,
    "scientificName": {
      "la": "Ocotea"
    },
    "vulgarName": [
      {
        "en": "Ocoteas"
      },
      {
        "es": "Ocoteas"
      },
      {
        "fr": "Ocotea"
      },
      {
        "pt": "Ocotea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3305677",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ocotea",
      "es": "https://es.wikipedia.org/wiki/Ocotea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ocotea_foetens_1322.jpg/330px-Ocotea_foetens_1322.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Ocotea_foetens.JPG/330px-Ocotea_foetens.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ocotea",
    "gbif": "https://www.gbif.org/species/3034076",
    "extract": {
      "en": "Ocotea is a genus of flowering plants belonging to the family Lauraceae. Many are evergreen trees with lauroid leaves.",
      "es": "Ocotea es un género de fanerógamas de la familia Lauraceae, incluyendo más de 200 especies de árboles y arbustos siempreverdes, distribuidos mayormente en regiones tropical y subtropical de Centro y Sudamérica, las Indias Occidentales, con algunas especies en África: Madagascar, y una, Ocotea foetens, nativa de las islas de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 43
      },
      "ifn3": {
        "count": 59
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
    "isGenus": 1,
    "scientificName": {
      "la": "Persea"
    },
    "vulgarName": [
      {
        "en": "Perseas"
      },
      {
        "es": "Perseas"
      },
      {
        "de": "Persea"
      },
      {
        "fr": "Persea"
      },
      {
        "pt": "Persea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132039",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Persea",
      "es": "https://es.wikipedia.org/wiki/Persea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Vi%C3%B1%C3%A1tigo_hojas.JPG/330px-Vi%C3%B1%C3%A1tigo_hojas.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Persea_americana_flowers_3.JPG/330px-Persea_americana_flowers_3.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Persea",
    "gbif": "https://www.gbif.org/species/3034041",
    "extract": {
      "en": "Persea is a genus of about 111 species of evergreen trees belonging to the laurel family, Lauraceae. The best-known member of the genus is the avocado, P. americana, widely cultivated in subtropical regions for its large, edible fruit.",
      "es": "Persea es un género de alrededor de 100 especies aceptadas, de las casi 400 descritas, de árboles perennifolios de la familia Lauraceae. El miembro más conocido es el aguacate o palto, muy cultivado en regiones subtropicales por sus frutos comestibles."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 26
      },
      "ifn3": {
        "count": 55
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Lauraceae"
    },
    "vulgarName": [
      {
        "es": "Laurisilva"
      },
      {
        "es": "Otras laurisilvas"
      },
      {
        "de": "Lorbeerwald"
      },
      {
        "fr": "Laurisylve"
      },
      {
        "pt": "Laurissilva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5971845"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species80",
    "isFamily": 1,
    "scientificName": {
      "nolang": "Lauraceae"
    },
    "vulgarName": [
      {
        "es": "Laurisilva"
      },
      {
        "de": "Lorbeerwald"
      },
      {
        "fr": "Laurisylve"
      },
      {
        "pt": "Laurissilva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5971845"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Lauraceae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 55
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species89",
    "isFamily": 1,
    "scientificName": {
      "nolang": "Lauraceae"
    },
    "vulgarName": [
      {
        "es": "Otras laurisilvas"
      },
      {
        "de": "Lorbeerwald"
      },
      {
        "fr": "Laurisylve"
      },
      {
        "pt": "Laurissilva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5971845"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 200
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
    "isGenus": 1,
    "scientificName": {
      "la": "Ulmus"
    },
    "vulgarName": [
      {
        "es": "Olmos"
      },
      {
        "en": "Elms"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131113",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Elm",
      "es": "https://es.wikipedia.org/wiki/Ulmus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/East_Coker_elm%2C_2.jpg/330px-East_Coker_elm%2C_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/e/eb/Mature_Ulmus_rubra_in_graveyard.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus",
    "gbif": "https://www.gbif.org/species/2984510",
    "extract": {
      "en": "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distributed over most of the Northern Hemisphere, inhabiting the temperate and tropical-montane regions of North America and Eurasia, ranging southward in Western Asia to Iran, in Africa to Libya, and in Southeast Asia into Indonesia.",
      "es": "Ulmus es un género de plantas perteneciente a la familia Ulmaceae, cuyos árboles son conocidos comúnmente como olmos. Tiene unos 40 taxones aceptados de los más de 300 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus"
    ],
    "nplots": {
      "ifn2": {
        "count": 200
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus"
    },
    "vulgarName": [
      {
        "en": "Elm"
      },
      {
        "es": "Olmo"
      },
      {
        "fr": "Orme"
      },
      {
        "pt": "Ulmeiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131113",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Elm",
      "es": "https://es.wikipedia.org/wiki/Ulmus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/East_Coker_elm%2C_2.jpg/330px-East_Coker_elm%2C_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/e/eb/Mature_Ulmus_rubra_in_graveyard.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus",
    "gbif": "https://www.gbif.org/species/2984510",
    "extract": {
      "en": "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distributed over most of the Northern Hemisphere, inhabiting the temperate and tropical-montane regions of North America and Eurasia, ranging southward in Western Asia to Iran, in Africa to Libya, and in Southeast Asia into Indonesia.",
      "es": "Ulmus es un género de plantas perteneciente a la familia Ulmaceae, cuyos árboles son conocidos comúnmente como olmos. Tiene unos 40 taxones aceptados de los más de 300 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 200
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus"
    },
    "vulgarName": [
      {
        "en": "Elm"
      },
      {
        "es": "Olmo"
      },
      {
        "fr": "Orme"
      },
      {
        "pt": "Ulmeiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131113",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Elm",
      "es": "https://es.wikipedia.org/wiki/Ulmus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/East_Coker_elm%2C_2.jpg/330px-East_Coker_elm%2C_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/e/eb/Mature_Ulmus_rubra_in_graveyard.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus",
    "gbif": "https://www.gbif.org/species/2984510",
    "extract": {
      "en": "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distributed over most of the Northern Hemisphere, inhabiting the temperate and tropical-montane regions of North America and Eurasia, ranging southward in Western Asia to Iran, in Africa to Libya, and in Southeast Asia into Indonesia.",
      "es": "Ulmus es un género de plantas perteneciente a la familia Ulmaceae, cuyos árboles son conocidos comúnmente como olmos. Tiene unos 40 taxones aceptados de los más de 300 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus glabra"
    },
    "vulgarName": [
      {
        "en": "Scotch elm"
      },
      {
        "en": "Scots elm"
      },
      {
        "en": "Wych elm"
      },
      {
        "es": "Olmo montano"
      },
      {
        "de": "Bergulme"
      },
      {
        "fr": "Orme de montagne"
      },
      {
        "pt": "Ulmus glabra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147498",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_glabra",
      "es": "https://es.wikipedia.org/wiki/Ulmus_glabra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/RN_Ulmus_glabra_%28alnarp_sweden%29.jpg/330px-RN_Ulmus_glabra_%28alnarp_sweden%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Ulmus_glabra_horizontalis.jpg/330px-Ulmus_glabra_horizontalis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_glabra",
    "gbif": "https://www.gbif.org/species/5361866",
    "extract": {
      "en": "Ulmus glabra, the wych elm or Scots elm, has the widest range of the European elm species, from Ireland eastwards to the Ural Mountains, and from the Arctic Circle south to the mountains of the Peloponnese and Sicily, where the species reaches its southern limit in Europe; it is also native to the Caucasus region and parts of Western Asia. A large deciduous tree, it is essentially a montane species, growing at altitudes up to 1,500 m (5,000 ft), preferring sites with moist soils and high humidity. The tree can form pure forests in Scandinavia and occurs as far north as latitude 67°N at Beiarn Municipality in Norway. It has been successfully introduced as far north as Tromsø and Alta in northern Norway (70°N). It has also been successfully introduced to Narsarsuaq, near the southern tip of Greenland (61°N).",
      "es": "El olmo montano, olmo de monte u olmo de montaña, entre otros, es un árbol de la familia de las ulmáceas, típico de las montañas de toda Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus pumila"
    },
    "vulgarName": [
      {
        "en": "Siberian elm"
      },
      {
        "es": "Olmo de Siberia"
      },
      {
        "de": "Sibirische Ulme"
      },
      {
        "fr": "Ulmus pumila"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1079824",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_pumila",
      "es": "https://es.wikipedia.org/wiki/Ulmus_pumila"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Image-Ulmus_pumila_%28Ulmus_gobicus%29_in_Gobi_Desert.jpg/330px-Image-Ulmus_pumila_%28Ulmus_gobicus%29_in_Gobi_Desert.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Ulmus_pumila.jpg/330px-Ulmus_pumila.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_pumila",
    "gbif": "https://www.gbif.org/species/5361877",
    "extract": {
      "en": "Ulmus pumila, the Siberian elm, is a tree native to Asia. It is also known as the Asiatic elm and dwarf elm, but sometimes mistakenly called the \"Chinese\" elm. U. pumila has been widely cultivated throughout Asia, North America, Argentina, and southern Europe, becoming naturalized in many places, notably across much of the United States.",
      "es": "El olmo de Siberia es una especie arbórea del género Ulmus de la familia Ulmaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus minor"
    },
    "vulgarName": [
      {
        "es": "Olmo"
      },
      {
        "en": "Field elm"
      },
      {
        "de": "Feldulme"
      },
      {
        "fr": "Orme champêtre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147487",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_minor",
      "es": "https://es.wikipedia.org/wiki/Ulmus_minor"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Blismes_elm_2007.jpg/330px-Blismes_elm_2007.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_minor",
    "gbif": "https://www.gbif.org/species/5361865",
    "extract": {
      "en": "Ulmus minor Mill., the field elm, is by far the most polymorphic of the European species, although its taxonomy remains a matter of contention. Its natural range is predominantly south European, extending to Asia Minor and Iran; its northern outposts are the Baltic islands of Öland and Gotland, although it may have been introduced by humans. The tree's typical habitat is low-lying forest along the main rivers, growing in association with oak and ash, where it tolerates summer floods as well as droughts.",
      "es": "Ulmus minor, el olmo común o negrillo, es una especie de árbol perteneciente a la familia Ulmaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Ulmus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species956",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus"
    },
    "vulgarName": [
      {
        "en": "Elm"
      },
      {
        "es": "Olmo"
      },
      {
        "fr": "Orme"
      },
      {
        "pt": "Ulmeiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131113",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Elm",
      "es": "https://es.wikipedia.org/wiki/Ulmus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/East_Coker_elm%2C_2.jpg/330px-East_Coker_elm%2C_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/e/eb/Mature_Ulmus_rubra_in_graveyard.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus",
    "gbif": "https://www.gbif.org/species/2984510",
    "extract": {
      "en": "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distributed over most of the Northern Hemisphere, inhabiting the temperate and tropical-montane regions of North America and Eurasia, ranging southward in Western Asia to Iran, in Africa to Libya, and in Southeast Asia into Indonesia.",
      "es": "Ulmus es un género de plantas perteneciente a la familia Ulmaceae, cuyos árboles son conocidos comúnmente como olmos. Tiene unos 40 taxones aceptados de los más de 300 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species256"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusGlabra",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus glabra"
    },
    "vulgarName": [
      {
        "en": "Scotch elm"
      },
      {
        "en": "Scots elm"
      },
      {
        "en": "Wych elm"
      },
      {
        "es": "Olmo montano"
      },
      {
        "de": "Bergulme"
      },
      {
        "fr": "Orme de montagne"
      },
      {
        "pt": "Ulmus glabra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147498",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_glabra",
      "es": "https://es.wikipedia.org/wiki/Ulmus_glabra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/RN_Ulmus_glabra_%28alnarp_sweden%29.jpg/330px-RN_Ulmus_glabra_%28alnarp_sweden%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Ulmus_glabra_horizontalis.jpg/330px-Ulmus_glabra_horizontalis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_glabra",
    "gbif": "https://www.gbif.org/species/5361866",
    "extract": {
      "en": "Ulmus glabra, the wych elm or Scots elm, has the widest range of the European elm species, from Ireland eastwards to the Ural Mountains, and from the Arctic Circle south to the mountains of the Peloponnese and Sicily, where the species reaches its southern limit in Europe; it is also native to the Caucasus region and parts of Western Asia. A large deciduous tree, it is essentially a montane species, growing at altitudes up to 1,500 m (5,000 ft), preferring sites with moist soils and high humidity. The tree can form pure forests in Scandinavia and occurs as far north as latitude 67°N at Beiarn Municipality in Norway. It has been successfully introduced as far north as Tromsø and Alta in northern Norway (70°N). It has also been successfully introduced to Narsarsuaq, near the southern tip of Greenland (61°N).",
      "es": "El olmo montano, olmo de monte u olmo de montaña, entre otros, es un árbol de la familia de las ulmáceas, típico de las montañas de toda Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species56"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusMinor",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus minor"
    },
    "vulgarName": [
      {
        "es": "Olmo"
      },
      {
        "en": "Field elm"
      },
      {
        "de": "Feldulme"
      },
      {
        "fr": "Orme champêtre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147487",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_minor",
      "es": "https://es.wikipedia.org/wiki/Ulmus_minor"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Blismes_elm_2007.jpg/330px-Blismes_elm_2007.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_minor",
    "gbif": "https://www.gbif.org/species/5361865",
    "extract": {
      "en": "Ulmus minor Mill., the field elm, is by far the most polymorphic of the European species, although its taxonomy remains a matter of contention. Its natural range is predominantly south European, extending to Asia Minor and Iran; its northern outposts are the Baltic islands of Öland and Gotland, although it may have been introduced by humans. The tree's typical habitat is low-lying forest along the main rivers, growing in association with oak and ash, where it tolerates summer floods as well as droughts.",
      "es": "Ulmus minor, el olmo común o negrillo, es una especie de árbol perteneciente a la familia Ulmaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species356"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus111",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/UlmusPumila",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ulmus pumila"
    },
    "vulgarName": [
      {
        "en": "Siberian elm"
      },
      {
        "es": "Olmo de Siberia"
      },
      {
        "de": "Sibirische Ulme"
      },
      {
        "fr": "Ulmus pumila"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1079824",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ulmus_pumila",
      "es": "https://es.wikipedia.org/wiki/Ulmus_pumila"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Image-Ulmus_pumila_%28Ulmus_gobicus%29_in_Gobi_Desert.jpg/330px-Image-Ulmus_pumila_%28Ulmus_gobicus%29_in_Gobi_Desert.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Ulmus_pumila.jpg/330px-Ulmus_pumila.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ulmus_pumila",
    "gbif": "https://www.gbif.org/species/5361877",
    "extract": {
      "en": "Ulmus pumila, the Siberian elm, is a tree native to Asia. It is also known as the Asiatic elm and dwarf elm, but sometimes mistakenly called the \"Chinese\" elm. U. pumila has been widely cultivated throughout Asia, North America, Argentina, and southern Europe, becoming naturalized in many places, notably across much of the United States.",
      "es": "El olmo de Siberia es una especie arbórea del género Ulmus de la familia Ulmaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3544
      },
      "ifn3": {
        "count": 4233
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
    "isGenus": 1,
    "scientificName": {
      "la": "Fagus"
    },
    "vulgarName": [
      {
        "en": "Beechs"
      },
      {
        "es": "Hayas"
      },
      {
        "de": "Buchen"
      },
      {
        "fr": "Fagus"
      },
      {
        "pt": "Fagus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25403",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Beech",
      "es": "https://es.wikipedia.org/wiki/Fagus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Beech-tree.JPG/330px-Beech-tree.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Fagus_sylvatica_Purpurea_JPG4a.jpg/330px-Fagus_sylvatica_Purpurea_JPG4a.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fagus",
    "gbif": "https://www.gbif.org/species/2874875",
    "extract": {
      "en": "Beech is a genus of deciduous trees in the family Fagaceae, native to subtropical and temperate Eurasia and North America. There are 14 accepted species in two distinct subgenera, Englerianae Denk & G.W.Grimm and Fagus. The subgenus Englerianae is found only in East Asia, distinctive for its low branches, often made up of several major trunks with yellowish bark. The better known species of subgenus Fagus are native to Europe, western and eastern Asia and eastern North America.",
      "es": "Fagus es un género de árboles caducifolios de la familia de las fagáceas, nativos de las zonas templadas de Europa, Asia y Norteamérica, llamados comúnmente hayas. Tiene diez especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica"
    ],
    "nplots": {
      "ifn2": {
        "count": 3544
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fagus sylvatica"
    },
    "vulgarName": [
      {
        "es": "Haya"
      },
      {
        "en": "Common beech"
      },
      {
        "en": "European beech"
      },
      {
        "de": "Rotbuche"
      },
      {
        "fr": "Hêtre commun"
      },
      {
        "pt": "Fagus sylvatica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146149",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fagus_sylvatica",
      "es": "https://es.wikipedia.org/wiki/Fagus_sylvatica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Fagus-sylvatica-cansiglio-forest-italy.jpg/330px-Fagus-sylvatica-cansiglio-forest-italy.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Illustration_Fagus_sylvatica0.jpg/330px-Illustration_Fagus_sylvatica0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fagus_sylvatica",
    "gbif": "https://www.gbif.org/species/2882316",
    "extract": {
      "en": "Fagus sylvatica, the European beech or common beech, is a large deciduous tree in the beech family with smooth silvery-grey bark, large leaf area, and a short trunk with low branches. It is native to much of Europe, growing in humid climates.",
      "es": "Fagus sylvatica, el haya común, es un árbol caducifolio de la familia de las fagáceas. A los bosques de hayas se les llama hayedos o hayales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3544
      },
      "ifn3": {
        "count": 4233
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fagus sylvatica"
    },
    "vulgarName": [
      {
        "es": "Haya"
      },
      {
        "en": "Common beech"
      },
      {
        "en": "European beech"
      },
      {
        "de": "Rotbuche"
      },
      {
        "fr": "Hêtre commun"
      },
      {
        "pt": "Fagus sylvatica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146149",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fagus_sylvatica",
      "es": "https://es.wikipedia.org/wiki/Fagus_sylvatica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Fagus-sylvatica-cansiglio-forest-italy.jpg/330px-Fagus-sylvatica-cansiglio-forest-italy.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Illustration_Fagus_sylvatica0.jpg/330px-Illustration_Fagus_sylvatica0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fagus_sylvatica",
    "gbif": "https://www.gbif.org/species/2882316",
    "extract": {
      "en": "Fagus sylvatica, the European beech or common beech, is a large deciduous tree in the beech family with smooth silvery-grey bark, large leaf area, and a short trunk with low branches. It is native to much of Europe, growing in humid climates.",
      "es": "Fagus sylvatica, el haya común, es un árbol caducifolio de la familia de las fagáceas. A los bosques de hayas se les llama hayedos o hayales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus122",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FagusSylvatica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 4233
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species71",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fagus sylvatica"
    },
    "vulgarName": [
      {
        "es": "Haya"
      },
      {
        "en": "Common beech"
      },
      {
        "en": "European beech"
      },
      {
        "de": "Rotbuche"
      },
      {
        "fr": "Hêtre commun"
      },
      {
        "pt": "Fagus sylvatica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146149",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fagus_sylvatica",
      "es": "https://es.wikipedia.org/wiki/Fagus_sylvatica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Fagus-sylvatica-cansiglio-forest-italy.jpg/330px-Fagus-sylvatica-cansiglio-forest-italy.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Illustration_Fagus_sylvatica0.jpg/330px-Illustration_Fagus_sylvatica0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fagus_sylvatica",
    "gbif": "https://www.gbif.org/species/2882316",
    "extract": {
      "en": "Fagus sylvatica, the European beech or common beech, is a large deciduous tree in the beech family with smooth silvery-grey bark, large leaf area, and a short trunk with low branches. It is native to much of Europe, growing in humid climates.",
      "es": "Fagus sylvatica, el haya común, es un árbol caducifolio de la familia de las fagáceas. A los bosques de hayas se les llama hayedos o hayales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2364
      },
      "ifn3": {
        "count": 2626
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
    "isGenus": 1,
    "scientificName": {
      "la": "Castanea"
    },
    "vulgarName": [
      {
        "es": "Castaños"
      },
      {
        "en": "Chestnuts"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q15635070",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Castanea_(journal)",
      "es": "https://es.wikipedia.org/wiki/Castanea;_Journal_of_the_Southern_Appalachian_Botanical_Club"
    },
    "images": [],
    "wikispecies": "https://species.wikimedia.org/wiki/ISSN_0008-7475",
    "extract": {
      "en": "Castanea, The Journal of the Southern Appalachian Botanical Society, is a biannual, peer-reviewed scientific journal published by the Southern Appalachian Botanical Society. It was established in 1936 and covers the botany of the eastern United States, in particular systematics, floristics, ecology, physiology, and biochemistry. The journal name Castanea comes from the genus of chestnuts that were fresh in the minds of the founders of the society when the journal was established; the chestnut blight ravaged the American Chestnut, Castanea dentata, in the early part of the twentieth century and drastically changed the plant communities of the Appalachians.",
      "es": "Castanea; Journal of the Southern Appalachian Botanical Club es una revista con ilustraciones y descripciones botánicas que es editada en Morgantown desde el año 1936."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 2626
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Castanea sativa"
    },
    "vulgarName": [
      {
        "es": "Castaño"
      },
      {
        "en": "Sweet chestnut"
      },
      {
        "de": "Edelkastanie"
      },
      {
        "fr": "Castanea sativa"
      },
      {
        "pt": "Castanea sativa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q22699",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sweet_chestnut",
      "es": "https://es.wikipedia.org/wiki/Castanea_sativa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Chestnuts.jpg/330px-Chestnuts.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Castanea_sativa_001.jpg/330px-Castanea_sativa_001.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Castanea_sativa",
    "gbif": "https://www.gbif.org/species/5333294",
    "extract": {
      "en": "The sweet chestnut, also known as the Spanish chestnut or European chestnut, is a species of tree in the family Fagaceae, native to Southern Europe and Anatolia, and widely cultivated in Western and Central Europe. A substantial, long-lived deciduous tree, it produces an edible seed, the chestnut, which has been used in cooking since ancient times.",
      "es": "El castaño es un árbol que pertenece a la familia de las fagáceas, cuyo fruto, la castaña, es comestible y fue una importante fuente alimenticia, en particular en algunas regiones del sur de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa"
    ],
    "nplots": {
      "ifn2": {
        "count": 2364
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Castanea sativa"
    },
    "vulgarName": [
      {
        "es": "Castaño"
      },
      {
        "en": "Sweet chestnut"
      },
      {
        "de": "Edelkastanie"
      },
      {
        "fr": "Castanea sativa"
      },
      {
        "pt": "Castanea sativa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q22699",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sweet_chestnut",
      "es": "https://es.wikipedia.org/wiki/Castanea_sativa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Chestnuts.jpg/330px-Chestnuts.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Castanea_sativa_001.jpg/330px-Castanea_sativa_001.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Castanea_sativa",
    "gbif": "https://www.gbif.org/species/5333294",
    "extract": {
      "en": "The sweet chestnut, also known as the Spanish chestnut or European chestnut, is a species of tree in the family Fagaceae, native to Southern Europe and Anatolia, and widely cultivated in Western and Central Europe. A substantial, long-lived deciduous tree, it produces an edible seed, the chestnut, which has been used in cooking since ancient times.",
      "es": "El castaño es un árbol que pertenece a la familia de las fagáceas, cuyo fruto, la castaña, es comestible y fue una importante fuente alimenticia, en particular en algunas regiones del sur de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species72",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species72"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus123",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2364
      },
      "ifn3": {
        "count": 2626
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CastaneaSativa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Castanea sativa"
    },
    "vulgarName": [
      {
        "es": "Castaño"
      },
      {
        "en": "Sweet chestnut"
      },
      {
        "de": "Edelkastanie"
      },
      {
        "fr": "Castanea sativa"
      },
      {
        "pt": "Castanea sativa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q22699",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sweet_chestnut",
      "es": "https://es.wikipedia.org/wiki/Castanea_sativa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Chestnuts.jpg/330px-Chestnuts.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Castanea_sativa_001.jpg/330px-Castanea_sativa_001.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Castanea_sativa",
    "gbif": "https://www.gbif.org/species/5333294",
    "extract": {
      "en": "The sweet chestnut, also known as the Spanish chestnut or European chestnut, is a species of tree in the family Fagaceae, native to Southern Europe and Anatolia, and widely cultivated in Western and Central Europe. A substantial, long-lived deciduous tree, it produces an edible seed, the chestnut, which has been used in cooking since ancient times.",
      "es": "El castaño es un árbol que pertenece a la familia de las fagáceas, cuyo fruto, la castaña, es comestible y fue una importante fuente alimenticia, en particular en algunas regiones del sur de Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 750
      },
      "ifn3": {
        "count": 638
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
    "isGenus": 1,
    "scientificName": {
      "la": "Populus"
    },
    "vulgarName": [
      {
        "es": "Chopos"
      },
      {
        "en": "Poplars"
      },
      {
        "de": "Pappeln"
      },
      {
        "pt": "Populus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25356",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus",
      "es": "https://es.wikipedia.org/wiki/Populus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Lapo_gyslos.jpeg/330px-Lapo_gyslos.jpeg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Illustration_Populus_nigra0.jpg/330px-Illustration_Populus_nigra0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus",
    "gbif": "https://www.gbif.org/species/3040183",
    "extract": {
      "en": "Populus is a genus of 25–30 species of deciduous flowering plants in the family Salicaceae, native to most of the Northern Hemisphere. English names variously applied to different species include poplar, aspen, and cottonwood.",
      "es": "El género Populus comprende unas cuarenta especies de árboles y arbolillos que habitan en zonas templadas y frías del hemisferio norte, comúnmente conocidos como álamos o chopos. Su aparición se remonta al Cretáceo inferior, con una notable expansión en el Terciario. Pertenece a la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 12
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus alba"
    },
    "vulgarName": [
      {
        "en": "Abele"
      },
      {
        "en": "Silver poplar"
      },
      {
        "en": "Silverleaf poplar"
      },
      {
        "en": "White poplar"
      },
      {
        "es": "Álamo"
      },
      {
        "de": "Silber-Pappel"
      },
      {
        "fr": "Populus alba"
      },
      {
        "pt": "Populus alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146269",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_alba",
      "es": "https://es.wikipedia.org/wiki/Populus_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Populus_alba_001.JPG/330px-Populus_alba_001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Populus_alba_01.jpg/330px-Populus_alba_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_alba",
    "gbif": "https://www.gbif.org/species/3040233",
    "extract": {
      "en": "Populus alba, commonly called silver poplar, silverleaf poplar, white poplar, or abele is a species of poplar, most closely related to the aspens. It is native to a region spanning from the Atlas Mountains of Africa, through most of South and Central Europe, into Central Asia; it has been introduced to many temperate, moist regions worldwide. It grows in moist sites, often by watersides, in regions with hot summers and cold to mild winters.",
      "es": "Populus alba, el álamo blanco, álamo común o chopo blanco es un árbol de fronda perteneciente a las salicáceas. Otros nombres comunes o vulgares de esta especie son: álamo plateado o álamo afgano."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula"
    ],
    "nplots": {
      "ifn2": {
        "count": 140
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus tremula"
    },
    "vulgarName": [
      {
        "en": "Common Aspen"
      },
      {
        "es": "Chopo temblón"
      },
      {
        "de": "Espe"
      },
      {
        "fr": "Tremble"
      },
      {
        "pt": "Populus tremula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146110",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_tremula",
      "es": "https://es.wikipedia.org/wiki/Populus_tremula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/PopulusTremula001.JPG/330px-PopulusTremula001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg/330px-Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_tremula",
    "gbif": "https://www.gbif.org/species/3040249",
    "extract": {
      "en": "Populus tremula is a species of poplar native to cool temperate regions of the Old World.",
      "es": "Populus tremula, el álamo temblón, chopo temblón o lamparilla es un árbol de fronda perteneciente a la familia de las salicáceas, que se distingue de otras especies emparentadas por los largos pedúnculos que se mueven con el viento y le dan su nombre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 604
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus nigra / Populus x canadensis"
    },
    "vulgarName": [
      {
        "en": "Black poplar"
      },
      {
        "en": "Canadian poplar"
      },
      {
        "en": "Carolina poplar"
      },
      {
        "en": "Hybrid poplar"
      },
      {
        "es": "Chopo"
      },
      {
        "es": "Chopo híbrido"
      },
      {
        "de": "Schwarz-Pappel"
      },
      {
        "fr": "Peuplier noir"
      },
      {
        "pt": "Populus nigra"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q147064",
      "http://www.wikidata.org/entity/Q149622"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 12
      },
      "ifn3": {
        "count": 27
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus alba"
    },
    "vulgarName": [
      {
        "en": "Abele"
      },
      {
        "en": "Silver poplar"
      },
      {
        "en": "Silverleaf poplar"
      },
      {
        "en": "White poplar"
      },
      {
        "es": "Álamo"
      },
      {
        "de": "Silber-Pappel"
      },
      {
        "fr": "Populus alba"
      },
      {
        "pt": "Populus alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146269",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_alba",
      "es": "https://es.wikipedia.org/wiki/Populus_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Populus_alba_001.JPG/330px-Populus_alba_001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Populus_alba_01.jpg/330px-Populus_alba_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_alba",
    "gbif": "https://www.gbif.org/species/3040233",
    "extract": {
      "en": "Populus alba, commonly called silver poplar, silverleaf poplar, white poplar, or abele is a species of poplar, most closely related to the aspens. It is native to a region spanning from the Atlas Mountains of Africa, through most of South and Central Europe, into Central Asia; it has been introduced to many temperate, moist regions worldwide. It grows in moist sites, often by watersides, in regions with hot summers and cold to mild winters.",
      "es": "Populus alba, el álamo blanco, álamo común o chopo blanco es un árbol de fronda perteneciente a las salicáceas. Otros nombres comunes o vulgares de esta especie son: álamo plateado o álamo afgano."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 604
      },
      "ifn3": {
        "count": 611
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus nigra / Populus x canadensis"
    },
    "vulgarName": [
      {
        "en": "Black poplar"
      },
      {
        "en": "Canadian poplar"
      },
      {
        "en": "Carolina poplar"
      },
      {
        "en": "Hybrid poplar"
      },
      {
        "es": "Chopo"
      },
      {
        "es": "Chopo híbrido"
      },
      {
        "de": "Schwarz-Pappel"
      },
      {
        "fr": "Peuplier noir"
      },
      {
        "pt": "Populus nigra"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q147064",
      "http://www.wikidata.org/entity/Q149622"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 140
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus tremula"
    },
    "vulgarName": [
      {
        "en": "Common Aspen"
      },
      {
        "es": "Chopo temblón"
      },
      {
        "de": "Espe"
      },
      {
        "fr": "Tremble"
      },
      {
        "pt": "Populus tremula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146110",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_tremula",
      "es": "https://es.wikipedia.org/wiki/Populus_tremula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/PopulusTremula001.JPG/330px-PopulusTremula001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg/330px-Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_tremula",
    "gbif": "https://www.gbif.org/species/3040249",
    "extract": {
      "en": "Populus tremula is a species of poplar native to cool temperate regions of the Old World.",
      "es": "Populus tremula, el álamo temblón, chopo temblón o lamparilla es un árbol de fronda perteneciente a la familia de las salicáceas, que se distingue de otras especies emparentadas por los largos pedúnculos que se mueven con el viento y le dan su nombre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 463
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species258",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus x canadensis"
    },
    "vulgarName": [
      {
        "en": "Canadian poplar"
      },
      {
        "en": "Carolina poplar"
      },
      {
        "en": "Hybrid poplar"
      },
      {
        "es": "Chopo híbrido"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q149622",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_%C3%97_canadensis",
      "es": "https://es.wikipedia.org/wiki/Populus_x_canadensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Populier_Populus_canadensis.jpg/330px-Populier_Populus_canadensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_%C3%97_canadensis",
    "gbif": "https://www.gbif.org/species/8190077",
    "extract": {
      "en": "Populus × canadensis, known as the hybrid black poplar, Canadian poplar or Carolina poplar, is an artificial hybrid between Populus nigra from Europe and Populus deltoides from North America, which arose when the two parent species were first brought together in cultivation in France soon after 1700. It is a vigorous, broadly columnar, deciduous tree growing to 40–45 m (131–148 ft), which is commonly used in plantation forestry and by landscape architects. The tallest reliably measured, near the Weltenburg Abbey in Kelheim, Germany, is 47 metres tall, and the stoutest, in Baak in the Netherlands, is 8.5 metres girth.",
      "es": "Populus × canadensis, los álamos negros del Canadá, es una denominación de un grupo muy polimorfo de híbridos obtenidos entre las descendencias de Populus deltoides y Populus nigra, y en algún caso de otras especies. Pertenecen a la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 27
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species51",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus alba"
    },
    "vulgarName": [
      {
        "en": "Abele"
      },
      {
        "en": "Silver poplar"
      },
      {
        "en": "Silverleaf poplar"
      },
      {
        "en": "White poplar"
      },
      {
        "es": "Álamo"
      },
      {
        "de": "Silber-Pappel"
      },
      {
        "fr": "Populus alba"
      },
      {
        "pt": "Populus alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146269",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_alba",
      "es": "https://es.wikipedia.org/wiki/Populus_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Populus_alba_001.JPG/330px-Populus_alba_001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Populus_alba_01.jpg/330px-Populus_alba_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_alba",
    "gbif": "https://www.gbif.org/species/3040233",
    "extract": {
      "en": "Populus alba, commonly called silver poplar, silverleaf poplar, white poplar, or abele is a species of poplar, most closely related to the aspens. It is native to a region spanning from the Atlas Mountains of Africa, through most of South and Central Europe, into Central Asia; it has been introduced to many temperate, moist regions worldwide. It grows in moist sites, often by watersides, in regions with hot summers and cold to mild winters.",
      "es": "Populus alba, el álamo blanco, álamo común o chopo blanco es un árbol de fronda perteneciente a las salicáceas. Otros nombres comunes o vulgares de esta especie son: álamo plateado o álamo afgano."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusTremula"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species52",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus tremula"
    },
    "vulgarName": [
      {
        "en": "Common Aspen"
      },
      {
        "es": "Chopo temblón"
      },
      {
        "de": "Espe"
      },
      {
        "fr": "Tremble"
      },
      {
        "pt": "Populus tremula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146110",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_tremula",
      "es": "https://es.wikipedia.org/wiki/Populus_tremula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/PopulusTremula001.JPG/330px-PopulusTremula001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg/330px-Populus_tremula_-_Eurasian_Aspen%2C_Giresun_2016_01-2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_tremula",
    "gbif": "https://www.gbif.org/species/3040249",
    "extract": {
      "en": "Populus tremula is a species of poplar native to cool temperate regions of the Old World.",
      "es": "Populus tremula, el álamo temblón, chopo temblón o lamparilla es un árbol de fronda perteneciente a la familia de las salicáceas, que se distingue de otras especies emparentadas por los largos pedúnculos que se mueven con el viento y le dan su nombre."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus131",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PopulusNigraPopulusXCanadensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 175
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species58",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Populus nigra"
    },
    "vulgarName": [
      {
        "en": "Black poplar"
      },
      {
        "es": "Chopo"
      },
      {
        "de": "Schwarz-Pappel"
      },
      {
        "fr": "Peuplier noir"
      },
      {
        "pt": "Populus nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147064",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Populus_nigra",
      "es": "https://es.wikipedia.org/wiki/Populus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Populus_nigra_kz1.jpg/330px-Populus_nigra_kz1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Populus_nigra_range.svg/langes-330px-Populus_nigra_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Populus_nigra",
    "gbif": "https://www.gbif.org/species/3040227",
    "extract": {
      "en": "Populus nigra, the black poplar, is a species of cottonwood poplar, the type species of section Aigeiros of the genus Populus, native to Europe, southwest and central Asia, and northwest Africa.",
      "es": "El álamo negro o chopo negro es una especie de árbol perteneciente a la familia de las salicáceas común en Europa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 580
      },
      "ifn3": {
        "count": 462
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
    "isGenus": 1,
    "scientificName": {
      "la": "Salix"
    },
    "vulgarName": [
      {
        "es": "Sauces"
      },
      {
        "en": "Willows"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36050",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Willow",
      "es": "https://es.wikipedia.org/wiki/Salix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Salix_alba_Morton.jpg/330px-Salix_alba_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Salix_alba11.jpg/330px-Salix_alba11.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix",
    "gbif": "https://www.gbif.org/species/3039576",
    "extract": {
      "en": "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species of typically deciduous trees and shrubs. They are primarily found on moist soils in cold and temperate regions.",
      "es": "Salix es un género compuesto de unas cuatrocientas especies de árboles y arbustos caducifolios dentro de la familia Salicaceae, se distribuyen principalmente por las zonas frías y templadas del Hemisferio Norte, con preferencia por tierras húmedas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix"
    ],
    "nplots": {
      "ifn2": {
        "count": 580
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix"
    },
    "vulgarName": [
      {
        "en": "Willow"
      },
      {
        "es": "Sauce"
      },
      {
        "de": "Weiden (Gattung)"
      },
      {
        "fr": "Saule"
      },
      {
        "pt": "Salgueiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36050",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Willow",
      "es": "https://es.wikipedia.org/wiki/Salix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Salix_alba_Morton.jpg/330px-Salix_alba_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Salix_alba11.jpg/330px-Salix_alba11.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix",
    "gbif": "https://www.gbif.org/species/3039576",
    "extract": {
      "en": "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species of typically deciduous trees and shrubs. They are primarily found on moist soils in cold and temperate regions.",
      "es": "Salix es un género compuesto de unas cuatrocientas especies de árboles y arbustos caducifolios dentro de la familia Salicaceae, se distribuyen principalmente por las zonas frías y templadas del Hemisferio Norte, con preferencia por tierras húmedas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 580
      },
      "ifn3": {
        "count": 462
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix"
    },
    "vulgarName": [
      {
        "en": "Willow"
      },
      {
        "es": "Sauce"
      },
      {
        "de": "Weiden (Gattung)"
      },
      {
        "fr": "Saule"
      },
      {
        "pt": "Salgueiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36050",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Willow",
      "es": "https://es.wikipedia.org/wiki/Salix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Salix_alba_Morton.jpg/330px-Salix_alba_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Salix_alba11.jpg/330px-Salix_alba11.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix",
    "gbif": "https://www.gbif.org/species/3039576",
    "extract": {
      "en": "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species of typically deciduous trees and shrubs. They are primarily found on moist soils in cold and temperate regions.",
      "es": "Salix es un género compuesto de unas cuatrocientas especies de árboles y arbustos caducifolios dentro de la familia Salicaceae, se distribuyen principalmente por las zonas frías y templadas del Hemisferio Norte, con preferencia por tierras húmedas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix alba"
    },
    "vulgarName": [
      {
        "en": "White willow"
      },
      {
        "es": "Sauce blanco"
      },
      {
        "de": "Silber-Weide"
      },
      {
        "fr": "Salix alba"
      },
      {
        "pt": "Salgueiro-branco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156918",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_alba",
      "es": "https://es.wikipedia.org/wiki/Salix_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Salix_alba_leaves.jpg/330px-Salix_alba_leaves.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Salix_alba_an_der_Isar.jpg/330px-Salix_alba_an_der_Isar.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_alba",
    "gbif": "https://www.gbif.org/species/5372513",
    "extract": {
      "en": "Salix alba, the white willow, is a species of willow native to Europe and western and Central Asia. The name derives from the white tone to the undersides of the leaves.",
      "es": "El sauce blanco o salguero es un árbol caducifolio de rápido crecimiento de la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix atrocinerea"
    },
    "vulgarName": [
      {
        "en": "Grey willow"
      },
      {
        "es": "Bardaguera"
      },
      {
        "fr": "Salix atrocinerea"
      },
      {
        "pt": "Salix atrocinerea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3320649",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_atrocinerea",
      "es": "https://es.wikipedia.org/wiki/Salix_atrocinerea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Salix_cinerea_flowers-2.jpg/330px-Salix_cinerea_flowers-2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Salix.jpg/330px-Salix.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_atrocinerea",
    "gbif": "https://www.gbif.org/species/5582546",
    "extract": {
      "en": "Salix atrocinerea, commonly called grey willow or large gray willow, is a species of willow. It is a bush or small tree up to 12 m (39 ft) tall. As a pioneer species of willow, it quickly colonizes poor soils.",
      "es": "El sauce cenizo o zalce, es una especie de arbusto o arbolito perteneciente a la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix babylonica"
    },
    "vulgarName": [
      {
        "en": "Babylon willow"
      },
      {
        "en": "Weeping willow"
      },
      {
        "es": "Sauce llorón"
      },
      {
        "de": "Echte Trauerweide"
      },
      {
        "fr": "Saule pleureur"
      },
      {
        "pt": "Salgueiro-chorão"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156307",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_babylonica",
      "es": "https://es.wikipedia.org/wiki/Salix_babylonica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Ch%C3%A2teau_de_Chenonceau_-_jardin_Russell-Page_%2801%29.jpg/330px-Ch%C3%A2teau_de_Chenonceau_-_jardin_Russell-Page_%2801%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/%28MHNT%29_Salix_babylonica_-_Les_Martels%2C_Giroussens_Tarn.jpg/330px-%28MHNT%29_Salix_babylonica_-_Les_Martels%2C_Giroussens_Tarn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_babylonica",
    "gbif": "https://www.gbif.org/species/5372639",
    "extract": {
      "en": "Salix babylonica is a species of willow native to dry areas of northern China, Korea, Mongolia, Japan, and Siberia but cultivated for millennia elsewhere in Asia, being traded along the Silk Road to southwest Asia and Europe.",
      "es": "El sauce llorón es un árbol que pertenece a la familia de las salicáceas y es nativo del este de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix cantabrica"
    },
    "vulgarName": [
      {
        "en": "Cantabrian willow"
      },
      {
        "es": "Sauce cantábrico"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q6117334"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Salix"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 462
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species57",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix"
    },
    "vulgarName": [
      {
        "en": "Willow"
      },
      {
        "es": "Sauce"
      },
      {
        "de": "Weiden (Gattung)"
      },
      {
        "fr": "Saule"
      },
      {
        "pt": "Salgueiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36050",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Willow",
      "es": "https://es.wikipedia.org/wiki/Salix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Salix_alba_Morton.jpg/330px-Salix_alba_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Salix_alba11.jpg/330px-Salix_alba11.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix",
    "gbif": "https://www.gbif.org/species/3039576",
    "extract": {
      "en": "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species of typically deciduous trees and shrubs. They are primarily found on moist soils in cold and temperate regions.",
      "es": "Salix es un género compuesto de unas cuatrocientas especies de árboles y arbustos caducifolios dentro de la familia Salicaceae, se distribuyen principalmente por las zonas frías y templadas del Hemisferio Norte, con preferencia por tierras húmedas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix caprea"
    },
    "vulgarName": [
      {
        "en": "Goat willow"
      },
      {
        "en": "Great sallow"
      },
      {
        "en": "Pussy willow"
      },
      {
        "es": "Sauce cabruno"
      },
      {
        "de": "Sal-Weide"
      },
      {
        "fr": "Saule marsault"
      },
      {
        "pt": "Salix caprea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159565",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_caprea",
      "es": "https://es.wikipedia.org/wiki/Salix_caprea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Waterwilg_%28DSC_2539%29.jpg/330px-Waterwilg_%28DSC_2539%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/20140302Salix_caprea14.jpg/330px-20140302Salix_caprea14.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_caprea",
    "gbif": "https://www.gbif.org/species/5372952",
    "extract": {
      "en": "Salix caprea, known as goat willow, pussy willow or great sallow, is a common species of willow native to Europe and western and central Asia.",
      "es": "El sauce cabruno, salce cabruno o zargatillo, es un pequeño árbol de fronda oriundo de Europa y Asia central y occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix elaeagnos"
    },
    "vulgarName": [
      {
        "en": "Bitter willow"
      },
      {
        "en": "Elaeagnus willow"
      },
      {
        "en": "Hoary willow"
      },
      {
        "en": "Olive willow"
      },
      {
        "en": "Rosemary willow"
      },
      {
        "es": "Sarga"
      },
      {
        "de": "Lavendel-Weide"
      },
      {
        "fr": "Salix elaeagnos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159484",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_eleagnos",
      "es": "https://es.wikipedia.org/wiki/Salix_eleagnos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Salix_eleagnos_%28Lavendel-Weide%29_IMG_37450.JPG/330px-Salix_eleagnos_%28Lavendel-Weide%29_IMG_37450.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Salix_elaeagnos1.jpg/330px-Salix_elaeagnos1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_eleagnos",
    "gbif": "https://www.gbif.org/species/5372655",
    "extract": {
      "en": "Salix eleagnos the bitter willow, olive willow, hoary willow, rosemary willow, or elaeagnus willow, is a species of flowering plant in the family Salicaceae, native to central and southern Europe and south west Asia. Growing to 3 m (10 ft) tall by 5 m (16 ft) broad, it is an erect bushy deciduous shrub with narrow grey-green leaves up to 20 cm (8 in) long, which turn yellow in autumn (fall). The green catkins, 3–6 cm (1–2 in) long, appear with the leaves in spring, male catkins having yellow anthers.",
      "es": "Salix eleagnos, el sauce gris, también conocido como sarga, es un árbol de fronda de hasta 20 m de alto, o arbusto alto, de la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix fragilis"
    },
    "vulgarName": [
      {
        "en": "Brittle willow"
      },
      {
        "en": "Crack willow"
      },
      {
        "es": "Mimbre"
      },
      {
        "de": "Bruch-Weide"
      },
      {
        "fr": "Saule fragile"
      },
      {
        "pt": "Salix fragilis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157518",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_fragilis",
      "es": "https://es.wikipedia.org/wiki/Salix_fragilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Salix_fragilis_001.jpg/330px-Salix_fragilis_001.jpg"
    ],
    "gbif": "https://www.gbif.org/species/5372829",
    "extract": {
      "en": "Salix fragilis is a scientific name that has historically been used for two different willows:Salix euxina, a non-hybrid species\nSalix × fragilis, the hybrid between Salix euxina and Salix alba",
      "es": "Salix fragilis, la mimbrera frágil, o simplemente mimbrera, aunque comparte este nombre con otras especies de Salix, es un sauce nativo de Europa y del oeste de Asia, que usualmente prospera en las riberas fluviales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island willow"
      },
      {
        "es": "Sauce canario"
      },
      {
        "pt": "Seixeiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3317045",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Salix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Salix_pedicellata_Habitus_2009-9-27_CampoCalatrava.jpg/330px-Salix_pedicellata_Habitus_2009-9-27_CampoCalatrava.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Salix_canarienisis05.JPG/330px-Salix_canarienisis05.JPG"
    ],
    "gbif": "https://www.gbif.org/species/5583405",
    "extract": {
      "en": "Salix pedicellata is a species of willow. It is a shrub or small tree to about 6–8 m tall, native around the Mediterranean Sea from Portugal to Lebanon and Syria in the north and from the Canary Islands to Tunisia in the south. Salix canariensis may be treated as a subspecies of S. pedicellata.",
      "es": "Salix canariensis es una especie de sauce nativo de las islas de Madeira y Canarias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix purpurea"
    },
    "vulgarName": [
      {
        "en": "Purple osier"
      },
      {
        "en": "Purple willow"
      },
      {
        "en": "Purpleosier willow"
      },
      {
        "es": "Mimbrera"
      },
      {
        "de": "Purpur-Weide"
      },
      {
        "fr": "Salix purpurea"
      },
      {
        "pt": "Salix purpurea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q39708",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_purpurea",
      "es": "https://es.wikipedia.org/wiki/Salix_purpurea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Salix_purpurea_003.jpg/330px-Salix_purpurea_003.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Salix_purpurea_Sturm25.jpg/330px-Salix_purpurea_Sturm25.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_purpurea",
    "gbif": "https://www.gbif.org/species/5372800",
    "extract": {
      "en": "Salix purpurea, known in Britain as purple willow, is a shrub or small tree native to Europe, western Asia and northwest Africa. It has been introduced to many other parts of the world as an ornamental garden plant, and it is widely used in basket making. Within its native range and some places where it is naturalised it is found in wetlands such as lake margins and the floodplains of rivers.",
      "es": "Salix purpurea, llamada popularmente mimbrera púrpura, sauce o salce colorado, mimbre púrpura o mimbre del río, es un arbusto de la familia de las Salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species257"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAlba",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix alba"
    },
    "vulgarName": [
      {
        "en": "White willow"
      },
      {
        "es": "Sauce blanco"
      },
      {
        "de": "Silber-Weide"
      },
      {
        "fr": "Salix alba"
      },
      {
        "pt": "Salgueiro-branco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156918",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_alba",
      "es": "https://es.wikipedia.org/wiki/Salix_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Salix_alba_leaves.jpg/330px-Salix_alba_leaves.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Salix_alba_an_der_Isar.jpg/330px-Salix_alba_an_der_Isar.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_alba",
    "gbif": "https://www.gbif.org/species/5372513",
    "extract": {
      "en": "Salix alba, the white willow, is a species of willow native to Europe and western and Central Asia. The name derives from the white tone to the undersides of the leaves.",
      "es": "El sauce blanco o salguero es un árbol caducifolio de rápido crecimiento de la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species357"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixAtrocinerea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix atrocinerea"
    },
    "vulgarName": [
      {
        "en": "Grey willow"
      },
      {
        "es": "Bardaguera"
      },
      {
        "fr": "Salix atrocinerea"
      },
      {
        "pt": "Salix atrocinerea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3320649",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_atrocinerea",
      "es": "https://es.wikipedia.org/wiki/Salix_atrocinerea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Salix_cinerea_flowers-2.jpg/330px-Salix_cinerea_flowers-2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Salix.jpg/330px-Salix.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_atrocinerea",
    "gbif": "https://www.gbif.org/species/5582546",
    "extract": {
      "en": "Salix atrocinerea, commonly called grey willow or large gray willow, is a species of willow. It is a bush or small tree up to 12 m (39 ft) tall. As a pioneer species of willow, it quickly colonizes poor soils.",
      "es": "El sauce cenizo o zalce, es una especie de arbusto o arbolito perteneciente a la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species457"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixBabylonica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix babylonica"
    },
    "vulgarName": [
      {
        "en": "Babylon willow"
      },
      {
        "en": "Weeping willow"
      },
      {
        "es": "Sauce llorón"
      },
      {
        "de": "Echte Trauerweide"
      },
      {
        "fr": "Saule pleureur"
      },
      {
        "pt": "Salgueiro-chorão"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156307",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_babylonica",
      "es": "https://es.wikipedia.org/wiki/Salix_babylonica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Ch%C3%A2teau_de_Chenonceau_-_jardin_Russell-Page_%2801%29.jpg/330px-Ch%C3%A2teau_de_Chenonceau_-_jardin_Russell-Page_%2801%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/%28MHNT%29_Salix_babylonica_-_Les_Martels%2C_Giroussens_Tarn.jpg/330px-%28MHNT%29_Salix_babylonica_-_Les_Martels%2C_Giroussens_Tarn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_babylonica",
    "gbif": "https://www.gbif.org/species/5372639",
    "extract": {
      "en": "Salix babylonica is a species of willow native to dry areas of northern China, Korea, Mongolia, Japan, and Siberia but cultivated for millennia elsewhere in Asia, being traded along the Silk Road to southwest Asia and Europe.",
      "es": "El sauce llorón es un árbol que pertenece a la familia de las salicáceas y es nativo del este de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species858"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island willow"
      },
      {
        "es": "Sauce canario"
      },
      {
        "pt": "Seixeiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3317045",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Salix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Salix_pedicellata_Habitus_2009-9-27_CampoCalatrava.jpg/330px-Salix_pedicellata_Habitus_2009-9-27_CampoCalatrava.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Salix_canarienisis05.JPG/330px-Salix_canarienisis05.JPG"
    ],
    "gbif": "https://www.gbif.org/species/5583405",
    "extract": {
      "en": "Salix pedicellata is a species of willow. It is a shrub or small tree to about 6–8 m tall, native around the Mediterranean Sea from Portugal to Lebanon and Syria in the north and from the Canary Islands to Tunisia in the south. Salix canariensis may be treated as a subspecies of S. pedicellata.",
      "es": "Salix canariensis es una especie de sauce nativo de las islas de Madeira y Canarias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species557"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCantabrica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix cantabrica"
    },
    "vulgarName": [
      {
        "en": "Cantabrian willow"
      },
      {
        "es": "Sauce cantábrico"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q6117334"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species657"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixCaprea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix caprea"
    },
    "vulgarName": [
      {
        "en": "Goat willow"
      },
      {
        "en": "Great sallow"
      },
      {
        "en": "Pussy willow"
      },
      {
        "es": "Sauce cabruno"
      },
      {
        "de": "Sal-Weide"
      },
      {
        "fr": "Saule marsault"
      },
      {
        "pt": "Salix caprea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159565",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_caprea",
      "es": "https://es.wikipedia.org/wiki/Salix_caprea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Waterwilg_%28DSC_2539%29.jpg/330px-Waterwilg_%28DSC_2539%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/20140302Salix_caprea14.jpg/330px-20140302Salix_caprea14.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_caprea",
    "gbif": "https://www.gbif.org/species/5372952",
    "extract": {
      "en": "Salix caprea, known as goat willow, pussy willow or great sallow, is a common species of willow native to Europe and western and central Asia.",
      "es": "El sauce cabruno, salce cabruno o zargatillo, es un pequeño árbol de fronda oriundo de Europa y Asia central y occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species757"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixElaeagnos",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix elaeagnos"
    },
    "vulgarName": [
      {
        "en": "Bitter willow"
      },
      {
        "en": "Elaeagnus willow"
      },
      {
        "en": "Hoary willow"
      },
      {
        "en": "Olive willow"
      },
      {
        "en": "Rosemary willow"
      },
      {
        "es": "Sarga"
      },
      {
        "de": "Lavendel-Weide"
      },
      {
        "fr": "Salix elaeagnos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159484",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_eleagnos",
      "es": "https://es.wikipedia.org/wiki/Salix_eleagnos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Salix_eleagnos_%28Lavendel-Weide%29_IMG_37450.JPG/330px-Salix_eleagnos_%28Lavendel-Weide%29_IMG_37450.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Salix_elaeagnos1.jpg/330px-Salix_elaeagnos1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_eleagnos",
    "gbif": "https://www.gbif.org/species/5372655",
    "extract": {
      "en": "Salix eleagnos the bitter willow, olive willow, hoary willow, rosemary willow, or elaeagnus willow, is a species of flowering plant in the family Salicaceae, native to central and southern Europe and south west Asia. Growing to 3 m (10 ft) tall by 5 m (16 ft) broad, it is an erect bushy deciduous shrub with narrow grey-green leaves up to 20 cm (8 in) long, which turn yellow in autumn (fall). The green catkins, 3–6 cm (1–2 in) long, appear with the leaves in spring, male catkins having yellow anthers.",
      "es": "Salix eleagnos, el sauce gris, también conocido como sarga, es un árbol de fronda de hasta 20 m de alto, o arbusto alto, de la familia de las salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species857"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixFragilis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix fragilis"
    },
    "vulgarName": [
      {
        "en": "Brittle willow"
      },
      {
        "en": "Crack willow"
      },
      {
        "es": "Mimbre"
      },
      {
        "de": "Bruch-Weide"
      },
      {
        "fr": "Saule fragile"
      },
      {
        "pt": "Salix fragilis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157518",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_fragilis",
      "es": "https://es.wikipedia.org/wiki/Salix_fragilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Salix_fragilis_001.jpg/330px-Salix_fragilis_001.jpg"
    ],
    "gbif": "https://www.gbif.org/species/5372829",
    "extract": {
      "en": "Salix fragilis is a scientific name that has historically been used for two different willows:Salix euxina, a non-hybrid species\nSalix × fragilis, the hybrid between Salix euxina and Salix alba",
      "es": "Salix fragilis, la mimbrera frágil, o simplemente mimbrera, aunque comparte este nombre con otras especies de Salix, es un sauce nativo de Europa y del oeste de Asia, que usualmente prospera en las riberas fluviales."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species957"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus132",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SalixPurpurea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Salix purpurea"
    },
    "vulgarName": [
      {
        "en": "Purple osier"
      },
      {
        "en": "Purple willow"
      },
      {
        "en": "Purpleosier willow"
      },
      {
        "es": "Mimbrera"
      },
      {
        "de": "Purpur-Weide"
      },
      {
        "fr": "Salix purpurea"
      },
      {
        "pt": "Salix purpurea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q39708",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Salix_purpurea",
      "es": "https://es.wikipedia.org/wiki/Salix_purpurea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Salix_purpurea_003.jpg/330px-Salix_purpurea_003.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Salix_purpurea_Sturm25.jpg/330px-Salix_purpurea_Sturm25.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Salix_purpurea",
    "gbif": "https://www.gbif.org/species/5372800",
    "extract": {
      "en": "Salix purpurea, known in Britain as purple willow, is a shrub or small tree native to Europe, western Asia and northwest Africa. It has been introduced to many other parts of the world as an ornamental garden plant, and it is widely used in basket making. Within its native range and some places where it is naturalised it is found in wetlands such as lake margins and the floodplains of rivers.",
      "es": "Salix purpurea, llamada popularmente mimbrera púrpura, sauce o salce colorado, mimbre púrpura o mimbre del río, es un arbusto de la familia de las Salicáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 129
      },
      "ifn3": {
        "count": 238
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
    "isGenus": 1,
    "scientificName": {
      "la": "Ceratonia"
    },
    "vulgarName": [
      {
        "es": "Algarrobos"
      },
      {
        "en": "Carobs"
      },
      {
        "pt": "Ceratonia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159376",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ceratonia",
      "es": "https://es.wikipedia.org/wiki/Ceratonia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Illustration_Ceratonia_siliqua0.jpg/330px-Illustration_Ceratonia_siliqua0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Ceratonia_siliqua%2C_total.jpg/330px-Ceratonia_siliqua%2C_total.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ceratonia",
    "gbif": "https://www.gbif.org/species/2962230",
    "extract": {
      "en": "Ceratonia, also known as carobs, is a small genus of flowering trees in the pea family, Fabaceae, endemic to the Mediterranean region and the Middle East. Its best known member is the carob tree, which is cultivated for its edible pods and has been widely introduced to regions with similar climates. The genus was long considered monotypic, but a second species, Ceratonia oreothauma, was identified in 1979 from Oman and Somalia. The genus is in subfamily Caesalpinioideae and tribe Umtizieae.",
      "es": "Ceratonia es un género de árboles de la familia Fabaceae, subfamilia Caesalpinioideae. Es natural de la región del Mediterráneo, Arabia y Somalía. Es el único género de la subtribu Ceratoniinae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 238
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ceratonia siliqua"
    },
    "vulgarName": [
      {
        "en": "Carob tree"
      },
      {
        "es": "Algarrobo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q68763",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carob",
      "es": "https://es.wikipedia.org/wiki/Ceratonia_siliqua"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg/330px-Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Illustration_Ceratonia_siliqua0.jpg/330px-Illustration_Ceratonia_siliqua0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ceratonia_siliqua",
    "gbif": "https://www.gbif.org/species/5356354",
    "extract": {
      "en": "The carob is a flowering evergreen tree or shrub in the Caesalpinioideae subfamily of the legume family, Fabaceae. The carob tree is native to the Mediterranean region and the Middle East. It is widely cultivated for its edible fruit, which takes the form of seed pods, and as an ornamental tree in gardens and landscapes. Spain is its largest producer, followed by Italy and Morocco.",
      "es": "El algarrobo europeo es una especie arbórea de la familia de las fabáceas originaria de la Cuenca del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua"
    ],
    "nplots": {
      "ifn2": {
        "count": 129
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ceratonia siliqua"
    },
    "vulgarName": [
      {
        "en": "Carob tree"
      },
      {
        "es": "Algarrobo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q68763",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carob",
      "es": "https://es.wikipedia.org/wiki/Ceratonia_siliqua"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg/330px-Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Illustration_Ceratonia_siliqua0.jpg/330px-Illustration_Ceratonia_siliqua0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ceratonia_siliqua",
    "gbif": "https://www.gbif.org/species/5356354",
    "extract": {
      "en": "The carob is a flowering evergreen tree or shrub in the Caesalpinioideae subfamily of the legume family, Fabaceae. The carob tree is native to the Mediterranean region and the Middle East. It is widely cultivated for its edible fruit, which takes the form of seed pods, and as an ornamental tree in gardens and landscapes. Spain is its largest producer, followed by Italy and Morocco.",
      "es": "El algarrobo europeo es una especie arbórea de la familia de las fabáceas originaria de la Cuenca del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species67",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species67"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus142",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 129
      },
      "ifn3": {
        "count": 238
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeratoniaSiliqua",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ceratonia siliqua"
    },
    "vulgarName": [
      {
        "en": "Carob tree"
      },
      {
        "es": "Algarrobo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q68763",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carob",
      "es": "https://es.wikipedia.org/wiki/Ceratonia_siliqua"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg/330px-Ceratonia_siliqua_Keciboynuzu_1370984_Nevit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Illustration_Ceratonia_siliqua0.jpg/330px-Illustration_Ceratonia_siliqua0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ceratonia_siliqua",
    "gbif": "https://www.gbif.org/species/5356354",
    "extract": {
      "en": "The carob is a flowering evergreen tree or shrub in the Caesalpinioideae subfamily of the legume family, Fabaceae. The carob tree is native to the Mediterranean region and the Middle East. It is widely cultivated for its edible fruit, which takes the form of seed pods, and as an ornamental tree in gardens and landscapes. Spain is its largest producer, followed by Italy and Morocco.",
      "es": "El algarrobo europeo es una especie arbórea de la familia de las fabáceas originaria de la Cuenca del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 141
      },
      "ifn3": {
        "count": 183
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
    "isGenus": 1,
    "scientificName": {
      "la": "Robinia"
    },
    "vulgarName": [
      {
        "en": "Locusts"
      },
      {
        "es": "Robinias"
      },
      {
        "de": "Robinien"
      },
      {
        "fr": "Robinia"
      },
      {
        "pt": "Robinia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q472943",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Robinia",
      "es": "https://es.wikipedia.org/wiki/Robinia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/8/86/Robina9146.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Robinia_L.",
    "gbif": "https://www.gbif.org/species/2952066",
    "extract": {
      "en": "Robinia is a genus of flowering plants in the family Fabaceae, tribe Robinieae, native to North America. Commonly known as locusts, they are deciduous trees and shrubs growing 4–25 metres (13–82 ft) tall. The leaves are pinnate with 7–21 oval leaflets. The flowers are white or pink, in usually pendulous racemes. Many species have thorny shoots, and several have sticky hairs on the shoots.",
      "es": "Robinia es un género de plantas arbustivas y arbóreas de la familia Fabaceae (Leguminosae), nativo de Norteamérica. El género tiene unas 8 especies aceptadas de las más de 120 descritas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica"
    ],
    "nplots": {
      "ifn2": {
        "count": 141
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Robinia pseudacacia / Sophora japonica"
    },
    "vulgarName": [
      {
        "en": "Black locust"
      },
      {
        "en": "Japanese pagoda tree"
      },
      {
        "es": "Acacia robinia"
      },
      {
        "es": "Acacia sofora"
      },
      {
        "de": "Gewöhnliche Robinie"
      },
      {
        "de": "Japanischer Schnurbaum"
      },
      {
        "fr": "Robinia pseudoacacia"
      },
      {
        "fr": "Styphnolobium japonicum"
      },
      {
        "pt": "Robinia pseudoacacia"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q10881597",
      "http://www.wikidata.org/entity/Q157417"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 141
      },
      "ifn3": {
        "count": 183
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Robinia pseudacacia / Sophora japonica"
    },
    "vulgarName": [
      {
        "en": "Black locust"
      },
      {
        "en": "Japanese pagoda tree"
      },
      {
        "es": "Acacia robinia"
      },
      {
        "es": "Acacia sofora"
      },
      {
        "de": "Gewöhnliche Robinie"
      },
      {
        "de": "Japanischer Schnurbaum"
      },
      {
        "fr": "Robinia pseudoacacia"
      },
      {
        "fr": "Styphnolobium japonicum"
      },
      {
        "pt": "Robinia pseudoacacia"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q10881597",
      "http://www.wikidata.org/entity/Q157417"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 183
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species92",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Robinia pseudacacia"
    },
    "vulgarName": [
      {
        "en": "Black locust"
      },
      {
        "es": "Acacia robinia"
      },
      {
        "de": "Gewöhnliche Robinie"
      },
      {
        "fr": "Robinia pseudoacacia"
      },
      {
        "pt": "Robinia pseudoacacia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157417",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Robinia_pseudoacacia",
      "es": "https://es.wikipedia.org/wiki/Robinia_pseudoacacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/8/86/Robina9146.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Robinia-pseudoacacia.JPG/330px-Robinia-pseudoacacia.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Robinia_pseudoacacia",
    "gbif": "https://www.gbif.org/species/5352251",
    "extract": {
      "en": "Robinia pseudoacacia, commonly known as black locust, is a medium-sized hardwood deciduous tree, belonging to the tribe Robinieae of the legume family. Another common name is false acacia, a literal translation of the specific name.",
      "es": "La falsa acacia es una especie del género Robinia en la familia Fabaceae. Es nativa del este de Estados Unidos, aunque se ha introducido en otros países. Es, junto con Sophora japonica y Gleditsia triacanthos, una de las tres «falsas acacias» plantadas en tantas ciudades del mundo para adornar calles y parques."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 672
      },
      "ifn3": {
        "count": 792
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
    "isGenus": 1,
    "scientificName": {
      "la": "Arbutus"
    },
    "vulgarName": [
      {
        "en": "Madrones"
      },
      {
        "es": "Madroños"
      },
      {
        "de": "Erdbeerbäume"
      },
      {
        "fr": "Arbutus"
      },
      {
        "pt": "Arbutus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q630838",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Arbutus,_Maryland",
      "es": "https://es.wikipedia.org/wiki/Arbutus_(Maryland)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Arbutus%2C_MD_Downtown.jpg/330px-Arbutus%2C_MD_Downtown.jpg"
    ],
    "extract": {
      "en": "Arbutus is an unincorporated community and a census-designated place in Baltimore County, Maryland, United States. The population was 20,483 at the 2010 census. The census area also contains the communities of Halethorpe and Relay, in which all three names were used during the 1960 census when the area had a population of 22,402.",
      "es": "Arbutus es un lugar designado por el censo ubicado en el condado de Baltimore en el estado estadounidense de Maryland. En el año 2010 tenía una población de 20483 habitantes y una densidad poblacional de 1.219,23 personas por km²."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 672
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Arbutus unedo / Arbutus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island madrone"
      },
      {
        "en": "Strawberry tree"
      },
      {
        "es": "Madroño"
      },
      {
        "es": "Madroño canario"
      },
      {
        "de": "Arbutus canariensis"
      },
      {
        "de": "Westlicher Erdbeerbaum"
      },
      {
        "fr": "Arbousier"
      },
      {
        "pt": "Medronheiro"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q136304",
      "http://www.wikidata.org/entity/Q329046"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 672
      },
      "ifn3": {
        "count": 792
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Arbutus unedo / Arbutus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island madrone"
      },
      {
        "en": "Strawberry tree"
      },
      {
        "es": "Madroño"
      },
      {
        "es": "Madroño canario"
      },
      {
        "de": "Arbutus canariensis"
      },
      {
        "de": "Westlicher Erdbeerbaum"
      },
      {
        "fr": "Arbousier"
      },
      {
        "pt": "Medronheiro"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q136304",
      "http://www.wikidata.org/entity/Q329046"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species268",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Arbutus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island madrone"
      },
      {
        "es": "Madroño canario"
      },
      {
        "de": "Arbutus canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q136304",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Arbutus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Arbutus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/20250630_Arbutus_canariensis.jpg/330px-20250630_Arbutus_canariensis.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Arbutus_canariensis2.jpg/330px-Arbutus_canariensis2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Arbutus_canariensis",
    "gbif": "https://www.gbif.org/species/4170826",
    "extract": {
      "en": "Arbutus canariensis, known in Spanish as madroño canario; in English as Canary Islands strawberry tree, is a species of shrub or tree in the heath family. It is endemic to the Canary Islands of Spain, specifically Tenerife, La Gomera, Gran Canaria, El Hierro, and La Palma. It is threatened by habitat loss.",
      "es": "Arbutus canariensis Veill., conocido en castellano como madroño canario, es una especie de árbol perenne perteneciente a la familia de Ericaceae. Es originario de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus151",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ArbutusUnedoArbutusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 792
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species68",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Arbutus unedo"
    },
    "vulgarName": [
      {
        "en": "Strawberry tree"
      },
      {
        "es": "Madroño"
      },
      {
        "de": "Westlicher Erdbeerbaum"
      },
      {
        "fr": "Arbousier"
      },
      {
        "pt": "Medronheiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q329046",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Arbutus_unedo",
      "es": "https://es.wikipedia.org/wiki/Arbutus_unedo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Arbutus_unedo_off_Bayshore_Drive_at_Coal_Harbour.jpg/330px-Arbutus_unedo_off_Bayshore_Drive_at_Coal_Harbour.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Arbutus_unedo_Corsica.jpg/330px-Arbutus_unedo_Corsica.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Arbutus_unedo",
    "gbif": "https://www.gbif.org/species/2882803",
    "extract": {
      "en": "Arbutus unedo, commonly known as strawberry tree, also called madrone, is an evergreen shrub or small tree in the family Ericaceae, native to the Mediterranean Basin and Western Europe. The tree is well known for its fruits, the arbutus berry, which bear some resemblance to the strawberry, hence the common name strawberry tree. However, it is not closely related to true strawberries of the genus Fragaria.",
      "es": "El madroño es una especie de arbusto perteneciente al género Arbutus en la familia Ericaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 182
      },
      "ifn3": {
        "count": 320
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
    "isGenus": 1,
    "scientificName": {
      "la": "Erica"
    },
    "vulgarName": [
      {
        "es": "Brezos"
      },
      {
        "en": "Heathers"
      },
      {
        "de": "Heidekräuter"
      },
      {
        "fr": "Erica"
      },
      {
        "pt": "Erica (género)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q206998",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_(plant)",
      "es": "https://es.wikipedia.org/wiki/Erica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Erica_herbacea0.jpg/330px-Erica_herbacea0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Illustration_Erica_tetralix0.jpg/330px-Illustration_Erica_tetralix0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_(Ericaceae)",
    "gbif": "https://www.gbif.org/species/2882780",
    "extract": {
      "en": "Erica is a genus of roughly 857 species of flowering plants in the family Ericaceae. The English common names heath and heather are shared by some closely related genera of similar appearance. The genus Calluna was formerly included in Erica; it differs in having even smaller scale-leaves, and the flower corolla consisting of separate petals. Erica is sometimes referred to as \"winter heather\" to distinguish it from Calluna \"summer heather\".",
      "es": "Erica es un género de plantas fanerógamas de la familia Ericaceae; también son conocidas como brezos. Son plantas resistentes a las sequías y a los fuegos. La gran mayoría de las especies son endémicas de Sudáfrica, y se denominan los brezos del Cabo. Las restantes 70 especies son nativas de otras partes de África, de la Macaronesia, de las regiones mediterráneas, y de Europa. Comprende 1976 especies descritas y, de estas, solo 863 aceptadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea"
    ],
    "nplots": {
      "ifn2": {
        "count": 182
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Erica arborea"
    },
    "vulgarName": [
      {
        "en": "Tree heath"
      },
      {
        "es": "Brezo arbóreo"
      },
      {
        "de": "Baumheide"
      },
      {
        "fr": "Erica arborea"
      },
      {
        "pt": "Urze-molar"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q176647",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_arborea",
      "es": "https://es.wikipedia.org/wiki/Erica_arborea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Erica_arborea_JPG1.jpg/330px-Erica_arborea_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Erica_arborea.jpg/330px-Erica_arborea.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_arborea",
    "gbif": "https://www.gbif.org/species/5333410",
    "extract": {
      "en": "Erica arborea, the tree heath or tree heather, is a species of flowering plant (angiosperms) in the heather family Ericaceae, native to the Mediterranean Basin and Ethiopia, Kenya and Tanzania in East Africa. It is also cultivated as an ornamental.",
      "es": "El brezo arbóreo, brezo blanco o simplemente brezo es una especie de planta arbustiva o pequeño árbol del género Erica, distribuida por la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 182
      },
      "ifn3": {
        "count": 320
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Erica arborea"
    },
    "vulgarName": [
      {
        "en": "Tree heath"
      },
      {
        "es": "Brezo arbóreo"
      },
      {
        "de": "Baumheide"
      },
      {
        "fr": "Erica arborea"
      },
      {
        "pt": "Urze-molar"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q176647",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_arborea",
      "es": "https://es.wikipedia.org/wiki/Erica_arborea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Erica_arborea_JPG1.jpg/330px-Erica_arborea_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Erica_arborea.jpg/330px-Erica_arborea.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_arborea",
    "gbif": "https://www.gbif.org/species/5333410",
    "extract": {
      "en": "Erica arborea, the tree heath or tree heather, is a species of flowering plant (angiosperms) in the heather family Ericaceae, native to the Mediterranean Basin and Ethiopia, Kenya and Tanzania in East Africa. It is also cultivated as an ornamental.",
      "es": "El brezo arbóreo, brezo blanco o simplemente brezo es una especie de planta arbustiva o pequeño árbol del género Erica, distribuida por la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Erica scoparia"
    },
    "vulgarName": [
      {
        "es": "Tejo"
      },
      {
        "en": "Heather"
      },
      {
        "es": "Brezo arbóreo escopario"
      },
      {
        "fr": "Erica scoparia"
      },
      {
        "pt": "Erica scoparia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2110024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_scoparia",
      "es": "https://es.wikipedia.org/wiki/Erica_scoparia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Erica_scoparia.jpg/330px-Erica_scoparia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_scoparia",
    "gbif": "https://www.gbif.org/species/7328034",
    "extract": {
      "en": "Erica scoparia, the green heather or common besom heath, is a shrubby European species of heath in the flowering plant family Ericaceae.",
      "es": "Erica scoparia es un tipo de brezo de la familia de las ericáceas, originario de Europa central y occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaArborea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 320
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species83",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Erica arborea"
    },
    "vulgarName": [
      {
        "en": "Tree heath"
      },
      {
        "es": "Brezo arbóreo"
      },
      {
        "de": "Baumheide"
      },
      {
        "fr": "Erica arborea"
      },
      {
        "pt": "Urze-molar"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q176647",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_arborea",
      "es": "https://es.wikipedia.org/wiki/Erica_arborea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Erica_arborea_JPG1.jpg/330px-Erica_arborea_JPG1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Erica_arborea.jpg/330px-Erica_arborea.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_arborea",
    "gbif": "https://www.gbif.org/species/5333410",
    "extract": {
      "en": "Erica arborea, the tree heath or tree heather, is a species of flowering plant (angiosperms) in the heather family Ericaceae, native to the Mediterranean Basin and Ethiopia, Kenya and Tanzania in East Africa. It is also cultivated as an ornamental.",
      "es": "El brezo arbóreo, brezo blanco o simplemente brezo es una especie de planta arbustiva o pequeño árbol del género Erica, distribuida por la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species283"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus152",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EricaScoparia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Erica scoparia"
    },
    "vulgarName": [
      {
        "es": "Tejo"
      },
      {
        "en": "Heather"
      },
      {
        "es": "Brezo arbóreo escopario"
      },
      {
        "fr": "Erica scoparia"
      },
      {
        "pt": "Erica scoparia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2110024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Erica_scoparia",
      "es": "https://es.wikipedia.org/wiki/Erica_scoparia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Erica_scoparia.jpg/330px-Erica_scoparia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Erica_scoparia",
    "gbif": "https://www.gbif.org/species/7328034",
    "extract": {
      "en": "Erica scoparia, the green heather or common besom heath, is a shrubby European species of heath in the flowering plant family Ericaceae.",
      "es": "Erica scoparia es un tipo de brezo de la familia de las ericáceas, originario de Europa central y occidental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
    "isGenus": 1,
    "scientificName": {
      "la": "Myrtus"
    },
    "vulgarName": [
      {
        "es": "Mirtos"
      },
      {
        "en": "Myrtles"
      },
      {
        "fr": "Myrtus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165152",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrtus",
      "es": "https://es.wikipedia.org/wiki/Myrtus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Starr_080304-3229_Myrtus_communis.jpg/330px-Starr_080304-3229_Myrtus_communis.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Myrtus_communis.jpg/330px-Myrtus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrtus",
    "gbif": "https://www.gbif.org/species/3032317",
    "extract": {
      "en": "Myrtus is a genus of flowering plants in the family Myrtaceae. It was first described by Swedish botanist Linnaeus in 1753.",
      "es": "Myrtus es un género de la familia Myrtaceae con una o dos especies, conocidas como mirto, arrayán o murta. Es oriundo de la Europa meridional y el norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrtus communis"
    },
    "vulgarName": [
      {
        "en": "Myrtle"
      },
      {
        "es": "Mirto"
      },
      {
        "de": "Myrte"
      },
      {
        "fr": "Myrtus communis"
      },
      {
        "pt": "Murta-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q6122027",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrtus_communis",
      "es": "https://es.wikipedia.org/wiki/Myrtus_communis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Myrtus_communis_L._subsp._communis_-_52505075873.png/330px-Myrtus_communis_L._subsp._communis_-_52505075873.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Starr_080304-3229_Myrtus_communis.jpg/330px-Starr_080304-3229_Myrtus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrtus_communis",
    "gbif": "https://www.gbif.org/species/3180085",
    "extract": {
      "en": "Myrtus communis, the common myrtle or true myrtle, is a species of flowering plant in the myrtle family Myrtaceae. It is an evergreen shrub native to southern Europe, North Africa, Western Asia, Macaronesia, and the Indian subcontinent, and also cultivated.",
      "es": "El mirto o arrayán europeo es una planta de la familia de las Myrtaceae, nativa del sudeste de Europa y del norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrtus communis"
    },
    "vulgarName": [
      {
        "en": "Myrtle"
      },
      {
        "es": "Mirto"
      },
      {
        "de": "Myrte"
      },
      {
        "fr": "Myrtus communis"
      },
      {
        "pt": "Murta-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q6122027",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrtus_communis",
      "es": "https://es.wikipedia.org/wiki/Myrtus_communis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Myrtus_communis_L._subsp._communis_-_52505075873.png/330px-Myrtus_communis_L._subsp._communis_-_52505075873.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Starr_080304-3229_Myrtus_communis.jpg/330px-Starr_080304-3229_Myrtus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrtus_communis",
    "gbif": "https://www.gbif.org/species/3180085",
    "extract": {
      "en": "Myrtus communis, the common myrtle or true myrtle, is a species of flowering plant in the myrtle family Myrtaceae. It is an evergreen shrub native to southern Europe, North Africa, Western Asia, Macaronesia, and the Indian subcontinent, and also cultivated.",
      "es": "El mirto o arrayán europeo es una planta de la familia de las Myrtaceae, nativa del sudeste de Europa y del norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus161",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyrtusCommunis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species6",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrtus communis"
    },
    "vulgarName": [
      {
        "en": "Myrtle"
      },
      {
        "es": "Mirto"
      },
      {
        "de": "Myrte"
      },
      {
        "fr": "Myrtus communis"
      },
      {
        "pt": "Murta-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q6122027",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrtus_communis",
      "es": "https://es.wikipedia.org/wiki/Myrtus_communis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Myrtus_communis_L._subsp._communis_-_52505075873.png/330px-Myrtus_communis_L._subsp._communis_-_52505075873.png",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Starr_080304-3229_Myrtus_communis.jpg/330px-Starr_080304-3229_Myrtus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrtus_communis",
    "gbif": "https://www.gbif.org/species/3180085",
    "extract": {
      "en": "Myrtus communis, the common myrtle or true myrtle, is a species of flowering plant in the myrtle family Myrtaceae. It is an evergreen shrub native to southern Europe, North Africa, Western Asia, Macaronesia, and the Indian subcontinent, and also cultivated.",
      "es": "El mirto o arrayán europeo es una planta de la familia de las Myrtaceae, nativa del sudeste de Europa y del norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 811
      },
      "ifn3": {
        "count": 805
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
    "isGenus": 1,
    "scientificName": {
      "la": "Acer"
    },
    "vulgarName": [
      {
        "de": "Ahorne"
      },
      {
        "fr": "Érable"
      },
      {
        "pt": "Acer (botânica)"
      },
      {
        "es": "Arces"
      },
      {
        "en": "Maples"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q42292",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Maple",
      "es": "https://es.wikipedia.org/wiki/Acer_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Acer_pseudoplatanus_002.jpg/330px-Acer_pseudoplatanus_002.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg/330px-Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer",
    "gbif": "https://www.gbif.org/species/3189834",
    "extract": {
      "en": "Acer is a genus of trees and shrubs commonly known as maples. The genus is placed in the soapberry family Sapindaceae. There are approximately 132 species, most of which are native to East Asia, with a number also appearing in Europe, northern Africa, and North America. Only one species, Acer laurinum, extends to the Southern Hemisphere. The type species of the genus is the sycamore maple Acer pseudoplatanus, one of the most common maple species in Europe. Most maples have easily identifiable palmate leaves and all share distinctive winged fruits. The closest relative of the maples is the small east Asian genus Dipteronia, followed by the more widespread genus Aesculus. Maple syrup is made from the sap of some maple species. It is one of the most common genera of trees in Asia. Many maple species are grown in gardens where they are valued for their autumn colour and often decorative foliage, some also for their attractive flowers, fruit, or bark.",
      "es": "Acer es un género de la familia de las sapindáceas, conocidos generalmente como arces, con unas 160 especies aceptadas de las casi 700 descritas. También están aceptados unos 80 taxones infraespecíficos de los más de 1250 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer"
    ],
    "nplots": {
      "ifn2": {
        "count": 811
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer"
    },
    "vulgarName": [
      {
        "en": "Maple"
      },
      {
        "es": "Arce"
      },
      {
        "de": "Ahorne"
      },
      {
        "fr": "Érable"
      },
      {
        "pt": "Acer (botânica)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q42292",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Maple",
      "es": "https://es.wikipedia.org/wiki/Acer_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Acer_pseudoplatanus_002.jpg/330px-Acer_pseudoplatanus_002.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg/330px-Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer",
    "gbif": "https://www.gbif.org/species/3189834",
    "extract": {
      "en": "Acer is a genus of trees and shrubs commonly known as maples. The genus is placed in the soapberry family Sapindaceae. There are approximately 132 species, most of which are native to East Asia, with a number also appearing in Europe, northern Africa, and North America. Only one species, Acer laurinum, extends to the Southern Hemisphere. The type species of the genus is the sycamore maple Acer pseudoplatanus, one of the most common maple species in Europe. Most maples have easily identifiable palmate leaves and all share distinctive winged fruits. The closest relative of the maples is the small east Asian genus Dipteronia, followed by the more widespread genus Aesculus. Maple syrup is made from the sap of some maple species. It is one of the most common genera of trees in Asia. Many maple species are grown in gardens where they are valued for their autumn colour and often decorative foliage, some also for their attractive flowers, fruit, or bark.",
      "es": "Acer es un género de la familia de las sapindáceas, conocidos generalmente como arces, con unas 160 especies aceptadas de las casi 700 descritas. También están aceptados unos 80 taxones infraespecíficos de los más de 1250 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 811
      },
      "ifn3": {
        "count": 633
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer"
    },
    "vulgarName": [
      {
        "en": "Maple"
      },
      {
        "es": "Arce"
      },
      {
        "de": "Ahorne"
      },
      {
        "fr": "Érable"
      },
      {
        "pt": "Acer (botânica)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q42292",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Maple",
      "es": "https://es.wikipedia.org/wiki/Acer_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Acer_pseudoplatanus_002.jpg/330px-Acer_pseudoplatanus_002.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg/330px-Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer",
    "gbif": "https://www.gbif.org/species/3189834",
    "extract": {
      "en": "Acer is a genus of trees and shrubs commonly known as maples. The genus is placed in the soapberry family Sapindaceae. There are approximately 132 species, most of which are native to East Asia, with a number also appearing in Europe, northern Africa, and North America. Only one species, Acer laurinum, extends to the Southern Hemisphere. The type species of the genus is the sycamore maple Acer pseudoplatanus, one of the most common maple species in Europe. Most maples have easily identifiable palmate leaves and all share distinctive winged fruits. The closest relative of the maples is the small east Asian genus Dipteronia, followed by the more widespread genus Aesculus. Maple syrup is made from the sap of some maple species. It is one of the most common genera of trees in Asia. Many maple species are grown in gardens where they are valued for their autumn colour and often decorative foliage, some also for their attractive flowers, fruit, or bark.",
      "es": "Acer es un género de la familia de las sapindáceas, conocidos generalmente como arces, con unas 160 especies aceptadas de las casi 700 descritas. También están aceptados unos 80 taxones infraespecíficos de los más de 1250 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer monspessulanum"
    },
    "vulgarName": [
      {
        "en": "Montpellier maple"
      },
      {
        "es": "Arce de Montpelier"
      },
      {
        "de": "Französischer Ahorn"
      },
      {
        "fr": "Érable de Montpellier"
      },
      {
        "pt": "Zelha"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161388",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_monspessulanum",
      "es": "https://es.wikipedia.org/wiki/Acer_monspessulanum"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Acer_monspessulanum_fg02.jpg/330px-Acer_monspessulanum_fg02.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Acer_monspessulanum_fg01.jpg/330px-Acer_monspessulanum_fg01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_monspessulanum",
    "gbif": "https://www.gbif.org/species/7262958",
    "extract": {
      "en": "Acer monspessulanum, the Montpellier maple, is a species of maple native to the Mediterranean region from Morocco and Portugal in the west, to Turkey, Syria, Lebanon, and Israel/Palestine in the east, and north to the Jura Mountains in France and the Eifel in Germany.",
      "es": "Acer monspessulanum, el arce de Montpellier,  enguelgue, o mundillo, es una especie de árbol perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer negundo"
    },
    "vulgarName": [
      {
        "en": "Ash-leaved maple"
      },
      {
        "en": "Box elder"
      },
      {
        "en": "Boxelder maple"
      },
      {
        "en": "Maple ash"
      },
      {
        "es": "Arce negundo"
      },
      {
        "de": "Eschen-Ahorn"
      },
      {
        "fr": "Acer negundo"
      },
      {
        "pt": "Acer negundo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161166",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_negundo",
      "es": "https://es.wikipedia.org/wiki/Acer_negundo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Acer_negundo_44809168.jpg/330px-Acer_negundo_44809168.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Acer_negundoAA.jpg/330px-Acer_negundoAA.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_negundo",
    "gbif": "https://www.gbif.org/species/3189866",
    "extract": {
      "en": "Acer negundo, also known as the box elder, boxelder maple, Manitoba maple or ash-leaved maple, is a species of maple native to North America from Canada to Honduras. It is a fast-growing, short-lived tree with opposite, ash-like compound leaves. It is sometimes considered a weedy or invasive species, and has been naturalized throughout much of the world, including South America, Australia, New Zealand, South Africa, much of Europe, and parts of Asia.",
      "es": "Acer negundo, acezintle, arce negundo o negundo, es una especie de árbol de la familia Sapindaceae nativa de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer opalus"
    },
    "vulgarName": [
      {
        "en": "Italian maple"
      },
      {
        "es": "Arce ópalus"
      },
      {
        "de": "Schneeball-Ahorn"
      },
      {
        "fr": "Érable à feuilles d'obier"
      },
      {
        "pt": "Acer opalus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163822",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_opalus",
      "es": "https://es.wikipedia.org/wiki/Acer_opalus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Acer_opalus_leaves_01_by_Line1.JPG/330px-Acer_opalus_leaves_01_by_Line1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Acer_opalus_a.JPG/330px-Acer_opalus_a.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_opalus",
    "gbif": "https://www.gbif.org/species/7100278",
    "extract": {
      "en": "Acer opalus, the Italian maple, is a species of maple native to the hills and mountains of southern and western Europe, from Italy to Spain and north to southern Germany, and also in northwest Africa in Algeria.",
      "es": "El orón o asar es una especie botánica perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer pseudoplatanus"
    },
    "vulgarName": [
      {
        "en": "Sycamore"
      },
      {
        "es": "Arce seudoplátano"
      },
      {
        "de": "Berg-Ahorn"
      },
      {
        "fr": "Érable sycomore"
      },
      {
        "pt": "Acer pseudoplatanus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156944",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_pseudoplatanus",
      "es": "https://es.wikipedia.org/wiki/Acer_pseudoplatanus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Acer_pseudoplatanus_005.jpg/330px-Acer_pseudoplatanus_005.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Acer_pseudoplatanus_Sturm07017.jpg/330px-Acer_pseudoplatanus_Sturm07017.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_pseudoplatanus",
    "gbif": "https://www.gbif.org/species/3189870",
    "extract": {
      "en": "Acer pseudoplatanus, known as the sycamore in the British Isles and as the sycamore maple in the United States, is a species of maple native to Central Europe and Western Asia. It is a large deciduous, broad-leaved tree, tolerant of wind and coastal exposure.",
      "es": "El arce blanco, falso plátano o arce sicómoro es una especie arbórea caducifolia perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer platanoides"
    },
    "vulgarName": [
      {
        "en": "Norway maple"
      },
      {
        "es": "Arce platanoide"
      },
      {
        "de": "Spitzahorn"
      },
      {
        "fr": "Érable plane"
      },
      {
        "pt": "Acer platanoides"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26745",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_platanoides",
      "es": "https://es.wikipedia.org/wiki/Acer_platanoides"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Spitz-Ahorn%28mbo%29.jpg/330px-Spitz-Ahorn%28mbo%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_platanoides",
    "gbif": "https://www.gbif.org/species/3189846",
    "extract": {
      "en": "Acer platanoides, commonly known as the Norway maple, is a species of maple native to eastern and central Europe and western Asia, from Spain east to Russia, north to southern Scandinavia and southeast to northern Iran. It was introduced to North America in the mid-1700s as a shade tree. It is a member of the family Sapindaceae.",
      "es": "El arce real, arce de Noruega, arce noruego o arce platanoide, es una especie arbórea perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 172
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer campestre"
    },
    "vulgarName": [
      {
        "es": "Arce"
      },
      {
        "en": "Field maple"
      },
      {
        "de": "Feldahorn"
      },
      {
        "fr": "Érable champêtre"
      },
      {
        "pt": "Acer campestre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158785",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_campestre",
      "es": "https://es.wikipedia.org/wiki/Acer_campestre"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Acer_campestre_in_Appennino2.jpg/330px-Acer_campestre_in_Appennino2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Entzia_-_Acer_Campestre_02.jpg/330px-Entzia_-_Acer_Campestre_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_campestre",
    "gbif": "https://www.gbif.org/species/3189863",
    "extract": {
      "en": "Acer campestre, known as the field maple, is a flowering plant species in the family Sapindaceae. It is native to much of continental Europe, Britain, southwest Asia from Turkey to the Caucasus, and north Africa in the Atlas Mountains. It has been widely planted, and is introduced outside its native range in Europe and areas of USA and Western Australia with suitable climate.",
      "es": "Acer campestre, el arce menor, arce campestre o arce silvestre es una especie perteneciente a la familia de las sapindáceas. Muy extendida por Europa y oeste de Asia; también en algunas zonas del norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Acer"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 633
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species976",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer"
    },
    "vulgarName": [
      {
        "en": "Maple"
      },
      {
        "es": "Arce"
      },
      {
        "de": "Ahorne"
      },
      {
        "fr": "Érable"
      },
      {
        "pt": "Acer (botânica)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q42292",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Maple",
      "es": "https://es.wikipedia.org/wiki/Acer_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Acer_pseudoplatanus_002.jpg/330px-Acer_pseudoplatanus_002.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg/330px-Acer_campestre_%E2%80%94_Flora_Batava_%E2%80%94_Volume_v15.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer",
    "gbif": "https://www.gbif.org/species/3189834",
    "extract": {
      "en": "Acer is a genus of trees and shrubs commonly known as maples. The genus is placed in the soapberry family Sapindaceae. There are approximately 132 species, most of which are native to East Asia, with a number also appearing in Europe, northern Africa, and North America. Only one species, Acer laurinum, extends to the Southern Hemisphere. The type species of the genus is the sycamore maple Acer pseudoplatanus, one of the most common maple species in Europe. Most maples have easily identifiable palmate leaves and all share distinctive winged fruits. The closest relative of the maples is the small east Asian genus Dipteronia, followed by the more widespread genus Aesculus. Maple syrup is made from the sap of some maple species. It is one of the most common genera of trees in Asia. Many maple species are grown in gardens where they are valued for their autumn colour and often decorative foliage, some also for their attractive flowers, fruit, or bark.",
      "es": "Acer es un género de la familia de las sapindáceas, conocidos generalmente como arces, con unas 160 especies aceptadas de las casi 700 descritas. También están aceptados unos 80 taxones infraespecíficos de los más de 1250 descritos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species76"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 172
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerCampestre",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer campestre"
    },
    "vulgarName": [
      {
        "es": "Arce"
      },
      {
        "en": "Field maple"
      },
      {
        "de": "Feldahorn"
      },
      {
        "fr": "Érable champêtre"
      },
      {
        "pt": "Acer campestre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158785",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_campestre",
      "es": "https://es.wikipedia.org/wiki/Acer_campestre"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Acer_campestre_in_Appennino2.jpg/330px-Acer_campestre_in_Appennino2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Entzia_-_Acer_Campestre_02.jpg/330px-Entzia_-_Acer_Campestre_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_campestre",
    "gbif": "https://www.gbif.org/species/3189863",
    "extract": {
      "en": "Acer campestre, known as the field maple, is a flowering plant species in the family Sapindaceae. It is native to much of continental Europe, Britain, southwest Asia from Turkey to the Caucasus, and north Africa in the Atlas Mountains. It has been widely planted, and is introduced outside its native range in Europe and areas of USA and Western Australia with suitable climate.",
      "es": "Acer campestre, el arce menor, arce campestre o arce silvestre es una especie perteneciente a la familia de las sapindáceas. Muy extendida por Europa y oeste de Asia; también en algunas zonas del norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species276"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerMonspessulanum",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer monspessulanum"
    },
    "vulgarName": [
      {
        "en": "Montpellier maple"
      },
      {
        "es": "Arce de Montpelier"
      },
      {
        "de": "Französischer Ahorn"
      },
      {
        "fr": "Érable de Montpellier"
      },
      {
        "pt": "Zelha"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161388",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_monspessulanum",
      "es": "https://es.wikipedia.org/wiki/Acer_monspessulanum"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Acer_monspessulanum_fg02.jpg/330px-Acer_monspessulanum_fg02.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Acer_monspessulanum_fg01.jpg/330px-Acer_monspessulanum_fg01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_monspessulanum",
    "gbif": "https://www.gbif.org/species/7262958",
    "extract": {
      "en": "Acer monspessulanum, the Montpellier maple, is a species of maple native to the Mediterranean region from Morocco and Portugal in the west, to Turkey, Syria, Lebanon, and Israel/Palestine in the east, and north to the Jura Mountains in France and the Eifel in Germany.",
      "es": "Acer monspessulanum, el arce de Montpellier,  enguelgue, o mundillo, es una especie de árbol perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species376"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerNegundo",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer negundo"
    },
    "vulgarName": [
      {
        "en": "Ash-leaved maple"
      },
      {
        "en": "Box elder"
      },
      {
        "en": "Boxelder maple"
      },
      {
        "en": "Maple ash"
      },
      {
        "es": "Arce negundo"
      },
      {
        "de": "Eschen-Ahorn"
      },
      {
        "fr": "Acer negundo"
      },
      {
        "pt": "Acer negundo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161166",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_negundo",
      "es": "https://es.wikipedia.org/wiki/Acer_negundo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Acer_negundo_44809168.jpg/330px-Acer_negundo_44809168.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Acer_negundoAA.jpg/330px-Acer_negundoAA.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_negundo",
    "gbif": "https://www.gbif.org/species/3189866",
    "extract": {
      "en": "Acer negundo, also known as the box elder, boxelder maple, Manitoba maple or ash-leaved maple, is a species of maple native to North America from Canada to Honduras. It is a fast-growing, short-lived tree with opposite, ash-like compound leaves. It is sometimes considered a weedy or invasive species, and has been naturalized throughout much of the world, including South America, Australia, New Zealand, South Africa, much of Europe, and parts of Asia.",
      "es": "Acer negundo, acezintle, arce negundo o negundo, es una especie de árbol de la familia Sapindaceae nativa de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species476"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerOpalus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer opalus"
    },
    "vulgarName": [
      {
        "en": "Italian maple"
      },
      {
        "es": "Arce ópalus"
      },
      {
        "de": "Schneeball-Ahorn"
      },
      {
        "fr": "Érable à feuilles d'obier"
      },
      {
        "pt": "Acer opalus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163822",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_opalus",
      "es": "https://es.wikipedia.org/wiki/Acer_opalus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Acer_opalus_leaves_01_by_Line1.JPG/330px-Acer_opalus_leaves_01_by_Line1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Acer_opalus_a.JPG/330px-Acer_opalus_a.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_opalus",
    "gbif": "https://www.gbif.org/species/7100278",
    "extract": {
      "en": "Acer opalus, the Italian maple, is a species of maple native to the hills and mountains of southern and western Europe, from Italy to Spain and north to southern Germany, and also in northwest Africa in Algeria.",
      "es": "El orón o asar es una especie botánica perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species676"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPlatanoides",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer platanoides"
    },
    "vulgarName": [
      {
        "en": "Norway maple"
      },
      {
        "es": "Arce platanoide"
      },
      {
        "de": "Spitzahorn"
      },
      {
        "fr": "Érable plane"
      },
      {
        "pt": "Acer platanoides"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26745",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_platanoides",
      "es": "https://es.wikipedia.org/wiki/Acer_platanoides"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Spitz-Ahorn%28mbo%29.jpg/330px-Spitz-Ahorn%28mbo%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_platanoides",
    "gbif": "https://www.gbif.org/species/3189846",
    "extract": {
      "en": "Acer platanoides, commonly known as the Norway maple, is a species of maple native to eastern and central Europe and western Asia, from Spain east to Russia, north to southern Scandinavia and southeast to northern Iran. It was introduced to North America in the mid-1700s as a shade tree. It is a member of the family Sapindaceae.",
      "es": "El arce real, arce de Noruega, arce noruego o arce platanoide, es una especie arbórea perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species576"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus171",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AcerPseudoplatanus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Acer pseudoplatanus"
    },
    "vulgarName": [
      {
        "en": "Sycamore"
      },
      {
        "es": "Arce seudoplátano"
      },
      {
        "de": "Berg-Ahorn"
      },
      {
        "fr": "Érable sycomore"
      },
      {
        "pt": "Acer pseudoplatanus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156944",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Acer_pseudoplatanus",
      "es": "https://es.wikipedia.org/wiki/Acer_pseudoplatanus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Acer_pseudoplatanus_005.jpg/330px-Acer_pseudoplatanus_005.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Acer_pseudoplatanus_Sturm07017.jpg/330px-Acer_pseudoplatanus_Sturm07017.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Acer_pseudoplatanus",
    "gbif": "https://www.gbif.org/species/3189870",
    "extract": {
      "en": "Acer pseudoplatanus, known as the sycamore in the British Isles and as the sycamore maple in the United States, is a species of maple native to Central Europe and Western Asia. It is a large deciduous, broad-leaved tree, tolerant of wind and coastal exposure.",
      "es": "El arce blanco, falso plátano o arce sicómoro es una especie arbórea caducifolia perteneciente a la familia de las sapindáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
    "isGenus": 1,
    "scientificName": {
      "la": "Pistacia"
    },
    "vulgarName": [
      {
        "en": "Pistachios"
      },
      {
        "es": "Pistachos"
      },
      {
        "de": "Pistazien"
      },
      {
        "fr": "Pistacia"
      },
      {
        "pt": "Pistacia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q35987",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pistacia",
      "es": "https://es.wikipedia.org/wiki/Pistacia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Pistacia_lentiscus_%28male_flowers%29.jpg/330px-Pistacia_lentiscus_%28male_flowers%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Pistacia_chinensis.jpg/330px-Pistacia_chinensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pistacia",
    "gbif": "https://www.gbif.org/species/3190459",
    "extract": {
      "en": "Pistacia is a genus of flowering plants in the cashew family, Anacardiaceae. It contains 10 to 20 species that are native to Africa and Eurasia from the Canary Islands, all of Africa, and southern Europe, warm and semidesert areas across Asia, and North America from Guatemala to Mexico, as well as southern Texas.",
      "es": "Pistacia es un género de diez especies de la familia Anacardiaceae, del orden de las sapindales, nativo de las Islas Canarias, norte de África incluyendo el Sahara, zonas cálidas y esteparias de Eurasia: sur de Europa, Asia central y oriental, y zonas cálidas de Norteamérica: México, Texas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pistacia terebinthus / Pistacia atlantica"
    },
    "vulgarName": [
      {
        "en": "Mt. Atlas mastic tree"
      },
      {
        "en": "Persian turpentine tree"
      },
      {
        "en": "Terebinth"
      },
      {
        "en": "Turpentine tree"
      },
      {
        "es": "Cornicabra"
      },
      {
        "es": "Cornicabra canaria"
      },
      {
        "de": "Atlantische Pistazie"
      },
      {
        "de": "Terpentin-Pistazie"
      },
      {
        "fr": "Pistachier térébinthe"
      },
      {
        "pt": "Terebinto"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q1788810",
      "http://www.wikidata.org/entity/Q63045"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pistacia terebinthus / Pistacia atlantica"
    },
    "vulgarName": [
      {
        "en": "Mt. Atlas mastic tree"
      },
      {
        "en": "Persian turpentine tree"
      },
      {
        "en": "Terebinth"
      },
      {
        "en": "Turpentine tree"
      },
      {
        "es": "Cornicabra"
      },
      {
        "es": "Cornicabra canaria"
      },
      {
        "de": "Atlantische Pistazie"
      },
      {
        "de": "Terpentin-Pistazie"
      },
      {
        "fr": "Pistachier térébinthe"
      },
      {
        "pt": "Terebinto"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q1788810",
      "http://www.wikidata.org/entity/Q63045"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species293",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pistacia atlantica"
    },
    "vulgarName": [
      {
        "en": "Mt. Atlas mastic tree"
      },
      {
        "en": "Persian turpentine tree"
      },
      {
        "es": "Cornicabra canaria"
      },
      {
        "de": "Atlantische Pistazie"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1788810",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pistacia_atlantica",
      "es": "https://es.wikipedia.org/wiki/Pistacia_atlantica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Pistacia_atlantica_%28Ein_Ovdat%29.JPG/330px-Pistacia_atlantica_%28Ein_Ovdat%29.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pistacia_atlantica",
    "gbif": "https://www.gbif.org/species/3190581",
    "extract": {
      "en": "Pistacia atlantica is a species of pistachio tree known by the English common names Mt. Atlas mastic tree, Mount Atlas pistachio, Atlantic pistachio, wild pistachio, turpentine tree and Atlantic terebinth.\nP. atlantica has three subspecies or varieties which have been described as atlantica, cabulica, and mutica. According to molecular phylogenetic studies, P. atlantica subsp. kurdica is actually a separate species, Pistacia eurycarpa.",
      "es": "El almácigo de Canarias o lengua de oveja es un árbol del género pistacia, de la familia de las anacardiáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus181",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PistaciaTerebinthusPistaciaAtlantica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species93",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pistacia terebinthus"
    },
    "vulgarName": [
      {
        "en": "Terebinth"
      },
      {
        "en": "Turpentine tree"
      },
      {
        "es": "Cornicabra"
      },
      {
        "de": "Terpentin-Pistazie"
      },
      {
        "fr": "Pistachier térébinthe"
      },
      {
        "pt": "Terebinto"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q63045",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pistacia_terebinthus",
      "es": "https://es.wikipedia.org/wiki/Pistacia_terebinthus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Pistacia_palaestina.JPG/330px-Pistacia_palaestina.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Pistachier2.JPG/330px-Pistachier2.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pistacia_terebinthus",
    "gbif": "https://www.gbif.org/species/3190580",
    "extract": {
      "en": "Pistacia terebinthus, also called the terebinth, is a deciduous shrub species of the genus Pistacia, native to the Mediterranean region from the western regions of Morocco and Portugal to Greece and western and southeastern Turkey. At one time terebinths growing on the eastern shores of the Mediterranean Sea were regarded as a separate species, Pistacia palaestina, but these are now considered to be a synonym of P. terebinthus.",
      "es": "El albotín, cornicabra o terebinto es un arbusto o árbol pequeño de hasta 6 m de alto de la familia de las anacardiáceas, del género Pistacia, nativo del Mediterráneo occidental y que se extiende desde las islas Canarias, Marruecos y la península ibérica, hasta Grecia y el oeste de Turquía."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
    "isGenus": 1,
    "scientificName": {
      "la": "Rhus"
    },
    "vulgarName": [
      {
        "en": "Rhus"
      },
      {
        "es": "Rhus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157649",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sumac",
      "es": "https://es.wikipedia.org/wiki/Rhus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/SumacFruit.JPG/330px-SumacFruit.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Rhus_copallinum.jpg/330px-Rhus_copallinum.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhus",
    "gbif": "https://www.gbif.org/species/3190534",
    "extract": {
      "en": "Sumac or sumach —not to be confused with poison sumac—is any of the roughly 35 species of flowering plants in the genus Rhus of the cashew and mango tree family, Anacardiaceae. However, it is Rhus coriaria that is most commonly used for culinary purposes. Sumac is prized as a spice—especially in Arab cuisine, and other Eastern cuisines—and used as a dye and holistic remedy. The plants grow in subtropical and temperate regions, on nearly every continent except Antarctica and South America.\nIt holds cultural significance as a symbolic item on the Haft-sin table during Nowruz, the Persian New Year.",
      "es": "Rhus es un género con aproximadamente 250 especies de plantas fanerógamas perteneciente a la familia Anacardiaceae. Algunas especies antes emplazadas en este género, ahora son incluidas en el género Toxicodendron, como T. radicans, T. diversilobum y T. vernix, y se diferencian por su follaje altamente alergénico y por su fruto blanco grisáceo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhus coriaria"
    },
    "vulgarName": [
      {
        "en": "Elm-leaved sumach"
      },
      {
        "en": "Sicilian sumac"
      },
      {
        "en": "Tanner's sumach"
      },
      {
        "es": "Zumaque"
      },
      {
        "de": "Gerber-Sumach"
      },
      {
        "fr": "Rhus coriaria"
      },
      {
        "pt": "Rhus coriaria"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159546",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhus_coriaria",
      "es": "https://es.wikipedia.org/wiki/Rhus_coriaria"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Sommacco.jpg/330px-Sommacco.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg/330px-Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhus_coriaria",
    "gbif": "https://www.gbif.org/species/3190563",
    "extract": {
      "en": "Rhus coriaria, commonly called Sicilian sumac, tanner's sumach, or elm-leaved sumach, is a deciduous shrub to small tree in the cashew family Anacardiaceae. It is native to southern Europe and western Asia. The dried fruits are used as a spice, particularly in combination with other spices in the mixture called za'atar.",
      "es": "Rhus coriaria, conocida popularmente como rus, es una especie de Rhus que se emplea principalmente en el curtido de cuero; su nombre científico en latín lo indica: coriarii (curtir). Es originaria del sur de Europa. En España suele denominarse zumaque."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhus coriaria"
    },
    "vulgarName": [
      {
        "en": "Elm-leaved sumach"
      },
      {
        "en": "Sicilian sumac"
      },
      {
        "en": "Tanner's sumach"
      },
      {
        "es": "Zumaque"
      },
      {
        "de": "Gerber-Sumach"
      },
      {
        "fr": "Rhus coriaria"
      },
      {
        "pt": "Rhus coriaria"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159546",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhus_coriaria",
      "es": "https://es.wikipedia.org/wiki/Rhus_coriaria"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Sommacco.jpg/330px-Sommacco.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg/330px-Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhus_coriaria",
    "gbif": "https://www.gbif.org/species/3190563",
    "extract": {
      "en": "Rhus coriaria, commonly called Sicilian sumac, tanner's sumach, or elm-leaved sumach, is a deciduous shrub to small tree in the cashew family Anacardiaceae. It is native to southern Europe and western Asia. The dried fruits are used as a spice, particularly in combination with other spices in the mixture called za'atar.",
      "es": "Rhus coriaria, conocida popularmente como rus, es una especie de Rhus que se emplea principalmente en el curtido de cuero; su nombre científico en latín lo indica: coriarii (curtir). Es originaria del sur de Europa. En España suele denominarse zumaque."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus182",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhusCoriaria"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species96",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhus coriaria"
    },
    "vulgarName": [
      {
        "en": "Elm-leaved sumach"
      },
      {
        "en": "Sicilian sumac"
      },
      {
        "en": "Tanner's sumach"
      },
      {
        "es": "Zumaque"
      },
      {
        "de": "Gerber-Sumach"
      },
      {
        "fr": "Rhus coriaria"
      },
      {
        "pt": "Rhus coriaria"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159546",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhus_coriaria",
      "es": "https://es.wikipedia.org/wiki/Rhus_coriaria"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Sommacco.jpg/330px-Sommacco.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg/330px-Toxicodendron_succedaneum_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-272.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhus_coriaria",
    "gbif": "https://www.gbif.org/species/3190563",
    "extract": {
      "en": "Rhus coriaria, commonly called Sicilian sumac, tanner's sumach, or elm-leaved sumach, is a deciduous shrub to small tree in the cashew family Anacardiaceae. It is native to southern Europe and western Asia. The dried fruits are used as a spice, particularly in combination with other spices in the mixture called za'atar.",
      "es": "Rhus coriaria, conocida popularmente como rus, es una especie de Rhus que se emplea principalmente en el curtido de cuero; su nombre científico en latín lo indica: coriarii (curtir). Es originaria del sur de Europa. En España suele denominarse zumaque."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1357
      },
      "ifn3": {
        "count": 1333
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
    "isGenus": 1,
    "scientificName": {
      "la": "Betula"
    },
    "vulgarName": [
      {
        "es": "Abedules"
      },
      {
        "en": "Birches"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25243",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Birch",
      "es": "https://es.wikipedia.org/wiki/Betula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Betula_pendula_001.jpg/330px-Betula_pendula_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Betula_ermannii0.jpg/330px-Betula_ermannii0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betula",
    "gbif": "https://www.gbif.org/species/2875008",
    "extract": {
      "en": "A birch is a thin-leaved deciduous hardwood tree of the genus Betula, in the family Betulaceae, which also includes alders, hazels, and hornbeams. It is closely related to the beech-oak family Fagaceae. The genus Betula contains 30 to 60 known taxa of which 11 are on the IUCN 2011 Red List of Threatened Species. They are typically short-lived pioneer species and are widespread in the Northern Hemisphere, particularly in northern areas of temperate climates and in boreal climates. Birch wood is used for a wide range of purposes.",
      "es": "Betula es un género de árboles de la familia Betulaceae y del orden Fagales. El nombre común «abedul» designa a varios diferentes árboles caducifolios pertenecientes a este género; a veces también se designa con este nombre a los alisos, árboles pertenecientes a la misma familia. Su nombre procede del latín betūlla, que a su vez procedería de la palabra betu, que era como los celtas designaban al abedul."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld"
    ],
    "nplots": {
      "ifn2": {
        "count": 1357
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula pendula Roth / Quercus pubescens Willd."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species73"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1357
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendulaRothQuercusPubescensWilld",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula pendula Roth / Quercus pubescens Willd."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula alba"
    },
    "vulgarName": [
      {
        "en": "Downy birch"
      },
      {
        "en": "European white birch"
      },
      {
        "en": "Hairy birch"
      },
      {
        "en": "Moor birch"
      },
      {
        "en": "White birch"
      },
      {
        "es": "Abedul pubescente"
      },
      {
        "de": "Moor-Birke"
      },
      {
        "fr": "Betula pubescens"
      },
      {
        "pt": "Betula pubescens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12836942"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula pendula"
    },
    "vulgarName": [
      {
        "en": "European white birch"
      },
      {
        "en": "Silver birch"
      },
      {
        "en": "Warty birch"
      },
      {
        "es": "Abedul péndula"
      },
      {
        "de": "Hänge-Birke"
      },
      {
        "fr": "Bouleau verruqueux"
      },
      {
        "pt": "Vidoeiro-branco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156895",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Betula_pendula",
      "es": "https://es.wikipedia.org/wiki/Betula_pendula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Betula_pendula_Finland.jpg/330px-Betula_pendula_Finland.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Arukask_T%C3%BCril.jpg/330px-Arukask_T%C3%BCril.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betula_pendula",
    "gbif": "https://www.gbif.org/species/5331916",
    "extract": {
      "en": "Betula pendula, commonly known as silver birch, warty birch, European white birch, or East Asian white birch, is a species of tree in the family Betulaceae, native to Europe and parts of Asia, though in southern Europe, it is only found at higher altitudes. Its range extends into Siberia, China, and southwest Asia in the mountains of northern Turkey, the Caucasus, and northern Iran. It has been introduced into North America, where it is known as the European white birch or weeping birch and is considered invasive in some states in the United States and parts of Canada.",
      "es": "El\nabedul común,\nabedul europeo,\nabedul llorón\nabedul péndulo,\nabedul plateado,\nabedul verrugoso o\naliso europeo\n(Betula pendula)\n(sin. B. verrucosa, Ehrh.)\nes un árbol caducifolio del género Betula."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1333
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula"
    },
    "vulgarName": [
      {
        "en": "Birch"
      },
      {
        "es": "Abedul"
      },
      {
        "de": "Birken"
      },
      {
        "fr": "Bouleau"
      },
      {
        "pt": "Bétula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25243",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Birch",
      "es": "https://es.wikipedia.org/wiki/Betula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Betula_pendula_001.jpg/330px-Betula_pendula_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Betula_ermannii0.jpg/330px-Betula_ermannii0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betula",
    "gbif": "https://www.gbif.org/species/2875008",
    "extract": {
      "en": "A birch is a thin-leaved deciduous hardwood tree of the genus Betula, in the family Betulaceae, which also includes alders, hazels, and hornbeams. It is closely related to the beech-oak family Fagaceae. The genus Betula contains 30 to 60 known taxa of which 11 are on the IUCN 2011 Red List of Threatened Species. They are typically short-lived pioneer species and are widespread in the Northern Hemisphere, particularly in northern areas of temperate climates and in boreal climates. Birch wood is used for a wide range of purposes.",
      "es": "Betula es un género de árboles de la familia Betulaceae y del orden Fagales. El nombre común «abedul» designa a varios diferentes árboles caducifolios pertenecientes a este género; a veces también se designa con este nombre a los alisos, árboles pertenecientes a la misma familia. Su nombre procede del latín betūlla, que a su vez procedería de la palabra betu, que era como los celtas designaban al abedul."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species73"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1333
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Betula",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula"
    },
    "vulgarName": [
      {
        "en": "Birch"
      },
      {
        "es": "Abedul"
      },
      {
        "de": "Birken"
      },
      {
        "fr": "Bouleau"
      },
      {
        "pt": "Bétula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25243",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Birch",
      "es": "https://es.wikipedia.org/wiki/Betula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Betula_pendula_001.jpg/330px-Betula_pendula_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Betula_ermannii0.jpg/330px-Betula_ermannii0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betula",
    "gbif": "https://www.gbif.org/species/2875008",
    "extract": {
      "en": "A birch is a thin-leaved deciduous hardwood tree of the genus Betula, in the family Betulaceae, which also includes alders, hazels, and hornbeams. It is closely related to the beech-oak family Fagaceae. The genus Betula contains 30 to 60 known taxa of which 11 are on the IUCN 2011 Red List of Threatened Species. They are typically short-lived pioneer species and are widespread in the Northern Hemisphere, particularly in northern areas of temperate climates and in boreal climates. Birch wood is used for a wide range of purposes.",
      "es": "Betula es un género de árboles de la familia Betulaceae y del orden Fagales. El nombre común «abedul» designa a varios diferentes árboles caducifolios pertenecientes a este género; a veces también se designa con este nombre a los alisos, árboles pertenecientes a la misma familia. Su nombre procede del latín betūlla, que a su vez procedería de la palabra betu, que era como los celtas designaban al abedul."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species273"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaAlba",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula alba"
    },
    "vulgarName": [
      {
        "en": "Downy birch"
      },
      {
        "en": "European white birch"
      },
      {
        "en": "Hairy birch"
      },
      {
        "en": "Moor birch"
      },
      {
        "en": "White birch"
      },
      {
        "es": "Abedul pubescente"
      },
      {
        "de": "Moor-Birke"
      },
      {
        "fr": "Betula pubescens"
      },
      {
        "pt": "Betula pubescens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12836942"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species373"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus191",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BetulaPendula",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Betula pendula"
    },
    "vulgarName": [
      {
        "en": "European white birch"
      },
      {
        "en": "Silver birch"
      },
      {
        "en": "Warty birch"
      },
      {
        "es": "Abedul péndula"
      },
      {
        "de": "Hänge-Birke"
      },
      {
        "fr": "Bouleau verruqueux"
      },
      {
        "pt": "Vidoeiro-branco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156895",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Betula_pendula",
      "es": "https://es.wikipedia.org/wiki/Betula_pendula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Betula_pendula_Finland.jpg/330px-Betula_pendula_Finland.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Arukask_T%C3%BCril.jpg/330px-Arukask_T%C3%BCril.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Betula_pendula",
    "gbif": "https://www.gbif.org/species/5331916",
    "extract": {
      "en": "Betula pendula, commonly known as silver birch, warty birch, European white birch, or East Asian white birch, is a species of tree in the family Betulaceae, native to Europe and parts of Asia, though in southern Europe, it is only found at higher altitudes. Its range extends into Siberia, China, and southwest Asia in the mountains of northern Turkey, the Caucasus, and northern Iran. It has been introduced into North America, where it is known as the European white birch or weeping birch and is considered invasive in some states in the United States and parts of Canada.",
      "es": "El\nabedul común,\nabedul europeo,\nabedul llorón\nabedul péndulo,\nabedul plateado,\nabedul verrugoso o\naliso europeo\n(Betula pendula)\n(sin. B. verrucosa, Ehrh.)\nes un árbol caducifolio del género Betula."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 562
      },
      "ifn3": {
        "count": 543
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
    "isGenus": 1,
    "scientificName": {
      "la": "Alnus"
    },
    "vulgarName": [
      {
        "en": "Alders"
      },
      {
        "es": "Alisos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25239",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Alder",
      "es": "https://es.wikipedia.org/wiki/Alnus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/20120904Alnus_glutinosa01.jpg/330px-20120904Alnus_glutinosa01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/1/19/Tagalder8139.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Alnus",
    "gbif": "https://www.gbif.org/species/2876099",
    "extract": {
      "en": "Alders are trees of the genus Alnus in the birch family Betulaceae. The genus includes about 35 species of monoecious trees and shrubs, a few reaching a large size, distributed throughout the north temperate zone with a few species extending into Central America, as well as the northern and southern Andes.",
      "es": "Alnus es un género de árboles de la familia Betulaceae. Contiene treinta especies de árboles y arbustos monoicos, denominados alisos, distribuidos por todo el mundo. Presentan hojas ovadas y de borde dentado o serrado. Las flores son en forma de amentos, los masculinos alargados y los femeninos cortos, ambos en la misma planta."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 562
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Alnus glutinosa"
    },
    "vulgarName": [
      {
        "en": "Alder"
      },
      {
        "en": "Black alder"
      },
      {
        "en": "Common alder"
      },
      {
        "en": "European alder"
      },
      {
        "es": "Aliso"
      },
      {
        "de": "Schwarz-Erle"
      },
      {
        "fr": "Alnus glutinosa"
      },
      {
        "pt": "Amieiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156904",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Alnus_glutinosa",
      "es": "https://es.wikipedia.org/wiki/Alnus_glutinosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/20120904Alnus_glutinosa01.jpg/330px-20120904Alnus_glutinosa01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Alnus_glutinosa_011.jpg/330px-Alnus_glutinosa_011.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Alnus_glutinosa",
    "gbif": "https://www.gbif.org/species/2876213",
    "extract": {
      "en": "Alnus glutinosa, the common alder, black alder, European alder, European black alder, or just alder, is a species of tree in the family Betulaceae, native to most of Europe, southwest Asia and northern Africa. It thrives in wet locations where its association with the bacterium Frankia alni enables it to grow in poor quality soils. It is a medium-sized, short-lived tree growing to a height of up to 30 metres (98 feet). It has short-stalked rounded leaves and separate male and female flowers in the form of catkins. The small, rounded fruits are cone-like and the seeds are dispersed by wind and water.",
      "es": "Alnus glutinosa, el aliso común o alno; también llamado, aliso negro, alisa o aliso, es un árbol de la familia de las betuláceas extendido por Europa y el suroeste de Asia. Su hábitat natural son los lugares húmedos y bosques de ribera. Habita por ejemplo en gran parte de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 562
      },
      "ifn3": {
        "count": 543
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Alnus glutinosa"
    },
    "vulgarName": [
      {
        "en": "Alder"
      },
      {
        "en": "Black alder"
      },
      {
        "en": "Common alder"
      },
      {
        "en": "European alder"
      },
      {
        "es": "Aliso"
      },
      {
        "de": "Schwarz-Erle"
      },
      {
        "fr": "Alnus glutinosa"
      },
      {
        "pt": "Amieiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156904",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Alnus_glutinosa",
      "es": "https://es.wikipedia.org/wiki/Alnus_glutinosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/20120904Alnus_glutinosa01.jpg/330px-20120904Alnus_glutinosa01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Alnus_glutinosa_011.jpg/330px-Alnus_glutinosa_011.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Alnus_glutinosa",
    "gbif": "https://www.gbif.org/species/2876213",
    "extract": {
      "en": "Alnus glutinosa, the common alder, black alder, European alder, European black alder, or just alder, is a species of tree in the family Betulaceae, native to most of Europe, southwest Asia and northern Africa. It thrives in wet locations where its association with the bacterium Frankia alni enables it to grow in poor quality soils. It is a medium-sized, short-lived tree growing to a height of up to 30 metres (98 feet). It has short-stalked rounded leaves and separate male and female flowers in the form of catkins. The small, rounded fruits are cone-like and the seeds are dispersed by wind and water.",
      "es": "Alnus glutinosa, el aliso común o alno; también llamado, aliso negro, alisa o aliso, es un árbol de la familia de las betuláceas extendido por Europa y el suroeste de Asia. Su hábitat natural son los lugares húmedos y bosques de ribera. Habita por ejemplo en gran parte de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus192",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AlnusGlutinosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 543
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species54",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Alnus glutinosa"
    },
    "vulgarName": [
      {
        "en": "Alder"
      },
      {
        "en": "Black alder"
      },
      {
        "en": "Common alder"
      },
      {
        "en": "European alder"
      },
      {
        "es": "Aliso"
      },
      {
        "de": "Schwarz-Erle"
      },
      {
        "fr": "Alnus glutinosa"
      },
      {
        "pt": "Amieiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156904",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Alnus_glutinosa",
      "es": "https://es.wikipedia.org/wiki/Alnus_glutinosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/20120904Alnus_glutinosa01.jpg/330px-20120904Alnus_glutinosa01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Alnus_glutinosa_011.jpg/330px-Alnus_glutinosa_011.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Alnus_glutinosa",
    "gbif": "https://www.gbif.org/species/2876213",
    "extract": {
      "en": "Alnus glutinosa, the common alder, black alder, European alder, European black alder, or just alder, is a species of tree in the family Betulaceae, native to most of Europe, southwest Asia and northern Africa. It thrives in wet locations where its association with the bacterium Frankia alni enables it to grow in poor quality soils. It is a medium-sized, short-lived tree growing to a height of up to 30 metres (98 feet). It has short-stalked rounded leaves and separate male and female flowers in the form of catkins. The small, rounded fruits are cone-like and the seeds are dispersed by wind and water.",
      "es": "Alnus glutinosa, el aliso común o alno; también llamado, aliso negro, alisa o aliso, es un árbol de la familia de las betuláceas extendido por Europa y el suroeste de Asia. Su hábitat natural son los lugares húmedos y bosques de ribera. Habita por ejemplo en gran parte de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 4
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
    "isGenus": 1,
    "scientificName": {
      "la": "Carpinus"
    },
    "vulgarName": [
      {
        "es": "Carpes"
      },
      {
        "en": "Hornbeams"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158513",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Hornbeam",
      "es": "https://es.wikipedia.org/wiki/Carpinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Carpinus_foliage.jpg/330px-Carpinus_foliage.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Carpinus",
    "gbif": "https://www.gbif.org/species/2875770",
    "extract": {
      "en": "Hornbeams are hardwood trees in the plant genus Carpinus in the family Betulaceae. Its species occur across much of the temperate regions of the Northern Hemisphere.",
      "es": "Los carpes (Carpinus) son un género de árboles relativamente pequeños de madera dura, en la familia Betulaceae, aunque algunos botánicos separan a Corylus y a Ostrya en una segregada familia de Corylaceae. Las 30-40 especies se encuentran atravesando muchas de las regiones templadas del hemisferio norte, con la mayor cantidad de especies en el este de Asia, particularmente China. Solo dos especies son de Europa, y solo una en el este de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus"
    ],
    "nplots": {
      "ifn2": {
        "count": 4
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Carpinus betulus"
    },
    "vulgarName": [
      {
        "en": "Hornbeam"
      },
      {
        "es": "Carpe"
      },
      {
        "de": "Hainbuche"
      },
      {
        "fr": "Charme commun"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158776",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carpinus_betulus",
      "es": "https://es.wikipedia.org/wiki/Carpinus_betulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg/330px-Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg/330px-Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Carpinus_betulus",
    "gbif": "https://www.gbif.org/species/2875818",
    "extract": {
      "en": "Carpinus betulus, the European or common hornbeam, is a species of tree in the birch family Betulaceae, native to Western Asia and central, eastern, and southern Europe, including southern England. It requires a warm climate for good growth, and occurs only at elevations up to 1,000 metres (3,300 ft). It grows in mixed stands with oak, and in some areas beech, and is also a common tree in scree forests. Hornbeam was also known as yoke elm. Together with Carpinus orientalis and Carpinus austrobalcanica, it is one of the three hornbeams found in Europe.",
      "es": "Carpinus betulus, el carpe blanco o carpe europeo, también conocido simplemente como carpe, abedulillo, hojaranzo, charmilla u ojaranzo es un Carpinus nativo del oeste, centro y sur de Europa, extendiéndose tan al oriente como el oeste de Rusia y Ucrania. Requiere un clima templado para buen crecimiento, solo a elevaciones por encima de los 600 m s. n. m. Crece entremezclado con Quercus, y en algunas áreas con Fagus, y es un árbol común en bosques degradados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 4
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Carpinus betulus"
    },
    "vulgarName": [
      {
        "en": "Hornbeam"
      },
      {
        "es": "Carpe"
      },
      {
        "de": "Hainbuche"
      },
      {
        "fr": "Charme commun"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158776",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carpinus_betulus",
      "es": "https://es.wikipedia.org/wiki/Carpinus_betulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg/330px-Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg/330px-Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Carpinus_betulus",
    "gbif": "https://www.gbif.org/species/2875818",
    "extract": {
      "en": "Carpinus betulus, the European or common hornbeam, is a species of tree in the birch family Betulaceae, native to Western Asia and central, eastern, and southern Europe, including southern England. It requires a warm climate for good growth, and occurs only at elevations up to 1,000 metres (3,300 ft). It grows in mixed stands with oak, and in some areas beech, and is also a common tree in scree forests. Hornbeam was also known as yoke elm. Together with Carpinus orientalis and Carpinus austrobalcanica, it is one of the three hornbeams found in Europe.",
      "es": "Carpinus betulus, el carpe blanco o carpe europeo, también conocido simplemente como carpe, abedulillo, hojaranzo, charmilla u ojaranzo es un Carpinus nativo del oeste, centro y sur de Europa, extendiéndose tan al oriente como el oeste de Rusia y Ucrania. Requiere un clima templado para buen crecimiento, solo a elevaciones por encima de los 600 m s. n. m. Crece entremezclado con Quercus, y en algunas áreas con Fagus, y es un árbol común en bosques degradados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus193",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CarpinusBetulus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species98",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Carpinus betulus"
    },
    "vulgarName": [
      {
        "en": "Hornbeam"
      },
      {
        "es": "Carpe"
      },
      {
        "de": "Hainbuche"
      },
      {
        "fr": "Charme commun"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158776",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Carpinus_betulus",
      "es": "https://es.wikipedia.org/wiki/Carpinus_betulus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg/330px-Carpinus_betulus_-_Hunsr%C3%BCck_001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg/330px-Brohmer-Berge-Rothem%C3%BChl-24-10-2009-30.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Carpinus_betulus",
    "gbif": "https://www.gbif.org/species/2875818",
    "extract": {
      "en": "Carpinus betulus, the European or common hornbeam, is a species of tree in the birch family Betulaceae, native to Western Asia and central, eastern, and southern Europe, including southern England. It requires a warm climate for good growth, and occurs only at elevations up to 1,000 metres (3,300 ft). It grows in mixed stands with oak, and in some areas beech, and is also a common tree in scree forests. Hornbeam was also known as yoke elm. Together with Carpinus orientalis and Carpinus austrobalcanica, it is one of the three hornbeams found in Europe.",
      "es": "Carpinus betulus, el carpe blanco o carpe europeo, también conocido simplemente como carpe, abedulillo, hojaranzo, charmilla u ojaranzo es un Carpinus nativo del oeste, centro y sur de Europa, extendiéndose tan al oriente como el oeste de Rusia y Ucrania. Requiere un clima templado para buen crecimiento, solo a elevaciones por encima de los 600 m s. n. m. Crece entremezclado con Quercus, y en algunas áreas con Fagus, y es un árbol común en bosques degradados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 394
      },
      "ifn3": {
        "count": 345
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
    "isGenus": 1,
    "scientificName": {
      "la": "Corylus"
    },
    "vulgarName": [
      {
        "es": "Avellanos"
      },
      {
        "en": "Hazelnuts"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145889",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Hazel",
      "es": "https://es.wikipedia.org/wiki/Corylus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Corylus_avellana_0001.JPG/330px-Corylus_avellana_0001.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Hazel_Catkins.jpg/330px-Hazel_Catkins.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Corylus",
    "gbif": "https://www.gbif.org/species/2875967",
    "extract": {
      "en": "Hazels are plants of the genus Corylus of deciduous trees and large shrubs native to the temperate Northern Hemisphere. The genus is usually placed in the birch family, Betulaceae, though some botanists split the hazels into a separate family Corylaceae. The fruit of the hazel is the hazelnut.",
      "es": "Corylus es un género de árboles caducifolios y grandes arbustos originario de los climas templados del hemisferio norte, conocidos con el nombre común de avellanos. El género se ubica normalmente en la familia de los abedules, las betuláceas, aunque algunos botánicos sitúan los avellanos en una familia separada, Corylaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana"
    ],
    "nplots": {
      "ifn2": {
        "count": 394
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Corylus avellana"
    },
    "vulgarName": [
      {
        "es": "Avellano"
      },
      {
        "en": "Common hazel"
      },
      {
        "de": "Gemeine Hasel"
      },
      {
        "fr": "Corylus avellana"
      },
      {
        "pt": "Avelã"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q124969",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Corylus_avellana",
      "es": "https://es.wikipedia.org/wiki/Corylus_avellana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Corylus_avellana.jpg/330px-Corylus_avellana.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Illustration_Corylus_avellana0.jpg/330px-Illustration_Corylus_avellana0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Corylus_avellana",
    "gbif": "https://www.gbif.org/species/2875979",
    "extract": {
      "en": "Corylus avellana, the common hazel, is a species of flowering plant in the birch family Betulaceae. The shrubs usually grow 3–8 metres tall. The nut is round, in contrast to the longer filbert nut. Common hazel is native to Europe and Western Asia.",
      "es": "El avellano, avellano común o avellano europeo es un árbol o arbusto caducifolio oriundo de Europa y Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 394
      },
      "ifn3": {
        "count": 345
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Corylus avellana"
    },
    "vulgarName": [
      {
        "es": "Avellano"
      },
      {
        "en": "Common hazel"
      },
      {
        "de": "Gemeine Hasel"
      },
      {
        "fr": "Corylus avellana"
      },
      {
        "pt": "Avelã"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q124969",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Corylus_avellana",
      "es": "https://es.wikipedia.org/wiki/Corylus_avellana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Corylus_avellana.jpg/330px-Corylus_avellana.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Illustration_Corylus_avellana0.jpg/330px-Illustration_Corylus_avellana0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Corylus_avellana",
    "gbif": "https://www.gbif.org/species/2875979",
    "extract": {
      "en": "Corylus avellana, the common hazel, is a species of flowering plant in the birch family Betulaceae. The shrubs usually grow 3–8 metres tall. The nut is round, in contrast to the longer filbert nut. Common hazel is native to Europe and Western Asia.",
      "es": "El avellano, avellano común o avellano europeo es un árbol o arbusto caducifolio oriundo de Europa y Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus194",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family19",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CorylusAvellana"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 345
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species74",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Corylus avellana"
    },
    "vulgarName": [
      {
        "es": "Avellano"
      },
      {
        "en": "Common hazel"
      },
      {
        "de": "Gemeine Hasel"
      },
      {
        "fr": "Corylus avellana"
      },
      {
        "pt": "Avelã"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q124969",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Corylus_avellana",
      "es": "https://es.wikipedia.org/wiki/Corylus_avellana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Corylus_avellana.jpg/330px-Corylus_avellana.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Illustration_Corylus_avellana0.jpg/330px-Illustration_Corylus_avellana0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Corylus_avellana",
    "gbif": "https://www.gbif.org/species/2875979",
    "extract": {
      "en": "Corylus avellana, the common hazel, is a species of flowering plant in the birch family Betulaceae. The shrubs usually grow 3–8 metres tall. The nut is round, in contrast to the longer filbert nut. Common hazel is native to Europe and Western Asia.",
      "es": "El avellano, avellano común o avellano europeo es un árbol o arbusto caducifolio oriundo de Europa y Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 40843
      },
      "ifn3": {
        "count": 43169
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
    "isGenus": 1,
    "scientificName": {
      "la": "Pinus"
    },
    "vulgarName": [
      {
        "es": "Pinos"
      },
      {
        "en": "Pines"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pine",
      "es": "https://es.wikipedia.org/wiki/Pinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg/330px-Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Illustration_Pinus_sylvestris0_new.jpg/330px-Illustration_Pinus_sylvestris0_new.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus",
    "gbif": "https://www.gbif.org/species/2684241",
    "extract": {
      "en": "A pine is any conifer in the genus Pinus of the family Pinaceae. Pinus is the sole genus in the subfamily Pinoideae. The species are evergreen trees or shrubs with their leaves in bunches, usually of 2 to 5 needles. The seeds are carried on woody cones, with two seeds to each cone scale.",
      "es": "Pinus es un género de plantas vasculares, comúnmente llamadas pinos, pertenecientes al grupo de las coníferas y, dentro de este, a la familia de las Pinaceae, que presentan una ramificación frecuentemente verticilada y más o menos regular."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 3778
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinea"
    },
    "vulgarName": [
      {
        "en": "Stone pine"
      },
      {
        "es": "Pino piñonero"
      },
      {
        "de": "Pinie"
      },
      {
        "fr": "Pin parasol"
      },
      {
        "pt": "Pinheiro-manso"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q106094",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Stone_pine",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Pinus_pinea_Wellington_Botanic_Gardens.jpg/330px-Pinus_pinea_Wellington_Botanic_Gardens.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinea",
    "gbif": "https://www.gbif.org/species/5285165",
    "extract": {
      "en": "The Italian stone pine, botanical name Pinus pinea, also known as the Mediterranean stone pine is a tree from the pine family, Pinaceae. The tree is native to the Mediterranean region, occurring in Southern Europe and the Levant. The species was introduced into North Africa millennia ago, and is also naturalized in the Canary Islands, South Africa and New South Wales.",
      "es": "Pinus pinea, el pino piñonero, pino manso, pino doncel o pino albar es una especie arbórea de la familia de las pináceas. Su nombre \"pino piñonero\" proviene del hecho de que produce como semilla grandes piñones consumidos por la humanidad desde tiempos inmemoriales, puesto que si bien los piñones de otras especies europeas de pino también se pueden comer, son mucho más pequeños. Es originario de la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 11502
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinaster"
    },
    "vulgarName": [
      {
        "en": "Cluster pine"
      },
      {
        "es": "Pino pináster"
      },
      {
        "de": "See-Kiefer"
      },
      {
        "fr": "Pinus pinaster"
      },
      {
        "pt": "Pinheiro-bravo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q271582",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_pinaster",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinaster"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Pino_resinero_%286344573367%29.jpg/330px-Pino_resinero_%286344573367%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Pinus_pinaster_20131229.jpg/330px-Pinus_pinaster_20131229.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinaster",
    "gbif": "https://www.gbif.org/species/5285565",
    "extract": {
      "en": "Pinus pinaster, the maritime pine is a pine native to the south Atlantic Europe region and parts of the western Mediterranean. It is a fast growing hard pine with long needles and large cones with medium-sized seeds with large wings.",
      "es": "Pinus pinaster, el pino resinero, pino rodeno, pino marítimo, pino rubial o pino negral es una especie arbórea de la familia de las pináceas que se extiende por España, Portugal, sur de Francia, Italia, Marruecos y pequeñas poblaciones en Argelia y Malta, aunque posiblemente introducidas por el hombre. Generalmente entre el nivel del mar y unos 800 metros, aunque en el sur de Marruecos se puede encontrar hasta los 2000 m. En algunos lugares se le conoce también como pino negral, aunque no se debe confundir con el Pinus nigra. Por la facilidad que tiene para colonizar nuevos espacios donde no es nativo, está incluido en la lista 100 de las especies exóticas invasoras más dañinas del mundo de la Unión Internacional para la Conservación de la Naturaleza."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus"
    },
    "vulgarName": [
      {
        "es": "Otros pinos"
      },
      {
        "en": "Other pines"
      },
      {
        "en": "Pine"
      },
      {
        "es": "Pinos"
      },
      {
        "de": "Kiefern"
      },
      {
        "fr": "Pin (plante)"
      },
      {
        "pt": "Pinheiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pine",
      "es": "https://es.wikipedia.org/wiki/Pinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg/330px-Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Illustration_Pinus_sylvestris0_new.jpg/330px-Illustration_Pinus_sylvestris0_new.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus",
    "gbif": "https://www.gbif.org/species/2684241",
    "extract": {
      "en": "A pine is any conifer in the genus Pinus of the family Pinaceae. Pinus is the sole genus in the subfamily Pinoideae. The species are evergreen trees or shrubs with their leaves in bunches, usually of 2 to 5 needles. The seeds are carried on woody cones, with two seeds to each cone scale.",
      "es": "Pinus es un género de plantas vasculares, comúnmente llamadas pinos, pertenecientes al grupo de las coníferas y, dentro de este, a la familia de las Pinaceae, que presentan una ramificación frecuentemente verticilada y más o menos regular."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris"
    ],
    "nplots": {
      "ifn2": {
        "count": 9187
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Scots pine"
      },
      {
        "es": "Pino silvestre"
      },
      {
        "de": "Waldkiefer"
      },
      {
        "fr": "Pin sylvestre"
      },
      {
        "pt": "Pinheiro-da-escócia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q133128",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Pinus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Skuleskogen_pine.jpg/330px-Skuleskogen_pine.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Borovice_pod_Kun%C4%9Btickou_Horou.jpg/330px-Borovice_pod_Kun%C4%9Btickou_Horou.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_sylvestris",
    "gbif": "https://www.gbif.org/species/5285637",
    "extract": {
      "en": "Pinus sylvestris is a species of tree in the pine family Pinaceae that is native to Eurasia. It is commonly known as the Scots pine in English; it is also known as the Scotch pine in the United States, and occasionally called the Baltic pine or European red pine. It can readily be identified by its combination of fairly short, blue-green leaves and orange-red bark.",
      "es": "El pino silvestre, también conocido como pino de Valsaín, pino serrano, pino albar, pino del Norte, pino rojo o pino bermejo, es una especie arbórea que pertenece a la familia Pinaceae, género Pinus. Esta conífera, que puede alcanzar los 30 m de altura, crece ampliamente por toda Eurasia. Las referencias al color rojo o bermejo se debe a su corteza, de un rojo subido en la parte alta del tronco, y pardorrojiza en la parte inferior."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata"
    ],
    "nplots": {
      "ifn2": {
        "count": 913
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus uncinata"
    },
    "vulgarName": [
      {
        "en": "Mountain pine"
      },
      {
        "es": "Pino uncinata"
      },
      {
        "de": "Bergkiefer"
      },
      {
        "fr": "Pinus mugo"
      },
      {
        "pt": "Pinus mugo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q149548",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_uncinata",
      "es": "https://es.wikipedia.org/wiki/Pinus_uncinata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Pinus_mugo_cone_01.jpg/330px-Pinus_mugo_cone_01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Pinus_uncinata0.JPG/330px-Pinus_uncinata0.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_uncinata",
    "gbif": "https://www.gbif.org/species/5285332",
    "extract": {
      "en": "Pinus mugo, known as dwarf mountain pine, mountain pine, scrub mountain pine, Swiss mountain pine, bog pine, creeping pine, or mugo pine, is a species of conifer, native to high elevation habitats from southwestern to Central Europe and Southeast Europe.",
      "es": "Pinus uncinata, de nombre común pino negro, es un árbol perteneciente a la familia de las pináceas. Es característico de las principales regiones de alta montaña de Europa como los Alpes, los Cárpatos o los Pirineos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea"
    ],
    "nplots": {
      "ifn2": {
        "count": 3212
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinea"
    },
    "vulgarName": [
      {
        "en": "Stone pine"
      },
      {
        "es": "Pino piñonero"
      },
      {
        "de": "Pinie"
      },
      {
        "fr": "Pin parasol"
      },
      {
        "pt": "Pinheiro-manso"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q106094",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Stone_pine",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Pinus_pinea_Wellington_Botanic_Gardens.jpg/330px-Pinus_pinea_Wellington_Botanic_Gardens.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinea",
    "gbif": "https://www.gbif.org/species/5285165",
    "extract": {
      "en": "The Italian stone pine, botanical name Pinus pinea, also known as the Mediterranean stone pine is a tree from the pine family, Pinaceae. The tree is native to the Mediterranean region, occurring in Southern Europe and the Levant. The species was introduced into North Africa millennia ago, and is also naturalized in the Canary Islands, South Africa and New South Wales.",
      "es": "Pinus pinea, el pino piñonero, pino manso, pino doncel o pino albar es una especie arbórea de la familia de las pináceas. Su nombre \"pino piñonero\" proviene del hecho de que produce como semilla grandes piñones consumidos por la humanidad desde tiempos inmemoriales, puesto que si bien los piñones de otras especies europeas de pino también se pueden comer, son mucho más pequeños. Es originario de la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 10844
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus halepensis"
    },
    "vulgarName": [
      {
        "en": "Aleppo pine"
      },
      {
        "es": "Pino carrasco"
      },
      {
        "es": "Pino halepensis"
      },
      {
        "de": "Aleppo-Kiefer"
      },
      {
        "fr": "Pinus halepensis"
      },
      {
        "pt": "Pinheiro-de-alepo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q211457",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_halepensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_halepensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg/330px-%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Pino_secolare_-_Castelleone_di_Suasa.JPG/330px-Pino_secolare_-_Castelleone_di_Suasa.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_halepensis",
    "gbif": "https://www.gbif.org/species/5285604",
    "extract": {
      "en": "Pinus halepensis, commonly known as the Aleppo pine, also known as the Jerusalem pine, is a pine native to the Mediterranean region. It was officially named by the botanist Philip Miller in his 1768 book The Gardener's Dictionary; he probably never went to Aleppo but mentions seeing large specimens at Goodwood in the garden of the Duke of Richmond, which were transplanted in 1739.",
      "es": "El Pinus halepensis, comúnmente conocido como pino carrasco o pino blanco, es una especie de árbol del género Pinus en la familia Pinaceae. Es originario de la región mediterránea, tanto del norte como del sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra"
    ],
    "nplots": {
      "ifn2": {
        "count": 6910
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus nigra"
    },
    "vulgarName": [
      {
        "en": "Black pine"
      },
      {
        "es": "Pino laricio"
      },
      {
        "de": "Schwarzkiefer"
      },
      {
        "fr": "Pinus nigra"
      },
      {
        "pt": "Pinheiro-larício"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145954",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_nigra",
      "es": "https://es.wikipedia.org/wiki/Pinus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg/330px-%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Pin_laricio_Corse.jpg/330px-Pin_laricio_Corse.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_nigra",
    "gbif": "https://www.gbif.org/species/5284809",
    "extract": {
      "en": "Pinus nigra, the Austrian pine or black pine, is a moderately variable species of pine, occurring across Southern Europe from the Iberian Peninsula and Lower Austria to the eastern Mediterranean, on the Anatolian peninsula of Turkey, Corsica and Cyprus, as well as Crimea and in the high mountains of Northwest Africa.",
      "es": "El pino salgareño es una especie arbórea de la familia de las pináceas. También se conoce como pino laricio, pino negral,o pino salgareño."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster"
    ],
    "nplots": {
      "ifn2": {
        "count": 12248
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinaster"
    },
    "vulgarName": [
      {
        "en": "Cluster pine"
      },
      {
        "es": "Pino pináster"
      },
      {
        "de": "See-Kiefer"
      },
      {
        "fr": "Pinus pinaster"
      },
      {
        "pt": "Pinheiro-bravo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q271582",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_pinaster",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinaster"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Pino_resinero_%286344573367%29.jpg/330px-Pino_resinero_%286344573367%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Pinus_pinaster_20131229.jpg/330px-Pinus_pinaster_20131229.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinaster",
    "gbif": "https://www.gbif.org/species/5285565",
    "extract": {
      "en": "Pinus pinaster, the maritime pine is a pine native to the south Atlantic Europe region and parts of the western Mediterranean. It is a fast growing hard pine with long needles and large cones with medium-sized seeds with large wings.",
      "es": "Pinus pinaster, el pino resinero, pino rodeno, pino marítimo, pino rubial o pino negral es una especie arbórea de la familia de las pináceas que se extiende por España, Portugal, sur de Francia, Italia, Marruecos y pequeñas poblaciones en Argelia y Malta, aunque posiblemente introducidas por el hombre. Generalmente entre el nivel del mar y unos 800 metros, aunque en el sur de Marruecos se puede encontrar hasta los 2000 m. En algunos lugares se le conoce también como pino negral, aunque no se debe confundir con el Pinus nigra. Por la facilidad que tiene para colonizar nuevos espacios donde no es nativo, está incluido en la lista 100 de las especies exóticas invasoras más dañinas del mundo de la Unión Internacional para la Conservación de la Naturaleza."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 1439
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island pine"
      },
      {
        "es": "Pino canario"
      },
      {
        "de": "Kanarische Kiefer"
      },
      {
        "fr": "Pinus canariensis"
      },
      {
        "pt": "Pinheiro-das-Canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q756191",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Caldera_de_Taburiente_La_Palma.jpg/330px-Caldera_de_Taburiente_La_Palma.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg/330px-Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_canariensis",
    "gbif": "https://www.gbif.org/species/5285243",
    "extract": {
      "en": "Pinus canariensis, the Canary Island pine, is a species of gymnosperm in the conifer family Pinaceae. It is a large, evergreen tree, native and endemic to the outer Canary Islands of the Atlantic Ocean.",
      "es": "Pinus canariensis, el pino canario o pino de Canarias es una conífera endémica de las Islas Canarias (España). El pino canario se considera, según una ley del Gobierno de Canarias, el símbolo natural de la isla de La Palma, conjuntamente con la graja."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata"
    ],
    "nplots": {
      "ifn2": {
        "count": 2352
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus radiata"
    },
    "vulgarName": [
      {
        "en": "Monterey pine"
      },
      {
        "es": "Pino radiata"
      },
      {
        "de": "Monterey-Kiefer"
      },
      {
        "fr": "Pin de Monterey"
      },
      {
        "pt": "Pinus radiata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q748888",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_radiata",
      "es": "https://es.wikipedia.org/wiki/Pinus_radiata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Pinus_radiata_BigSur.jpg/330px-Pinus_radiata_BigSur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Lopez_Lake_tree2.jpg/330px-Lopez_Lake_tree2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_radiata",
    "gbif": "https://www.gbif.org/species/5285727",
    "extract": {
      "en": "Pinus radiata, the Monterey pine, insignis pine or radiata pine, is a species of pine native to the Central Coast of California, and the Guadalupe and Cedros islands of Mexico. It is an evergreen conifer in the family Pinaceae.",
      "es": "Pinus radiata, llamado pino insigne, pino de Monterrey o pino de California es una especie arbórea perteneciente a la familia de las pináceas, originaria del suroeste de los Estados Unidos, principalmente California."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 29
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 29
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus"
    },
    "vulgarName": [
      {
        "es": "Otros pinos"
      },
      {
        "en": "Other pines"
      },
      {
        "en": "Pine"
      },
      {
        "es": "Pinos"
      },
      {
        "de": "Kiefern"
      },
      {
        "fr": "Pin (plante)"
      },
      {
        "pt": "Pinheiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pine",
      "es": "https://es.wikipedia.org/wiki/Pinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg/330px-Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Illustration_Pinus_sylvestris0_new.jpg/330px-Illustration_Pinus_sylvestris0_new.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus",
    "gbif": "https://www.gbif.org/species/2684241",
    "extract": {
      "en": "A pine is any conifer in the genus Pinus of the family Pinaceae. Pinus is the sole genus in the subfamily Pinoideae. The species are evergreen trees or shrubs with their leaves in bunches, usually of 2 to 5 needles. The seeds are carried on woody cones, with two seeds to each cone scale.",
      "es": "Pinus es un género de plantas vasculares, comúnmente llamadas pinos, pertenecientes al grupo de las coníferas y, dentro de este, a la familia de las Pinaceae, que presentan una ramificación frecuentemente verticilada y más o menos regular."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1439
      },
      "ifn3": {
        "count": 1862
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island pine"
      },
      {
        "es": "Pino canario"
      },
      {
        "de": "Kanarische Kiefer"
      },
      {
        "fr": "Pinus canariensis"
      },
      {
        "pt": "Pinheiro-das-Canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q756191",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Caldera_de_Taburiente_La_Palma.jpg/330px-Caldera_de_Taburiente_La_Palma.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg/330px-Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_canariensis",
    "gbif": "https://www.gbif.org/species/5285243",
    "extract": {
      "en": "Pinus canariensis, the Canary Island pine, is a species of gymnosperm in the conifer family Pinaceae. It is a large, evergreen tree, native and endemic to the outer Canary Islands of the Atlantic Ocean.",
      "es": "Pinus canariensis, el pino canario o pino de Canarias es una conífera endémica de las Islas Canarias (España). El pino canario se considera, según una ley del Gobierno de Canarias, el símbolo natural de la isla de La Palma, conjuntamente con la graja."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 10844
      },
      "ifn3": {
        "count": 11884
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus halepensis"
    },
    "vulgarName": [
      {
        "en": "Aleppo pine"
      },
      {
        "es": "Pino carrasco"
      },
      {
        "es": "Pino halepensis"
      },
      {
        "de": "Aleppo-Kiefer"
      },
      {
        "fr": "Pinus halepensis"
      },
      {
        "pt": "Pinheiro-de-alepo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q211457",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_halepensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_halepensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg/330px-%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Pino_secolare_-_Castelleone_di_Suasa.JPG/330px-Pino_secolare_-_Castelleone_di_Suasa.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_halepensis",
    "gbif": "https://www.gbif.org/species/5285604",
    "extract": {
      "en": "Pinus halepensis, commonly known as the Aleppo pine, also known as the Jerusalem pine, is a pine native to the Mediterranean region. It was officially named by the botanist Philip Miller in his 1768 book The Gardener's Dictionary; he probably never went to Aleppo but mentions seeing large specimens at Goodwood in the garden of the Duke of Richmond, which were transplanted in 1739.",
      "es": "El Pinus halepensis, comúnmente conocido como pino carrasco o pino blanco, es una especie de árbol del género Pinus en la familia Pinaceae. Es originario de la región mediterránea, tanto del norte como del sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 6910
      },
      "ifn3": {
        "count": 7777
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus nigra"
    },
    "vulgarName": [
      {
        "en": "Black pine"
      },
      {
        "es": "Pino laricio"
      },
      {
        "de": "Schwarzkiefer"
      },
      {
        "fr": "Pinus nigra"
      },
      {
        "pt": "Pinheiro-larício"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145954",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_nigra",
      "es": "https://es.wikipedia.org/wiki/Pinus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg/330px-%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Pin_laricio_Corse.jpg/330px-Pin_laricio_Corse.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_nigra",
    "gbif": "https://www.gbif.org/species/5284809",
    "extract": {
      "en": "Pinus nigra, the Austrian pine or black pine, is a moderately variable species of pine, occurring across Southern Europe from the Iberian Peninsula and Lower Austria to the eastern Mediterranean, on the Anatolian peninsula of Turkey, Corsica and Cyprus, as well as Crimea and in the high mountains of Northwest Africa.",
      "es": "El pino salgareño es una especie arbórea de la familia de las pináceas. También se conoce como pino laricio, pino negral,o pino salgareño."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species26",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species26"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 12248
      },
      "ifn3": {
        "count": 11502
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinaster",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinaster"
    },
    "vulgarName": [
      {
        "en": "Cluster pine"
      },
      {
        "es": "Pino pináster"
      },
      {
        "de": "See-Kiefer"
      },
      {
        "fr": "Pinus pinaster"
      },
      {
        "pt": "Pinheiro-bravo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q271582",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_pinaster",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinaster"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Pino_resinero_%286344573367%29.jpg/330px-Pino_resinero_%286344573367%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Pinus_pinaster_20131229.jpg/330px-Pinus_pinaster_20131229.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinaster",
    "gbif": "https://www.gbif.org/species/5285565",
    "extract": {
      "en": "Pinus pinaster, the maritime pine is a pine native to the south Atlantic Europe region and parts of the western Mediterranean. It is a fast growing hard pine with long needles and large cones with medium-sized seeds with large wings.",
      "es": "Pinus pinaster, el pino resinero, pino rodeno, pino marítimo, pino rubial o pino negral es una especie arbórea de la familia de las pináceas que se extiende por España, Portugal, sur de Francia, Italia, Marruecos y pequeñas poblaciones en Argelia y Malta, aunque posiblemente introducidas por el hombre. Generalmente entre el nivel del mar y unos 800 metros, aunque en el sur de Marruecos se puede encontrar hasta los 2000 m. En algunos lugares se le conoce también como pino negral, aunque no se debe confundir con el Pinus nigra. Por la facilidad que tiene para colonizar nuevos espacios donde no es nativo, está incluido en la lista 100 de las especies exóticas invasoras más dañinas del mundo de la Unión Internacional para la Conservación de la Naturaleza."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species23"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 3212
      },
      "ifn3": {
        "count": 3778
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusPinea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus pinea"
    },
    "vulgarName": [
      {
        "en": "Stone pine"
      },
      {
        "es": "Pino piñonero"
      },
      {
        "de": "Pinie"
      },
      {
        "fr": "Pin parasol"
      },
      {
        "pt": "Pinheiro-manso"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q106094",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Stone_pine",
      "es": "https://es.wikipedia.org/wiki/Pinus_pinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Pinus_pinea_Wellington_Botanic_Gardens.jpg/330px-Pinus_pinea_Wellington_Botanic_Gardens.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_pinea",
    "gbif": "https://www.gbif.org/species/5285165",
    "extract": {
      "en": "The Italian stone pine, botanical name Pinus pinea, also known as the Mediterranean stone pine is a tree from the pine family, Pinaceae. The tree is native to the Mediterranean region, occurring in Southern Europe and the Levant. The species was introduced into North Africa millennia ago, and is also naturalized in the Canary Islands, South Africa and New South Wales.",
      "es": "Pinus pinea, el pino piñonero, pino manso, pino doncel o pino albar es una especie arbórea de la familia de las pináceas. Su nombre \"pino piñonero\" proviene del hecho de que produce como semilla grandes piñones consumidos por la humanidad desde tiempos inmemoriales, puesto que si bien los piñones de otras especies europeas de pino también se pueden comer, son mucho más pequeños. Es originario de la región mediterránea."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2352
      },
      "ifn3": {
        "count": 2288
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus radiata"
    },
    "vulgarName": [
      {
        "en": "Monterey pine"
      },
      {
        "es": "Pino radiata"
      },
      {
        "de": "Monterey-Kiefer"
      },
      {
        "fr": "Pin de Monterey"
      },
      {
        "pt": "Pinus radiata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q748888",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_radiata",
      "es": "https://es.wikipedia.org/wiki/Pinus_radiata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Pinus_radiata_BigSur.jpg/330px-Pinus_radiata_BigSur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Lopez_Lake_tree2.jpg/330px-Lopez_Lake_tree2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_radiata",
    "gbif": "https://www.gbif.org/species/5285727",
    "extract": {
      "en": "Pinus radiata, the Monterey pine, insignis pine or radiata pine, is a species of pine native to the Central Coast of California, and the Guadalupe and Cedros islands of Mexico. It is an evergreen conifer in the family Pinaceae.",
      "es": "Pinus radiata, llamado pino insigne, pino de Monterrey o pino de California es una especie arbórea perteneciente a la familia de las pináceas, originaria del suroeste de los Estados Unidos, principalmente California."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 9187
      },
      "ifn3": {
        "count": 10331
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Scots pine"
      },
      {
        "es": "Pino silvestre"
      },
      {
        "de": "Waldkiefer"
      },
      {
        "fr": "Pin sylvestre"
      },
      {
        "pt": "Pinheiro-da-escócia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q133128",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Pinus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Skuleskogen_pine.jpg/330px-Skuleskogen_pine.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Borovice_pod_Kun%C4%9Btickou_Horou.jpg/330px-Borovice_pod_Kun%C4%9Btickou_Horou.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_sylvestris",
    "gbif": "https://www.gbif.org/species/5285637",
    "extract": {
      "en": "Pinus sylvestris is a species of tree in the pine family Pinaceae that is native to Eurasia. It is commonly known as the Scots pine in English; it is also known as the Scotch pine in the United States, and occasionally called the Baltic pine or European red pine. It can readily be identified by its combination of fairly short, blue-green leaves and orange-red bark.",
      "es": "El pino silvestre, también conocido como pino de Valsaín, pino serrano, pino albar, pino del Norte, pino rojo o pino bermejo, es una especie arbórea que pertenece a la familia Pinaceae, género Pinus. Esta conífera, que puede alcanzar los 30 m de altura, crece ampliamente por toda Eurasia. Las referencias al color rojo o bermejo se debe a su corteza, de un rojo subido en la parte alta del tronco, y pardorrojiza en la parte inferior."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 913
      },
      "ifn3": {
        "count": 999
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus uncinata"
    },
    "vulgarName": [
      {
        "en": "Mountain pine"
      },
      {
        "es": "Pino uncinata"
      },
      {
        "de": "Bergkiefer"
      },
      {
        "fr": "Pinus mugo"
      },
      {
        "pt": "Pinus mugo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q149548",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_uncinata",
      "es": "https://es.wikipedia.org/wiki/Pinus_uncinata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Pinus_mugo_cone_01.jpg/330px-Pinus_mugo_cone_01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Pinus_uncinata0.JPG/330px-Pinus_uncinata0.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_uncinata",
    "gbif": "https://www.gbif.org/species/5285332",
    "extract": {
      "en": "Pinus mugo, known as dwarf mountain pine, mountain pine, scrub mountain pine, Swiss mountain pine, bog pine, creeping pine, or mugo pine, is a species of conifer, native to high elevation habitats from southwestern to Central Europe and Southeast Europe.",
      "es": "Pinus uncinata, de nombre común pino negro, es un árbol perteneciente a la familia de las pináceas. Es característico de las principales regiones de alta montaña de Europa como los Alpes, los Cárpatos o los Pirineos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species20",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus"
    },
    "vulgarName": [
      {
        "en": "Pine"
      },
      {
        "es": "Pinos"
      },
      {
        "de": "Kiefern"
      },
      {
        "fr": "Pin (plante)"
      },
      {
        "pt": "Pinheiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pine",
      "es": "https://es.wikipedia.org/wiki/Pinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg/330px-Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Illustration_Pinus_sylvestris0_new.jpg/330px-Illustration_Pinus_sylvestris0_new.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus",
    "gbif": "https://www.gbif.org/species/2684241",
    "extract": {
      "en": "A pine is any conifer in the genus Pinus of the family Pinaceae. Pinus is the sole genus in the subfamily Pinoideae. The species are evergreen trees or shrubs with their leaves in bunches, usually of 2 to 5 needles. The seeds are carried on woody cones, with two seeds to each cone scale.",
      "es": "Pinus es un género de plantas vasculares, comúnmente llamadas pinos, pertenecientes al grupo de las coníferas y, dentro de este, a la familia de las Pinaceae, que presentan una ramificación frecuentemente verticilada y más o menos regular."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusSylvestris"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 10331
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species21",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Scots pine"
      },
      {
        "es": "Pino silvestre"
      },
      {
        "de": "Waldkiefer"
      },
      {
        "fr": "Pin sylvestre"
      },
      {
        "pt": "Pinheiro-da-escócia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q133128",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Pinus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Skuleskogen_pine.jpg/330px-Skuleskogen_pine.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Borovice_pod_Kun%C4%9Btickou_Horou.jpg/330px-Borovice_pod_Kun%C4%9Btickou_Horou.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_sylvestris",
    "gbif": "https://www.gbif.org/species/5285637",
    "extract": {
      "en": "Pinus sylvestris is a species of tree in the pine family Pinaceae that is native to Eurasia. It is commonly known as the Scots pine in English; it is also known as the Scotch pine in the United States, and occasionally called the Baltic pine or European red pine. It can readily be identified by its combination of fairly short, blue-green leaves and orange-red bark.",
      "es": "El pino silvestre, también conocido como pino de Valsaín, pino serrano, pino albar, pino del Norte, pino rojo o pino bermejo, es una especie arbórea que pertenece a la familia Pinaceae, género Pinus. Esta conífera, que puede alcanzar los 30 m de altura, crece ampliamente por toda Eurasia. Las referencias al color rojo o bermejo se debe a su corteza, de un rojo subido en la parte alta del tronco, y pardorrojiza en la parte inferior."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusUncinata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 999
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species22",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus uncinata"
    },
    "vulgarName": [
      {
        "en": "Mountain pine"
      },
      {
        "es": "Pino uncinata"
      },
      {
        "de": "Bergkiefer"
      },
      {
        "fr": "Pinus mugo"
      },
      {
        "pt": "Pinus mugo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q149548",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_uncinata",
      "es": "https://es.wikipedia.org/wiki/Pinus_uncinata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Pinus_mugo_cone_01.jpg/330px-Pinus_mugo_cone_01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Pinus_uncinata0.JPG/330px-Pinus_uncinata0.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_uncinata",
    "gbif": "https://www.gbif.org/species/5285332",
    "extract": {
      "en": "Pinus mugo, known as dwarf mountain pine, mountain pine, scrub mountain pine, Swiss mountain pine, bog pine, creeping pine, or mugo pine, is a species of conifer, native to high elevation habitats from southwestern to Central Europe and Southeast Europe.",
      "es": "Pinus uncinata, de nombre común pino negro, es un árbol perteneciente a la familia de las pináceas. Es característico de las principales regiones de alta montaña de Europa como los Alpes, los Cárpatos o los Pirineos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusHalepensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 11884
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species24",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus halepensis"
    },
    "vulgarName": [
      {
        "en": "Aleppo pine"
      },
      {
        "es": "Pino carrasco"
      },
      {
        "es": "Pino halepensis"
      },
      {
        "de": "Aleppo-Kiefer"
      },
      {
        "fr": "Pinus halepensis"
      },
      {
        "pt": "Pinheiro-de-alepo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q211457",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_halepensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_halepensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg/330px-%CE%A7%CE%B1%CE%BB%CE%AD%CF%80%CE%B9%CE%BF%CF%82_%CF%80%CE%B5%CF%8D%CE%BA%CE%B7_%CE%A3%CE%BF%CF%8D%CE%BD%CE%B9%CE%BF_1963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Pino_secolare_-_Castelleone_di_Suasa.JPG/330px-Pino_secolare_-_Castelleone_di_Suasa.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_halepensis",
    "gbif": "https://www.gbif.org/species/5285604",
    "extract": {
      "en": "Pinus halepensis, commonly known as the Aleppo pine, also known as the Jerusalem pine, is a pine native to the Mediterranean region. It was officially named by the botanist Philip Miller in his 1768 book The Gardener's Dictionary; he probably never went to Aleppo but mentions seeing large specimens at Goodwood in the garden of the Duke of Richmond, which were transplanted in 1739.",
      "es": "El Pinus halepensis, comúnmente conocido como pino carrasco o pino blanco, es una especie de árbol del género Pinus en la familia Pinaceae. Es originario de la región mediterránea, tanto del norte como del sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusNigra"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 7777
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species25",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus nigra"
    },
    "vulgarName": [
      {
        "en": "Black pine"
      },
      {
        "es": "Pino laricio"
      },
      {
        "de": "Schwarzkiefer"
      },
      {
        "fr": "Pinus nigra"
      },
      {
        "pt": "Pinheiro-larício"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145954",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_nigra",
      "es": "https://es.wikipedia.org/wiki/Pinus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg/330px-%C5%9Awierklaniec_pinus_nigra_12.06.2010_p.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Pin_laricio_Corse.jpg/330px-Pin_laricio_Corse.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_nigra",
    "gbif": "https://www.gbif.org/species/5284809",
    "extract": {
      "en": "Pinus nigra, the Austrian pine or black pine, is a moderately variable species of pine, occurring across Southern Europe from the Iberian Peninsula and Lower Austria to the eastern Mediterranean, on the Anatolian peninsula of Turkey, Corsica and Cyprus, as well as Crimea and in the high mountains of Northwest Africa.",
      "es": "El pino salgareño es una especie arbórea de la familia de las pináceas. También se conoce como pino laricio, pino negral,o pino salgareño."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1862
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species27",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus canariensis"
    },
    "vulgarName": [
      {
        "en": "Canary Island pine"
      },
      {
        "es": "Pino canario"
      },
      {
        "de": "Kanarische Kiefer"
      },
      {
        "fr": "Pinus canariensis"
      },
      {
        "pt": "Pinheiro-das-Canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q756191",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_canariensis",
      "es": "https://es.wikipedia.org/wiki/Pinus_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Caldera_de_Taburiente_La_Palma.jpg/330px-Caldera_de_Taburiente_La_Palma.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg/330px-Pinus_canariensis_-_Pico_Birigoyo_-_La_Palma_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_canariensis",
    "gbif": "https://www.gbif.org/species/5285243",
    "extract": {
      "en": "Pinus canariensis, the Canary Island pine, is a species of gymnosperm in the conifer family Pinaceae. It is a large, evergreen tree, native and endemic to the outer Canary Islands of the Atlantic Ocean.",
      "es": "Pinus canariensis, el pino canario o pino de Canarias es una conífera endémica de las Islas Canarias (España). El pino canario se considera, según una ley del Gobierno de Canarias, el símbolo natural de la isla de La Palma, conjuntamente con la graja."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PinusRadiata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 2288
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species28",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus radiata"
    },
    "vulgarName": [
      {
        "en": "Monterey pine"
      },
      {
        "es": "Pino radiata"
      },
      {
        "de": "Monterey-Kiefer"
      },
      {
        "fr": "Pin de Monterey"
      },
      {
        "pt": "Pinus radiata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q748888",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pinus_radiata",
      "es": "https://es.wikipedia.org/wiki/Pinus_radiata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Pinus_radiata_BigSur.jpg/330px-Pinus_radiata_BigSur.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Lopez_Lake_tree2.jpg/330px-Lopez_Lake_tree2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus_radiata",
    "gbif": "https://www.gbif.org/species/5285727",
    "extract": {
      "en": "Pinus radiata, the Monterey pine, insignis pine or radiata pine, is a species of pine native to the Central Coast of California, and the Guadalupe and Cedros islands of Mexico. It is an evergreen conifer in the family Pinaceae.",
      "es": "Pinus radiata, llamado pino insigne, pino de Monterrey o pino de California es una especie arbórea perteneciente a la familia de las pináceas, originaria del suroeste de los Estados Unidos, principalmente California."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus211",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species29",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pinus"
    },
    "vulgarName": [
      {
        "es": "Otros pinos"
      },
      {
        "en": "Other pines"
      },
      {
        "de": "Kiefern"
      },
      {
        "fr": "Pin (plante)"
      },
      {
        "pt": "Pinheiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q12024",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pine",
      "es": "https://es.wikipedia.org/wiki/Pinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg/330px-Pinus_jeffreyi_at_Lassen_Volcanic_National_Park.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Illustration_Pinus_sylvestris0_new.jpg/330px-Illustration_Pinus_sylvestris0_new.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pinus",
    "gbif": "https://www.gbif.org/species/2684241",
    "extract": {
      "en": "A pine is any conifer in the genus Pinus of the family Pinaceae. Pinus is the sole genus in the subfamily Pinoideae. The species are evergreen trees or shrubs with their leaves in bunches, usually of 2 to 5 needles. The seeds are carried on woody cones, with two seeds to each cone scale.",
      "es": "Pinus es un género de plantas vasculares, comúnmente llamadas pinos, pertenecientes al grupo de las coníferas y, dentro de este, a la familia de las Pinaceae, que presentan una ramificación frecuentemente verticilada y más o menos regular."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
    "isGenus": 1,
    "scientificName": {
      "la": "Cedrus"
    },
    "vulgarName": [
      {
        "de": "Zedern"
      },
      {
        "fr": "Cèdre"
      },
      {
        "pt": "Cedrus"
      },
      {
        "en": "Cedars"
      },
      {
        "es": "Cedros"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128550",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus",
      "es": "https://es.wikipedia.org/wiki/Cedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/View_from_the_Barouk_Forest_1.JPG/330px-View_from_the_Barouk_Forest_1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Cedrus_atlantica2.jpg/330px-Cedrus_atlantica2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus",
    "gbif": "https://www.gbif.org/species/2685742",
    "extract": {
      "en": "Cedrus, with the common English name cedar, is a genus of coniferous trees in the plant family Pinaceae. They are native to the mountains of the western Himalayas and the Mediterranean region at high altitudes. The trees grow tall with a cylindrical trunk and a wide leafy crown. The cones are erect; the leaves grow in tufts of 15–45 needle leaves, which can be bright green or blue-green with a waxy coat. When the cones are mature, they disintegrate to release the seeds, which are winged. Both pollen and seeds are wind-dispersed.",
      "es": "Los cedros constituyen un género (Cedrus) de coníferas pináceas. Son árboles de gran tamaño, de madera olorosa y copa cónica o vertical, muy utilizados para ornamentación de parques. Poseen una distribución disjunta: norte de África, Medio Oriente y el Himalaya."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus"
    },
    "vulgarName": [
      {
        "en": "Cedar"
      },
      {
        "es": "Cedrus spp."
      },
      {
        "de": "Zedern"
      },
      {
        "fr": "Cèdre"
      },
      {
        "pt": "Cedrus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128550",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus",
      "es": "https://es.wikipedia.org/wiki/Cedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/View_from_the_Barouk_Forest_1.JPG/330px-View_from_the_Barouk_Forest_1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Cedrus_atlantica2.jpg/330px-Cedrus_atlantica2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus",
    "gbif": "https://www.gbif.org/species/2685742",
    "extract": {
      "en": "Cedrus, with the common English name cedar, is a genus of coniferous trees in the plant family Pinaceae. They are native to the mountains of the western Himalayas and the Mediterranean region at high altitudes. The trees grow tall with a cylindrical trunk and a wide leafy crown. The cones are erect; the leaves grow in tufts of 15–45 needle leaves, which can be bright green or blue-green with a waxy coat. When the cones are mature, they disintegrate to release the seeds, which are winged. Both pollen and seeds are wind-dispersed.",
      "es": "Los cedros constituyen un género (Cedrus) de coníferas pináceas. Son árboles de gran tamaño, de madera olorosa y copa cónica o vertical, muy utilizados para ornamentación de parques. Poseen una distribución disjunta: norte de África, Medio Oriente y el Himalaya."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus"
    },
    "vulgarName": [
      {
        "en": "Cedar"
      },
      {
        "es": "Cedrus spp."
      },
      {
        "de": "Zedern"
      },
      {
        "fr": "Cèdre"
      },
      {
        "pt": "Cedrus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128550",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus",
      "es": "https://es.wikipedia.org/wiki/Cedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/View_from_the_Barouk_Forest_1.JPG/330px-View_from_the_Barouk_Forest_1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Cedrus_atlantica2.jpg/330px-Cedrus_atlantica2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus",
    "gbif": "https://www.gbif.org/species/2685742",
    "extract": {
      "en": "Cedrus, with the common English name cedar, is a genus of coniferous trees in the plant family Pinaceae. They are native to the mountains of the western Himalayas and the Mediterranean region at high altitudes. The trees grow tall with a cylindrical trunk and a wide leafy crown. The cones are erect; the leaves grow in tufts of 15–45 needle leaves, which can be bright green or blue-green with a waxy coat. When the cones are mature, they disintegrate to release the seeds, which are winged. Both pollen and seeds are wind-dispersed.",
      "es": "Los cedros constituyen un género (Cedrus) de coníferas pináceas. Son árboles de gran tamaño, de madera olorosa y copa cónica o vertical, muy utilizados para ornamentación de parques. Poseen una distribución disjunta: norte de África, Medio Oriente y el Himalaya."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus atlantica"
    },
    "vulgarName": [
      {
        "en": "Cedar"
      },
      {
        "es": "Cedro"
      },
      {
        "de": "Atlas-Zeder"
      },
      {
        "fr": "Cedrus atlantica"
      },
      {
        "pt": "Cedro-do-atlas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q623489",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_atlantica",
      "es": "https://es.wikipedia.org/wiki/Cedrus_atlantica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Cedrus_atlantica.jpg/330px-Cedrus_atlantica.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/C%C3%A8dre_du_Ch%C3%A9lia_15_%28Algeria%29.JPG/330px-C%C3%A8dre_du_Ch%C3%A9lia_15_%28Algeria%29.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_libani_subsp._atlantica",
    "gbif": "https://www.gbif.org/species/5284702",
    "extract": {
      "en": "Cedrus atlantica, the Atlas cedar, is a species of tree in the pine family Pinaceae, native to the Rif and Atlas Mountains of Morocco, and to the Tell Atlas in Algeria. A majority of the modern sources treat it as a distinct species Cedrus atlantica, but some sources consider it a subspecies of Lebanon cedar.",
      "es": "Cedrus atlantica, cedro del Atlas, cedro plateado o cedro atlántico es una especie arbórea perteneciente a la familia de las pináceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus deodara"
    },
    "vulgarName": [
      {
        "en": "Deodar cedar"
      },
      {
        "en": "Himalayan cedar"
      },
      {
        "es": "Cedro del Himalaya"
      },
      {
        "de": "Himalaya-Zeder"
      },
      {
        "fr": "Cedrus deodara"
      },
      {
        "pt": "Cedro-do-himalaia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146935",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_deodara",
      "es": "https://es.wikipedia.org/wiki/Cedrus_deodara"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Cedrus_deodara_Manali_2.jpg/330px-Cedrus_deodara_Manali_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Cedrus_deodara_JPG1b.jpg/330px-Cedrus_deodara_JPG1b.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_deodara",
    "gbif": "https://www.gbif.org/species/5284698",
    "extract": {
      "en": "Cedrus deodara, the deodar cedar, Himalayan cedar, or deodar, is a species of cedar native to the Himalayas.",
      "es": "Cedrus deodara, comúnmente llamado cedro del Himalaya, cedro deodar o cedro de la India, es una especie perteneciente a la familia Pinaceae, nativa del oeste del Himalaya, este de Afganistán, Pakistán, noroeste y norte y centro de India, sudoeste del Tíbet y oeste de Nepal, desarrollándose a 1500-3200 m de altitud."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus libani"
    },
    "vulgarName": [
      {
        "en": "Cedar of Lebanon"
      },
      {
        "en": "Lebanon cedar"
      },
      {
        "es": "Cedrus libani"
      },
      {
        "de": "Libanon-Zeder"
      },
      {
        "fr": "Cèdre du Liban"
      },
      {
        "pt": "Cedro-do-líbano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q61105",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_libani",
      "es": "https://es.wikipedia.org/wiki/Cedrus_libani"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/C%C3%A8dre_du_Liban_Barouk_2005.jpg/330px-C%C3%A8dre_du_Liban_Barouk_2005.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/The_Cedars_of_God%2C_Lebanon_2002.jpeg/330px-The_Cedars_of_God%2C_Lebanon_2002.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_libani",
    "gbif": "https://www.gbif.org/species/5284682",
    "extract": {
      "en": "Cedrus libani, commonly known as cedar of Lebanon, Lebanon cedar, or Lebanese cedar, is a species of large evergreen conifer in the genus Cedrus, which belongs to the pine family and is native to the mountains of the Eastern Mediterranean basin. Known for its longevity, height, and durable wood, it has held profound significance for millennia. The tree features in ancient Mesopotamian and Israelite literature, notably in the Hebrew Bible, according to which the tree was used in the construction of the Jerusalem Temple by Solomon, who received the trees from Hiram of Tyre. Today, it is the national emblem of Lebanon and is widely used as an ornamental tree in parks and gardens. Historically the ancient Phoenicians used Cedar wood for shipbuilding and traded Cedar trees with Ancient Egypt, Ancient Greece, Anatolians, Israelites, Iberians, Punics, Sicilians,Romans and Ancient Iraq.",
      "es": "El Cedrus libani, comúnmente conocido como cedro del Líbano, es una especie de cedro nativa de las montañas de la cuenca del Mediterráneo Oriental. Es una conífera acicufolia de hoja perenne que puede alcanzar los 40 m de altura. Es el emblema nacional del Líbano y se usa ampliamente como árbol ornamental en parques y jardines."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species917",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus"
    },
    "vulgarName": [
      {
        "en": "Cedar"
      },
      {
        "es": "Cedrus spp."
      },
      {
        "de": "Zedern"
      },
      {
        "fr": "Cèdre"
      },
      {
        "pt": "Cedrus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128550",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus",
      "es": "https://es.wikipedia.org/wiki/Cedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/View_from_the_Barouk_Forest_1.JPG/330px-View_from_the_Barouk_Forest_1.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Cedrus_atlantica2.jpg/330px-Cedrus_atlantica2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus",
    "gbif": "https://www.gbif.org/species/2685742",
    "extract": {
      "en": "Cedrus, with the common English name cedar, is a genus of coniferous trees in the plant family Pinaceae. They are native to the mountains of the western Himalayas and the Mediterranean region at high altitudes. The trees grow tall with a cylindrical trunk and a wide leafy crown. The cones are erect; the leaves grow in tufts of 15–45 needle leaves, which can be bright green or blue-green with a waxy coat. When the cones are mature, they disintegrate to release the seeds, which are winged. Both pollen and seeds are wind-dispersed.",
      "es": "Los cedros constituyen un género (Cedrus) de coníferas pináceas. Son árboles de gran tamaño, de madera olorosa y copa cónica o vertical, muy utilizados para ornamentación de parques. Poseen una distribución disjunta: norte de África, Medio Oriente y el Himalaya."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species17"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusAtlantica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus atlantica"
    },
    "vulgarName": [
      {
        "en": "Cedar"
      },
      {
        "es": "Cedro"
      },
      {
        "de": "Atlas-Zeder"
      },
      {
        "fr": "Cedrus atlantica"
      },
      {
        "pt": "Cedro-do-atlas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q623489",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_atlantica",
      "es": "https://es.wikipedia.org/wiki/Cedrus_atlantica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Cedrus_atlantica.jpg/330px-Cedrus_atlantica.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/C%C3%A8dre_du_Ch%C3%A9lia_15_%28Algeria%29.JPG/330px-C%C3%A8dre_du_Ch%C3%A9lia_15_%28Algeria%29.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_libani_subsp._atlantica",
    "gbif": "https://www.gbif.org/species/5284702",
    "extract": {
      "en": "Cedrus atlantica, the Atlas cedar, is a species of tree in the pine family Pinaceae, native to the Rif and Atlas Mountains of Morocco, and to the Tell Atlas in Algeria. A majority of the modern sources treat it as a distinct species Cedrus atlantica, but some sources consider it a subspecies of Lebanon cedar.",
      "es": "Cedrus atlantica, cedro del Atlas, cedro plateado o cedro atlántico es una especie arbórea perteneciente a la familia de las pináceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species217"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusDeodara",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus deodara"
    },
    "vulgarName": [
      {
        "en": "Deodar cedar"
      },
      {
        "en": "Himalayan cedar"
      },
      {
        "es": "Cedro del Himalaya"
      },
      {
        "de": "Himalaya-Zeder"
      },
      {
        "fr": "Cedrus deodara"
      },
      {
        "pt": "Cedro-do-himalaia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146935",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_deodara",
      "es": "https://es.wikipedia.org/wiki/Cedrus_deodara"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Cedrus_deodara_Manali_2.jpg/330px-Cedrus_deodara_Manali_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Cedrus_deodara_JPG1b.jpg/330px-Cedrus_deodara_JPG1b.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_deodara",
    "gbif": "https://www.gbif.org/species/5284698",
    "extract": {
      "en": "Cedrus deodara, the deodar cedar, Himalayan cedar, or deodar, is a species of cedar native to the Himalayas.",
      "es": "Cedrus deodara, comúnmente llamado cedro del Himalaya, cedro deodar o cedro de la India, es una especie perteneciente a la familia Pinaceae, nativa del oeste del Himalaya, este de Afganistán, Pakistán, noroeste y norte y centro de India, sudoeste del Tíbet y oeste de Nepal, desarrollándose a 1500-3200 m de altitud."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species317"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus212",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CedrusLibani",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cedrus libani"
    },
    "vulgarName": [
      {
        "en": "Cedar of Lebanon"
      },
      {
        "en": "Lebanon cedar"
      },
      {
        "es": "Cedrus libani"
      },
      {
        "de": "Libanon-Zeder"
      },
      {
        "fr": "Cèdre du Liban"
      },
      {
        "pt": "Cedro-do-líbano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q61105",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cedrus_libani",
      "es": "https://es.wikipedia.org/wiki/Cedrus_libani"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/C%C3%A8dre_du_Liban_Barouk_2005.jpg/330px-C%C3%A8dre_du_Liban_Barouk_2005.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/The_Cedars_of_God%2C_Lebanon_2002.jpeg/330px-The_Cedars_of_God%2C_Lebanon_2002.jpeg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cedrus_libani",
    "gbif": "https://www.gbif.org/species/5284682",
    "extract": {
      "en": "Cedrus libani, commonly known as cedar of Lebanon, Lebanon cedar, or Lebanese cedar, is a species of large evergreen conifer in the genus Cedrus, which belongs to the pine family and is native to the mountains of the Eastern Mediterranean basin. Known for its longevity, height, and durable wood, it has held profound significance for millennia. The tree features in ancient Mesopotamian and Israelite literature, notably in the Hebrew Bible, according to which the tree was used in the construction of the Jerusalem Temple by Solomon, who received the trees from Hiram of Tyre. Today, it is the national emblem of Lebanon and is widely used as an ornamental tree in parks and gardens. Historically the ancient Phoenicians used Cedar wood for shipbuilding and traded Cedar trees with Ancient Egypt, Ancient Greece, Anatolians, Israelites, Iberians, Punics, Sicilians,Romans and Ancient Iraq.",
      "es": "El Cedrus libani, comúnmente conocido como cedro del Líbano, es una especie de cedro nativa de las montañas de la cuenca del Mediterráneo Oriental. Es una conífera acicufolia de hoja perenne que puede alcanzar los 40 m de altura. Es el emblema nacional del Líbano y se usa ampliamente como árbol ornamental en parques y jardines."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 335
      },
      "ifn3": {
        "count": 423
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
    "isGenus": 1,
    "scientificName": {
      "la": "Abies"
    },
    "vulgarName": [
      {
        "es": "Abetos"
      },
      {
        "en": "Firs"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25350",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fir",
      "es": "https://es.wikipedia.org/wiki/Abies"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Abies_koreana_%28szyszki%29.JPG/330px-Abies_koreana_%28szyszki%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Abies_bracteata.jpg/330px-Abies_bracteata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies",
    "gbif": "https://www.gbif.org/species/2684876",
    "extract": {
      "en": "Firs are evergreen coniferous trees belonging to the genus Abies in the family Pinaceae. There are approximately 48–65 extant species, found on mountains throughout much of North and Central America, Eurasia, and North Africa. The genus is most closely related to Keteleeria, a small genus confined to eastern Asia.",
      "es": "Abies es un género de árboles de la familia de las pináceas, dentro de las coníferas. El género comprende 55 especies conocidas como abetos, 33 de las cuales pueden considerarse como primarias y las 22 restantes como secundarias o tal vez subespecies de las anteriores. Crecen principalmente en bosques de coníferas de Asia central y oriental, centro y sur de Europa y Norteamérica. Su altura varía de 10 a 80 m."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 295
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies alba"
    },
    "vulgarName": [
      {
        "en": "European silver fir"
      },
      {
        "en": "Silver fir"
      },
      {
        "es": "Pinabete"
      },
      {
        "de": "Weiß-Tanne"
      },
      {
        "fr": "Abies alba"
      },
      {
        "pt": "Abies alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_alba",
      "es": "https://es.wikipedia.org/wiki/Abies_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Abies_alba_Wis%C5%82a_1.jpg/330px-Abies_alba_Wis%C5%82a_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Sapin_lure.jpg/330px-Sapin_lure.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_alba",
    "gbif": "https://www.gbif.org/species/2685484",
    "extract": {
      "en": "Abies alba, the European silver fir or silver fir, is a fir native to the mountains of Europe, from the Pyrenees north to Normandy, east to the Alps and the Carpathians, Slovakia, Slovenia, Croatia, Bosnia and Herzegovina, Montenegro, Serbia, and south to Italy, Bulgaria, Kosovo, Albania and northern Greece.",
      "es": "Abies alba, el abeto común o abeto blanco es un árbol perennifolio de la familia de las pináceas, originaria de las regiones montañosas de Europa. De porte piramidal, tamaño medio o elevado, entre 20 y 50 metros, puede alcanzar los 60 metros de altura, su tronco es derecho y columnar, desprovisto de ramas en su parte inferior, de hasta 6 metros de circunferencia, con corteza cenicienta a blanquecina, lisa y con vesículas resinosas; se oscurece y resquebraja en los ejemplares viejos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo"
    ],
    "nplots": {
      "ifn2": {
        "count": 40
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies pinsapo"
    },
    "vulgarName": [
      {
        "en": "Spanish fir"
      },
      {
        "es": "Pinsapo"
      },
      {
        "de": "Spanische Tanne"
      },
      {
        "fr": "Abies pinsapo"
      },
      {
        "pt": "Abies pinsapo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q849381",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_pinsapo",
      "es": "https://es.wikipedia.org/wiki/Abies_pinsapo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg/330px-Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_pinsapo",
    "gbif": "https://www.gbif.org/species/2685464",
    "extract": {
      "en": "Abies pinsapo, Spanish fir, is a species of tree in the family Pinaceae, native to southern Spain and northern Morocco. Related to other species of Mediterranean firs, it appears at elevations of 900–1,800 metres (3,000–5,900 ft) in the Sierra de Grazalema in the Province of Cádiz and the Sierra de las Nieves and Sierra Bermeja, both near Ronda in the province of Málaga. In Morocco, it is limited to the Rif Mountains at elevations of 1,400–2,100 metres (4,600–6,900 ft) on Jebel Tisouka and Jebel Tasaot. The scientific name pinsapo is from the Spanish vernacular name for the species.",
      "es": "Abies pinsapo, el pinsapo, es una especie perteneciente a la familia Pinaceae y de distribución restringida a la Serranía de Ronda y de Cádiz sistema montañoso situado en el extremo meridional de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 295
      },
      "ifn3": {
        "count": 357
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies alba"
    },
    "vulgarName": [
      {
        "en": "European silver fir"
      },
      {
        "en": "Silver fir"
      },
      {
        "es": "Pinabete"
      },
      {
        "de": "Weiß-Tanne"
      },
      {
        "fr": "Abies alba"
      },
      {
        "pt": "Abies alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_alba",
      "es": "https://es.wikipedia.org/wiki/Abies_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Abies_alba_Wis%C5%82a_1.jpg/330px-Abies_alba_Wis%C5%82a_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Sapin_lure.jpg/330px-Sapin_lure.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_alba",
    "gbif": "https://www.gbif.org/species/2685484",
    "extract": {
      "en": "Abies alba, the European silver fir or silver fir, is a fir native to the mountains of Europe, from the Pyrenees north to Normandy, east to the Alps and the Carpathians, Slovakia, Slovenia, Croatia, Bosnia and Herzegovina, Montenegro, Serbia, and south to Italy, Bulgaria, Kosovo, Albania and northern Greece.",
      "es": "Abies alba, el abeto común o abeto blanco es un árbol perennifolio de la familia de las pináceas, originaria de las regiones montañosas de Europa. De porte piramidal, tamaño medio o elevado, entre 20 y 50 metros, puede alcanzar los 60 metros de altura, su tronco es derecho y columnar, desprovisto de ramas en su parte inferior, de hasta 6 metros de circunferencia, con corteza cenicienta a blanquecina, lisa y con vesículas resinosas; se oscurece y resquebraja en los ejemplares viejos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 40
      },
      "ifn3": {
        "count": 66
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies pinsapo"
    },
    "vulgarName": [
      {
        "en": "Spanish fir"
      },
      {
        "es": "Pinsapo"
      },
      {
        "de": "Spanische Tanne"
      },
      {
        "fr": "Abies pinsapo"
      },
      {
        "pt": "Abies pinsapo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q849381",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_pinsapo",
      "es": "https://es.wikipedia.org/wiki/Abies_pinsapo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg/330px-Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_pinsapo",
    "gbif": "https://www.gbif.org/species/2685464",
    "extract": {
      "en": "Abies pinsapo, Spanish fir, is a species of tree in the family Pinaceae, native to southern Spain and northern Morocco. Related to other species of Mediterranean firs, it appears at elevations of 900–1,800 metres (3,000–5,900 ft) in the Sierra de Grazalema in the Province of Cádiz and the Sierra de las Nieves and Sierra Bermeja, both near Ronda in the province of Málaga. In Morocco, it is limited to the Rif Mountains at elevations of 1,400–2,100 metres (4,600–6,900 ft) on Jebel Tisouka and Jebel Tasaot. The scientific name pinsapo is from the Spanish vernacular name for the species.",
      "es": "Abies pinsapo, el pinsapo, es una especie perteneciente a la familia Pinaceae y de distribución restringida a la Serranía de Ronda y de Cádiz sistema montañoso situado en el extremo meridional de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 357
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species31",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies alba"
    },
    "vulgarName": [
      {
        "en": "European silver fir"
      },
      {
        "en": "Silver fir"
      },
      {
        "es": "Pinabete"
      },
      {
        "de": "Weiß-Tanne"
      },
      {
        "fr": "Abies alba"
      },
      {
        "pt": "Abies alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_alba",
      "es": "https://es.wikipedia.org/wiki/Abies_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Abies_alba_Wis%C5%82a_1.jpg/330px-Abies_alba_Wis%C5%82a_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Sapin_lure.jpg/330px-Sapin_lure.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_alba",
    "gbif": "https://www.gbif.org/species/2685484",
    "extract": {
      "en": "Abies alba, the European silver fir or silver fir, is a fir native to the mountains of Europe, from the Pyrenees north to Normandy, east to the Alps and the Carpathians, Slovakia, Slovenia, Croatia, Bosnia and Herzegovina, Montenegro, Serbia, and south to Italy, Bulgaria, Kosovo, Albania and northern Greece.",
      "es": "Abies alba, el abeto común o abeto blanco es un árbol perennifolio de la familia de las pináceas, originaria de las regiones montañosas de Europa. De porte piramidal, tamaño medio o elevado, entre 20 y 50 metros, puede alcanzar los 60 metros de altura, su tronco es derecho y columnar, desprovisto de ramas en su parte inferior, de hasta 6 metros de circunferencia, con corteza cenicienta a blanquecina, lisa y con vesículas resinosas; se oscurece y resquebraja en los ejemplares viejos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus213",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AbiesPinsapo"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 66
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species32",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Abies pinsapo"
    },
    "vulgarName": [
      {
        "en": "Spanish fir"
      },
      {
        "es": "Pinsapo"
      },
      {
        "de": "Spanische Tanne"
      },
      {
        "fr": "Abies pinsapo"
      },
      {
        "pt": "Abies pinsapo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q849381",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Abies_pinsapo",
      "es": "https://es.wikipedia.org/wiki/Abies_pinsapo"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg/330px-Abies_pinsapo%2C_joven%2C_en_la_Sierra_de_las_Nieves.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Abies_pinsapo",
    "gbif": "https://www.gbif.org/species/2685464",
    "extract": {
      "en": "Abies pinsapo, Spanish fir, is a species of tree in the family Pinaceae, native to southern Spain and northern Morocco. Related to other species of Mediterranean firs, it appears at elevations of 900–1,800 metres (3,000–5,900 ft) in the Sierra de Grazalema in the Province of Cádiz and the Sierra de las Nieves and Sierra Bermeja, both near Ronda in the province of Málaga. In Morocco, it is limited to the Rif Mountains at elevations of 1,400–2,100 metres (4,600–6,900 ft) on Jebel Tisouka and Jebel Tasaot. The scientific name pinsapo is from the Spanish vernacular name for the species.",
      "es": "Abies pinsapo, el pinsapo, es una especie perteneciente a la familia Pinaceae y de distribución restringida a la Serranía de Ronda y de Cádiz sistema montañoso situado en el extremo meridional de la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 168
      },
      "ifn3": {
        "count": 140
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
    "isGenus": 1,
    "scientificName": {
      "la": "Larix"
    },
    "vulgarName": [
      {
        "es": "Alerces"
      },
      {
        "en": "Larches"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25618",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larch",
      "es": "https://es.wikipedia.org/wiki/Larix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Larix_decidua_Aletschwald.jpg/330px-Larix_decidua_Aletschwald.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Siberian-larch.jpg/330px-Siberian-larch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix",
    "gbif": "https://www.gbif.org/species/2686156",
    "extract": {
      "en": "Larches are deciduous conifers in the genus Larix, of the family Pinaceae. Growing to as much as 60 m (195 ft) tall, they are native to the cooler regions of the Northern Hemisphere. They grow in lowland forests in the far north, and high in mountains further south. Larches are among the dominant plants in the boreal forests of Siberia and Canada, making them the most abundant genus of trees on earth. Larch wood is tough and relatively durable; it is used in boatbuilding, cladding, decking, garden furniture, fencing, and construction. Products extracted from larch include arabinogalactan, rosin, turpentine, and an essential oil.",
      "es": "Larix es un género de árboles de la familia de las pináceas dentro de las coníferas. Son llamados comúnmente lárice o alerces; contiene unas trece especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix"
    ],
    "nplots": {
      "ifn2": {
        "count": 168
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix"
    },
    "vulgarName": [
      {
        "en": "Larch"
      },
      {
        "es": "Alerce"
      },
      {
        "de": "Lärchen"
      },
      {
        "fr": "Larix"
      },
      {
        "pt": "Larix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25618",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larch",
      "es": "https://es.wikipedia.org/wiki/Larix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Larix_decidua_Aletschwald.jpg/330px-Larix_decidua_Aletschwald.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Siberian-larch.jpg/330px-Siberian-larch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix",
    "gbif": "https://www.gbif.org/species/2686156",
    "extract": {
      "en": "Larches are deciduous conifers in the genus Larix, of the family Pinaceae. Growing to as much as 60 m (195 ft) tall, they are native to the cooler regions of the Northern Hemisphere. They grow in lowland forests in the far north, and high in mountains further south. Larches are among the dominant plants in the boreal forests of Siberia and Canada, making them the most abundant genus of trees on earth. Larch wood is tough and relatively durable; it is used in boatbuilding, cladding, decking, garden furniture, fencing, and construction. Products extracted from larch include arabinogalactan, rosin, turpentine, and an essential oil.",
      "es": "Larix es un género de árboles de la familia de las pináceas dentro de las coníferas. Son llamados comúnmente lárice o alerces; contiene unas trece especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 168
      },
      "ifn3": {
        "count": 140
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix"
    },
    "vulgarName": [
      {
        "en": "Larch"
      },
      {
        "es": "Alerce"
      },
      {
        "de": "Lärchen"
      },
      {
        "fr": "Larix"
      },
      {
        "pt": "Larix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25618",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larch",
      "es": "https://es.wikipedia.org/wiki/Larix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Larix_decidua_Aletschwald.jpg/330px-Larix_decidua_Aletschwald.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Siberian-larch.jpg/330px-Siberian-larch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix",
    "gbif": "https://www.gbif.org/species/2686156",
    "extract": {
      "en": "Larches are deciduous conifers in the genus Larix, of the family Pinaceae. Growing to as much as 60 m (195 ft) tall, they are native to the cooler regions of the Northern Hemisphere. They grow in lowland forests in the far north, and high in mountains further south. Larches are among the dominant plants in the boreal forests of Siberia and Canada, making them the most abundant genus of trees on earth. Larch wood is tough and relatively durable; it is used in boatbuilding, cladding, decking, garden furniture, fencing, and construction. Products extracted from larch include arabinogalactan, rosin, turpentine, and an essential oil.",
      "es": "Larix es un género de árboles de la familia de las pináceas dentro de las coníferas. Son llamados comúnmente lárice o alerces; contiene unas trece especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix decidua"
    },
    "vulgarName": [
      {
        "en": "European larch"
      },
      {
        "es": "Alerce común"
      },
      {
        "de": "Europäische Lärche"
      },
      {
        "fr": "Larix decidua"
      },
      {
        "pt": "Lariço-europeu"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146048",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larix_decidua",
      "es": "https://es.wikipedia.org/wiki/Larix_decidua"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/L%27A_de_Bran%2C_%281798_m%29_Val_d%27Anniviers._Europese_larix_%28Larix_decidua%29_01.JPG/330px-L%27A_de_Bran%2C_%281798_m%29_Val_d%27Anniviers._Europese_larix_%28Larix_decidua%29_01.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/M%C3%A9l%C3%A8ze_en_Automne.JPG/330px-M%C3%A9l%C3%A8ze_en_Automne.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix_decidua",
    "gbif": "https://www.gbif.org/species/2686212",
    "extract": {
      "en": "Larix decidua, the European larch, is a species of larch native to the mountains of central Europe, in the Alps and Carpathian Mountains, with small disjunct lowland populations in northern Poland. Its life span has been confirmed to be close to 1000 years, with ages of around 2000 years likely.",
      "es": "Larix decidua, el alerce europeo o lárice, es una especie del género Larix, de la familia de las pináceas nativa de las montañas de Europa Central, en los Alpes y Cárpatos, con poblaciones disjuntas en las tierras bajas del norte de Polonia y sur de Lituania. El alerce es la única conífera europea que pierde sus agujas, mientras que las piceas, los pinos y abetos las conservan en invierno."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix leptolepis"
    },
    "vulgarName": [
      {
        "en": "Japanese larch"
      },
      {
        "en": "Karamatsu"
      },
      {
        "es": "Alerce del Japón"
      },
      {
        "de": "Japanische Lärche"
      },
      {
        "fr": "Mélèze du Japon"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147439",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larix_kaempferi",
      "es": "https://es.wikipedia.org/wiki/Larix_kaempferi"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Larix_kaempferi_Oze_NP.jpg/330px-Larix_kaempferi_Oze_NP.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Larix-kaempferi.JPG/330px-Larix-kaempferi.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix_kaempferi",
    "gbif": "https://www.gbif.org/species/2686157",
    "extract": {
      "en": "Larix kaempferi, the Japanese larch or karamatsu in Japanese, is a species of larch native to Japan, in the mountains of Chūbu and Kantō regions in central Honshū.",
      "es": "Larix kaempferi, el alerce del Japón, es una conífera, especie de alerce nativo de Japón, en las montañas de las regiones de Chūbu y Kantō en el centro de Honshū."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Larix"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 140
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species35",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix"
    },
    "vulgarName": [
      {
        "en": "Larch"
      },
      {
        "es": "Alerce"
      },
      {
        "de": "Lärchen"
      },
      {
        "fr": "Larix"
      },
      {
        "pt": "Larix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25618",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larch",
      "es": "https://es.wikipedia.org/wiki/Larix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Larix_decidua_Aletschwald.jpg/330px-Larix_decidua_Aletschwald.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Siberian-larch.jpg/330px-Siberian-larch.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix",
    "gbif": "https://www.gbif.org/species/2686156",
    "extract": {
      "en": "Larches are deciduous conifers in the genus Larix, of the family Pinaceae. Growing to as much as 60 m (195 ft) tall, they are native to the cooler regions of the Northern Hemisphere. They grow in lowland forests in the far north, and high in mountains further south. Larches are among the dominant plants in the boreal forests of Siberia and Canada, making them the most abundant genus of trees on earth. Larch wood is tough and relatively durable; it is used in boatbuilding, cladding, decking, garden furniture, fencing, and construction. Products extracted from larch include arabinogalactan, rosin, turpentine, and an essential oil.",
      "es": "Larix es un género de árboles de la familia de las pináceas dentro de las coníferas. Son llamados comúnmente lárice o alerces; contiene unas trece especies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix x eurolepis"
    },
    "vulgarName": [
      {
        "de": "Lärchen"
      },
      {
        "fr": "Larix"
      },
      {
        "pt": "Larix"
      },
      {
        "es": "Alerce híbrido"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q17274488"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species235"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixDecidua",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix decidua"
    },
    "vulgarName": [
      {
        "en": "European larch"
      },
      {
        "es": "Alerce común"
      },
      {
        "de": "Europäische Lärche"
      },
      {
        "fr": "Larix decidua"
      },
      {
        "pt": "Lariço-europeu"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146048",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larix_decidua",
      "es": "https://es.wikipedia.org/wiki/Larix_decidua"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/L%27A_de_Bran%2C_%281798_m%29_Val_d%27Anniviers._Europese_larix_%28Larix_decidua%29_01.JPG/330px-L%27A_de_Bran%2C_%281798_m%29_Val_d%27Anniviers._Europese_larix_%28Larix_decidua%29_01.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/M%C3%A9l%C3%A8ze_en_Automne.JPG/330px-M%C3%A9l%C3%A8ze_en_Automne.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix_decidua",
    "gbif": "https://www.gbif.org/species/2686212",
    "extract": {
      "en": "Larix decidua, the European larch, is a species of larch native to the mountains of central Europe, in the Alps and Carpathian Mountains, with small disjunct lowland populations in northern Poland. Its life span has been confirmed to be close to 1000 years, with ages of around 2000 years likely.",
      "es": "Larix decidua, el alerce europeo o lárice, es una especie del género Larix, de la familia de las pináceas nativa de las montañas de Europa Central, en los Alpes y Cárpatos, con poblaciones disjuntas en las tierras bajas del norte de Polonia y sur de Lituania. El alerce es la única conífera europea que pierde sus agujas, mientras que las piceas, los pinos y abetos las conservan en invierno."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species335"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixLeptolepis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix leptolepis"
    },
    "vulgarName": [
      {
        "en": "Japanese larch"
      },
      {
        "en": "Karamatsu"
      },
      {
        "es": "Alerce del Japón"
      },
      {
        "de": "Japanische Lärche"
      },
      {
        "fr": "Mélèze du Japon"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147439",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Larix_kaempferi",
      "es": "https://es.wikipedia.org/wiki/Larix_kaempferi"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Larix_kaempferi_Oze_NP.jpg/330px-Larix_kaempferi_Oze_NP.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Larix-kaempferi.JPG/330px-Larix-kaempferi.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Larix_kaempferi",
    "gbif": "https://www.gbif.org/species/2686157",
    "extract": {
      "en": "Larix kaempferi, the Japanese larch or karamatsu in Japanese, is a species of larch native to Japan, in the mountains of Chūbu and Kantō regions in central Honshū.",
      "es": "Larix kaempferi, el alerce del Japón, es una conífera, especie de alerce nativo de Japón, en las montañas de las regiones de Chūbu y Kantō en el centro de Honshū."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species435"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus214",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LarixXEurolepis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Larix x eurolepis"
    },
    "vulgarName": [
      {
        "de": "Lärchen"
      },
      {
        "fr": "Larix"
      },
      {
        "pt": "Larix"
      },
      {
        "es": "Alerce híbrido"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q17274488"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
    "isGenus": 1,
    "scientificName": {
      "la": "Picea"
    },
    "vulgarName": [
      {
        "es": "Piceas"
      },
      {
        "en": "Spruces"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26782",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Spruce",
      "es": "https://es.wikipedia.org/wiki/Picea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Picea_abies.jpg/330px-Picea_abies.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg/330px-Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picea",
    "gbif": "https://www.gbif.org/species/7606064",
    "extract": {
      "en": "A spruce is a tree of the genus Picea, a genus of some 37 species of coniferous evergreen trees in the family Pinaceae, found in the northern temperate and boreal (taiga) regions of the Northern Hemisphere. Picea is treated either in the subfamily Pinoideae, or the sole genus in its own subfamily Piceoideae.",
      "es": "La pícea constituye un género de la familia Pinaceae con unas 35 especies, dentro de las coníferas. Son árboles entre 20 a 60 metros de altura, con porte piramidal, hojas aisladas, planas o tetragonales puntiagudas y estróbilos colgantes que no se disgregan hasta madurar. Entre sus representantes más conocidos están el abeto rojo y la Picea glauca. La mayoría de las especies del género son árboles longevos y de crecimiento lento. Su madera es muy utilizada para fabricar instrumentos musicales, como violines o guitarras."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picea abies"
    },
    "vulgarName": [
      {
        "en": "Norway spruce"
      },
      {
        "es": "Pícea"
      },
      {
        "de": "Gemeine Fichte"
      },
      {
        "fr": "Épicéa commun"
      },
      {
        "pt": "Picea abies"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picea_abies",
      "es": "https://es.wikipedia.org/wiki/Picea_abies"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg/330px-Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picea_abies",
    "gbif": "https://www.gbif.org/species/5284884",
    "extract": {
      "en": "Picea abies, the Norway spruce, Norway fir or European spruce, is a species of spruce native to Northern, Central and Eastern Europe.",
      "es": "La pícea común, pícea de Noruega o pícea europea, es una conífera de la familia de las pináceas. Aunque en ocasiones se le identifica popularmente como abeto rojo o falso abeto, estrictamente hablando no lo es, por no pertenecer al género Abies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picea abies"
    },
    "vulgarName": [
      {
        "en": "Norway spruce"
      },
      {
        "es": "Pícea"
      },
      {
        "de": "Gemeine Fichte"
      },
      {
        "fr": "Épicéa commun"
      },
      {
        "pt": "Picea abies"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picea_abies",
      "es": "https://es.wikipedia.org/wiki/Picea_abies"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg/330px-Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picea_abies",
    "gbif": "https://www.gbif.org/species/5284884",
    "extract": {
      "en": "Picea abies, the Norway spruce, Norway fir or European spruce, is a species of spruce native to Northern, Central and Eastern Europe.",
      "es": "La pícea común, pícea de Noruega o pícea europea, es una conífera de la familia de las pináceas. Aunque en ocasiones se le identifica popularmente como abeto rojo o falso abeto, estrictamente hablando no lo es, por no pertenecer al género Abies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PiceaAbies"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species33",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picea abies"
    },
    "vulgarName": [
      {
        "en": "Norway spruce"
      },
      {
        "es": "Pícea"
      },
      {
        "de": "Gemeine Fichte"
      },
      {
        "fr": "Épicéa commun"
      },
      {
        "pt": "Picea abies"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q145992",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picea_abies",
      "es": "https://es.wikipedia.org/wiki/Picea_abies"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg/330px-Kuusk_Keila-Paldiski_rdt_%C3%A4%C3%A4res.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picea_abies",
    "gbif": "https://www.gbif.org/species/5284884",
    "extract": {
      "en": "Picea abies, the Norway spruce, Norway fir or European spruce, is a species of spruce native to Northern, Central and Eastern Europe.",
      "es": "La pícea común, pícea de Noruega o pícea europea, es una conífera de la familia de las pináceas. Aunque en ocasiones se le identifica popularmente como abeto rojo o falso abeto, estrictamente hablando no lo es, por no pertenecer al género Abies."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 72
      },
      "ifn3": {
        "count": 126
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
    "isGenus": 1,
    "scientificName": {
      "la": "Pseudotsuga"
    },
    "vulgarName": [
      {
        "en": "Douglas-firs"
      },
      {
        "es": "Pinos oregón"
      },
      {
        "de": "Douglasien"
      },
      {
        "fr": "Pseudotsuga"
      },
      {
        "pt": "Pseudotsuga"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158771",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pseudotsuga",
      "es": "https://es.wikipedia.org/wiki/Pseudotsuga"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Pseudotsuga_menziesii_28236.JPG/330px-Pseudotsuga_menziesii_28236.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Pseudotsuga_menziesii_glauca_tree.jpg/330px-Pseudotsuga_menziesii_glauca_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pseudotsuga",
    "gbif": "https://www.gbif.org/species/2685775",
    "extract": {
      "en": "Pseudotsuga is a genus of evergreen coniferous trees in the family Pinaceae. Common names for species in the genus include Douglas fir, Douglas-fir, Douglas tree, Oregon pine and Bigcone spruce. Pseudotsuga menziesii is widespread in western North America and is an important source of timber. The number of species has long been debated, but two in western North America and two to four in eastern Asia are commonly acknowledged.",
      "es": "Pseudotsuga es un género de coníferas dentro de la familia de las pináceas. Se les llama, en español \"douglasias\" o \"abetos de Douglas\", aunque no son realmente abetos. Hay cinco especies, dos en el oeste de Norteamérica, una en México y dos en el este de Asia. Las Douglasias plantearon problemas de clasificación a los botánicos del siglo XIX debido a la similitud que presentan con otras varias coníferas conocidas en su tiempo, lo que originó que unas veces lo clasificaran en Pinus, Picea, Abies, Tsuga, e incluso en las Sequoia. Debido a sus conos distintivos, la Douglasia finalmente se clasificaron en el nuevo género Pseudotsuga por el botánico francés Carrière en 1867."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii"
    ],
    "nplots": {
      "ifn2": {
        "count": 72
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pseudotsuga menziesii"
    },
    "vulgarName": [
      {
        "en": "Douglas-fir"
      },
      {
        "es": "Seudotsuga"
      },
      {
        "de": "Gewöhnliche Douglasie"
      },
      {
        "fr": "Pseudotsuga menziesii"
      },
      {
        "pt": "Pseudotsuga menziesii"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156687",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Douglas_fir",
      "es": "https://es.wikipedia.org/wiki/Pseudotsuga_menziesii"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Pseudotsuga_menziesii_4584.JPG/330px-Pseudotsuga_menziesii_4584.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Pseudotsuga_menziesii_levila.png/330px-Pseudotsuga_menziesii_levila.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pseudotsuga_menziesii",
    "gbif": "https://www.gbif.org/species/2685796",
    "extract": {
      "en": "The Douglas fir is an evergreen conifer species in the pine family, Pinaceae. It is the tallest tree in the Pinaceae family. It is native to western North America and is also known as Douglas-fir, Douglas spruce, Oregon pine, and Columbian pine. There are three varieties: coast Douglas-fir, Rocky Mountain Douglas-fir and Mexican Douglas-fir.",
      "es": "Pseudotsuga menziesii, comúnmente llamado abeto de Douglas, douglasia verde, falsa tsuga verde de las Rocosas, pino Oregón, pino de Oregón o Douglas de Oregón, es un árbol del género Pseudotsuga originario de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 72
      },
      "ifn3": {
        "count": 126
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pseudotsuga menziesii"
    },
    "vulgarName": [
      {
        "en": "Douglas-fir"
      },
      {
        "es": "Seudotsuga"
      },
      {
        "de": "Gewöhnliche Douglasie"
      },
      {
        "fr": "Pseudotsuga menziesii"
      },
      {
        "pt": "Pseudotsuga menziesii"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156687",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Douglas_fir",
      "es": "https://es.wikipedia.org/wiki/Pseudotsuga_menziesii"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Pseudotsuga_menziesii_4584.JPG/330px-Pseudotsuga_menziesii_4584.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Pseudotsuga_menziesii_levila.png/330px-Pseudotsuga_menziesii_levila.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pseudotsuga_menziesii",
    "gbif": "https://www.gbif.org/species/2685796",
    "extract": {
      "en": "The Douglas fir is an evergreen conifer species in the pine family, Pinaceae. It is the tallest tree in the Pinaceae family. It is native to western North America and is also known as Douglas-fir, Douglas spruce, Oregon pine, and Columbian pine. There are three varieties: coast Douglas-fir, Rocky Mountain Douglas-fir and Mexican Douglas-fir.",
      "es": "Pseudotsuga menziesii, comúnmente llamado abeto de Douglas, douglasia verde, falsa tsuga verde de las Rocosas, pino Oregón, pino de Oregón o Douglas de Oregón, es un árbol del género Pseudotsuga originario de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus216",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family21",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PseudotsugaMenziesii"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 126
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species34",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pseudotsuga menziesii"
    },
    "vulgarName": [
      {
        "en": "Douglas-fir"
      },
      {
        "es": "Seudotsuga"
      },
      {
        "de": "Gewöhnliche Douglasie"
      },
      {
        "fr": "Pseudotsuga menziesii"
      },
      {
        "pt": "Pseudotsuga menziesii"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156687",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Douglas_fir",
      "es": "https://es.wikipedia.org/wiki/Pseudotsuga_menziesii"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Pseudotsuga_menziesii_4584.JPG/330px-Pseudotsuga_menziesii_4584.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Pseudotsuga_menziesii_levila.png/330px-Pseudotsuga_menziesii_levila.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pseudotsuga_menziesii",
    "gbif": "https://www.gbif.org/species/2685796",
    "extract": {
      "en": "The Douglas fir is an evergreen conifer species in the pine family, Pinaceae. It is the tallest tree in the Pinaceae family. It is native to western North America and is also known as Douglas-fir, Douglas spruce, Oregon pine, and Columbian pine. There are three varieties: coast Douglas-fir, Rocky Mountain Douglas-fir and Mexican Douglas-fir.",
      "es": "Pseudotsuga menziesii, comúnmente llamado abeto de Douglas, douglasia verde, falsa tsuga verde de las Rocosas, pino Oregón, pino de Oregón o Douglas de Oregón, es un árbol del género Pseudotsuga originario de Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
    "isGenus": 1,
    "scientificName": {
      "la": "Cupressus"
    },
    "vulgarName": [
      {
        "de": "Zypressen"
      },
      {
        "fr": "Cyprès"
      },
      {
        "pt": "Cupressus"
      },
      {
        "es": "Cipreses"
      },
      {
        "en": "Cypresses"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146911",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus",
      "es": "https://es.wikipedia.org/wiki/Cupressus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Cypress_Halefka.JPG/330px-Cypress_Halefka.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Med_Cypress.jpg/330px-Med_Cypress.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus",
    "gbif": "https://www.gbif.org/species/2683954",
    "extract": {
      "en": "Cupressus is one of several genera of evergreen conifers within the family Cupressaceae; for the others, see cypress. It is considered a polyphyletic group. Based on genetic and morphological analysis, the genus Cupressus is found in the subfamily Cupressoideae. The common name \"cypress\" comes via the Old French cipres from the Latin cyparissus, which is the latinisation of the Greek κυπάρισσος (kypárissos). The name derives from Cyparissus, a mythological figure who was turned into a tree after killing a stag.",
      "es": "Cupressus es un género de árboles llamados comúnmente ciprés. Se han naturalizado en todas las regiones templadas del hemisferio norte; con las temperaturas y suelos adecuados se pueden encontrar creciendo espontáneamente y de forma dispersa. Se cultivan comercialmente en África oriental, Sudáfrica y Nueva Zelanda.[cita requerida]Muchas de las especies se cultivan como árbol ornamental en parques y jardines de Europa y en Asia se sitúan junto a los templos. Los cipreses son también ampliamente utilizados como setos medianeros ya que sus raíces son pivotantes, es decir, crecen en profundidad y no dañan los muros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus"
    },
    "vulgarName": [
      {
        "en": "Cypress"
      },
      {
        "es": "Ciprés"
      },
      {
        "de": "Zypressen"
      },
      {
        "fr": "Cyprès"
      },
      {
        "pt": "Cupressus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146911",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus",
      "es": "https://es.wikipedia.org/wiki/Cupressus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Cypress_Halefka.JPG/330px-Cypress_Halefka.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Med_Cypress.jpg/330px-Med_Cypress.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus",
    "gbif": "https://www.gbif.org/species/2683954",
    "extract": {
      "en": "Cupressus is one of several genera of evergreen conifers within the family Cupressaceae; for the others, see cypress. It is considered a polyphyletic group. Based on genetic and morphological analysis, the genus Cupressus is found in the subfamily Cupressoideae. The common name \"cypress\" comes via the Old French cipres from the Latin cyparissus, which is the latinisation of the Greek κυπάρισσος (kypárissos). The name derives from Cyparissus, a mythological figure who was turned into a tree after killing a stag.",
      "es": "Cupressus es un género de árboles llamados comúnmente ciprés. Se han naturalizado en todas las regiones templadas del hemisferio norte; con las temperaturas y suelos adecuados se pueden encontrar creciendo espontáneamente y de forma dispersa. Se cultivan comercialmente en África oriental, Sudáfrica y Nueva Zelanda.[cita requerida]Muchas de las especies se cultivan como árbol ornamental en parques y jardines de Europa y en Asia se sitúan junto a los templos. Los cipreses son también ampliamente utilizados como setos medianeros ya que sus raíces son pivotantes, es decir, crecen en profundidad y no dañan los muros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus"
    },
    "vulgarName": [
      {
        "en": "Cypress"
      },
      {
        "es": "Ciprés"
      },
      {
        "de": "Zypressen"
      },
      {
        "fr": "Cyprès"
      },
      {
        "pt": "Cupressus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146911",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus",
      "es": "https://es.wikipedia.org/wiki/Cupressus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Cypress_Halefka.JPG/330px-Cypress_Halefka.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Med_Cypress.jpg/330px-Med_Cypress.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus",
    "gbif": "https://www.gbif.org/species/2683954",
    "extract": {
      "en": "Cupressus is one of several genera of evergreen conifers within the family Cupressaceae; for the others, see cypress. It is considered a polyphyletic group. Based on genetic and morphological analysis, the genus Cupressus is found in the subfamily Cupressoideae. The common name \"cypress\" comes via the Old French cipres from the Latin cyparissus, which is the latinisation of the Greek κυπάρισσος (kypárissos). The name derives from Cyparissus, a mythological figure who was turned into a tree after killing a stag.",
      "es": "Cupressus es un género de árboles llamados comúnmente ciprés. Se han naturalizado en todas las regiones templadas del hemisferio norte; con las temperaturas y suelos adecuados se pueden encontrar creciendo espontáneamente y de forma dispersa. Se cultivan comercialmente en África oriental, Sudáfrica y Nueva Zelanda.[cita requerida]Muchas de las especies se cultivan como árbol ornamental en parques y jardines de Europa y en Asia se sitúan junto a los templos. Los cipreses son también ampliamente utilizados como setos medianeros ya que sus raíces son pivotantes, es decir, crecen en profundidad y no dañan los muros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus arizonica"
    },
    "vulgarName": [
      {
        "en": "Arizona cypress"
      },
      {
        "es": "Ciprés arizónica"
      },
      {
        "fr": "Cyprès de l'Arizona"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q670040"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Cedar-of-Goa"
      },
      {
        "en": "Mexican white cedar"
      },
      {
        "es": "Ciprés lambertiana"
      },
      {
        "de": "Mexikanische Zypresse"
      },
      {
        "fr": "Cyprès du Portugal"
      },
      {
        "pt": "Cipreste-português"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1308561",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Hesperocyparis_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Cupressus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Mexican_Cypress%2C_Tecolotl%C3%A1n%2C_Jalisco%2C_Mexico_50252677.jpg/330px-Mexican_Cypress%2C_Tecolotl%C3%A1n%2C_Jalisco%2C_Mexico_50252677.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Cupressus_lusitanica_kz04.jpg/330px-Cupressus_lusitanica_kz04.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus_lusitanica",
    "gbif": "https://www.gbif.org/species/2684046",
    "extract": {
      "en": "Hesperocyparis lusitanica, the Mexican cypress, cedar-of-Goa or Goa cedar, is a species of cypress native to Mexico and Central America. It has also been introduced to Belize, Costa Rica and Nicaragua, growing at 1,200–3,000 metres (3,900–9,800 ft) altitude.",
      "es": "Hesperocyparis lusitanica, de nombre común Ciprés mexicano, ciprés de México, cedro Blanco, cedro de Buesaco, o cedro de Portugal, es una especie del género Hesperocyparis. Es originario de México, Guatemalay Honduras."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus sempervirens"
    },
    "vulgarName": [
      {
        "en": "Cypress"
      },
      {
        "es": "Ciprés"
      },
      {
        "de": "Mittelmeer-Zypresse"
      },
      {
        "fr": "Cupressus sempervirens"
      },
      {
        "pt": "Cipreste-italiano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147513",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus_sempervirens",
      "es": "https://es.wikipedia.org/wiki/Cupressus_sempervirens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/%CE%95%CE%B8%CE%BD%CE%B9%CE%BA%CF%8C%CF%82_%CE%94%CF%81%CF%85%CE%BC%CF%8C%CF%82_%CE%A3%CE%B1%CE%BC%CE%B1%CF%81%CE%B9%CE%AC%CF%82.jpg/330px-%CE%95%CE%B8%CE%BD%CE%B9%CE%BA%CF%8C%CF%82_%CE%94%CF%81%CF%85%CE%BC%CF%8C%CF%82_%CE%A3%CE%B1%CE%BC%CE%B1%CF%81%CE%B9%CE%AC%CF%82.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Greece_Symi.jpg/330px-Greece_Symi.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus_sempervirens",
    "gbif": "https://www.gbif.org/species/2684030",
    "extract": {
      "en": "Cupressus sempervirens, the Mediterranean cypress, is a species of cypress native to the eastern Mediterranean region and Iran. It is well-adapted to the environmental conditions that it lives in due to its ability to survive in both acidic and alkaline soils and withstand drought. Cupressus sempervirens is important in Mediterranean and Middle Eastern culture. In Iran it is both a sacred tree and a metaphor for \"the graceful figure of the beloved\".",
      "es": "Cupressus sempervirens, el ciprés común o ciprés mediterráneo, es una especie arbórea de hoja perenne de la familia de las Cupresáceas. Puede llegar a ser muy longevo, existiendo ejemplares con más de 1000 años. En algunas áreas, particularmente de los Estados Unidos, se conoce con el nombre de \"ciprés italiano\"; ya que la especie es muy común en Italia, aunque no es originario de allí."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus macrocarpa"
    },
    "vulgarName": [
      {
        "en": "Monterey cypress"
      },
      {
        "es": "Ciprés americano"
      },
      {
        "de": "Monterey-Zypresse"
      },
      {
        "fr": "Cyprès de Lambert"
      },
      {
        "pt": "Cipreste-da-Califórnia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1137183"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Cupressus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species936",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus"
    },
    "vulgarName": [
      {
        "en": "Cypress"
      },
      {
        "es": "Ciprés"
      },
      {
        "de": "Zypressen"
      },
      {
        "fr": "Cyprès"
      },
      {
        "pt": "Cupressus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146911",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus",
      "es": "https://es.wikipedia.org/wiki/Cupressus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Cypress_Halefka.JPG/330px-Cypress_Halefka.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Med_Cypress.jpg/330px-Med_Cypress.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus",
    "gbif": "https://www.gbif.org/species/2683954",
    "extract": {
      "en": "Cupressus is one of several genera of evergreen conifers within the family Cupressaceae; for the others, see cypress. It is considered a polyphyletic group. Based on genetic and morphological analysis, the genus Cupressus is found in the subfamily Cupressoideae. The common name \"cypress\" comes via the Old French cipres from the Latin cyparissus, which is the latinisation of the Greek κυπάρισσος (kypárissos). The name derives from Cyparissus, a mythological figure who was turned into a tree after killing a stag.",
      "es": "Cupressus es un género de árboles llamados comúnmente ciprés. Se han naturalizado en todas las regiones templadas del hemisferio norte; con las temperaturas y suelos adecuados se pueden encontrar creciendo espontáneamente y de forma dispersa. Se cultivan comercialmente en África oriental, Sudáfrica y Nueva Zelanda.[cita requerida]Muchas de las especies se cultivan como árbol ornamental en parques y jardines de Europa y en Asia se sitúan junto a los templos. Los cipreses son también ampliamente utilizados como setos medianeros ya que sus raíces son pivotantes, es decir, crecen en profundidad y no dañan los muros."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species236"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusArizonica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus arizonica"
    },
    "vulgarName": [
      {
        "en": "Arizona cypress"
      },
      {
        "es": "Ciprés arizónica"
      },
      {
        "fr": "Cyprès de l'Arizona"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q670040"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species336"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusLusitanica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Cedar-of-Goa"
      },
      {
        "en": "Mexican white cedar"
      },
      {
        "es": "Ciprés lambertiana"
      },
      {
        "de": "Mexikanische Zypresse"
      },
      {
        "fr": "Cyprès du Portugal"
      },
      {
        "pt": "Cipreste-português"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1308561",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Hesperocyparis_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Cupressus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Mexican_Cypress%2C_Tecolotl%C3%A1n%2C_Jalisco%2C_Mexico_50252677.jpg/330px-Mexican_Cypress%2C_Tecolotl%C3%A1n%2C_Jalisco%2C_Mexico_50252677.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Cupressus_lusitanica_kz04.jpg/330px-Cupressus_lusitanica_kz04.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus_lusitanica",
    "gbif": "https://www.gbif.org/species/2684046",
    "extract": {
      "en": "Hesperocyparis lusitanica, the Mexican cypress, cedar-of-Goa or Goa cedar, is a species of cypress native to Mexico and Central America. It has also been introduced to Belize, Costa Rica and Nicaragua, growing at 1,200–3,000 metres (3,900–9,800 ft) altitude.",
      "es": "Hesperocyparis lusitanica, de nombre común Ciprés mexicano, ciprés de México, cedro Blanco, cedro de Buesaco, o cedro de Portugal, es una especie del género Hesperocyparis. Es originario de México, Guatemalay Honduras."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species436"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusMacrocarpa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus macrocarpa"
    },
    "vulgarName": [
      {
        "en": "Monterey cypress"
      },
      {
        "es": "Ciprés americano"
      },
      {
        "de": "Monterey-Zypresse"
      },
      {
        "fr": "Cyprès de Lambert"
      },
      {
        "pt": "Cipreste-da-Califórnia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1137183"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species36"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus221",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CupressusSempervirens",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cupressus sempervirens"
    },
    "vulgarName": [
      {
        "en": "Cypress"
      },
      {
        "es": "Ciprés"
      },
      {
        "de": "Mittelmeer-Zypresse"
      },
      {
        "fr": "Cupressus sempervirens"
      },
      {
        "pt": "Cipreste-italiano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147513",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cupressus_sempervirens",
      "es": "https://es.wikipedia.org/wiki/Cupressus_sempervirens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/%CE%95%CE%B8%CE%BD%CE%B9%CE%BA%CF%8C%CF%82_%CE%94%CF%81%CF%85%CE%BC%CF%8C%CF%82_%CE%A3%CE%B1%CE%BC%CE%B1%CF%81%CE%B9%CE%AC%CF%82.jpg/330px-%CE%95%CE%B8%CE%BD%CE%B9%CE%BA%CF%8C%CF%82_%CE%94%CF%81%CF%85%CE%BC%CF%8C%CF%82_%CE%A3%CE%B1%CE%BC%CE%B1%CF%81%CE%B9%CE%AC%CF%82.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Greece_Symi.jpg/330px-Greece_Symi.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cupressus_sempervirens",
    "gbif": "https://www.gbif.org/species/2684030",
    "extract": {
      "en": "Cupressus sempervirens, the Mediterranean cypress, is a species of cypress native to the eastern Mediterranean region and Iran. It is well-adapted to the environmental conditions that it lives in due to its ability to survive in both acidic and alkaline soils and withstand drought. Cupressus sempervirens is important in Mediterranean and Middle Eastern culture. In Iran it is both a sacred tree and a metaphor for \"the graceful figure of the beloved\".",
      "es": "Cupressus sempervirens, el ciprés común o ciprés mediterráneo, es una especie arbórea de hoja perenne de la familia de las Cupresáceas. Puede llegar a ser muy longevo, existiendo ejemplares con más de 1000 años. En algunas áreas, particularmente de los Estados Unidos, se conoce con el nombre de \"ciprés italiano\"; ya que la especie es muy común en Italia, aunque no es originario de allí."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 2399
      },
      "ifn3": {
        "count": 2776
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
    "isGenus": 1,
    "scientificName": {
      "la": "Juniperus"
    },
    "vulgarName": [
      {
        "en": "Junipers"
      },
      {
        "es": "Sabinas y enebros"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25662",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniper",
      "es": "https://es.wikipedia.org/wiki/Juniperus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Juniperus_osteosperma_1.jpg/330px-Juniperus_osteosperma_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Juniperus_phoenicea1.jpg/330px-Juniperus_phoenicea1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus",
    "gbif": "https://www.gbif.org/species/2684359",
    "extract": {
      "en": "Junipers are coniferous trees and shrubs in the genus Juniperus of the cypress family Cupressaceae. Depending on the taxonomy, between 50 and 67 species of junipers are widely distributed throughout the Northern Hemisphere as far south as tropical Africa, as far north as the Arctic, and parts of Asia and Central America. The highest-known juniper forest occurs at an altitude of 4,900 metres (16,100 ft) in southeastern Tibet and the northern Himalayas, creating one of the highest tree lines on earth.",
      "es": "El género Juniperus, de amplia distribución, comprende las especies llamadas comúnmente enebros o sabinas. Los juníperos son coníferas arbóreas o arbustivas, pertenecientes a la familia Cupressaceae. Dependiendo del punto de vista taxonómico, hay entre 50 y 67 especies, ampliamente distribuidas por todo el hemisferio norte, desde el Ártico hacia el sur hasta el África tropical en el Viejo Mundo, y hasta las montañas de Centroamérica. Las especies se reparten en dos secciones (sectio), los enebros y las sabinas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 755
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus cedrus / Juniperus communis / Juniperus oxycedrus"
    },
    "vulgarName": [
      {
        "en": "Cade"
      },
      {
        "en": "Cade juniper"
      },
      {
        "en": "Canary Islands juniper"
      },
      {
        "en": "Common juniper"
      },
      {
        "en": "Prickly cedar"
      },
      {
        "en": "Prickly juniper"
      },
      {
        "en": "Sharp cedar"
      },
      {
        "es": "Enebro canario"
      },
      {
        "es": "Enebro común"
      },
      {
        "es": "Enebro oxicedro"
      },
      {
        "de": "Gemeiner Wacholder"
      },
      {
        "de": "Stech-Wacholder"
      },
      {
        "fr": "Juniperus communis"
      },
      {
        "fr": "Juniperus oxycedrus"
      },
      {
        "pt": "Cedro-de-espanha"
      },
      {
        "pt": "Juniperus communis"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q1723636",
      "http://www.wikidata.org/entity/Q184300",
      "http://www.wikidata.org/entity/Q26325"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera"
    ],
    "nplots": {
      "ifn2": {
        "count": 1596
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus thurifera"
    },
    "vulgarName": [
      {
        "en": "Spanish juniper"
      },
      {
        "es": "Sabina albar"
      },
      {
        "de": "Spanischer Wacholder"
      },
      {
        "fr": "Juniperus thurifera"
      },
      {
        "pt": "Juniperus thurifera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1510186",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_thurifera",
      "es": "https://es.wikipedia.org/wiki/Juniperus_thurifera"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Juniperus-thurifera-01.jpg/330px-Juniperus-thurifera-01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_thurifera",
    "gbif": "https://www.gbif.org/species/2684528",
    "extract": {
      "en": "Juniperus thurifera, Is a species of juniper native to the mountains of the western Mediterranean region, from southern France across eastern and central Spain to Morocco and locally in northern Algeria.",
      "es": "Juniperus thurifera, la sabina albar, enebra, trabina, tarabina o trabino es una especie de la familia Cupresáceas. Crece en un área disjunta en el Mediterráneo occidental, que abarca la parte más continental de los Alpes franceses e italianos, comarcas interiores del centro y el este de la península ibérica, algunas montañas de Córcega y el norte de África. Además de estas áreas mayores, está presente en localidades aisladas, como en las cabeceras de los ríos Garona y Arieja en la vertiente norte de Pirineos, en la cabecera del valle del río Noguera Pallaresa y sus afluentes al sur, en la comarca de La Litera en la provincia de Huesca y en el límite entre las provincias de León y Asturias. Esta distribución sugiere un carácter relíctico, restos de una distribución más amplia en tiempos geológicos pasados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "nplots": {
      "ifn2": {
        "count": 77
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus phoenicea / Juniperus sabina"
    },
    "vulgarName": [
      {
        "en": "Arâr"
      },
      {
        "en": "Phoenicean juniper"
      },
      {
        "en": "Savin"
      },
      {
        "en": "Savin juniper"
      },
      {
        "es": "Sabina negral"
      },
      {
        "es": "Sabina rastrera"
      },
      {
        "de": "Phönizischer Wacholder"
      },
      {
        "de": "Sadebaum"
      },
      {
        "fr": "Genévrier de Phénicie"
      },
      {
        "fr": "Juniperus sabina"
      },
      {
        "pt": "Juniperus phoenicea"
      },
      {
        "pt": "Juniperus sabina"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q148630",
      "http://www.wikidata.org/entity/Q183497"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 755
      },
      "ifn3": {
        "count": 589
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus cedrus / Juniperus communis / Juniperus oxycedrus"
    },
    "vulgarName": [
      {
        "en": "Cade"
      },
      {
        "en": "Cade juniper"
      },
      {
        "en": "Canary Islands juniper"
      },
      {
        "en": "Common juniper"
      },
      {
        "en": "Prickly cedar"
      },
      {
        "en": "Prickly juniper"
      },
      {
        "en": "Sharp cedar"
      },
      {
        "es": "Enebro canario"
      },
      {
        "es": "Enebro común"
      },
      {
        "es": "Enebro oxicedro"
      },
      {
        "de": "Gemeiner Wacholder"
      },
      {
        "de": "Stech-Wacholder"
      },
      {
        "fr": "Juniperus communis"
      },
      {
        "fr": "Juniperus oxycedrus"
      },
      {
        "pt": "Cedro-de-espanha"
      },
      {
        "pt": "Juniperus communis"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q1723636",
      "http://www.wikidata.org/entity/Q184300",
      "http://www.wikidata.org/entity/Q26325"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 77
      },
      "ifn3": {
        "count": 76
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus phoenicea / Juniperus sabina"
    },
    "vulgarName": [
      {
        "en": "Arâr"
      },
      {
        "en": "Phoenicean juniper"
      },
      {
        "en": "Savin"
      },
      {
        "en": "Savin juniper"
      },
      {
        "es": "Sabina negral"
      },
      {
        "es": "Sabina rastrera"
      },
      {
        "de": "Phönizischer Wacholder"
      },
      {
        "de": "Sadebaum"
      },
      {
        "fr": "Genévrier de Phénicie"
      },
      {
        "fr": "Juniperus sabina"
      },
      {
        "pt": "Juniperus phoenicea"
      },
      {
        "pt": "Juniperus sabina"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q148630",
      "http://www.wikidata.org/entity/Q183497"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 1596
      },
      "ifn3": {
        "count": 1364
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus thurifera"
    },
    "vulgarName": [
      {
        "en": "Spanish juniper"
      },
      {
        "es": "Sabina albar"
      },
      {
        "de": "Spanischer Wacholder"
      },
      {
        "fr": "Juniperus thurifera"
      },
      {
        "pt": "Juniperus thurifera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1510186",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_thurifera",
      "es": "https://es.wikipedia.org/wiki/Juniperus_thurifera"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Juniperus-thurifera-01.jpg/330px-Juniperus-thurifera-01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_thurifera",
    "gbif": "https://www.gbif.org/species/2684528",
    "extract": {
      "en": "Juniperus thurifera, Is a species of juniper native to the mountains of the western Mediterranean region, from southern France across eastern and central Spain to Morocco and locally in northern Algeria.",
      "es": "Juniperus thurifera, la sabina albar, enebra, trabina, tarabina o trabino es una especie de la familia Cupresáceas. Crece en un área disjunta en el Mediterráneo occidental, que abarca la parte más continental de los Alpes franceses e italianos, comarcas interiores del centro y el este de la península ibérica, algunas montañas de Córcega y el norte de África. Además de estas áreas mayores, está presente en localidades aisladas, como en las cabeceras de los ríos Garona y Arieja en la vertiente norte de Pirineos, en la cabecera del valle del río Noguera Pallaresa y sus afluentes al sur, en la comarca de La Litera en la provincia de Huesca y en el límite entre las provincias de León y Asturias. Esta distribución sugiere un carácter relíctico, restos de una distribución más amplia en tiempos geológicos pasados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 589
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species237",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus oxycedrus"
    },
    "vulgarName": [
      {
        "en": "Cade"
      },
      {
        "en": "Cade juniper"
      },
      {
        "en": "Prickly cedar"
      },
      {
        "en": "Prickly juniper"
      },
      {
        "en": "Sharp cedar"
      },
      {
        "es": "Enebro oxicedro"
      },
      {
        "de": "Stech-Wacholder"
      },
      {
        "fr": "Juniperus oxycedrus"
      },
      {
        "pt": "Cedro-de-espanha"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q184300",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_oxycedrus",
      "es": "https://es.wikipedia.org/wiki/Juniperus_oxycedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Cade1.jpg/330px-Cade1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Juniperus_oxycedrus_g1.jpg/330px-Juniperus_oxycedrus_g1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_oxycedrus",
    "gbif": "https://www.gbif.org/species/2684451",
    "extract": {
      "en": "Juniperus oxycedrus, vernacularly called Cade, cade juniper, prickly juniper, prickly cedar, or sharp cedar, is a species of juniper, native across the Mediterranean region, growing on a variety of rocky sites from sea level. The specific epithet oxycedrus means \"sharp cedar\" and this species may have been the original cedar or cedrus of the ancient Greeks.",
      "es": "El enebro rojo, enebro de la miera o cade es una especie del género Juniperus. Otros nombres comunes son oxicedro y cedro de España. Su hábitat es el contorno de la región Mediterránea. Se puede encontrar en la mayor parte de la península ibérica y en las islas Baleares, faltando solo en el noroeste. Su distribución llega hasta Irán."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus turbinata"
    },
    "vulgarName": {
      "es": "Sabina canaria"
    },
    "wikidata": "http://www.wikidata.org/entity/Q3811306",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_turbinata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Juniperus_phoenicea_turbinata.jpg/330px-Juniperus_phoenicea_turbinata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_turbinata",
    "gbif": "https://www.gbif.org/species/2684652",
    "extract": {
      "en": "Juniperus turbinata is a woody plant in the family Cupressaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species239",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus sabina"
    },
    "vulgarName": [
      {
        "en": "Savin"
      },
      {
        "en": "Savin juniper"
      },
      {
        "es": "Sabina rastrera"
      },
      {
        "de": "Sadebaum"
      },
      {
        "fr": "Juniperus sabina"
      },
      {
        "pt": "Juniperus sabina"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q148630",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_sabina",
      "es": "https://es.wikipedia.org/wiki/Juniperus_sabina"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Juniperus_sabina_cult1.jpg/330px-Juniperus_sabina_cult1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Juniperus_sabina_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-212.jpg/330px-Juniperus_sabina_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-212.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_sabina",
    "gbif": "https://www.gbif.org/species/2684419",
    "extract": {
      "en": "Juniperus sabina, the savin juniper or savin, is a species of juniper native to the mountains of central and southern Europe and western and central Asia, from Spain to eastern Siberia, typically growing at elevations of 1,000–3,300 metres.",
      "es": "Juniperus sabina, la sabina rastrera o terrera, es una especie del género Juniperus cuyo hábitat se extiende por Europa central y meridional, oeste de Asia (Turquía) y se cita también en Argelia, extendiéndose por la mitad este de España. En este país se encuentra en la cordillera Cantábrica por el norte, alcanzando Sierra Nevada al sur. Aparece en las provincias de Almería, Asturias, Cantabria, Castellón, Cuenca, Gerona, Granada, Guadalajara, Huesca, Jaén, Lérida, León, Navarra, Palencia, Soria, Teruel, Valencia y Zaragoza."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species337",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus cedrus"
    },
    "vulgarName": [
      {
        "en": "Canary Islands juniper"
      },
      {
        "es": "Enebro canario"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1723636",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_cedrus",
      "es": "https://es.wikipedia.org/wiki/Juniperus_cedrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Juniperus_cedrus_-_Jard%C3%ADn_Bot%C3%A1nico_del_Centro_de_Visitantes_-_El_Paso_-_La_Palma.jpg/330px-Juniperus_cedrus_-_Jard%C3%ADn_Bot%C3%A1nico_del_Centro_de_Visitantes_-_El_Paso_-_La_Palma.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_cedrus",
    "gbif": "https://www.gbif.org/species/2684616",
    "extract": {
      "en": "Juniperus cedrus, the Canary Islands juniper, is a species of juniper, native to the western Canary Islands and Madeira, where it occurs at elevations of 500–2400 m. It is closely related to Juniperus oxycedrus of the Mediterranean region and Juniperus brevifolia of the Azores.",
      "es": "El cedro de Canarias o cedro canario es una especie de enebro, originario de las Islas Canarias y Madeira, donde crece a altitudes de 500 a 2400 metros. Es un pariente cercano del Juniperus oxycedrus de la región mediterránea y de Juniperus brevifolia o cedro de las Azores."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusCedrusJuniperusCommunisJuniperusOxycedrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species37",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus communis"
    },
    "vulgarName": [
      {
        "en": "Common juniper"
      },
      {
        "es": "Enebro común"
      },
      {
        "de": "Gemeiner Wacholder"
      },
      {
        "fr": "Juniperus communis"
      },
      {
        "pt": "Juniperus communis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26325",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_communis",
      "es": "https://es.wikipedia.org/wiki/Juniperus_communis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Jeneverbes.jpg/330px-Jeneverbes.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Den_Italienske_Sti%2C_eneb%C3%A6r.JPG/330px-Den_Italienske_Sti%2C_eneb%C3%A6r.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_communis",
    "gbif": "https://www.gbif.org/species/2684709",
    "extract": {
      "en": "Juniperus communis, the common juniper, is a species of small tree or shrub in the cypress family Cupressaceae. An evergreen conifer, it has the largest geographical range of any woody plant, with a Holarctic distribution throughout the cool temperate Northern Hemisphere.",
      "es": "El enebro común es una especie de planta leñosa de la familia Cupressaceae. Tiene una amplia distribución: se extiende desde las frías regiones del hemisferio norte hasta las zonas montañosas a 30° de latitud N en Norteamérica, Europa y Asia. También puede verse escrito jinebro. Además, produce gálbulos conocidos como enebrinas de aspecto redondo y con un color azul, que varía desde muy intenso (negro) hasta un azul marino oscuro. Los gálbulos crecen en racimo y no son bayas o frutos. Tampoco deben ser confundidos con los arándanos puesto que se trata de vegetales radicalmente distintos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusThurifera"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 1364
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species38",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus thurifera"
    },
    "vulgarName": [
      {
        "en": "Spanish juniper"
      },
      {
        "es": "Sabina albar"
      },
      {
        "de": "Spanischer Wacholder"
      },
      {
        "fr": "Juniperus thurifera"
      },
      {
        "pt": "Juniperus thurifera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1510186",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_thurifera",
      "es": "https://es.wikipedia.org/wiki/Juniperus_thurifera"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Juniperus-thurifera-01.jpg/330px-Juniperus-thurifera-01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_thurifera",
    "gbif": "https://www.gbif.org/species/2684528",
    "extract": {
      "en": "Juniperus thurifera, Is a species of juniper native to the mountains of the western Mediterranean region, from southern France across eastern and central Spain to Morocco and locally in northern Algeria.",
      "es": "Juniperus thurifera, la sabina albar, enebra, trabina, tarabina o trabino es una especie de la familia Cupresáceas. Crece en un área disjunta en el Mediterráneo occidental, que abarca la parte más continental de los Alpes franceses e italianos, comarcas interiores del centro y el este de la península ibérica, algunas montañas de Córcega y el norte de África. Además de estas áreas mayores, está presente en localidades aisladas, como en las cabeceras de los ríos Garona y Arieja en la vertiente norte de Pirineos, en la cabecera del valle del río Noguera Pallaresa y sus afluentes al sur, en la comarca de La Litera en la provincia de Huesca y en el límite entre las provincias de León y Asturias. Esta distribución sugiere un carácter relíctico, restos de una distribución más amplia en tiempos geológicos pasados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusPhoeniceaJuniperusSabina"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 76
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species39",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus phoenicea"
    },
    "vulgarName": [
      {
        "en": "Arâr"
      },
      {
        "en": "Phoenicean juniper"
      },
      {
        "es": "Sabina negral"
      },
      {
        "de": "Phönizischer Wacholder"
      },
      {
        "fr": "Genévrier de Phénicie"
      },
      {
        "pt": "Juniperus phoenicea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q183497",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_phoenicea",
      "es": "https://es.wikipedia.org/wiki/Juniperus_phoenicea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Juniperus_phoenicea1.jpg/330px-Juniperus_phoenicea1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_phoenicea",
    "gbif": "https://www.gbif.org/species/2684640",
    "extract": {
      "en": "Juniperus phoenicea, the Phoenicean juniper or Arâr, is a species of juniper found in the western Mediterranean region.",
      "es": "Juniperus phoenicea es una especie de conífera que habita en el contorno de la región mediterránea, alcanzando hasta las Islas Canarias. Es la sabina más frecuente en la Península, faltando en gran parte de la mitad occidental. No suele ser abundante, apareciendo la mayoría de las veces aislada o en rodales poco extensos. La sabina se considera, según una ley del Gobierno de Canarias, el símbolo natural de la isla de El Hierro, conjuntamente con el lagarto gigante de El Hierro."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 729
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus"
    },
    "vulgarName": [
      {
        "en": "Juniper"
      },
      {
        "es": "Enebros y sabinas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25662",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniper",
      "es": "https://es.wikipedia.org/wiki/Juniperus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Juniperus_osteosperma_1.jpg/330px-Juniperus_osteosperma_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Juniperus_phoenicea1.jpg/330px-Juniperus_phoenicea1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus",
    "gbif": "https://www.gbif.org/species/2684359",
    "extract": {
      "en": "Junipers are coniferous trees and shrubs in the genus Juniperus of the cypress family Cupressaceae. Depending on the taxonomy, between 50 and 67 species of junipers are widely distributed throughout the Northern Hemisphere as far south as tropical Africa, as far north as the Arctic, and parts of Asia and Central America. The highest-known juniper forest occurs at an altitude of 4,900 metres (16,100 ft) in southeastern Tibet and the northern Himalayas, creating one of the highest tree lines on earth.",
      "es": "El género Juniperus, de amplia distribución, comprende las especies llamadas comúnmente enebros o sabinas. Los juníperos son coníferas arbóreas o arbustivas, pertenecientes a la familia Cupressaceae. Dependiendo del punto de vista taxonómico, hay entre 50 y 67 especies, ampliamente distribuidas por todo el hemisferio norte, desde el Ártico hacia el sur hasta el África tropical en el Viejo Mundo, y hasta las montañas de Centroamérica. Las especies se reparten en dos secciones (sectio), los enebros y las sabinas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species937"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 729
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juniperus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus"
    },
    "vulgarName": [
      {
        "en": "Juniper"
      },
      {
        "es": "Enebros y sabinas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q25662",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniper",
      "es": "https://es.wikipedia.org/wiki/Juniperus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Juniperus_osteosperma_1.jpg/330px-Juniperus_osteosperma_1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Juniperus_phoenicea1.jpg/330px-Juniperus_phoenicea1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus",
    "gbif": "https://www.gbif.org/species/2684359",
    "extract": {
      "en": "Junipers are coniferous trees and shrubs in the genus Juniperus of the cypress family Cupressaceae. Depending on the taxonomy, between 50 and 67 species of junipers are widely distributed throughout the Northern Hemisphere as far south as tropical Africa, as far north as the Arctic, and parts of Asia and Central America. The highest-known juniper forest occurs at an altitude of 4,900 metres (16,100 ft) in southeastern Tibet and the northern Himalayas, creating one of the highest tree lines on earth.",
      "es": "El género Juniperus, de amplia distribución, comprende las especies llamadas comúnmente enebros o sabinas. Los juníperos son coníferas arbóreas o arbustivas, pertenecientes a la familia Cupressaceae. Dependiendo del punto de vista taxonómico, hay entre 50 y 67 especies, ampliamente distribuidas por todo el hemisferio norte, desde el Ártico hacia el sur hasta el África tropical en el Viejo Mundo, y hasta las montañas de Centroamérica. Las especies se reparten en dos secciones (sectio), los enebros y las sabinas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species238"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus222",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuniperusTurbinata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juniperus turbinata"
    },
    "vulgarName": {
      "es": "Sabina canaria"
    },
    "wikidata": "http://www.wikidata.org/entity/Q3811306",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juniperus_turbinata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Juniperus_phoenicea_turbinata.jpg/330px-Juniperus_phoenicea_turbinata.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juniperus_turbinata",
    "gbif": "https://www.gbif.org/species/2684652",
    "extract": {
      "en": "Juniperus turbinata is a woody plant in the family Cupressaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 76
      },
      "ifn3": {
        "count": 78
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
    "isGenus": 1,
    "scientificName": {
      "la": "Chamaecyparis"
    },
    "vulgarName": [
      {
        "en": "False cypresses"
      },
      {
        "es": "Falsos cipreses"
      },
      {
        "de": "Scheinzypressen"
      },
      {
        "fr": "Chamaecyparis"
      },
      {
        "pt": "Chamaecyparis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147791",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaecyparis",
      "es": "https://es.wikipedia.org/wiki/Chamaecyparis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/4/48/Sawara.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Chamaecyparis_lawsoniana0.jpg/330px-Chamaecyparis_lawsoniana0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaecyparis",
    "gbif": "https://www.gbif.org/species/2683848",
    "extract": {
      "en": "Chamaecyparis, common names cypress or false cypress, is a genus of conifers in the cypress family Cupressaceae, native to eastern Asia and to the western and eastern margins of the United States. The name is derived from the Greek khamai (χαμαί), meaning \"on the earth\", and kuparissos (κυπάρισσος) for \"cypress\".",
      "es": "Chamaecyparis es un género de plantas de la familia Cupressaceae, originarias del este de Asia y este y oeste de Norteamérica. A los árboles de esta familia se les suele llamar en español \"camecíparis\" o \"falso ciprés\". Entre los sinónimos de este género están Retinispora Siebold & Zucc. y Retinospora Carr."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana"
    ],
    "nplots": {
      "ifn2": {
        "count": 76
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Chamaecyparis lawsoniana"
    },
    "vulgarName": [
      {
        "en": "Lawson cypress"
      },
      {
        "en": "Port Orford cedar"
      },
      {
        "es": "Falso ciprés de Lawson"
      },
      {
        "de": "Lawsons Scheinzypresse"
      },
      {
        "fr": "Cyprès de Lawson"
      },
      {
        "pt": "Chamaecyparis lawsoniana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161360",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaecyparis_lawsoniana",
      "es": "https://es.wikipedia.org/wiki/Chamaecyparis_lawsoniana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Chamaecyparis_lawsoniana_Dorena1.jpg/330px-Chamaecyparis_lawsoniana_Dorena1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg/330px-Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaecyparis_lawsoniana",
    "gbif": "https://www.gbif.org/species/2683866",
    "extract": {
      "en": "Chamaecyparis lawsoniana, known as Port Orford cedar or Lawson's cypress, is a species of conifer in the genus Chamaecyparis, family Cupressaceae. It is native to Oregon and northwestern California, and grows from sea level up to 1,500 metres (4,900 ft) in the valleys of the Klamath Mountains, often along streams.",
      "es": "Chamaecyparis lawsoniana, el falso ciprés de Lawson, camecíparis de Lawson, \"cedro\" de Oregón o \"cedro\" de Puerto Oxford es un ciprés dentro del género Chamaecyparis, familia Cupressaceae, que aunque en el comercio hortícola se le llame \"cedro\" de Oregón o \"cedro\" de Puerto Oxford en su medio nativo, no es realmente un verdadero cedro)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 76
      },
      "ifn3": {
        "count": 78
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Chamaecyparis lawsoniana"
    },
    "vulgarName": [
      {
        "en": "Lawson cypress"
      },
      {
        "en": "Port Orford cedar"
      },
      {
        "es": "Falso ciprés de Lawson"
      },
      {
        "de": "Lawsons Scheinzypresse"
      },
      {
        "fr": "Cyprès de Lawson"
      },
      {
        "pt": "Chamaecyparis lawsoniana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161360",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaecyparis_lawsoniana",
      "es": "https://es.wikipedia.org/wiki/Chamaecyparis_lawsoniana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Chamaecyparis_lawsoniana_Dorena1.jpg/330px-Chamaecyparis_lawsoniana_Dorena1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg/330px-Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaecyparis_lawsoniana",
    "gbif": "https://www.gbif.org/species/2683866",
    "extract": {
      "en": "Chamaecyparis lawsoniana, known as Port Orford cedar or Lawson's cypress, is a species of conifer in the genus Chamaecyparis, family Cupressaceae. It is native to Oregon and northwestern California, and grows from sea level up to 1,500 metres (4,900 ft) in the valleys of the Klamath Mountains, often along streams.",
      "es": "Chamaecyparis lawsoniana, el falso ciprés de Lawson, camecíparis de Lawson, \"cedro\" de Oregón o \"cedro\" de Puerto Oxford es un ciprés dentro del género Chamaecyparis, familia Cupressaceae, que aunque en el comercio hortícola se le llame \"cedro\" de Oregón o \"cedro\" de Puerto Oxford en su medio nativo, no es realmente un verdadero cedro)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus228",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaecyparisLawsoniana"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 78
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species18",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Chamaecyparis lawsoniana"
    },
    "vulgarName": [
      {
        "en": "Lawson cypress"
      },
      {
        "en": "Port Orford cedar"
      },
      {
        "es": "Falso ciprés de Lawson"
      },
      {
        "de": "Lawsons Scheinzypresse"
      },
      {
        "fr": "Cyprès de Lawson"
      },
      {
        "pt": "Chamaecyparis lawsoniana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161360",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaecyparis_lawsoniana",
      "es": "https://es.wikipedia.org/wiki/Chamaecyparis_lawsoniana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Chamaecyparis_lawsoniana_Dorena1.jpg/330px-Chamaecyparis_lawsoniana_Dorena1.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg/330px-Lawsons_Scheinzypresse_auf_Friedhof_Alkersleben.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaecyparis_lawsoniana",
    "gbif": "https://www.gbif.org/species/2683866",
    "extract": {
      "en": "Chamaecyparis lawsoniana, known as Port Orford cedar or Lawson's cypress, is a species of conifer in the genus Chamaecyparis, family Cupressaceae. It is native to Oregon and northwestern California, and grows from sea level up to 1,500 metres (4,900 ft) in the valleys of the Klamath Mountains, often along streams.",
      "es": "Chamaecyparis lawsoniana, el falso ciprés de Lawson, camecíparis de Lawson, \"cedro\" de Oregón o \"cedro\" de Puerto Oxford es un ciprés dentro del género Chamaecyparis, familia Cupressaceae, que aunque en el comercio hortícola se le llame \"cedro\" de Oregón o \"cedro\" de Puerto Oxford en su medio nativo, no es realmente un verdadero cedro)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
    "isGenus": 1,
    "scientificName": {
      "la": "Taxus"
    },
    "vulgarName": [
      {
        "es": "Tejos"
      },
      {
        "en": "Yews"
      },
      {
        "de": "Eiben"
      },
      {
        "fr": "Taxus"
      },
      {
        "pt": "Taxus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27355",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Taxus",
      "es": "https://es.wikipedia.org/wiki/Taxus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Taxus_baccata_MHNT.jpg/330px-Taxus_baccata_MHNT.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Taxus_baccata_MHNT_flowers_male.jpg/330px-Taxus_baccata_MHNT_flowers_male.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Taxus",
    "gbif": "https://www.gbif.org/species/2684902",
    "extract": {
      "en": "Taxus is a genus of coniferous trees or shrubs known as yews in the family Taxaceae. Yews occur around the globe in temperate zones of the northern hemisphere, northernmost in Norway and southernmost in the South Celebes. Some populations exist in tropical highlands.",
      "es": "Los tejos (Taxus) son un género de árboles coníferos de la familia Taxaceae, propios de las zonas montañosas, con ambientes frescos y húmedos, y que prefieren los terrenos calizos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Taxus baccata"
    },
    "vulgarName": [
      {
        "es": "Tejo"
      },
      {
        "en": "Yew"
      },
      {
        "de": "Europäische Eibe"
      },
      {
        "fr": "If commun"
      },
      {
        "pt": "Taxus baccata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q179729",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Taxus_baccata",
      "es": "https://es.wikipedia.org/wiki/Taxus_baccata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Taxus_baccata_MHNT.jpg/330px-Taxus_baccata_MHNT.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Taxus_baccata_tree.jpg/330px-Taxus_baccata_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Taxus_baccata",
    "gbif": "https://www.gbif.org/species/5284517",
    "extract": {
      "en": "Taxus baccata is an Old World species of evergreen tree in the family Taxaceae. It is the tree originally known as yew, though to distinguish it from related species it is sometimes called common yew, European yew, or, in North America, English yew. It is a woodland tree in its native range, including much of Eurasia and Northwest Africa. All parts of the plant except the fleshy aril are poisonous, with toxins that can be absorbed through inhalation, ingestion, and transpiration through the skin.",
      "es": "El tejo común o tejo negro, es una especie del género Taxus originaria de Europa occidental, central y meridional. Es una gimnosperma de la familia de las taxáceas, grupo primitivo ampliamente difundido ya desde el Jurásico y del que actualmente el tejo es el único representante europeo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 17
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Taxus baccata"
    },
    "vulgarName": [
      {
        "es": "Tejo"
      },
      {
        "en": "Yew"
      },
      {
        "de": "Europäische Eibe"
      },
      {
        "fr": "If commun"
      },
      {
        "pt": "Taxus baccata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q179729",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Taxus_baccata",
      "es": "https://es.wikipedia.org/wiki/Taxus_baccata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Taxus_baccata_MHNT.jpg/330px-Taxus_baccata_MHNT.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Taxus_baccata_tree.jpg/330px-Taxus_baccata_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Taxus_baccata",
    "gbif": "https://www.gbif.org/species/5284517",
    "extract": {
      "en": "Taxus baccata is an Old World species of evergreen tree in the family Taxaceae. It is the tree originally known as yew, though to distinguish it from related species it is sometimes called common yew, European yew, or, in North America, English yew. It is a woodland tree in its native range, including much of Eurasia and Northwest Africa. All parts of the plant except the fleshy aril are poisonous, with toxins that can be absorbed through inhalation, ingestion, and transpiration through the skin.",
      "es": "El tejo común o tejo negro, es una especie del género Taxus originaria de Europa occidental, central y meridional. Es una gimnosperma de la familia de las taxáceas, grupo primitivo ampliamente difundido ya desde el Jurásico y del que actualmente el tejo es el único representante europeo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus231",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family23",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TaxusBaccata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species14",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Taxus baccata"
    },
    "vulgarName": [
      {
        "es": "Tejo"
      },
      {
        "en": "Yew"
      },
      {
        "de": "Europäische Eibe"
      },
      {
        "fr": "If commun"
      },
      {
        "pt": "Taxus baccata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q179729",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Taxus_baccata",
      "es": "https://es.wikipedia.org/wiki/Taxus_baccata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Taxus_baccata_MHNT.jpg/330px-Taxus_baccata_MHNT.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Taxus_baccata_tree.jpg/330px-Taxus_baccata_tree.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Taxus_baccata",
    "gbif": "https://www.gbif.org/species/5284517",
    "extract": {
      "en": "Taxus baccata is an Old World species of evergreen tree in the family Taxaceae. It is the tree originally known as yew, though to distinguish it from related species it is sometimes called common yew, European yew, or, in North America, English yew. It is a woodland tree in its native range, including much of Eurasia and Northwest Africa. All parts of the plant except the fleshy aril are poisonous, with toxins that can be absorbed through inhalation, ingestion, and transpiration through the skin.",
      "es": "El tejo común o tejo negro, es una especie del género Taxus originaria de Europa occidental, central y meridional. Es una gimnosperma de la familia de las taxáceas, grupo primitivo ampliamente difundido ya desde el Jurásico y del que actualmente el tejo es el único representante europeo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
    "isGenus": 1,
    "scientificName": {
      "la": "Sambucus"
    },
    "vulgarName": [
      {
        "de": "Holunder"
      },
      {
        "fr": "Sureau"
      },
      {
        "pt": "Sambucus"
      },
      {
        "en": "Elderberries"
      },
      {
        "es": "Saúcos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131448",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sambucus",
      "es": "https://es.wikipedia.org/wiki/Sambucus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Sambucus-berries.jpg/330px-Sambucus-berries.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Sambucus_nigra_2004_c.jpg/330px-Sambucus_nigra_2004_c.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sambucus",
    "gbif": "https://www.gbif.org/species/2888721",
    "extract": {
      "en": "Sambucus is a genus of between 20 and 30 species of flowering plants in the family Adoxaceae. The various species are commonly referred to as elder, with the flowers as elderflower, and the fruit as elderberry.",
      "es": "El saúco (Sambucus) es un género de unas cinco a treinta especies perteneciente a la familia de las adoxáceas, originario de las regiones templadas a subtropicales de ambos hemisferios, aunque más extendido en el hemisferio norte, mientras que en el hemisferio sur queda restringido a Oceanía y América del Sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus nigra / Sambucus racemosa"
    },
    "vulgarName": [
      {
        "en": "Black elder"
      },
      {
        "en": "Elder"
      },
      {
        "en": "Elderberry"
      },
      {
        "en": "European black elderberry"
      },
      {
        "en": "European elder"
      },
      {
        "en": "European elderberry"
      },
      {
        "en": "Red elderberry"
      },
      {
        "en": "Red-berried elder"
      },
      {
        "es": "Saúco negro"
      },
      {
        "es": "Saúco racemosa"
      },
      {
        "de": "Roter Holunder"
      },
      {
        "de": "Schwarzer Holunder"
      },
      {
        "fr": "Sambucus nigra"
      },
      {
        "fr": "Sambucus racemosa"
      },
      {
        "pt": "Sambucus nigra"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q157276",
      "http://www.wikidata.org/entity/Q22701"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 27
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus nigra / Sambucus racemosa"
    },
    "vulgarName": [
      {
        "en": "Black elder"
      },
      {
        "en": "Elder"
      },
      {
        "en": "Elderberry"
      },
      {
        "en": "European black elderberry"
      },
      {
        "en": "European elder"
      },
      {
        "en": "European elderberry"
      },
      {
        "en": "Red elderberry"
      },
      {
        "en": "Red-berried elder"
      },
      {
        "es": "Saúco negro"
      },
      {
        "es": "Saúco racemosa"
      },
      {
        "de": "Roter Holunder"
      },
      {
        "de": "Schwarzer Holunder"
      },
      {
        "fr": "Sambucus nigra"
      },
      {
        "fr": "Sambucus racemosa"
      },
      {
        "pt": "Sambucus nigra"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q157276",
      "http://www.wikidata.org/entity/Q22701"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species297",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus racemosa"
    },
    "vulgarName": [
      {
        "en": "Red elderberry"
      },
      {
        "en": "Red-berried elder"
      },
      {
        "es": "Saúco racemosa"
      },
      {
        "de": "Roter Holunder"
      },
      {
        "fr": "Sambucus racemosa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157276",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sambucus_racemosa",
      "es": "https://es.wikipedia.org/wiki/Sambucus_racemosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Sambucus_racemosa_%281%29.jpg/330px-Sambucus_racemosa_%281%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Sambucus_racemosa_ies.jpg/330px-Sambucus_racemosa_ies.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sambucus_racemosa",
    "gbif": "https://www.gbif.org/species/2888723",
    "extract": {
      "en": "Sambucus racemosa is a species of elder known by the common names red-berried elder and red elderberry. It produces a red drupe.",
      "es": "Sambucus racemosa, el saúco rojo, es una especie de Sambucus originario de Europa, el Asia templada y el norte y el centro de Norteamérica. Crece en los medios ribereños, bosques y otros hábitats, generalmente en zonas húmedas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SambucusNigraSambucusRacemosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species97",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus nigra"
    },
    "vulgarName": [
      {
        "en": "Black elder"
      },
      {
        "en": "Elder"
      },
      {
        "en": "Elderberry"
      },
      {
        "en": "European black elderberry"
      },
      {
        "en": "European elder"
      },
      {
        "en": "European elderberry"
      },
      {
        "es": "Saúco negro"
      },
      {
        "de": "Schwarzer Holunder"
      },
      {
        "fr": "Sambucus nigra"
      },
      {
        "pt": "Sambucus nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q22701",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sambucus_nigra",
      "es": "https://es.wikipedia.org/wiki/Sambucus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Sambucus_nigra_004.jpg/330px-Sambucus_nigra_004.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sambucus_nigra",
    "gbif": "https://www.gbif.org/species/2888728",
    "extract": {
      "en": "Sambucus nigra is a species complex of flowering plants in the family Viburnaceae native to most of Europe. Common names include elder, elderberry, black elder, European elder,  European elderberry, and European black elderberry. It grows in a variety of conditions including both wet and dry fertile soils, primarily in sunny locations. The plant is widely grown as an ornamental shrub or small tree.",
      "es": "El saúco negro, saúco común o, simplemente, saúco es una especie del género Sambucus, perteneciente a la familia Adoxaceae. Se le conoce también, erróneamente, como sahuco."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus"
    },
    "vulgarName": [
      {
        "en": "Elder"
      },
      {
        "en": "Elderberry"
      },
      {
        "es": "Saúco"
      },
      {
        "de": "Holunder"
      },
      {
        "fr": "Sureau"
      },
      {
        "pt": "Sambucus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131448",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sambucus",
      "es": "https://es.wikipedia.org/wiki/Sambucus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Sambucus-berries.jpg/330px-Sambucus-berries.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Sambucus_nigra_2004_c.jpg/330px-Sambucus_nigra_2004_c.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sambucus",
    "gbif": "https://www.gbif.org/species/2888721",
    "extract": {
      "en": "Sambucus is a genus of between 20 and 30 species of flowering plants in the family Adoxaceae. The various species are commonly referred to as elder, with the flowers as elderflower, and the fruit as elderberry.",
      "es": "El saúco (Sambucus) es un género de unas cinco a treinta especies perteneciente a la familia de las adoxáceas, originario de las regiones templadas a subtropicales de ambos hemisferios, aunque más extendido en el hemisferio norte, mientras que en el hemisferio sur queda restringido a Oceanía y América del Sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species997"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus311",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family31",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sambucus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sambucus"
    },
    "vulgarName": [
      {
        "en": "Elder"
      },
      {
        "en": "Elderberry"
      },
      {
        "es": "Saúco"
      },
      {
        "de": "Holunder"
      },
      {
        "fr": "Sureau"
      },
      {
        "pt": "Sambucus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q131448",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sambucus",
      "es": "https://es.wikipedia.org/wiki/Sambucus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Sambucus-berries.jpg/330px-Sambucus-berries.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Sambucus_nigra_2004_c.jpg/330px-Sambucus_nigra_2004_c.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sambucus",
    "gbif": "https://www.gbif.org/species/2888721",
    "extract": {
      "en": "Sambucus is a genus of between 20 and 30 species of flowering plants in the family Adoxaceae. The various species are commonly referred to as elder, with the flowers as elderflower, and the fruit as elderberry.",
      "es": "El saúco (Sambucus) es un género de unas cinco a treinta especies perteneciente a la familia de las adoxáceas, originario de las regiones templadas a subtropicales de ambos hemisferios, aunque más extendido en el hemisferio norte, mientras que en el hemisferio sur queda restringido a Oceanía y América del Sur."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 470
      },
      "ifn3": {
        "count": 431
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
    "isGenus": 1,
    "scientificName": {
      "la": "Ilex"
    },
    "vulgarName": [
      {
        "es": "Acebos"
      },
      {
        "en": "Hollies"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q117085",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Holly",
      "es": "https://es.wikipedia.org/wiki/Ilex"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg/330px-Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Ilex_aquifolium.jpg/330px-Ilex_aquifolium.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex",
    "gbif": "https://www.gbif.org/species/10792217",
    "extract": {
      "en": "Ilex or holly is a genus of over 570 species of flowering plants in the family Aquifoliaceae, and the only living genus in that family. Ilex has the most species of any woody dioecious angiosperm genus. The species are evergreen or deciduous trees, shrubs, and climbers from tropics to temperate zones worldwide. The type species is Ilex aquifolium, the common European holly used in Christmas decorations and cards.",
      "es": "Ilex es un género con unas 400 especies aceptadas, de las más de 1000 descritas, formado por árboles y arbustos comúnmente conocidos como acebos. Es uno de los tres géneros de la familia Aquifoliaceae; los otros dos son Nemopanthus y Prinos (monoespecífico), aunque la APG admite un solo género: Ilex. La mayor diversidad de especies se da en las regiones cercanas a los trópicos, donde también se encuentran las mayores densidades de acebedos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium"
    ],
    "nplots": {
      "ifn2": {
        "count": 357
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex aquifolium"
    },
    "vulgarName": [
      {
        "es": "Acebo"
      },
      {
        "en": "Holly"
      },
      {
        "de": "Europäische Stechpalme"
      },
      {
        "fr": "Houx"
      },
      {
        "pt": "Ilex aquifolium"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q192190",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_aquifolium",
      "es": "https://es.wikipedia.org/wiki/Ilex_aquifolium"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg/330px-Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Ilex_aquifolium_001.JPG/330px-Ilex_aquifolium_001.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_aquifolium",
    "gbif": "https://www.gbif.org/species/5414222",
    "extract": {
      "en": "Ilex aquifolium, the holly, common holly, English holly, European holly, or occasionally Christmas holly, is a species of flowering plant in the family Aquifoliaceae, native to western and southern Europe, northwest Africa, and southwest Asia. It is regarded as the type species of the genus Ilex, which by association is also called holly. It is an evergreen tree or shrub found, for example, in shady areas of forests of oak and in beech hedges. In the British Isles it is one of very few native hardwood evergreen trees. It has a great capacity to adapt to different conditions and is a pioneer species that repopulates the margins of forests or clearcuts.",
      "es": "El acebo es un arbusto o un pequeño árbol de la familia de las Aquifoliáceas, aunque puede llegar a medir unos veinte metros de altura y vivir siglos. Forma parte de la tradición decorativa navideña tras sustituir al muérdago, en la tradición occidental católica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 113
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex canariensis"
    },
    "vulgarName": [
      {
        "en": "Small-leaved holly"
      },
      {
        "es": "Acebiño"
      },
      {
        "fr": "Ilex canariensis"
      },
      {
        "pt": "Ilex canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3315524",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_canariensis",
      "es": "https://es.wikipedia.org/wiki/Ilex_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg/330px-Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Acebi%C3%B1o_Ilex_canariensis.JPG/330px-Acebi%C3%B1o_Ilex_canariensis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_canariensis",
    "gbif": "https://www.gbif.org/species/7315701",
    "extract": {
      "en": "Ilex canariensis, the small-leaved holly, is an endemic species of holly native to Macaronesian islands. It is a species of plant in the family Aquifoliaceae. It is found in the Macaronesian islands of Madeira (Portugal) and Canary Islands (Spain).",
      "es": "Ilex canariensis Poir., conocido en castellano como acebiño, es una especie de arbusto o árbol pequeño perenne perteneciente a la familia Aquifoliaceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 357
      },
      "ifn3": {
        "count": 240
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex aquifolium"
    },
    "vulgarName": [
      {
        "es": "Acebo"
      },
      {
        "en": "Holly"
      },
      {
        "de": "Europäische Stechpalme"
      },
      {
        "fr": "Houx"
      },
      {
        "pt": "Ilex aquifolium"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q192190",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_aquifolium",
      "es": "https://es.wikipedia.org/wiki/Ilex_aquifolium"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg/330px-Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Ilex_aquifolium_001.JPG/330px-Ilex_aquifolium_001.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_aquifolium",
    "gbif": "https://www.gbif.org/species/5414222",
    "extract": {
      "en": "Ilex aquifolium, the holly, common holly, English holly, European holly, or occasionally Christmas holly, is a species of flowering plant in the family Aquifoliaceae, native to western and southern Europe, northwest Africa, and southwest Asia. It is regarded as the type species of the genus Ilex, which by association is also called holly. It is an evergreen tree or shrub found, for example, in shady areas of forests of oak and in beech hedges. In the British Isles it is one of very few native hardwood evergreen trees. It has a great capacity to adapt to different conditions and is a pioneer species that repopulates the margins of forests or clearcuts.",
      "es": "El acebo es un arbusto o un pequeño árbol de la familia de las Aquifoliáceas, aunque puede llegar a medir unos veinte metros de altura y vivir siglos. Forma parte de la tradición decorativa navideña tras sustituir al muérdago, en la tradición occidental católica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 113
      },
      "ifn3": {
        "count": 191
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex canariensis"
    },
    "vulgarName": [
      {
        "en": "Small-leaved holly"
      },
      {
        "es": "Acebiño"
      },
      {
        "fr": "Ilex canariensis"
      },
      {
        "pt": "Ilex canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3315524",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_canariensis",
      "es": "https://es.wikipedia.org/wiki/Ilex_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg/330px-Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Acebi%C3%B1o_Ilex_canariensis.JPG/330px-Acebi%C3%B1o_Ilex_canariensis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_canariensis",
    "gbif": "https://www.gbif.org/species/7315701",
    "extract": {
      "en": "Ilex canariensis, the small-leaved holly, is an endemic species of holly native to Macaronesian islands. It is a species of plant in the family Aquifoliaceae. It is found in the Macaronesian islands of Madeira (Portugal) and Canary Islands (Spain).",
      "es": "Ilex canariensis Poir., conocido en castellano como acebiño, es una especie de arbusto o árbol pequeño perenne perteneciente a la familia Aquifoliaceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex platyphylla"
    },
    "vulgarName": {
      "es": "Naranjero"
    },
    "wikidata": "http://www.wikidata.org/entity/Q38467302"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexAquifolium"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 240
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species65",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex aquifolium"
    },
    "vulgarName": [
      {
        "es": "Acebo"
      },
      {
        "en": "Holly"
      },
      {
        "de": "Europäische Stechpalme"
      },
      {
        "fr": "Houx"
      },
      {
        "pt": "Ilex aquifolium"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q192190",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_aquifolium",
      "es": "https://es.wikipedia.org/wiki/Ilex_aquifolium"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg/330px-Ilex-aquifolium_%28Europaeische_Stechpalme-1%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Ilex_aquifolium_001.JPG/330px-Ilex_aquifolium_001.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_aquifolium",
    "gbif": "https://www.gbif.org/species/5414222",
    "extract": {
      "en": "Ilex aquifolium, the holly, common holly, English holly, European holly, or occasionally Christmas holly, is a species of flowering plant in the family Aquifoliaceae, native to western and southern Europe, northwest Africa, and southwest Asia. It is regarded as the type species of the genus Ilex, which by association is also called holly. It is an evergreen tree or shrub found, for example, in shady areas of forests of oak and in beech hedges. In the British Isles it is one of very few native hardwood evergreen trees. It has a great capacity to adapt to different conditions and is a pioneer species that repopulates the margins of forests or clearcuts.",
      "es": "El acebo es un arbusto o un pequeño árbol de la familia de las Aquifoliáceas, aunque puede llegar a medir unos veinte metros de altura y vivir siglos. Forma parte de la tradición decorativa navideña tras sustituir al muérdago, en la tradición occidental católica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 191
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species82",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex canariensis"
    },
    "vulgarName": [
      {
        "en": "Small-leaved holly"
      },
      {
        "es": "Acebiño"
      },
      {
        "fr": "Ilex canariensis"
      },
      {
        "pt": "Ilex canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3315524",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ilex_canariensis",
      "es": "https://es.wikipedia.org/wiki/Ilex_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg/330px-Ilex_canariensis_en_el_PN_de_Garajonay_%28La_Gomera%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Acebi%C3%B1o_Ilex_canariensis.JPG/330px-Acebi%C3%B1o_Ilex_canariensis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ilex_canariensis",
    "gbif": "https://www.gbif.org/species/7315701",
    "extract": {
      "en": "Ilex canariensis, the small-leaved holly, is an endemic species of holly native to Macaronesian islands. It is a species of plant in the family Aquifoliaceae. It is found in the Macaronesian islands of Madeira (Portugal) and Canary Islands (Spain).",
      "es": "Ilex canariensis Poir., conocido en castellano como acebiño, es una especie de arbusto o árbol pequeño perenne perteneciente a la familia Aquifoliaceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species282"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus321",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family32",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/IlexPlatyphylla",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ilex platyphylla"
    },
    "vulgarName": {
      "es": "Naranjero"
    },
    "wikidata": "http://www.wikidata.org/entity/Q38467302"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 10
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
    "isGenus": 1,
    "scientificName": {
      "la": "Buxus"
    },
    "vulgarName": [
      {
        "es": "Bojs"
      },
      {
        "en": "Boxwoods"
      },
      {
        "de": "Buchsbäume"
      },
      {
        "fr": "Buis"
      },
      {
        "pt": "Buxus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158703",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Buxus",
      "es": "https://es.wikipedia.org/wiki/Buxus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Buxus_sempervirens.jpg/330px-Buxus_sempervirens.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Buxus",
    "gbif": "https://www.gbif.org/species/2984666",
    "extract": {
      "en": "Buxus is a genus of about seventy species in the family Buxaceae. Common names include box and boxwood.",
      "es": "Buxus es un género de plantas de la familia de las buxáceas, conocido vulgarmente como boj. Los bojes son unas 100 especies de arbustos y pequeños árboles de hoja perenne procedentes de Europa, Asia, África, Madagascar y Mesoamérica. La mayoría de las especies son tropicales o subtropicales. La más conocida, Buxus sempervirens, está bien adaptada al fresco clima continental europeo. Los focos de diversidad más importantes son Cuba, con unas 30 especies, China, con 17, y Madagascar, con 9 especies endémicas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "nplots": {
      "ifn2": {
        "count": 10
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Buxus sempervirens / Buxus balearica"
    },
    "vulgarName": [
      {
        "en": "Boxwood"
      },
      {
        "en": "Common box"
      },
      {
        "en": "European box"
      },
      {
        "es": "Boj"
      },
      {
        "es": "Boj de Baleares"
      },
      {
        "de": "Balearen-Buchsbaum"
      },
      {
        "de": "Gewöhnlicher Buchsbaum"
      },
      {
        "fr": "Buis des Baléares"
      },
      {
        "fr": "Buxus sempervirens"
      },
      {
        "pt": "Buxo"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q163278",
      "http://www.wikidata.org/entity/Q27344"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 10
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Buxus sempervirens / Buxus balearica"
    },
    "vulgarName": [
      {
        "en": "Boxwood"
      },
      {
        "en": "Common box"
      },
      {
        "en": "European box"
      },
      {
        "es": "Boj"
      },
      {
        "es": "Boj de Baleares"
      },
      {
        "de": "Balearen-Buchsbaum"
      },
      {
        "de": "Gewöhnlicher Buchsbaum"
      },
      {
        "fr": "Buis des Baléares"
      },
      {
        "fr": "Buxus sempervirens"
      },
      {
        "pt": "Buxo"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q163278",
      "http://www.wikidata.org/entity/Q27344"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species291",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Buxus balearica"
    },
    "vulgarName": [
      {
        "es": "Boj de Baleares"
      },
      {
        "de": "Balearen-Buchsbaum"
      },
      {
        "fr": "Buis des Baléares"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163278",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Buxus_balearica",
      "es": "https://es.wikipedia.org/wiki/Buxus_balearica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Buxus_balearica0427.jpg/330px-Buxus_balearica0427.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Buxus_balearica",
    "gbif": "https://www.gbif.org/species/3988113",
    "extract": {
      "en": "Buxus balearica, the Balearic boxwood, is a shrub or small evergreen tree typical of the Mediterranean forest. It grows wild in Algeria, Morocco, the Island of Sardinia and Spain.",
      "es": "Buxus balearica, o boj balear, es un arbusto o pequeño árbol siempreverde, propio del bosque mediterráneo, donde crece en forma silvestre en Argelia, Marruecos, la isla de Cerdeña y España."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus351",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family35",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/BuxusSempervirensBuxusBalearica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species91",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Buxus sempervirens"
    },
    "vulgarName": [
      {
        "en": "Boxwood"
      },
      {
        "en": "Common box"
      },
      {
        "en": "European box"
      },
      {
        "es": "Boj"
      },
      {
        "de": "Gewöhnlicher Buchsbaum"
      },
      {
        "fr": "Buxus sempervirens"
      },
      {
        "pt": "Buxo"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27344",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Buxus_sempervirens",
      "es": "https://es.wikipedia.org/wiki/Buxus_sempervirens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Buxus_sempervirens.jpg/330px-Buxus_sempervirens.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Buxus_sempervirens",
    "gbif": "https://www.gbif.org/species/2984671",
    "extract": {
      "en": "Buxus sempervirens, the common box, European box, or boxwood, is a species of flowering plant in the genus Buxus, native to western and southern Europe, northwest Africa, and southwest Asia, from southern England south to northern Morocco, and east through the northern Mediterranean region to Turkey. Buxus colchica of western Caucasus and B. hyrcana of northern Iran and eastern Caucasus are commonly treated as synonyms of B. sempervirens.",
      "es": "Buxus sempervirens, el boj común, es un arbusto o pequeño árbol siempreverde, originario de Europa, donde crece en forma silvestre desde las islas británicas hasta la costa del mar Mediterráneo y del mar Caspio. Se utiliza como ornamental en jardinería, y su madera dura y pesada se emplea en ebanistería para tallas delicadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
    "isGenus": 1,
    "scientificName": {
      "la": "Celtis"
    },
    "vulgarName": [
      {
        "es": "Almeces"
      },
      {
        "en": "Hackberries"
      },
      {
        "de": "Zürgelbäume"
      },
      {
        "fr": "Micocoulier"
      },
      {
        "pt": "Celtis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q248582",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Celtis",
      "es": "https://es.wikipedia.org/wiki/Celtis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Celtis_sinensis3.jpg/330px-Celtis_sinensis3.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Celtis-caucasica-fruit.JPG/330px-Celtis-caucasica-fruit.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Celtis",
    "gbif": "https://www.gbif.org/species/2984479",
    "extract": {
      "en": "Celtis is a genus of about 60–70 species of deciduous trees, commonly known as hackberries or nettle trees, in the hemp family Cannabaceae. It has a cosmopolitan distribution.",
      "es": "Celtis, el almez, es un género de cerca de 70 especies aceptadas, de las más de 300 descritas, de árboles caducifolios cosmopolitas de regiones templadas del sur de Europa, sur y este de Asia, sur y centro de Norteamérica, sur de Sudamérica, y sur a centro de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Celtis australis"
    },
    "vulgarName": [
      {
        "es": "Almez"
      },
      {
        "en": "Hackberry"
      },
      {
        "de": "Europäischer Zürgelbaum"
      },
      {
        "fr": "Micocoulier de Provence"
      },
      {
        "pt": "Celtis australis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q255375",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Celtis_australis",
      "es": "https://es.wikipedia.org/wiki/Celtis_australis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Illustration_Celtis_australis0.jpg/330px-Illustration_Celtis_australis0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Celtis_australis1.jpg/330px-Illustration_Celtis_australis1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Celtis_australis",
    "gbif": "https://www.gbif.org/species/2984492",
    "extract": {
      "en": "Celtis australis, the European nettle tree, European hackberry, Mediterranean hackberry, lote tree, southern nettle tree, or honeyberry, is a deciduous tree native to Southern Europe, North Africa, and Asia Minor.",
      "es": "Celtis australis, conocido como lodón, almez, aligonero, ledonero, lodoño, lodón, litón, litonero, quicavero, doroñeto, golonero o latonero es una especie de árbol tradicionalmente incluida en la familia de las ulmáceas (Ulmaceae), aunque en la actualidad se incluye dentro de las cannabáceas, una familia próxima. Lodón proviene del cruce del latín lotus y unĕdo con -ōnis (mirra). Nombre que recibía el loto. Es por ello, que posiblemente se trate del árbol al que los clásicos llamaron Loto."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Celtis australis"
    },
    "vulgarName": [
      {
        "es": "Almez"
      },
      {
        "en": "Hackberry"
      },
      {
        "de": "Europäischer Zürgelbaum"
      },
      {
        "fr": "Micocoulier de Provence"
      },
      {
        "pt": "Celtis australis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q255375",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Celtis_australis",
      "es": "https://es.wikipedia.org/wiki/Celtis_australis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Illustration_Celtis_australis0.jpg/330px-Illustration_Celtis_australis0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Celtis_australis1.jpg/330px-Illustration_Celtis_australis1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Celtis_australis",
    "gbif": "https://www.gbif.org/species/2984492",
    "extract": {
      "en": "Celtis australis, the European nettle tree, European hackberry, Mediterranean hackberry, lote tree, southern nettle tree, or honeyberry, is a deciduous tree native to Southern Europe, North Africa, and Asia Minor.",
      "es": "Celtis australis, conocido como lodón, almez, aligonero, ledonero, lodoño, lodón, litón, litonero, quicavero, doroñeto, golonero o latonero es una especie de árbol tradicionalmente incluida en la familia de las ulmáceas (Ulmaceae), aunque en la actualidad se incluye dentro de las cannabáceas, una familia próxima. Lodón proviene del cruce del latín lotus y unĕdo con -ōnis (mirra). Nombre que recibía el loto. Es por ello, que posiblemente se trate del árbol al que los clásicos llamaron Loto."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus361",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family36",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CeltisAustralis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species13",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Celtis australis"
    },
    "vulgarName": [
      {
        "es": "Almez"
      },
      {
        "en": "Hackberry"
      },
      {
        "de": "Europäischer Zürgelbaum"
      },
      {
        "fr": "Micocoulier de Provence"
      },
      {
        "pt": "Celtis australis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q255375",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Celtis_australis",
      "es": "https://es.wikipedia.org/wiki/Celtis_australis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Illustration_Celtis_australis0.jpg/330px-Illustration_Celtis_australis0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Celtis_australis1.jpg/330px-Illustration_Celtis_australis1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Celtis_australis",
    "gbif": "https://www.gbif.org/species/2984492",
    "extract": {
      "en": "Celtis australis, the European nettle tree, European hackberry, Mediterranean hackberry, lote tree, southern nettle tree, or honeyberry, is a deciduous tree native to Southern Europe, North Africa, and Asia Minor.",
      "es": "Celtis australis, conocido como lodón, almez, aligonero, ledonero, lodoño, lodón, litón, litonero, quicavero, doroñeto, golonero o latonero es una especie de árbol tradicionalmente incluida en la familia de las ulmáceas (Ulmaceae), aunque en la actualidad se incluye dentro de las cannabáceas, una familia próxima. Lodón proviene del cruce del latín lotus y unĕdo con -ōnis (mirra). Nombre que recibía el loto. Es por ello, que posiblemente se trate del árbol al que los clásicos llamaron Loto."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
    "isGenus": 1,
    "scientificName": {
      "la": "Euonymus"
    },
    "vulgarName": [
      {
        "es": "Boneteros"
      },
      {
        "en": "Euonymus"
      },
      {
        "de": "Spindelsträucher"
      },
      {
        "fr": "Euonymus"
      },
      {
        "pt": "Euonymus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161113",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Euonymus",
      "es": "https://es.wikipedia.org/wiki/Euonymus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Euonymus_europaeus.jpg/330px-Euonymus_europaeus.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Euonymus_carnosus_flower_2.jpg/330px-Euonymus_carnosus_flower_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Euonymus",
    "gbif": "https://www.gbif.org/species/3169115",
    "extract": {
      "en": "Euonymus is a genus of flowering plants in the staff vine family Celastraceae. Common names vary widely among different species and between different English-speaking countries, but include spindle, burning-bush, strawberry-bush, wahoo, wintercreeper, or simply euonymus. It has about 140 species of deciduous and evergreen shrubs, small trees and lianas. They are mostly native to East Asia, extending to the Himalayas, and they are also distributed in Europe, Australasia, North America, and Madagascar. Fifty species are endemic to China.",
      "es": "El género de los boneteros, Euonymus comprende arbustos de hoja caduca y perennes y de árboles pequeños. Se distribuyen por Europa, Asia, Australia, Norteamérica y Madagascar. Comprende 445 especies descritas y de estas, solo 142 aceptadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Euonymus europaeus"
    },
    "vulgarName": [
      {
        "en": "Common spindle"
      },
      {
        "en": "European spindle"
      },
      {
        "en": "Spindle"
      },
      {
        "es": "Bonetero"
      },
      {
        "de": "Gewöhnlicher Spindelstrauch"
      },
      {
        "fr": "Fusain d'Europe"
      },
      {
        "pt": "Euonymus europaeus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161379",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Euonymus_europaeus",
      "es": "https://es.wikipedia.org/wiki/Euonymus_europaeus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Euonymus_europaeus_2024_G2.jpg/330px-Euonymus_europaeus_2024_G2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Illustration_Euonymus_europaea0.jpg/330px-Illustration_Euonymus_europaea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Euonymus_europaeus",
    "gbif": "https://www.gbif.org/species/3169131",
    "extract": {
      "en": "Euonymus europaeus, the spindle, European spindle, or common spindle, is a species of flowering plant in the family Celastraceae, native to much of Europe, where it inhabits the edges of forest, hedges and gentle slopes, tending to thrive on nutrient-rich, chalky and salt-poor soils. It is a deciduous shrub or small tree.",
      "es": "Euonymus europaeus, el 'bonetero, bonete de cura, evónimo o husera es un arbusto de hojas caducas o pequeño árbol de la familia Celastraceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Euonymus europaeus"
    },
    "vulgarName": [
      {
        "en": "Common spindle"
      },
      {
        "en": "European spindle"
      },
      {
        "en": "Spindle"
      },
      {
        "es": "Bonetero"
      },
      {
        "de": "Gewöhnlicher Spindelstrauch"
      },
      {
        "fr": "Fusain d'Europe"
      },
      {
        "pt": "Euonymus europaeus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161379",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Euonymus_europaeus",
      "es": "https://es.wikipedia.org/wiki/Euonymus_europaeus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Euonymus_europaeus_2024_G2.jpg/330px-Euonymus_europaeus_2024_G2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Illustration_Euonymus_europaea0.jpg/330px-Illustration_Euonymus_europaea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Euonymus_europaeus",
    "gbif": "https://www.gbif.org/species/3169131",
    "extract": {
      "en": "Euonymus europaeus, the spindle, European spindle, or common spindle, is a species of flowering plant in the family Celastraceae, native to much of Europe, where it inhabits the edges of forest, hedges and gentle slopes, tending to thrive on nutrient-rich, chalky and salt-poor soils. It is a deciduous shrub or small tree.",
      "es": "Euonymus europaeus, el 'bonetero, bonete de cura, evónimo o husera es un arbusto de hojas caducas o pequeño árbol de la familia Celastraceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus371",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family37",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/EuonymusEuropaeus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species5",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Euonymus europaeus"
    },
    "vulgarName": [
      {
        "en": "Common spindle"
      },
      {
        "en": "European spindle"
      },
      {
        "en": "Spindle"
      },
      {
        "es": "Bonetero"
      },
      {
        "de": "Gewöhnlicher Spindelstrauch"
      },
      {
        "fr": "Fusain d'Europe"
      },
      {
        "pt": "Euonymus europaeus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161379",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Euonymus_europaeus",
      "es": "https://es.wikipedia.org/wiki/Euonymus_europaeus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Euonymus_europaeus_2024_G2.jpg/330px-Euonymus_europaeus_2024_G2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Illustration_Euonymus_europaea0.jpg/330px-Illustration_Euonymus_europaea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Euonymus_europaeus",
    "gbif": "https://www.gbif.org/species/3169131",
    "extract": {
      "en": "Euonymus europaeus, the spindle, European spindle, or common spindle, is a species of flowering plant in the family Celastraceae, native to much of Europe, where it inhabits the edges of forest, hedges and gentle slopes, tending to thrive on nutrient-rich, chalky and salt-poor soils. It is a deciduous shrub or small tree.",
      "es": "Euonymus europaeus, el 'bonetero, bonete de cura, evónimo o husera es un arbusto de hojas caducas o pequeño árbol de la familia Celastraceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
    "isGenus": 1,
    "scientificName": {
      "la": "Cornus"
    },
    "vulgarName": [
      {
        "es": "Cornejos"
      },
      {
        "en": "Dogwoods"
      },
      {
        "de": "Hartriegel"
      },
      {
        "fr": "Cornus (plante)"
      },
      {
        "pt": "Cornus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q646451",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cornus,_Aveyron",
      "es": "https://es.wikipedia.org/wiki/Cornus_(Aveyron)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Cornus_tour.JPG/330px-Cornus_tour.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Ch%C3%A2teau_de_Sorgues.jpg/330px-Ch%C3%A2teau_de_Sorgues.jpg"
    ],
    "extract": {
      "en": "Cornus is a commune in the Aveyron department in southern France.",
      "es": " Cornus  es una población y comuna francesa, situada en la región de Mediodía-Pirineos, departamento de Aveyron, en el distrito de Millau y cantón de Cornus."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cornus sanguinea"
    },
    "vulgarName": [
      {
        "en": "Dogwood"
      },
      {
        "es": "Cornejo"
      },
      {
        "de": "Roter Hartriegel"
      },
      {
        "fr": "Cornouiller sanguin"
      },
      {
        "pt": "Cornus sanguinea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161416",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cornus_sanguinea",
      "es": "https://es.wikipedia.org/wiki/Cornus_sanguinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Cornus_sanguinea_Sturm39.jpg/330px-Cornus_sanguinea_Sturm39.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Cornus_sanguinea0.jpg/330px-Cornus_sanguinea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cornus_sanguinea",
    "gbif": "https://www.gbif.org/species/3082234",
    "extract": {
      "en": "Cornus sanguinea, the common dogwood or bloody dogwood, is a species of dogwood native to most of Europe and western Asia, from England and central Scotland east to the Caspian Sea. It is widely grown as an ornamental plant.",
      "es": "Cornus sanguinea, el sanguino o sanguiño, también conocido como cornejo, es una especie perteneciente a la familia de las cornáceas. Es originaria de la mayor parte de Europa y Asia occidental, incluyendo Gran Bretaña y el sur de Escandinavia, llegando por el este hasta el mar Caspio."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cornus sanguinea"
    },
    "vulgarName": [
      {
        "en": "Dogwood"
      },
      {
        "es": "Cornejo"
      },
      {
        "de": "Roter Hartriegel"
      },
      {
        "fr": "Cornouiller sanguin"
      },
      {
        "pt": "Cornus sanguinea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161416",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cornus_sanguinea",
      "es": "https://es.wikipedia.org/wiki/Cornus_sanguinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Cornus_sanguinea_Sturm39.jpg/330px-Cornus_sanguinea_Sturm39.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Cornus_sanguinea0.jpg/330px-Cornus_sanguinea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cornus_sanguinea",
    "gbif": "https://www.gbif.org/species/3082234",
    "extract": {
      "en": "Cornus sanguinea, the common dogwood or bloody dogwood, is a species of dogwood native to most of Europe and western Asia, from England and central Scotland east to the Caspian Sea. It is widely grown as an ornamental plant.",
      "es": "Cornus sanguinea, el sanguino o sanguiño, también conocido como cornejo, es una especie perteneciente a la familia de las cornáceas. Es originaria de la mayor parte de Europa y Asia occidental, incluyendo Gran Bretaña y el sur de Escandinavia, llegando por el este hasta el mar Caspio."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus381",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family38",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CornusSanguinea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species9",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Cornus sanguinea"
    },
    "vulgarName": [
      {
        "en": "Dogwood"
      },
      {
        "es": "Cornejo"
      },
      {
        "de": "Roter Hartriegel"
      },
      {
        "fr": "Cornouiller sanguin"
      },
      {
        "pt": "Cornus sanguinea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161416",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cornus_sanguinea",
      "es": "https://es.wikipedia.org/wiki/Cornus_sanguinea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Cornus_sanguinea_Sturm39.jpg/330px-Cornus_sanguinea_Sturm39.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Cornus_sanguinea0.jpg/330px-Cornus_sanguinea0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Cornus_sanguinea",
    "gbif": "https://www.gbif.org/species/3082234",
    "extract": {
      "en": "Cornus sanguinea, the common dogwood or bloody dogwood, is a species of dogwood native to most of Europe and western Asia, from England and central Scotland east to the Caspian Sea. It is widely grown as an ornamental plant.",
      "es": "Cornus sanguinea, el sanguino o sanguiño, también conocido como cornejo, es una especie perteneciente a la familia de las cornáceas. Es originaria de la mayor parte de Europa y Asia occidental, incluyendo Gran Bretaña y el sur de Escandinavia, llegando por el este hasta el mar Caspio."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 36
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
    "isGenus": 1,
    "scientificName": {
      "la": "Juglans"
    },
    "vulgarName": [
      {
        "de": "Walnüsse"
      },
      {
        "fr": "Noyer"
      },
      {
        "pt": "Juglans"
      },
      {
        "es": "Nogales"
      },
      {
        "en": "Walnuts"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2453469",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans",
      "es": "https://es.wikipedia.org/wiki/Juglans"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Juglans_major_Morton.jpg/330px-Juglans_major_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Juglans_regia_Broadview.jpg/330px-Juglans_regia_Broadview.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans",
    "gbif": "https://www.gbif.org/species/3054350",
    "extract": {
      "en": "Walnut trees are any species of tree in the plant genus Juglans, the type genus of the family Juglandaceae, the seeds of which are referred to as walnuts. All species are deciduous trees, 10–40 metres (33–131 ft) tall, with pinnate leaves 200–900 millimetres (7.9–35.4 in), with 5–25 leaflets; the shoots have chambered pith, a character shared with the wingnuts (Pterocarya), but not the hickories (Carya) in the same family.",
      "es": "Juglans es un género de árboles caducifolios llamados comúnmente nogales, de la familia de las juglandáceas. Lo componen una veintena de especies aceptadas de las 150 descritas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia"
    ],
    "nplots": {
      "ifn2": {
        "count": 36
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans regia"
    },
    "vulgarName": [
      {
        "en": "Carpathian walnut"
      },
      {
        "en": "Common walnut"
      },
      {
        "en": "English walnut"
      },
      {
        "en": "Madeira walnut"
      },
      {
        "en": "Persian walnut"
      },
      {
        "es": "Nogal"
      },
      {
        "de": "Echte Walnuss"
      },
      {
        "fr": "Noyer commun"
      },
      {
        "pt": "Nogueira-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q46871",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans_regia",
      "es": "https://es.wikipedia.org/wiki/Juglans_regia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Noyer_centenaire_en_automne.JPG/330px-Noyer_centenaire_en_automne.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/20110802Walnussbaum_Plankstadt2.jpg/330px-20110802Walnussbaum_Plankstadt2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans_regia",
    "gbif": "https://www.gbif.org/species/3054368",
    "extract": {
      "en": "Juglans regia, known by various common names including the common walnut, English walnut, or Persian walnut amongst other names, is a species of walnut. It is native to Eurasia in at least southwest and central Asia and southeast Europe, but its exact natural area is obscure due to its long history of cultivation.",
      "es": "El nogal común, nogal europeo o nogal español, y, en México, nuez de Castilla, es un árbol monoico y caducifolio de la familia de las Juglandaceae en el orden de las Fagales. Es la especie del género más difundida en Europa, extendiéndose por todo el suroeste y centro de Asia, hasta el Himalaya y sudoeste de China."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 36
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans regia"
    },
    "vulgarName": [
      {
        "en": "Carpathian walnut"
      },
      {
        "en": "Common walnut"
      },
      {
        "en": "English walnut"
      },
      {
        "en": "Madeira walnut"
      },
      {
        "en": "Persian walnut"
      },
      {
        "es": "Nogal"
      },
      {
        "de": "Echte Walnuss"
      },
      {
        "fr": "Noyer commun"
      },
      {
        "pt": "Nogueira-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q46871",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans_regia",
      "es": "https://es.wikipedia.org/wiki/Juglans_regia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Noyer_centenaire_en_automne.JPG/330px-Noyer_centenaire_en_automne.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/20110802Walnussbaum_Plankstadt2.jpg/330px-20110802Walnussbaum_Plankstadt2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans_regia",
    "gbif": "https://www.gbif.org/species/3054368",
    "extract": {
      "en": "Juglans regia, known by various common names including the common walnut, English walnut, or Persian walnut amongst other names, is a species of walnut. It is native to Eurasia in at least southwest and central Asia and southeast Europe, but its exact natural area is obscure due to its long history of cultivation.",
      "es": "El nogal común, nogal europeo o nogal español, y, en México, nuez de Castilla, es un árbol monoico y caducifolio de la familia de las Juglandaceae en el orden de las Fagales. Es la especie del género más difundida en Europa, extendiéndose por todo el suroeste y centro de Asia, hasta el Himalaya y sudoeste de China."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans nigra"
    },
    "vulgarName": [
      {
        "es": "Nogal"
      },
      {
        "en": "Eastern American black walnut"
      },
      {
        "de": "Schwarznuss"
      },
      {
        "fr": "Noyer noir"
      },
      {
        "pt": "Juglans nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q852572",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans_nigra",
      "es": "https://es.wikipedia.org/wiki/Juglans_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Black_Walnut_nut_and_leave_detail.JPG/330px-Black_Walnut_nut_and_leave_detail.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans_nigra",
    "gbif": "https://www.gbif.org/species/3054357",
    "extract": {
      "en": "Juglans nigra, the eastern American black walnut, is a species of deciduous tree in the walnut family, Juglandaceae, native to central and eastern North America, growing mostly in riparian zones.",
      "es": "Juglans nigra, el nogal negro americano, es un árbol juglandáceo, pariente del nogal común. Especie muy extendida en Norteamérica, también se cultiva ampliamente por el sur de Europa, el Sur de Sudamérica y Asia oriental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansRegia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species75",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans regia"
    },
    "vulgarName": [
      {
        "en": "Carpathian walnut"
      },
      {
        "en": "Common walnut"
      },
      {
        "en": "English walnut"
      },
      {
        "en": "Madeira walnut"
      },
      {
        "en": "Persian walnut"
      },
      {
        "es": "Nogal"
      },
      {
        "de": "Echte Walnuss"
      },
      {
        "fr": "Noyer commun"
      },
      {
        "pt": "Nogueira-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q46871",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans_regia",
      "es": "https://es.wikipedia.org/wiki/Juglans_regia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Noyer_centenaire_en_automne.JPG/330px-Noyer_centenaire_en_automne.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/20110802Walnussbaum_Plankstadt2.jpg/330px-20110802Walnussbaum_Plankstadt2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans_regia",
    "gbif": "https://www.gbif.org/species/3054368",
    "extract": {
      "en": "Juglans regia, known by various common names including the common walnut, English walnut, or Persian walnut amongst other names, is a species of walnut. It is native to Eurasia in at least southwest and central Asia and southeast Europe, but its exact natural area is obscure due to its long history of cultivation.",
      "es": "El nogal común, nogal europeo o nogal español, y, en México, nuez de Castilla, es un árbol monoico y caducifolio de la familia de las Juglandaceae en el orden de las Fagales. Es la especie del género más difundida en Europa, extendiéndose por todo el suroeste y centro de Asia, hasta el Himalaya y sudoeste de China."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans"
    },
    "vulgarName": [
      {
        "es": "Nogal"
      },
      {
        "en": "Walnut"
      },
      {
        "de": "Walnüsse"
      },
      {
        "fr": "Noyer"
      },
      {
        "pt": "Juglans"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2453469",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans",
      "es": "https://es.wikipedia.org/wiki/Juglans"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Juglans_major_Morton.jpg/330px-Juglans_major_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Juglans_regia_Broadview.jpg/330px-Juglans_regia_Broadview.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans",
    "gbif": "https://www.gbif.org/species/3054350",
    "extract": {
      "en": "Walnut trees are any species of tree in the plant genus Juglans, the type genus of the family Juglandaceae, the seeds of which are referred to as walnuts. All species are deciduous trees, 10–40 metres (33–131 ft) tall, with pinnate leaves 200–900 millimetres (7.9–35.4 in), with 5–25 leaflets; the shoots have chambered pith, a character shared with the wingnuts (Pterocarya), but not the hickories (Carya) in the same family.",
      "es": "Juglans es un género de árboles caducifolios llamados comúnmente nogales, de la familia de las juglandáceas. Lo componen una veintena de especies aceptadas de las 150 descritas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species975"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Juglans",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans"
    },
    "vulgarName": [
      {
        "es": "Nogal"
      },
      {
        "en": "Walnut"
      },
      {
        "de": "Walnüsse"
      },
      {
        "fr": "Noyer"
      },
      {
        "pt": "Juglans"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2453469",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans",
      "es": "https://es.wikipedia.org/wiki/Juglans"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Juglans_major_Morton.jpg/330px-Juglans_major_Morton.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Juglans_regia_Broadview.jpg/330px-Juglans_regia_Broadview.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans",
    "gbif": "https://www.gbif.org/species/3054350",
    "extract": {
      "en": "Walnut trees are any species of tree in the plant genus Juglans, the type genus of the family Juglandaceae, the seeds of which are referred to as walnuts. All species are deciduous trees, 10–40 metres (33–131 ft) tall, with pinnate leaves 200–900 millimetres (7.9–35.4 in), with 5–25 leaflets; the shoots have chambered pith, a character shared with the wingnuts (Pterocarya), but not the hickories (Carya) in the same family.",
      "es": "Juglans es un género de árboles caducifolios llamados comúnmente nogales, de la familia de las juglandáceas. Lo componen una veintena de especies aceptadas de las 150 descritas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species275"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus391",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family39",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/JuglansNigra",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Juglans nigra"
    },
    "vulgarName": [
      {
        "es": "Nogal"
      },
      {
        "en": "Eastern American black walnut"
      },
      {
        "de": "Schwarznuss"
      },
      {
        "fr": "Noyer noir"
      },
      {
        "pt": "Juglans nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q852572",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Juglans_nigra",
      "es": "https://es.wikipedia.org/wiki/Juglans_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Black_Walnut_nut_and_leave_detail.JPG/330px-Black_Walnut_nut_and_leave_detail.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Juglans_nigra",
    "gbif": "https://www.gbif.org/species/3054357",
    "extract": {
      "en": "Juglans nigra, the eastern American black walnut, is a species of deciduous tree in the walnut family, Juglandaceae, native to central and eastern North America, growing mostly in riparian zones.",
      "es": "Juglans nigra, el nogal negro americano, es un árbol juglandáceo, pariente del nogal común. Especie muy extendida en Norteamérica, también se cultiva ampliamente por el sur de Europa, el Sur de Sudamérica y Asia oriental."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Apollonias barbujana"
    },
    "vulgarName": [
      {
        "en": "Barbusano"
      },
      {
        "en": "Canary laurel"
      },
      {
        "es": "Barbusano"
      },
      {
        "de": "Barbusano"
      },
      {
        "pt": "Apollonias barbujana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q807884",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Apollonias_barbujana",
      "es": "https://es.wikipedia.org/wiki/Apollonias_barbujana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Apollonias_barbujana.jpg/330px-Apollonias_barbujana.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Apollonias_barbujana",
    "gbif": "https://www.gbif.org/species/7304460",
    "extract": {
      "en": "Persea barbujana, the Canary laurel or barbusano, is a species of tree in the laurel family, Lauraceae. It is endemic to the Macaronesian islands of Madeira and the Canary Islands. It is often placed as the sole species in genus Apollonias. Molecular phylogenic analyses found that the species is nested within the genus Persea, which also includes the Macaronesian endemic Persea indica.",
      "es": "Persea barbujana (Cav.) Mabb. & Nieto Fel., conocida en castellano como barbusano, es una especie de árbol perenne perteneciente a la familia Lauraceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Apollonias barbujana"
    },
    "vulgarName": [
      {
        "en": "Barbusano"
      },
      {
        "en": "Canary laurel"
      },
      {
        "es": "Barbusano"
      },
      {
        "de": "Barbusano"
      },
      {
        "pt": "Apollonias barbujana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q807884",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Apollonias_barbujana",
      "es": "https://es.wikipedia.org/wiki/Apollonias_barbujana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Apollonias_barbujana.jpg/330px-Apollonias_barbujana.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Apollonias_barbujana",
    "gbif": "https://www.gbif.org/species/7304460",
    "extract": {
      "en": "Persea barbujana, the Canary laurel or barbusano, is a species of tree in the laurel family, Lauraceae. It is endemic to the Macaronesian islands of Madeira and the Canary Islands. It is often placed as the sole species in genus Apollonias. Molecular phylogenic analyses found that the species is nested within the genus Persea, which also includes the Macaronesian endemic Persea indica.",
      "es": "Persea barbujana (Cav.) Mabb. & Nieto Fel., conocida en castellano como barbusano, es una especie de árbol perenne perteneciente a la familia Lauraceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus401",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ApolloniasBarbujana"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species88",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Apollonias barbujana"
    },
    "vulgarName": [
      {
        "en": "Barbusano"
      },
      {
        "en": "Canary laurel"
      },
      {
        "es": "Barbusano"
      },
      {
        "de": "Barbusano"
      },
      {
        "pt": "Apollonias barbujana"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q807884",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Apollonias_barbujana",
      "es": "https://es.wikipedia.org/wiki/Apollonias_barbujana"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Apollonias_barbujana.jpg/330px-Apollonias_barbujana.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Apollonias_barbujana",
    "gbif": "https://www.gbif.org/species/7304460",
    "extract": {
      "en": "Persea barbujana, the Canary laurel or barbusano, is a species of tree in the laurel family, Lauraceae. It is endemic to the Macaronesian islands of Madeira and the Canary Islands. It is often placed as the sole species in genus Apollonias. Molecular phylogenic analyses found that the species is nested within the genus Persea, which also includes the Macaronesian endemic Persea indica.",
      "es": "Persea barbujana (Cav.) Mabb. & Nieto Fel., conocida en castellano como barbusano, es una especie de árbol perenne perteneciente a la familia Lauraceae. Es originaria de la Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "nplots": {
      "ifn2": {
        "count": 130
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Laurus nobilis / Laurus azorica"
    },
    "vulgarName": [
      {
        "en": "Azores laurel"
      },
      {
        "en": "Bay tree"
      },
      {
        "en": "Macaronesian laurel"
      },
      {
        "es": "Laurel"
      },
      {
        "es": "Laurel canario"
      },
      {
        "de": "Azoren-Lorbeer"
      },
      {
        "de": "Echter Lorbeer"
      },
      {
        "fr": "Laurus azorica"
      },
      {
        "fr": "Laurus nobilis"
      },
      {
        "pt": "Laurus azorica"
      },
      {
        "pt": "Loureiro"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q161931",
      "http://www.wikidata.org/entity/Q26006"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 130
      },
      "ifn3": {
        "count": 190
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Laurus nobilis / Laurus azorica"
    },
    "vulgarName": [
      {
        "en": "Azores laurel"
      },
      {
        "en": "Bay tree"
      },
      {
        "en": "Macaronesian laurel"
      },
      {
        "es": "Laurel"
      },
      {
        "es": "Laurel canario"
      },
      {
        "de": "Azoren-Lorbeer"
      },
      {
        "de": "Echter Lorbeer"
      },
      {
        "fr": "Laurus azorica"
      },
      {
        "fr": "Laurus nobilis"
      },
      {
        "pt": "Laurus azorica"
      },
      {
        "pt": "Loureiro"
      }
    ],
    "wikidata": [
      "http://www.wikidata.org/entity/Q161931",
      "http://www.wikidata.org/entity/Q26006"
    ]
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 190
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species294",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Laurus azorica"
    },
    "vulgarName": [
      {
        "en": "Azores laurel"
      },
      {
        "en": "Macaronesian laurel"
      },
      {
        "es": "Laurel canario"
      },
      {
        "de": "Azoren-Lorbeer"
      },
      {
        "fr": "Laurus azorica"
      },
      {
        "pt": "Laurus azorica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161931",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Laurus_azorica",
      "es": "https://es.wikipedia.org/wiki/Laurus_azorica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Laurus_azorica_%28Flowers%29_2.jpg/330px-Laurus_azorica_%28Flowers%29_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Laurus_azorica_%28Flowers%29.jpg/330px-Laurus_azorica_%28Flowers%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Laurus_azorica",
    "gbif": "https://www.gbif.org/species/7304543",
    "extract": {
      "en": "Laurus azorica, the Azores laurel or Macaronesian laurel, is a small, evergreen tree in the laurel family (Lauraceae), found only on the Azores island group in the North Atlantic.",
      "es": "Laurus azorica, loro o laurel de Azores es una especie de planta en la familia Lauraceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus402",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/LaurusNobilisLaurusAzorica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species94",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Laurus nobilis"
    },
    "vulgarName": [
      {
        "en": "Bay tree"
      },
      {
        "es": "Laurel"
      },
      {
        "de": "Echter Lorbeer"
      },
      {
        "fr": "Laurus nobilis"
      },
      {
        "pt": "Loureiro"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q26006",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Laurus_nobilis",
      "es": "https://es.wikipedia.org/wiki/Laurus_nobilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Starr-071024-0195-Laurus_nobilis-leaves-Enchanting_Floral_Gardens_of_Kula-Maui_%2824867859296%29.jpg/330px-Starr-071024-0195-Laurus_nobilis-leaves-Enchanting_Floral_Gardens_of_Kula-Maui_%2824867859296%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Loureiro%2C_Laurus_nobilis.jpg/330px-Loureiro%2C_Laurus_nobilis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Laurus_nobilis",
    "gbif": "https://www.gbif.org/species/3034015",
    "extract": {
      "en": "Laurus nobilis is an aromatic evergreen tree or large shrub with green, glabrous (smooth) leaves. It is in the flowering plant family Lauraceae. According to Muer, Jahn, & Sauerbier, the stem can be 1 metre in diameter and the tree can be as high as 20 metres. It is native to the Mediterranean region and is used as bay leaf for seasoning in cooking. Its common names include bay tree, bay laurel, sweet bay, true laurel, Grecian laurel, or simply laurel. Laurus nobilis figures prominently in classical Greco-Roman culture.",
      "es": "El laurel es una especie de planta perenne de la familia de las lauráceas originaria de la región del mar Mediterráneo y de la mitad norte de la costa atlántica de la península ibérica. Sus hojas son utilizadas con fines medicinales y en la cocina."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ocotea foetens"
    },
    "vulgarName": [
      {
        "en": "Rain tree of Hierro island"
      },
      {
        "en": "Stinkwood"
      },
      {
        "en": "Til"
      },
      {
        "en": "Tilo"
      },
      {
        "es": "Tilo"
      },
      {
        "de": "Stinkender Lorbeer"
      },
      {
        "fr": "Ocotea foetens"
      },
      {
        "pt": "Ocotea foetens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q510517",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ocotea_foetens",
      "es": "https://es.wikipedia.org/wiki/Ocotea_foetens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Ocotea_foetens.JPG/330px-Ocotea_foetens.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ocotea_foetens_1322.jpg/330px-Ocotea_foetens_1322.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ocotea_foetens",
    "gbif": "https://www.gbif.org/species/4180201",
    "extract": {
      "en": "Ocotea foetens, commonly called til or stinkwood is a species of tree in the family Lauraceae. It is evergreen and grows up to 40 m tall. It is a common constituent of the laurisilva forests of Madeira and the Canary Islands. Leaf fossils of this species are known from the Mio-Pleistocene of Madeira Island.",
      "es": "Ocotea foetens (Aiton) Baill., conocida en castellano como til o tilo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ocotea foetens"
    },
    "vulgarName": [
      {
        "en": "Rain tree of Hierro island"
      },
      {
        "en": "Stinkwood"
      },
      {
        "en": "Til"
      },
      {
        "en": "Tilo"
      },
      {
        "es": "Tilo"
      },
      {
        "de": "Stinkender Lorbeer"
      },
      {
        "fr": "Ocotea foetens"
      },
      {
        "pt": "Ocotea foetens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q510517",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ocotea_foetens",
      "es": "https://es.wikipedia.org/wiki/Ocotea_foetens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Ocotea_foetens.JPG/330px-Ocotea_foetens.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ocotea_foetens_1322.jpg/330px-Ocotea_foetens_1322.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ocotea_foetens",
    "gbif": "https://www.gbif.org/species/4180201",
    "extract": {
      "en": "Ocotea foetens, commonly called til or stinkwood is a species of tree in the family Lauraceae. It is evergreen and grows up to 40 m tall. It is a common constituent of the laurisilva forests of Madeira and the Canary Islands. Leaf fossils of this species are known from the Mio-Pleistocene of Madeira Island.",
      "es": "Ocotea foetens (Aiton) Baill., conocida en castellano como til o tilo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus403",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OcoteaFoetens"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species87",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ocotea foetens"
    },
    "vulgarName": [
      {
        "en": "Rain tree of Hierro island"
      },
      {
        "en": "Stinkwood"
      },
      {
        "en": "Til"
      },
      {
        "en": "Tilo"
      },
      {
        "es": "Tilo"
      },
      {
        "de": "Stinkender Lorbeer"
      },
      {
        "fr": "Ocotea foetens"
      },
      {
        "pt": "Ocotea foetens"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q510517",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ocotea_foetens",
      "es": "https://es.wikipedia.org/wiki/Ocotea_foetens"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Ocotea_foetens.JPG/330px-Ocotea_foetens.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Ocotea_foetens_1322.jpg/330px-Ocotea_foetens_1322.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ocotea_foetens",
    "gbif": "https://www.gbif.org/species/4180201",
    "extract": {
      "en": "Ocotea foetens, commonly called til or stinkwood is a species of tree in the family Lauraceae. It is evergreen and grows up to 40 m tall. It is a common constituent of the laurisilva forests of Madeira and the Canary Islands. Leaf fossils of this species are known from the Mio-Pleistocene of Madeira Island.",
      "es": "Ocotea foetens (Aiton) Baill., conocida en castellano como til o tilo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica"
    ],
    "nplots": {
      "ifn2": {
        "count": 43
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Persea indica"
    },
    "vulgarName": [
      {
        "es": "Viñátigo"
      },
      {
        "de": "Indische Persea"
      },
      {
        "fr": "Persea indica"
      },
      {
        "pt": "Persea indica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q654852",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Persea_indica",
      "es": "https://es.wikipedia.org/wiki/Persea_indica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Persea_indica.jpg/330px-Persea_indica.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Vi%C3%B1%C3%A1tigo_hojas.JPG/330px-Vi%C3%B1%C3%A1tigo_hojas.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Persea_indica",
    "gbif": "https://www.gbif.org/species/4181596",
    "extract": {
      "en": "Persea indica is a large, evergreen tree in the laurel family (Lauraceae), native to humid uplands on Madeira and the Canary Islands in the North Atlantic. It belongs to the genus Persea, a group of evergreen trees including the avocado. It is threatened by habitat loss.",
      "es": "Persea indica (L.) Spreng., conocida en castellano como viñátigo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 43
      },
      "ifn3": {
        "count": 59
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Persea indica"
    },
    "vulgarName": [
      {
        "es": "Viñátigo"
      },
      {
        "de": "Indische Persea"
      },
      {
        "fr": "Persea indica"
      },
      {
        "pt": "Persea indica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q654852",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Persea_indica",
      "es": "https://es.wikipedia.org/wiki/Persea_indica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Persea_indica.jpg/330px-Persea_indica.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Vi%C3%B1%C3%A1tigo_hojas.JPG/330px-Vi%C3%B1%C3%A1tigo_hojas.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Persea_indica",
    "gbif": "https://www.gbif.org/species/4181596",
    "extract": {
      "en": "Persea indica is a large, evergreen tree in the laurel family (Lauraceae), native to humid uplands on Madeira and the Canary Islands in the North Atlantic. It belongs to the genus Persea, a group of evergreen trees including the avocado. It is threatened by habitat loss.",
      "es": "Persea indica (L.) Spreng., conocida en castellano como viñátigo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus404",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family40",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PerseaIndica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 59
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species84",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Persea indica"
    },
    "vulgarName": [
      {
        "es": "Viñátigo"
      },
      {
        "de": "Indische Persea"
      },
      {
        "fr": "Persea indica"
      },
      {
        "pt": "Persea indica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q654852",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Persea_indica",
      "es": "https://es.wikipedia.org/wiki/Persea_indica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Persea_indica.jpg/330px-Persea_indica.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Vi%C3%B1%C3%A1tigo_hojas.JPG/330px-Vi%C3%B1%C3%A1tigo_hojas.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Persea_indica",
    "gbif": "https://www.gbif.org/species/4181596",
    "extract": {
      "en": "Persea indica is a large, evergreen tree in the laurel family (Lauraceae), native to humid uplands on Madeira and the Canary Islands in the North Atlantic. It belongs to the genus Persea, a group of evergreen trees including the avocado. It is threatened by habitat loss.",
      "es": "Persea indica (L.) Spreng., conocida en castellano como viñátigo, es una especie de árbol perenne de la familia de las Lauraceae. Es originaria de Macaronesia, siendo uno de los componentes del bosque de laurisilva atlántica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 81
      },
      "ifn3": {
        "count": 33
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
    "isGenus": 1,
    "scientificName": {
      "la": "Tilia"
    },
    "vulgarName": [
      {
        "de": "Linden (Gattung)"
      },
      {
        "fr": "Tilia"
      },
      {
        "pt": "Tilia"
      },
      {
        "en": "Lime trees"
      },
      {
        "es": "Tilos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q127849",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia",
      "es": "https://es.wikipedia.org/wiki/Tilia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Kristinas_lind_2013.jpg/330px-Kristinas_lind_2013.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg/330px-Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia",
    "gbif": "https://www.gbif.org/species/3152041",
    "extract": {
      "en": "Tilia is a genus of about 30 species of trees or bushes, native throughout most of the temperate Northern Hemisphere. The species are known as linden or lime for the European and Asian species, and linden or basswood for North American species and more generally in American literature. The greatest species diversity is found in Asia, but the genus also occurs widely in Europe and eastern North America. Under the Cronquist classification system, this genus was placed in the family Tiliaceae, but genetic research summarised by the Angiosperm Phylogeny Group has resulted in the incorporation of this genus, and of most of the previous family, into the Malvaceae.",
      "es": "Los tilos (Tilia) son un género de árboles de la familia de las malváceas, nativos de las regiones templadas del hemisferio norte. Comprende una treintena de especies, que se distribuyen a lo ancho de Asia, Europa y el oriente de Norteamérica; se cultivan con alguna frecuencia en el hemisferio sur como ornamentales. Existen además numerosos híbridos espontáneos y artificiales, un factor que dificulta la elaboración de una taxonomía precisa para la especie."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia"
    ],
    "nplots": {
      "ifn2": {
        "count": 81
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia"
    },
    "vulgarName": [
      {
        "en": "Lime tree"
      },
      {
        "es": "Til"
      },
      {
        "de": "Linden (Gattung)"
      },
      {
        "fr": "Tilia"
      },
      {
        "pt": "Tilia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q127849",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia",
      "es": "https://es.wikipedia.org/wiki/Tilia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Kristinas_lind_2013.jpg/330px-Kristinas_lind_2013.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg/330px-Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia",
    "gbif": "https://www.gbif.org/species/3152041",
    "extract": {
      "en": "Tilia is a genus of about 30 species of trees or bushes, native throughout most of the temperate Northern Hemisphere. The species are known as linden or lime for the European and Asian species, and linden or basswood for North American species and more generally in American literature. The greatest species diversity is found in Asia, but the genus also occurs widely in Europe and eastern North America. Under the Cronquist classification system, this genus was placed in the family Tiliaceae, but genetic research summarised by the Angiosperm Phylogeny Group has resulted in the incorporation of this genus, and of most of the previous family, into the Malvaceae.",
      "es": "Los tilos (Tilia) son un género de árboles de la familia de las malváceas, nativos de las regiones templadas del hemisferio norte. Comprende una treintena de especies, que se distribuyen a lo ancho de Asia, Europa y el oriente de Norteamérica; se cultivan con alguna frecuencia en el hemisferio sur como ornamentales. Existen además numerosos híbridos espontáneos y artificiales, un factor que dificulta la elaboración de una taxonomía precisa para la especie."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 81
      },
      "ifn3": {
        "count": 33
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia"
    },
    "vulgarName": [
      {
        "en": "Lime tree"
      },
      {
        "es": "Til"
      },
      {
        "de": "Linden (Gattung)"
      },
      {
        "fr": "Tilia"
      },
      {
        "pt": "Tilia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q127849",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia",
      "es": "https://es.wikipedia.org/wiki/Tilia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Kristinas_lind_2013.jpg/330px-Kristinas_lind_2013.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg/330px-Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia",
    "gbif": "https://www.gbif.org/species/3152041",
    "extract": {
      "en": "Tilia is a genus of about 30 species of trees or bushes, native throughout most of the temperate Northern Hemisphere. The species are known as linden or lime for the European and Asian species, and linden or basswood for North American species and more generally in American literature. The greatest species diversity is found in Asia, but the genus also occurs widely in Europe and eastern North America. Under the Cronquist classification system, this genus was placed in the family Tiliaceae, but genetic research summarised by the Angiosperm Phylogeny Group has resulted in the incorporation of this genus, and of most of the previous family, into the Malvaceae.",
      "es": "Los tilos (Tilia) son un género de árboles de la familia de las malváceas, nativos de las regiones templadas del hemisferio norte. Comprende una treintena de especies, que se distribuyen a lo ancho de Asia, Europa y el oriente de Norteamérica; se cultivan con alguna frecuencia en el hemisferio sur como ornamentales. Existen además numerosos híbridos espontáneos y artificiales, un factor que dificulta la elaboración de una taxonomía precisa para la especie."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia cordata"
    },
    "vulgarName": [
      {
        "en": "Little leaf linden"
      },
      {
        "en": "Small-leaved lime"
      },
      {
        "en": "Small-leaved linden"
      },
      {
        "es": "Tilo norteño"
      },
      {
        "de": "Winterlinde"
      },
      {
        "fr": "Tilleul à petites feuilles"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158746",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia_cordata",
      "es": "https://es.wikipedia.org/wiki/Tilia_cordata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Tilia-cordata2.JPG/330px-Tilia-cordata2.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/3._Tilia_cordata_-_29_de_abril_de_2025.jpg/330px-3._Tilia_cordata_-_29_de_abril_de_2025.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia_cordata",
    "gbif": "https://www.gbif.org/species/3152047",
    "extract": {
      "en": "Tilia cordata, the small-leaved lime or small-leaved linden, is a species of tree in the family Malvaceae, native to much of Europe. Its other common names include little-leaf or littleleaf linden, or traditionally in South East England, pry or pry tree. Its range extends from Britain through mainland Europe to the Caucasus and western Asia. In the south of its range it is restricted to high elevations.",
      "es": "Tilia cordata, conocida popularmente como tilo norteño, tilo silvestre o tilo de hoja pequeña, es una especie arbórea originaria de Europa perteneciente a la familia de las Malvaceae, que vive desde España hasta los Montes Urales y las montañas de Líbano, Siria y Turquía."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia platyphyllos"
    },
    "vulgarName": [
      {
        "en": "Largeleaf linden"
      },
      {
        "es": "Tilo común"
      },
      {
        "de": "Sommerlinde"
      },
      {
        "fr": "Tilleul à grandes feuilles"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156831",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia_platyphyllos",
      "es": "https://es.wikipedia.org/wiki/Tilia_platyphyllos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/L%C3%ADpa_u_Horn%C3%ADho_Z%C3%A1blat%C3%AD_v_roce_2011_%281%29.JPG/330px-L%C3%ADpa_u_Horn%C3%ADho_Z%C3%A1blat%C3%AD_v_roce_2011_%281%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_platyphyllos%2801%29.jpg/330px-Tilia_platyphyllos%2801%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia_platyphyllos",
    "gbif": "https://www.gbif.org/species/3152048",
    "extract": {
      "en": "Tilia platyphyllos, the large-leaved lime, broad-leaved lime, or large-leaved linden, is a species of flowering plant in the family Malvaceae (Tiliaceae). It is a deciduous tree, native to much of continental Europe including southwestern Great Britain, typically growing on limestone-derived soils. It is not native in Scotland or Ireland, but is naturalised there. The name \"lime\", possibly a corruption of \"line\" originally from \"lind\", has been in use for centuries and also attaches to other species of Tilia. It is not, however, closely related to the lime fruit tree, a species of citrus. The specific epithet platyphyllos means \"with broad leaves\" in Greek.",
      "es": "Tilia platyphyllos, tilo de hoja ancha, tilo común o tilo de hoja grande, es una especie arbórea perteneciente a la familia de las Malvaceae, muy habitual en los bosques de Europa. Se distingue fácilmente del tilo de hoja estrecha o silvestre, Tilia cordata."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tilia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 33
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species77",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia"
    },
    "vulgarName": [
      {
        "en": "Lime tree"
      },
      {
        "es": "Til"
      },
      {
        "de": "Linden (Gattung)"
      },
      {
        "fr": "Tilia"
      },
      {
        "pt": "Tilia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q127849",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia",
      "es": "https://es.wikipedia.org/wiki/Tilia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Kristinas_lind_2013.jpg/330px-Kristinas_lind_2013.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg/330px-Tilia_cordata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-139.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia",
    "gbif": "https://www.gbif.org/species/3152041",
    "extract": {
      "en": "Tilia is a genus of about 30 species of trees or bushes, native throughout most of the temperate Northern Hemisphere. The species are known as linden or lime for the European and Asian species, and linden or basswood for North American species and more generally in American literature. The greatest species diversity is found in Asia, but the genus also occurs widely in Europe and eastern North America. Under the Cronquist classification system, this genus was placed in the family Tiliaceae, but genetic research summarised by the Angiosperm Phylogeny Group has resulted in the incorporation of this genus, and of most of the previous family, into the Malvaceae.",
      "es": "Los tilos (Tilia) son un género de árboles de la familia de las malváceas, nativos de las regiones templadas del hemisferio norte. Comprende una treintena de especies, que se distribuyen a lo ancho de Asia, Europa y el oriente de Norteamérica; se cultivan con alguna frecuencia en el hemisferio sur como ornamentales. Existen además numerosos híbridos espontáneos y artificiales, un factor que dificulta la elaboración de una taxonomía precisa para la especie."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species277"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaCordata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia cordata"
    },
    "vulgarName": [
      {
        "en": "Little leaf linden"
      },
      {
        "en": "Small-leaved lime"
      },
      {
        "en": "Small-leaved linden"
      },
      {
        "es": "Tilo norteño"
      },
      {
        "de": "Winterlinde"
      },
      {
        "fr": "Tilleul à petites feuilles"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158746",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia_cordata",
      "es": "https://es.wikipedia.org/wiki/Tilia_cordata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Tilia-cordata2.JPG/330px-Tilia-cordata2.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/3._Tilia_cordata_-_29_de_abril_de_2025.jpg/330px-3._Tilia_cordata_-_29_de_abril_de_2025.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia_cordata",
    "gbif": "https://www.gbif.org/species/3152047",
    "extract": {
      "en": "Tilia cordata, the small-leaved lime or small-leaved linden, is a species of tree in the family Malvaceae, native to much of Europe. Its other common names include little-leaf or littleleaf linden, or traditionally in South East England, pry or pry tree. Its range extends from Britain through mainland Europe to the Caucasus and western Asia. In the south of its range it is restricted to high elevations.",
      "es": "Tilia cordata, conocida popularmente como tilo norteño, tilo silvestre o tilo de hoja pequeña, es una especie arbórea originaria de Europa perteneciente a la familia de las Malvaceae, que vive desde España hasta los Montes Urales y las montañas de Líbano, Siria y Turquía."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species377"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus411",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family41",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TiliaPlatyphyllos",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tilia platyphyllos"
    },
    "vulgarName": [
      {
        "en": "Largeleaf linden"
      },
      {
        "es": "Tilo común"
      },
      {
        "de": "Sommerlinde"
      },
      {
        "fr": "Tilleul à grandes feuilles"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156831",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tilia_platyphyllos",
      "es": "https://es.wikipedia.org/wiki/Tilia_platyphyllos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/L%C3%ADpa_u_Horn%C3%ADho_Z%C3%A1blat%C3%AD_v_roce_2011_%281%29.JPG/330px-L%C3%ADpa_u_Horn%C3%ADho_Z%C3%A1blat%C3%AD_v_roce_2011_%281%29.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tilia_platyphyllos%2801%29.jpg/330px-Tilia_platyphyllos%2801%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tilia_platyphyllos",
    "gbif": "https://www.gbif.org/species/3152048",
    "extract": {
      "en": "Tilia platyphyllos, the large-leaved lime, broad-leaved lime, or large-leaved linden, is a species of flowering plant in the family Malvaceae (Tiliaceae). It is a deciduous tree, native to much of continental Europe including southwestern Great Britain, typically growing on limestone-derived soils. It is not native in Scotland or Ireland, but is naturalised there. The name \"lime\", possibly a corruption of \"line\" originally from \"lind\", has been in use for centuries and also attaches to other species of Tilia. It is not, however, closely related to the lime fruit tree, a species of citrus. The specific epithet platyphyllos means \"with broad leaves\" in Greek.",
      "es": "Tilia platyphyllos, tilo de hoja ancha, tilo común o tilo de hoja grande, es una especie arbórea perteneciente a la familia de las Malvaceae, muy habitual en los bosques de Europa. Se distingue fácilmente del tilo de hoja estrecha o silvestre, Tilia cordata."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 202
      },
      "ifn3": {
        "count": 308
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
    "isGenus": 1,
    "scientificName": {
      "la": "Myrica"
    },
    "vulgarName": [
      {
        "es": "Arrayanes"
      },
      {
        "en": "Bayberries"
      },
      {
        "de": "Myrica"
      },
      {
        "fr": "Myrica"
      },
      {
        "pt": "Myrica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q133287",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrica",
      "es": "https://es.wikipedia.org/wiki/Myrica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Gagelstrauch%28Myrica_gale%29female.JPG/330px-Gagelstrauch%28Myrica_gale%29female.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/d/d6/Myrica_faya.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrica",
    "gbif": "https://www.gbif.org/species/5938218",
    "extract": {
      "en": "Myrica is a genus of about 35–50 species of small trees and shrubs in the family Myricaceae, order Fagales. The genus has a wide distribution, including Africa, Asia, Europe, North America, and South America, and missing only from Antarctica and Oceania. Some botanists split the genus into two genera on the basis of the catkin and fruit structure, restricting Myrica to a few species, and treating the others in Morella.",
      "es": "Myrica es un género con 35-50 especies de árboles pequeños y arbustos perteneciente a la familia de las miricáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya"
    ],
    "nplots": {
      "ifn2": {
        "count": 202
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrica faya"
    },
    "vulgarName": [
      {
        "en": "Faya"
      },
      {
        "en": "Firetree"
      },
      {
        "en": "Haya"
      },
      {
        "es": "Faya"
      },
      {
        "de": "Gagelbaum"
      },
      {
        "pt": "Myrica faya"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1491096",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrica_faya",
      "es": "https://es.wikipedia.org/wiki/Morella_faya"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/d/d6/Myrica_faya.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrica_faya",
    "gbif": "https://www.gbif.org/species/5414211",
    "extract": {
      "en": "Myrica faya is a species of Myrica, native to Macaronesia, and possibly also western coastal mainland Portugal.",
      "es": "Morella faya (Aiton) Wilbur, conocida en castellano como faya o haya canaria, es una especie de árbol perenne perteneciente a la familia de las miricáceas. Es originario de la Macaronesia, estando además introducida y asilvestrada en Portugal, Nueva Zelanda, Australia y Estados Unidos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 202
      },
      "ifn3": {
        "count": 308
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrica faya"
    },
    "vulgarName": [
      {
        "en": "Faya"
      },
      {
        "en": "Firetree"
      },
      {
        "en": "Haya"
      },
      {
        "es": "Faya"
      },
      {
        "de": "Gagelbaum"
      },
      {
        "pt": "Myrica faya"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1491096",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrica_faya",
      "es": "https://es.wikipedia.org/wiki/Morella_faya"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/d/d6/Myrica_faya.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrica_faya",
    "gbif": "https://www.gbif.org/species/5414211",
    "extract": {
      "en": "Myrica faya is a species of Myrica, native to Macaronesia, and possibly also western coastal mainland Portugal.",
      "es": "Morella faya (Aiton) Wilbur, conocida en castellano como faya o haya canaria, es una especie de árbol perenne perteneciente a la familia de las miricáceas. Es originario de la Macaronesia, estando además introducida y asilvestrada en Portugal, Nueva Zelanda, Australia y Estados Unidos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus431",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family43",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MyricaFaya"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 308
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species81",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Myrica faya"
    },
    "vulgarName": [
      {
        "en": "Faya"
      },
      {
        "en": "Firetree"
      },
      {
        "en": "Haya"
      },
      {
        "es": "Faya"
      },
      {
        "de": "Gagelbaum"
      },
      {
        "pt": "Myrica faya"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1491096",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Myrica_faya",
      "es": "https://es.wikipedia.org/wiki/Morella_faya"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/d/d6/Myrica_faya.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Myrica_faya",
    "gbif": "https://www.gbif.org/species/5414211",
    "extract": {
      "en": "Myrica faya is a species of Myrica, native to Macaronesia, and possibly also western coastal mainland Portugal.",
      "es": "Morella faya (Aiton) Wilbur, conocida en castellano como faya o haya canaria, es una especie de árbol perenne perteneciente a la familia de las miricáceas. Es originario de la Macaronesia, estando además introducida y asilvestrada en Portugal, Nueva Zelanda, Australia y Estados Unidos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 637
      },
      "ifn3": {
        "count": 692
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
    "isGenus": 1,
    "scientificName": {
      "la": "Fraxinus"
    },
    "vulgarName": [
      {
        "de": "Eschen (Pflanzengattung)"
      },
      {
        "fr": "Frêne"
      },
      {
        "pt": "Fraxinus"
      },
      {
        "en": "Ash trees"
      },
      {
        "es": "Fresnos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128887",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg/330px-Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/K%C3%B6hler_Fraxinus_ornus.jpg/330px-K%C3%B6hler_Fraxinus_ornus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus",
    "gbif": "https://www.gbif.org/species/3172323",
    "extract": {
      "en": "Fraxinus, commonly called ash, is a genus of plants in the olive and lilac family, Oleaceae, and comprises 45–65 species of usually medium-to-large trees, most of which are deciduous, although some subtropical species are evergreen. The genus is widespread throughout much of Europe, Asia, and North America.",
      "es": "Fraxinus es un género de la familia de las oleáceas, cuyos miembros son conocidos generalmente como fresnos. Contiene 45-65 especies de árboles de porte mediano a grande, de hoja caduca en general, aunque unas pocas especies subtropicales son perennifolias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 637
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus"
    },
    "vulgarName": [
      {
        "en": "Ash"
      },
      {
        "es": "Fresno"
      },
      {
        "de": "Eschen (Pflanzengattung)"
      },
      {
        "fr": "Frêne"
      },
      {
        "pt": "Fraxinus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128887",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg/330px-Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/K%C3%B6hler_Fraxinus_ornus.jpg/330px-K%C3%B6hler_Fraxinus_ornus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus",
    "gbif": "https://www.gbif.org/species/3172323",
    "extract": {
      "en": "Fraxinus, commonly called ash, is a genus of plants in the olive and lilac family, Oleaceae, and comprises 45–65 species of usually medium-to-large trees, most of which are deciduous, although some subtropical species are evergreen. The genus is widespread throughout much of Europe, Asia, and North America.",
      "es": "Fraxinus es un género de la familia de las oleáceas, cuyos miembros son conocidos generalmente como fresnos. Contiene 45-65 especies de árboles de porte mediano a grande, de hoja caduca en general, aunque unas pocas especies subtropicales son perennifolias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 637
      },
      "ifn3": {
        "count": 389
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus"
    },
    "vulgarName": [
      {
        "en": "Ash"
      },
      {
        "es": "Fresno"
      },
      {
        "de": "Eschen (Pflanzengattung)"
      },
      {
        "fr": "Frêne"
      },
      {
        "pt": "Fraxinus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128887",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg/330px-Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/K%C3%B6hler_Fraxinus_ornus.jpg/330px-K%C3%B6hler_Fraxinus_ornus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus",
    "gbif": "https://www.gbif.org/species/3172323",
    "extract": {
      "en": "Fraxinus, commonly called ash, is a genus of plants in the olive and lilac family, Oleaceae, and comprises 45–65 species of usually medium-to-large trees, most of which are deciduous, although some subtropical species are evergreen. The genus is widespread throughout much of Europe, Asia, and North America.",
      "es": "Fraxinus es un género de la familia de las oleáceas, cuyos miembros son conocidos generalmente como fresnos. Contiene 45-65 especies de árboles de porte mediano a grande, de hoja caduca en general, aunque unas pocas especies subtropicales son perennifolias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 237
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus excelsior"
    },
    "vulgarName": [
      {
        "en": "Ash"
      },
      {
        "en": "Common ash"
      },
      {
        "en": "European ash"
      },
      {
        "es": "Fresno excelsior"
      },
      {
        "de": "Gemeine Esche"
      },
      {
        "fr": "Frêne élevé"
      },
      {
        "pt": "Fraxinus excelsior"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156907",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_excelsior",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_excelsior"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Fraxinus_excelsior.jpg/330px-Fraxinus_excelsior.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Ash_Tree_-_geograph.org.uk_-_590710.jpg/330px-Ash_Tree_-_geograph.org.uk_-_590710.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_excelsior",
    "gbif": "https://www.gbif.org/species/3172358",
    "extract": {
      "en": "Fraxinus excelsior, known as the ash, or European ash or common ash to distinguish it from other types of ash, is a flowering plant species in the olive family Oleaceae. It is native throughout mainland Europe east to the Caucasus and Alborz mountains, and west to Great Britain and Ireland, the latter determining its western boundary. The northernmost location is in the Trondheimsfjord region of Norway. The species is widely cultivated and reportedly naturalised in New Zealand and in scattered locales in the United States and Canada. The wood has many uses as it is flexible, workable, strong and lightweight.",
      "es": "Fraxinus excelsior, el fresno norteño, fresno de hoja ancha o fresno común, es una especie perteneciente a la familia de las oleáceas. Es un árbol nativo de la mayor parte de Europa; desde España, principalmente el norte, hasta Rusia. Su hábitat natural más septentrional se encuentra en Trondheim, Noruega, y el meridional, en el norte de Grecia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus ornus"
    },
    "vulgarName": [
      {
        "en": "Manna ash"
      },
      {
        "es": "Fresno orno"
      },
      {
        "de": "Manna-Esche"
      },
      {
        "fr": "Fraxinus ornus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161421",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_ornus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_ornus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Fraxinus_ornus_JPG2.jpg/330px-Fraxinus_ornus_JPG2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_ornus",
    "gbif": "https://www.gbif.org/species/3172347",
    "extract": {
      "en": "Fraxinus ornus, the manna ash or South European flowering ash, is a species of Fraxinus native to Southern Europe and Southwestern Asia, from Spain and Italy north to Austria and the Czech Republic, and east through the Balkans, Turkey, and western Syria to Lebanon and Armenia.",
      "es": "Fraxinus ornus, el fresno de flor, orno, fresno del maná o fresno florido, es una especie de árbol perteneciente a la familia Oleaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 66
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus angustifolia"
    },
    "vulgarName": [
      {
        "es": "Fresno"
      },
      {
        "en": "Narrow-leafed ash"
      },
      {
        "de": "Schmalblättrige Esche"
      },
      {
        "fr": "Fraxinus angustifolia"
      },
      {
        "pt": "Fraxinus angustifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q518949",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_angustifolia",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_angustifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Fraxinus_angustifolia_foliage.jpg/330px-Fraxinus_angustifolia_foliage.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Fresno_%28Colmenar_Viejo%29.jpg/330px-Fresno_%28Colmenar_Viejo%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_angustifolia",
    "gbif": "https://www.gbif.org/species/7325877",
    "extract": {
      "en": "Fraxinus angustifolia, the narrow-leaved ash, is a species of Fraxinus native to Central Europe and Southern Europe, Northwest Africa, and Southwest Asia.",
      "es": "Fraxinus angustifolia, el fresno sureño, fresno de hoja estrecha o fresno de hojas estrechas es un árbol de la familia de las oleáceas. Es el fresno más común en la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Fraxinus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 389
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species955",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus"
    },
    "vulgarName": [
      {
        "en": "Ash"
      },
      {
        "es": "Fresno"
      },
      {
        "de": "Eschen (Pflanzengattung)"
      },
      {
        "fr": "Frêne"
      },
      {
        "pt": "Fraxinus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q128887",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg/330px-Fraxinus_ornus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-062.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/K%C3%B6hler_Fraxinus_ornus.jpg/330px-K%C3%B6hler_Fraxinus_ornus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus",
    "gbif": "https://www.gbif.org/species/3172323",
    "extract": {
      "en": "Fraxinus, commonly called ash, is a genus of plants in the olive and lilac family, Oleaceae, and comprises 45–65 species of usually medium-to-large trees, most of which are deciduous, although some subtropical species are evergreen. The genus is widespread throughout much of Europe, Asia, and North America.",
      "es": "Fraxinus es un género de la familia de las oleáceas, cuyos miembros son conocidos generalmente como fresnos. Contiene 45-65 especies de árboles de porte mediano a grande, de hoja caduca en general, aunque unas pocas especies subtropicales son perennifolias."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species55"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 66
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusAngustifolia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus angustifolia"
    },
    "vulgarName": [
      {
        "es": "Fresno"
      },
      {
        "en": "Narrow-leafed ash"
      },
      {
        "de": "Schmalblättrige Esche"
      },
      {
        "fr": "Fraxinus angustifolia"
      },
      {
        "pt": "Fraxinus angustifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q518949",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_angustifolia",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_angustifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Fraxinus_angustifolia_foliage.jpg/330px-Fraxinus_angustifolia_foliage.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Fresno_%28Colmenar_Viejo%29.jpg/330px-Fresno_%28Colmenar_Viejo%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_angustifolia",
    "gbif": "https://www.gbif.org/species/7325877",
    "extract": {
      "en": "Fraxinus angustifolia, the narrow-leaved ash, is a species of Fraxinus native to Central Europe and Southern Europe, Northwest Africa, and Southwest Asia.",
      "es": "Fraxinus angustifolia, el fresno sureño, fresno de hoja estrecha o fresno de hojas estrechas es un árbol de la familia de las oleáceas. Es el fresno más común en la península ibérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species255"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 237
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusExcelsior",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus excelsior"
    },
    "vulgarName": [
      {
        "en": "Ash"
      },
      {
        "en": "Common ash"
      },
      {
        "en": "European ash"
      },
      {
        "es": "Fresno excelsior"
      },
      {
        "de": "Gemeine Esche"
      },
      {
        "fr": "Frêne élevé"
      },
      {
        "pt": "Fraxinus excelsior"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156907",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_excelsior",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_excelsior"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Fraxinus_excelsior.jpg/330px-Fraxinus_excelsior.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Ash_Tree_-_geograph.org.uk_-_590710.jpg/330px-Ash_Tree_-_geograph.org.uk_-_590710.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_excelsior",
    "gbif": "https://www.gbif.org/species/3172358",
    "extract": {
      "en": "Fraxinus excelsior, known as the ash, or European ash or common ash to distinguish it from other types of ash, is a flowering plant species in the olive family Oleaceae. It is native throughout mainland Europe east to the Caucasus and Alborz mountains, and west to Great Britain and Ireland, the latter determining its western boundary. The northernmost location is in the Trondheimsfjord region of Norway. The species is widely cultivated and reportedly naturalised in New Zealand and in scattered locales in the United States and Canada. The wood has many uses as it is flexible, workable, strong and lightweight.",
      "es": "Fraxinus excelsior, el fresno norteño, fresno de hoja ancha o fresno común, es una especie perteneciente a la familia de las oleáceas. Es un árbol nativo de la mayor parte de Europa; desde España, principalmente el norte, hasta Rusia. Su hábitat natural más septentrional se encuentra en Trondheim, Noruega, y el meridional, en el norte de Grecia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species355"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus441",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FraxinusOrnus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Fraxinus ornus"
    },
    "vulgarName": [
      {
        "en": "Manna ash"
      },
      {
        "es": "Fresno orno"
      },
      {
        "de": "Manna-Esche"
      },
      {
        "fr": "Fraxinus ornus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161421",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fraxinus_ornus",
      "es": "https://es.wikipedia.org/wiki/Fraxinus_ornus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Fraxinus_ornus_JPG2.jpg/330px-Fraxinus_ornus_JPG2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Fraxinus_ornus",
    "gbif": "https://www.gbif.org/species/3172347",
    "extract": {
      "en": "Fraxinus ornus, the manna ash or South European flowering ash, is a species of Fraxinus native to Southern Europe and Southwestern Asia, from Spain and Italy north to Austria and the Czech Republic, and east through the Balkans, Turkey, and western Syria to Lebanon and Armenia.",
      "es": "Fraxinus ornus, el fresno de flor, orno, fresno del maná o fresno florido, es una especie de árbol perteneciente a la familia Oleaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 634
      },
      "ifn3": {
        "count": 813
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
    "isGenus": 1,
    "scientificName": {
      "la": "Olea"
    },
    "vulgarName": [
      {
        "en": "Olives"
      },
      {
        "es": "Olivos"
      },
      {
        "de": "Ölbäume"
      },
      {
        "fr": "Olea"
      },
      {
        "pt": "Olea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q296910",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Olea",
      "es": "https://es.wikipedia.org/wiki/Olea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Olive-tree-fruit-august-0.jpg/330px-Olive-tree-fruit-august-0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Olea",
    "gbif": "https://www.gbif.org/species/3172244",
    "extract": {
      "en": "Olea is a genus of flowering plants in the family Oleaceae. It includes 11 species accepted by Plants of the World Online native to warm temperate and tropical regions of the Middle East, southern Europe, Africa, southern Asia, and Australasia. They are evergreen trees and shrubs, with small, opposite, entire leaves. The fruit is a drupe. Leaves of Olea contain trichosclereids.",
      "es": "Olea es un género de 34 especies aceptadas de la familia Oleaceae, nativa de regiones templadas cálidas y tropicales del sur de Europa, África, sur de Asia y Australasia. Son árboles siempreverdes, arbustos, con hojas pequeñas, opuestas, enteras. El fruto es una drupa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea"
    ],
    "nplots": {
      "ifn2": {
        "count": 634
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Olea europaea"
    },
    "vulgarName": [
      {
        "en": "Wild olive tree"
      },
      {
        "es": "Acebuche"
      },
      {
        "de": "Olivenbaum"
      },
      {
        "fr": "Olea europaea"
      },
      {
        "pt": "Oliveira"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q37083",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Olive",
      "es": "https://es.wikipedia.org/wiki/Olea_europaea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Olivesfromjordan.jpg/330px-Olivesfromjordan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg/330px-Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Olea_europaea",
    "gbif": "https://www.gbif.org/species/5415040",
    "extract": {
      "en": "The olive is a species of subtropical evergreen tree in the family Oleaceae. Originating in Asia Minor, it is abundant throughout the Mediterranean Basin, with wild subspecies in Africa and western Asia; modern cultivars are traced primarily to the Near East, Aegean Sea, and Strait of Gibraltar. The olive is the type species for its genus, Olea, and lends its name to the Oleaceae plant family, which includes lilac, jasmine, forsythia, and ash. The olive fruit is classed botanically as a drupe, similar in structure and function to the cherry or peach. The term oil was originally synonymous with olive oil, the liquid fat derived from olives.",
      "es": "Olea europaea, llamado comúnmente olivo y olivera, así como también oliva y aceituno, es un árbol pequeño perennifolio que puede alcanzar hasta 15 m de altura, con tronco grueso de aspecto retorcido. Su corteza es de color gris o plateado y tiene hojas opuestas, lanceoladas. Las flores son hermafroditas, en panículas axilares multifloras, con corola blanca. El fruto, la aceituna u oliva, es una drupa de 1 a 3,5 cm de largo. Su periodo de floración sucede entre mayo y julio en el hemisferio norte, y entre noviembre y enero en el hemisferio sur, mientras que su periodo de fructificación ocurre entre septiembre y diciembre en el hemisferio norte, y entre marzo y junio en el hemisferio sur. De este fruto se obtiene un aceite muy apreciado en gastronomía, el aceite de oliva."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 634
      },
      "ifn3": {
        "count": 813
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Olea europaea"
    },
    "vulgarName": [
      {
        "en": "Wild olive tree"
      },
      {
        "es": "Acebuche"
      },
      {
        "de": "Olivenbaum"
      },
      {
        "fr": "Olea europaea"
      },
      {
        "pt": "Oliveira"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q37083",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Olive",
      "es": "https://es.wikipedia.org/wiki/Olea_europaea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Olivesfromjordan.jpg/330px-Olivesfromjordan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg/330px-Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Olea_europaea",
    "gbif": "https://www.gbif.org/species/5415040",
    "extract": {
      "en": "The olive is a species of subtropical evergreen tree in the family Oleaceae. Originating in Asia Minor, it is abundant throughout the Mediterranean Basin, with wild subspecies in Africa and western Asia; modern cultivars are traced primarily to the Near East, Aegean Sea, and Strait of Gibraltar. The olive is the type species for its genus, Olea, and lends its name to the Oleaceae plant family, which includes lilac, jasmine, forsythia, and ash. The olive fruit is classed botanically as a drupe, similar in structure and function to the cherry or peach. The term oil was originally synonymous with olive oil, the liquid fat derived from olives.",
      "es": "Olea europaea, llamado comúnmente olivo y olivera, así como también oliva y aceituno, es un árbol pequeño perennifolio que puede alcanzar hasta 15 m de altura, con tronco grueso de aspecto retorcido. Su corteza es de color gris o plateado y tiene hojas opuestas, lanceoladas. Las flores son hermafroditas, en panículas axilares multifloras, con corola blanca. El fruto, la aceituna u oliva, es una drupa de 1 a 3,5 cm de largo. Su periodo de floración sucede entre mayo y julio en el hemisferio norte, y entre noviembre y enero en el hemisferio sur, mientras que su periodo de fructificación ocurre entre septiembre y diciembre en el hemisferio norte, y entre marzo y junio en el hemisferio sur. De este fruto se obtiene un aceite muy apreciado en gastronomía, el aceite de oliva."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus442",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/OleaEuropaea"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 813
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species66",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Olea europaea"
    },
    "vulgarName": [
      {
        "en": "Wild olive tree"
      },
      {
        "es": "Acebuche"
      },
      {
        "de": "Olivenbaum"
      },
      {
        "fr": "Olea europaea"
      },
      {
        "pt": "Oliveira"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q37083",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Olive",
      "es": "https://es.wikipedia.org/wiki/Olea_europaea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Olivesfromjordan.jpg/330px-Olivesfromjordan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg/330px-Oliveira_%28Olea_europaea%29_na_Pra%C3%A7a_da_Esta%C3%A7%C3%A3o%2C_Bag%C3%A9%2C_RS%2C_Brasil_%288160_x_6120px%29.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Olea_europaea",
    "gbif": "https://www.gbif.org/species/5415040",
    "extract": {
      "en": "The olive is a species of subtropical evergreen tree in the family Oleaceae. Originating in Asia Minor, it is abundant throughout the Mediterranean Basin, with wild subspecies in Africa and western Asia; modern cultivars are traced primarily to the Near East, Aegean Sea, and Strait of Gibraltar. The olive is the type species for its genus, Olea, and lends its name to the Oleaceae plant family, which includes lilac, jasmine, forsythia, and ash. The olive fruit is classed botanically as a drupe, similar in structure and function to the cherry or peach. The term oil was originally synonymous with olive oil, the liquid fat derived from olives.",
      "es": "Olea europaea, llamado comúnmente olivo y olivera, así como también oliva y aceituno, es un árbol pequeño perennifolio que puede alcanzar hasta 15 m de altura, con tronco grueso de aspecto retorcido. Su corteza es de color gris o plateado y tiene hojas opuestas, lanceoladas. Las flores son hermafroditas, en panículas axilares multifloras, con corola blanca. El fruto, la aceituna u oliva, es una drupa de 1 a 3,5 cm de largo. Su periodo de floración sucede entre mayo y julio en el hemisferio norte, y entre noviembre y enero en el hemisferio sur, mientras que su periodo de fructificación ocurre entre septiembre y diciembre en el hemisferio norte, y entre marzo y junio en el hemisferio sur. De este fruto se obtiene un aceite muy apreciado en gastronomía, el aceite de oliva."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 19
      },
      "ifn3": {
        "count": 62
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
    "isGenus": 1,
    "scientificName": {
      "la": "Phillyrea"
    },
    "vulgarName": [
      {
        "es": "Labiernagos"
      },
      {
        "en": "Phillyreas"
      },
      {
        "de": "Steinlinden"
      },
      {
        "fr": "Phillyrea"
      },
      {
        "pt": "Phillyrea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1512683",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phillyrea",
      "es": "https://es.wikipedia.org/wiki/Phillyrea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Phillyrea_latifolia2.jpg/330px-Phillyrea_latifolia2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phillyrea",
    "gbif": "https://www.gbif.org/species/7325888",
    "extract": {
      "en": "Phillyrea is a genus of two species of flowering plants in the family Oleaceae, native to the Mediterranean region, and naturalized in the Canary Islands and Madeira.",
      "es": "Phillyrea es un género con 80 especies de plantas con flores perteneciente a la familia Oleaceae. Son nativas de la región del Mediterráneo, Islas Canarias y Madeira."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia"
    ],
    "nplots": {
      "ifn2": {
        "count": 19
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phillyrea latifolia"
    },
    "vulgarName": [
      {
        "en": "Green olive tree"
      },
      {
        "en": "Mock privet"
      },
      {
        "es": "Labiérnago"
      },
      {
        "fr": "Phillyrea latifolia"
      },
      {
        "pt": "Phillyrea latifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q784070",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phillyrea_latifolia",
      "es": "https://es.wikipedia.org/wiki/Phillyrea_latifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Phillyrea_latifolia2.jpg/330px-Phillyrea_latifolia2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Phillyrea_latifolia.jpg/330px-Phillyrea_latifolia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phillyrea_latifolia",
    "gbif": "https://www.gbif.org/species/7325923",
    "extract": {
      "en": "Phillyrea latifolia, commonly known as green olive tree or mock privet, is a species of tree in the family Oleaceae. It is native to the Mediterranean Basin, from Morocco and Portugal in the west, to the Levant in the east.",
      "es": "El labiérnago de hoja ancha, labiérnago negro o agracejo es una especie de la familia de las oleáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 19
      },
      "ifn3": {
        "count": 62
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phillyrea latifolia"
    },
    "vulgarName": [
      {
        "en": "Green olive tree"
      },
      {
        "en": "Mock privet"
      },
      {
        "es": "Labiérnago"
      },
      {
        "fr": "Phillyrea latifolia"
      },
      {
        "pt": "Phillyrea latifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q784070",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phillyrea_latifolia",
      "es": "https://es.wikipedia.org/wiki/Phillyrea_latifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Phillyrea_latifolia2.jpg/330px-Phillyrea_latifolia2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Phillyrea_latifolia.jpg/330px-Phillyrea_latifolia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phillyrea_latifolia",
    "gbif": "https://www.gbif.org/species/7325923",
    "extract": {
      "en": "Phillyrea latifolia, commonly known as green olive tree or mock privet, is a species of tree in the family Oleaceae. It is native to the Mediterranean Basin, from Morocco and Portugal in the west, to the Levant in the east.",
      "es": "El labiérnago de hoja ancha, labiérnago negro o agracejo es una especie de la familia de las oleáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus443",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhillyreaLatifolia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 62
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species8",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phillyrea latifolia"
    },
    "vulgarName": [
      {
        "en": "Green olive tree"
      },
      {
        "en": "Mock privet"
      },
      {
        "es": "Labiérnago"
      },
      {
        "fr": "Phillyrea latifolia"
      },
      {
        "pt": "Phillyrea latifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q784070",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phillyrea_latifolia",
      "es": "https://es.wikipedia.org/wiki/Phillyrea_latifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Phillyrea_latifolia2.jpg/330px-Phillyrea_latifolia2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Phillyrea_latifolia.jpg/330px-Phillyrea_latifolia.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phillyrea_latifolia",
    "gbif": "https://www.gbif.org/species/7325923",
    "extract": {
      "en": "Phillyrea latifolia, commonly known as green olive tree or mock privet, is a species of tree in the family Oleaceae. It is native to the Mediterranean Basin, from Morocco and Portugal in the west, to the Levant in the east.",
      "es": "El labiérnago de hoja ancha, labiérnago negro o agracejo es una especie de la familia de las oleáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
    "isGenus": 1,
    "scientificName": {
      "la": "Picconia"
    },
    "vulgarName": [
      {
        "es": "Palos blancos"
      },
      {
        "en": "White woods"
      },
      {
        "pt": "Picconia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q7190600",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picconia",
      "es": "https://es.wikipedia.org/wiki/Picconia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Picconia_excelsa.jpg/330px-Picconia_excelsa.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picconia_(Oleaceae)",
    "gbif": "https://www.gbif.org/species/3233686",
    "extract": {
      "en": "Picconia is a genus of two species of flowering plants in the family Oleaceae, found in the laurel forests habitat of Macaronesia.",
      "es": "Picconia es un género de plantas de la familia Oleaceae con dos especies. Es originario de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picconia excelsa"
    },
    "vulgarName": [
      {
        "en": "White wood"
      },
      {
        "es": "Palo blanco"
      },
      {
        "de": "Picconia excelsa"
      },
      {
        "fr": "Picconia excelsa"
      },
      {
        "pt": "Picconia excelsa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q148728",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picconia_excelsa",
      "es": "https://es.wikipedia.org/wiki/Picconia_excelsa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Picconia_excelsa.jpg/330px-Picconia_excelsa.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Picconia_excelsa_01.JPG/330px-Picconia_excelsa_01.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picconia_excelsa",
    "gbif": "https://www.gbif.org/species/5549937",
    "extract": {
      "en": "Picconia excelsa, commonly known as palo blanco, pau blanco, or branqueiro, is a species of tree in the family Oleaceae. It is endemic to Macaronesia, occurring only on Madeira and the Canary Islands.",
      "es": "Picconia excelsa (Aiton) DC., conocido en castellano como palo blanco, es una especie de árbol o a veces arbusto siempreverde de aspecto lauroide, perteneciente a la familia Oleaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picconia excelsa"
    },
    "vulgarName": [
      {
        "en": "White wood"
      },
      {
        "es": "Palo blanco"
      },
      {
        "de": "Picconia excelsa"
      },
      {
        "fr": "Picconia excelsa"
      },
      {
        "pt": "Picconia excelsa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q148728",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picconia_excelsa",
      "es": "https://es.wikipedia.org/wiki/Picconia_excelsa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Picconia_excelsa.jpg/330px-Picconia_excelsa.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Picconia_excelsa_01.JPG/330px-Picconia_excelsa_01.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picconia_excelsa",
    "gbif": "https://www.gbif.org/species/5549937",
    "extract": {
      "en": "Picconia excelsa, commonly known as palo blanco, pau blanco, or branqueiro, is a species of tree in the family Oleaceae. It is endemic to Macaronesia, occurring only on Madeira and the Canary Islands.",
      "es": "Picconia excelsa (Aiton) DC., conocido en castellano como palo blanco, es una especie de árbol o a veces arbusto siempreverde de aspecto lauroide, perteneciente a la familia Oleaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus444",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family44",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PicconiaExcelsa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species86",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Picconia excelsa"
    },
    "vulgarName": [
      {
        "en": "White wood"
      },
      {
        "es": "Palo blanco"
      },
      {
        "de": "Picconia excelsa"
      },
      {
        "fr": "Picconia excelsa"
      },
      {
        "pt": "Picconia excelsa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q148728",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Picconia_excelsa",
      "es": "https://es.wikipedia.org/wiki/Picconia_excelsa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Picconia_excelsa.jpg/330px-Picconia_excelsa.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Picconia_excelsa_01.JPG/330px-Picconia_excelsa_01.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Picconia_excelsa",
    "gbif": "https://www.gbif.org/species/5549937",
    "extract": {
      "en": "Picconia excelsa, commonly known as palo blanco, pau blanco, or branqueiro, is a species of tree in the family Oleaceae. It is endemic to Macaronesia, occurring only on Madeira and the Canary Islands.",
      "es": "Picconia excelsa (Aiton) DC., conocido en castellano como palo blanco, es una especie de árbol o a veces arbusto siempreverde de aspecto lauroide, perteneciente a la familia Oleaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 63
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
    "isGenus": 1,
    "scientificName": {
      "la": "Platanus"
    },
    "vulgarName": [
      {
        "es": "Plátanos"
      },
      {
        "en": "Sycamores"
      },
      {
        "de": "Platanen"
      },
      {
        "fr": "Platane"
      },
      {
        "pt": "Plátano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163025",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Platanus",
      "es": "https://es.wikipedia.org/wiki/Platanus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Platanus_orientalis_fruits%2C_Thasos.jpg/330px-Platanus_orientalis_fruits%2C_Thasos.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Plataan_bladeren.jpg/330px-Plataan_bladeren.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus",
    "gbif": "https://www.gbif.org/species/3152811",
    "extract": {
      "en": "Platanus is a genus consisting of a small number of tree species. They are the sole living members of the family Platanaceae.",
      "es": "Platanus es un género consistente en una pequeña cantidad de especies de árboles nativas del hemisferio norte. Son los únicos miembros existentes de la familia Platanaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica"
    ],
    "nplots": {
      "ifn2": {
        "count": 63
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Platanus hispanica"
    },
    "vulgarName": [
      {
        "en": "Hybrid plane"
      },
      {
        "en": "London plane"
      },
      {
        "en": "London plane tree"
      },
      {
        "es": "Plátano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161374",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/London_plane",
      "es": "https://es.wikipedia.org/wiki/Platanus_%C3%97_hispanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Berkeley_Square_-_geograph.org.uk_-_911963.jpg/330px-Berkeley_Square_-_geograph.org.uk_-_911963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Platanus.JPG/330px-Platanus.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus_%C3%97_hispanica",
    "gbif": "https://www.gbif.org/species/7400250",
    "extract": {
      "en": "The London plane, or sometimes hybrid plane, Platanus × hispanica, is a tree in the genus Platanus. It is often known by the synonym Platanus × acerifolia, a later name. It is a hybrid of Platanus orientalis and Platanus occidentalis.",
      "es": "Platanus × hispanica, conocido también como Platanus × acerifolia, y por nombre común plátano de sombra, es un árbol de imponente porte que alcanza los 55 m de alto, perteneciente a la familia de las platanáceas. Normalmente se considera un híbrido de Platanus orientalis y Platanus occidentalis, aunque hay expertos que opinan que puede tratarse de un cultivar de P. orientalis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 63
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Platanus hispanica"
    },
    "vulgarName": [
      {
        "en": "Hybrid plane"
      },
      {
        "en": "London plane"
      },
      {
        "en": "London plane tree"
      },
      {
        "es": "Plátano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161374",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/London_plane",
      "es": "https://es.wikipedia.org/wiki/Platanus_%C3%97_hispanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Berkeley_Square_-_geograph.org.uk_-_911963.jpg/330px-Berkeley_Square_-_geograph.org.uk_-_911963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Platanus.JPG/330px-Platanus.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus_%C3%97_hispanica",
    "gbif": "https://www.gbif.org/species/7400250",
    "extract": {
      "en": "The London plane, or sometimes hybrid plane, Platanus × hispanica, is a tree in the genus Platanus. It is often known by the synonym Platanus × acerifolia, a later name. It is a hybrid of Platanus orientalis and Platanus occidentalis.",
      "es": "Platanus × hispanica, conocido también como Platanus × acerifolia, y por nombre común plátano de sombra, es un árbol de imponente porte que alcanza los 55 m de alto, perteneciente a la familia de las platanáceas. Normalmente se considera un híbrido de Platanus orientalis y Platanus occidentalis, aunque hay expertos que opinan que puede tratarse de un cultivar de P. orientalis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Platanus orientalis"
    },
    "vulgarName": [
      {
        "en": "Old World sycamore"
      },
      {
        "en": "Oriental plane"
      },
      {
        "es": "Plátano oriental"
      },
      {
        "de": "Morgenländische Platane"
      },
      {
        "fr": "Platane d'Orient"
      },
      {
        "pt": "Platanus orientalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161105",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Platanus_orientalis",
      "es": "https://es.wikipedia.org/wiki/Platanus_orientalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Plane_tree_Grove_Tsav_River.jpg/330px-Plane_tree_Grove_Tsav_River.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Fruits_of_Platanus_orientalis.jpg/330px-Fruits_of_Platanus_orientalis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus_orientalis",
    "gbif": "https://www.gbif.org/species/3152816",
    "extract": {
      "en": "Platanus orientalis, the Oriental plane, is a large, deciduous tree in the family Platanaceae, growing to 30 m (98 ft) or more, and known for its longevity and spreading crown. In autumn, its deep green leaves may change to blood red, amber, and yellow.",
      "es": "Platanus orientalis, el plátano oriental, es una especie arbórea caducifolia, de gran tamaño, ampliamente distribuida y de una larga vida, perteneciente a la familia Platanaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusHispanica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species79",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Platanus hispanica"
    },
    "vulgarName": [
      {
        "en": "Hybrid plane"
      },
      {
        "en": "London plane"
      },
      {
        "en": "London plane tree"
      },
      {
        "es": "Plátano"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161374",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/London_plane",
      "es": "https://es.wikipedia.org/wiki/Platanus_%C3%97_hispanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Berkeley_Square_-_geograph.org.uk_-_911963.jpg/330px-Berkeley_Square_-_geograph.org.uk_-_911963.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Platanus.JPG/330px-Platanus.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus_%C3%97_hispanica",
    "gbif": "https://www.gbif.org/species/7400250",
    "extract": {
      "en": "The London plane, or sometimes hybrid plane, Platanus × hispanica, is a tree in the genus Platanus. It is often known by the synonym Platanus × acerifolia, a later name. It is a hybrid of Platanus orientalis and Platanus occidentalis.",
      "es": "Platanus × hispanica, conocido también como Platanus × acerifolia, y por nombre común plátano de sombra, es un árbol de imponente porte que alcanza los 55 m de alto, perteneciente a la familia de las platanáceas. Normalmente se considera un híbrido de Platanus orientalis y Platanus occidentalis, aunque hay expertos que opinan que puede tratarse de un cultivar de P. orientalis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species279"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus461",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family46",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PlatanusOrientalis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Platanus orientalis"
    },
    "vulgarName": [
      {
        "en": "Old World sycamore"
      },
      {
        "en": "Oriental plane"
      },
      {
        "es": "Plátano oriental"
      },
      {
        "de": "Morgenländische Platane"
      },
      {
        "fr": "Platane d'Orient"
      },
      {
        "pt": "Platanus orientalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161105",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Platanus_orientalis",
      "es": "https://es.wikipedia.org/wiki/Platanus_orientalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Plane_tree_Grove_Tsav_River.jpg/330px-Plane_tree_Grove_Tsav_River.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Fruits_of_Platanus_orientalis.jpg/330px-Fruits_of_Platanus_orientalis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Platanus_orientalis",
    "gbif": "https://www.gbif.org/species/3152816",
    "extract": {
      "en": "Platanus orientalis, the Oriental plane, is a large, deciduous tree in the family Platanaceae, growing to 30 m (98 ft) or more, and known for its longevity and spreading crown. In autumn, its deep green leaves may change to blood red, amber, and yellow.",
      "es": "Platanus orientalis, el plátano oriental, es una especie arbórea caducifolia, de gran tamaño, ampliamente distribuida y de una larga vida, perteneciente a la familia Platanaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
    "isGenus": 1,
    "scientificName": {
      "la": "Heberdenia"
    },
    "vulgarName": [
      {
        "en": "Heberdenia"
      },
      {
        "es": "Heberdenias"
      },
      {
        "pt": "Heberdenia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q933826",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Heberdenia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Heberdenia_excelsa.jpg/330px-Heberdenia_excelsa.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Heberdenia",
    "gbif": "https://www.gbif.org/species/7331123",
    "extract": {
      "en": "Heberdenia is a genus of plant in the family Primulaceae. It contains the following species :Heberdenia excelsa (Ait.) Banks"
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Heberdenia bahamensis"
    },
    "vulgarName": [
      {
        "es": "Aderno"
      },
      {
        "pt": "Aderno"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q15304926"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Heberdenia bahamensis"
    },
    "vulgarName": [
      {
        "es": "Aderno"
      },
      {
        "pt": "Aderno"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q15304926"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus471",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/HeberdeniaBahamensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species1",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Heberdenia bahamensis"
    },
    "vulgarName": [
      {
        "es": "Aderno"
      },
      {
        "pt": "Aderno"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q15304926"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
    "isGenus": 1,
    "scientificName": {
      "la": "Frangula"
    },
    "vulgarName": [
      {
        "es": "Arraclán"
      },
      {
        "en": "Alder buckthorns"
      },
      {
        "de": "Faulbäume"
      },
      {
        "fr": "Frangula"
      },
      {
        "pt": "Frangula"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q79189",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Frangula",
      "es": "https://es.wikipedia.org/wiki/Frangula"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Frangula-alnus-fruits.JPG/330px-Frangula-alnus-fruits.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Frangula_rupestris_2.jpg/330px-Frangula_rupestris_2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Frangula",
    "gbif": "https://www.gbif.org/species/3039453",
    "extract": {
      "en": "Frangula is a genus of about 56 species of flowering shrubs or small trees, commonly known as buckthorn, in the buckthorn family Rhamnaceae. The common name buckthorn is also used to describe species of the closely related genus Rhamnus in the same family, and also the superficially similar but unrelated sea-buckthorn, Hippophae rhamnoides in the Elaeagnaceae.",
      "es": "Frangula es un género de plantas de la familia Rhamnaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Frangula alnus"
    },
    "vulgarName": [
      {
        "en": "Alder buckthorn"
      },
      {
        "es": "Arraclán"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146136",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Frangula_alnus",
      "es": "https://es.wikipedia.org/wiki/Frangula_alnus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Frangula-alnus-fruits.JPG/330px-Frangula-alnus-fruits.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg/330px-Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Frangula_alnus",
    "gbif": "https://www.gbif.org/species/3039454",
    "extract": {
      "en": "Frangula alnus, commonly known as alder buckthorn, glossy buckthorn, or breaking buckthorn, is a tall deciduous shrub in the family Rhamnaceae. Unlike other \"buckthorns\", alder buckthorn does not have thorns. It is native to Europe, northernmost Africa, and western Asia, from Ireland and Great Britain north to the 68th parallel in Scandinavia, east to central Siberia and Xinjiang in western China, and south to northern Morocco, Turkey, and the Alborz in Iran and the Caucasus Mountains; in the northwest of its range, it is rare and scattered. It is also introduced and naturalised in eastern North America.",
      "es": "El arraclán es un arbusto de 3 a 6 metros de altura que crece en bosques galería y de ribera, orlas de robledales, roquedos y zonas húmedas con suelos neutros o ácidos de Europa, Asia, norte de África y naturalizado en Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Frangula alnus"
    },
    "vulgarName": [
      {
        "en": "Alder buckthorn"
      },
      {
        "es": "Arraclán"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146136",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Frangula_alnus",
      "es": "https://es.wikipedia.org/wiki/Frangula_alnus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Frangula-alnus-fruits.JPG/330px-Frangula-alnus-fruits.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg/330px-Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Frangula_alnus",
    "gbif": "https://www.gbif.org/species/3039454",
    "extract": {
      "en": "Frangula alnus, commonly known as alder buckthorn, glossy buckthorn, or breaking buckthorn, is a tall deciduous shrub in the family Rhamnaceae. Unlike other \"buckthorns\", alder buckthorn does not have thorns. It is native to Europe, northernmost Africa, and western Asia, from Ireland and Great Britain north to the 68th parallel in Scandinavia, east to central Siberia and Xinjiang in western China, and south to northern Morocco, Turkey, and the Alborz in Iran and the Caucasus Mountains; in the northwest of its range, it is rare and scattered. It is also introduced and naturalised in eastern North America.",
      "es": "El arraclán es un arbusto de 3 a 6 metros de altura que crece en bosques galería y de ribera, orlas de robledales, roquedos y zonas húmedas con suelos neutros o ácidos de Europa, Asia, norte de África y naturalizado en Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus481",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FrangulaAlnus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species3",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Frangula alnus"
    },
    "vulgarName": [
      {
        "en": "Alder buckthorn"
      },
      {
        "es": "Arraclán"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146136",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Frangula_alnus",
      "es": "https://es.wikipedia.org/wiki/Frangula_alnus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Frangula-alnus-fruits.JPG/330px-Frangula-alnus-fruits.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg/330px-Rhamnus_frangula_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-120.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Frangula_alnus",
    "gbif": "https://www.gbif.org/species/3039454",
    "extract": {
      "en": "Frangula alnus, commonly known as alder buckthorn, glossy buckthorn, or breaking buckthorn, is a tall deciduous shrub in the family Rhamnaceae. Unlike other \"buckthorns\", alder buckthorn does not have thorns. It is native to Europe, northernmost Africa, and western Asia, from Ireland and Great Britain north to the 68th parallel in Scandinavia, east to central Siberia and Xinjiang in western China, and south to northern Morocco, Turkey, and the Alborz in Iran and the Caucasus Mountains; in the northwest of its range, it is rare and scattered. It is also introduced and naturalised in eastern North America.",
      "es": "El arraclán es un arbusto de 3 a 6 metros de altura que crece en bosques galería y de ribera, orlas de robledales, roquedos y zonas húmedas con suelos neutros o ácidos de Europa, Asia, norte de África y naturalizado en Norteamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
    "isGenus": 1,
    "scientificName": {
      "la": "Rhamnus"
    },
    "vulgarName": [
      {
        "en": "Buckthorns"
      },
      {
        "es": "Espinos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q79190",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_(plant)",
      "es": "https://es.wikipedia.org/wiki/Rhamnus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Rhamnus_cathartica_f%C3%BCr_Wikipedia.jpg/330px-Rhamnus_cathartica_f%C3%BCr_Wikipedia.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Rhamnus_frangula.jpg/330px-Rhamnus_frangula.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhamnus",
    "gbif": "https://www.gbif.org/species/3039471",
    "extract": {
      "en": "Rhamnus is a genus of about 140 accepted species of shrubs or small trees, commonly known as buckthorns, in the family Rhamnaceae. Its species range from 1 to 10 m tall and are native mainly in east Asia and North America, but found throughout the temperate and subtropical Northern Hemisphere, and also more locally in the subtropical Southern Hemisphere in parts of Africa and South America.",
      "es": "Rhamnus es un género que comprende cerca de 100 especies de arbustos o pequeños árboles de 1 a 10 m de alto, de la familia de las Ramnáceas. Son nativas de regiones templadas y subtropicales del Hemisferio Norte, en partes de África y de Sudamérica."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhamnus alaternus"
    },
    "vulgarName": [
      {
        "en": "Italian buckthorn"
      },
      {
        "es": "Aladierno"
      },
      {
        "de": "Stechpalmen-Kreuzdorn"
      },
      {
        "fr": "Nerprun alaterne"
      },
      {
        "pt": "Rhamnus alaternus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q721200",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_alaternus",
      "es": "https://es.wikipedia.org/wiki/Rhamnus_alaternus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Rhamnus_alaternus_%288692911406%29.jpg/330px-Rhamnus_alaternus_%288692911406%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Rhamnus_alaternus1627.JPG/330px-Rhamnus_alaternus1627.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhamnus_alaternus",
    "gbif": "https://www.gbif.org/species/6371424",
    "extract": {
      "en": "Rhamnus alaternus is a species of flowering plant in the buckthorn family Rhamnaceae, known by the common names Italian buckthorn or Mediterranean buckthorn. It is a hardy medium-sized evergreen shrub with fragrant flowers.",
      "es": "Rhamnus alaternus conocido popularmente como aladierna, aladierno, alaterno o carrasquilla, es un pequeño árbol perenne y dioico de la familia de las ramnáceas característico de la región del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhamnus alaternus"
    },
    "vulgarName": [
      {
        "en": "Italian buckthorn"
      },
      {
        "es": "Aladierno"
      },
      {
        "de": "Stechpalmen-Kreuzdorn"
      },
      {
        "fr": "Nerprun alaterne"
      },
      {
        "pt": "Rhamnus alaternus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q721200",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_alaternus",
      "es": "https://es.wikipedia.org/wiki/Rhamnus_alaternus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Rhamnus_alaternus_%288692911406%29.jpg/330px-Rhamnus_alaternus_%288692911406%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Rhamnus_alaternus1627.JPG/330px-Rhamnus_alaternus1627.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhamnus_alaternus",
    "gbif": "https://www.gbif.org/species/6371424",
    "extract": {
      "en": "Rhamnus alaternus is a species of flowering plant in the buckthorn family Rhamnaceae, known by the common names Italian buckthorn or Mediterranean buckthorn. It is a hardy medium-sized evergreen shrub with fragrant flowers.",
      "es": "Rhamnus alaternus conocido popularmente como aladierna, aladierno, alaterno o carrasquilla, es un pequeño árbol perenne y dioico de la familia de las ramnáceas característico de la región del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhamnus glandulosa"
    },
    "vulgarName": [
      {
        "es": "Sanguino"
      },
      {
        "pt": "Rhamnus glandulosa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3282363",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_glandulosa",
      "es": "https://es.wikipedia.org/wiki/Rhamnus_glandulosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Rhamnus_glandulosa.jpg/330px-Rhamnus_glandulosa.jpg"
    ],
    "gbif": "https://www.gbif.org/species/3875196",
    "extract": {
      "en": "Rhamnus glandulosa is a species of plant in the family Rhamnaceae. It is endemic to Madeira and the Canary Islands.",
      "es": "Rhamnus glandulosa, sanguinero, es una especie de planta con flor en la familia Rhamnaceae. Se la halla endémicamente en Portugal: isla de Madeira y en España: islas Canarias. Está amenazada por pérdida de hábitat."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusAlaternus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species4",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhamnus alaternus"
    },
    "vulgarName": [
      {
        "en": "Italian buckthorn"
      },
      {
        "es": "Aladierno"
      },
      {
        "de": "Stechpalmen-Kreuzdorn"
      },
      {
        "fr": "Nerprun alaterne"
      },
      {
        "pt": "Rhamnus alaternus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q721200",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_alaternus",
      "es": "https://es.wikipedia.org/wiki/Rhamnus_alaternus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Rhamnus_alaternus_%288692911406%29.jpg/330px-Rhamnus_alaternus_%288692911406%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Rhamnus_alaternus1627.JPG/330px-Rhamnus_alaternus1627.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Rhamnus_alaternus",
    "gbif": "https://www.gbif.org/species/6371424",
    "extract": {
      "en": "Rhamnus alaternus is a species of flowering plant in the buckthorn family Rhamnaceae, known by the common names Italian buckthorn or Mediterranean buckthorn. It is a hardy medium-sized evergreen shrub with fragrant flowers.",
      "es": "Rhamnus alaternus conocido popularmente como aladierna, aladierno, alaterno o carrasquilla, es un pequeño árbol perenne y dioico de la familia de las ramnáceas característico de la región del Mediterráneo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species389"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus482",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family48",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RhamnusGlandulosa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Rhamnus glandulosa"
    },
    "vulgarName": [
      {
        "es": "Sanguino"
      },
      {
        "pt": "Rhamnus glandulosa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q3282363",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Rhamnus_glandulosa",
      "es": "https://es.wikipedia.org/wiki/Rhamnus_glandulosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Rhamnus_glandulosa.jpg/330px-Rhamnus_glandulosa.jpg"
    ],
    "gbif": "https://www.gbif.org/species/3875196",
    "extract": {
      "en": "Rhamnus glandulosa is a species of plant in the family Rhamnaceae. It is endemic to Madeira and the Canary Islands.",
      "es": "Rhamnus glandulosa, sanguinero, es una especie de planta con flor en la familia Rhamnaceae. Se la halla endémicamente en Portugal: isla de Madeira y en España: islas Canarias. Está amenazada por pérdida de hábitat."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
    "isGenus": 1,
    "scientificName": {
      "la": "Amelanchier"
    },
    "vulgarName": [
      {
        "es": "Cornijuelos"
      },
      {
        "en": "Shadbush"
      },
      {
        "de": "Felsenbirnen"
      },
      {
        "fr": "Amélanchier"
      },
      {
        "pt": "Amelanchier"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q156957",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Amelanchier",
      "es": "https://es.wikipedia.org/wiki/Amelanchier"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Amelanchier_grandiflora2.jpg/330px-Amelanchier_grandiflora2.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Amelanchier",
    "gbif": "https://www.gbif.org/species/3023817",
    "extract": {
      "en": "Amelanchier, also known as shadbush, shadwood or shadblow, serviceberry or sarvisberry, juneberry, saskatoon, sugarplum, wild-plum or chuckley pear, is a genus of about 20 species of deciduous-leaved shrubs and small trees in the rose family (Rosaceae).",
      "es": "Amelanchier es un género de plantas de la familia de las rosáceas. Se conocen por el nombre de guillomos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Amelanchier ovalis"
    },
    "vulgarName": [
      {
        "en": "Snowy mespilus"
      },
      {
        "es": "Guillomo"
      },
      {
        "de": "Gewöhnliche Felsenbirne"
      },
      {
        "fr": "Amélanchier à feuilles ovales"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159560",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Amelanchier_ovalis",
      "es": "https://es.wikipedia.org/wiki/Amelanchier_ovalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Amelanchier_ovalis01.jpg/330px-Amelanchier_ovalis01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Amelanchier_ovalis.JPG/330px-Amelanchier_ovalis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Amelanchier_ovalis",
    "gbif": "https://www.gbif.org/species/3023878",
    "extract": {
      "en": "Amelanchier ovalis, commonly known as snowy mespilus or serviceberry, is a deciduous shrub in the family Rosaceae. Its pome fruits are edible and can be eaten raw or cooked. The species is native to central and southern Europe, as well as North Africa and the Middle East.",
      "es": "Amelanchier ovalis Medik. 1793 es una especie de plantas de los llamados guillomos de la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Amelanchier ovalis"
    },
    "vulgarName": [
      {
        "en": "Snowy mespilus"
      },
      {
        "es": "Guillomo"
      },
      {
        "de": "Gewöhnliche Felsenbirne"
      },
      {
        "fr": "Amélanchier à feuilles ovales"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159560",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Amelanchier_ovalis",
      "es": "https://es.wikipedia.org/wiki/Amelanchier_ovalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Amelanchier_ovalis01.jpg/330px-Amelanchier_ovalis01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Amelanchier_ovalis.JPG/330px-Amelanchier_ovalis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Amelanchier_ovalis",
    "gbif": "https://www.gbif.org/species/3023878",
    "extract": {
      "en": "Amelanchier ovalis, commonly known as snowy mespilus or serviceberry, is a deciduous shrub in the family Rosaceae. Its pome fruits are edible and can be eaten raw or cooked. The species is native to central and southern Europe, as well as North Africa and the Middle East.",
      "es": "Amelanchier ovalis Medik. 1793 es una especie de plantas de los llamados guillomos de la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus491",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AmelanchierOvalis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species2",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Amelanchier ovalis"
    },
    "vulgarName": [
      {
        "en": "Snowy mespilus"
      },
      {
        "es": "Guillomo"
      },
      {
        "de": "Gewöhnliche Felsenbirne"
      },
      {
        "fr": "Amélanchier à feuilles ovales"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159560",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Amelanchier_ovalis",
      "es": "https://es.wikipedia.org/wiki/Amelanchier_ovalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Amelanchier_ovalis01.jpg/330px-Amelanchier_ovalis01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Amelanchier_ovalis.JPG/330px-Amelanchier_ovalis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Amelanchier_ovalis",
    "gbif": "https://www.gbif.org/species/3023878",
    "extract": {
      "en": "Amelanchier ovalis, commonly known as snowy mespilus or serviceberry, is a deciduous shrub in the family Rosaceae. Its pome fruits are edible and can be eaten raw or cooked. The species is native to central and southern Europe, as well as North Africa and the Middle East.",
      "es": "Amelanchier ovalis Medik. 1793 es una especie de plantas de los llamados guillomos de la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 196
      },
      "ifn3": {
        "count": 515
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
    "isGenus": 1,
    "scientificName": {
      "la": "Crataegus"
    },
    "vulgarName": [
      {
        "de": "Weißdorne"
      },
      {
        "fr": "Aubépine"
      },
      {
        "pt": "Crataegus"
      },
      {
        "es": "Espinos"
      },
      {
        "en": "Hawthorns"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132557",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus",
      "es": "https://es.wikipedia.org/wiki/Crataegus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Crataegus%2C_various_species%2C_fruit.jpg/330px-Crataegus%2C_various_species%2C_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus",
    "gbif": "https://www.gbif.org/species/3013395",
    "extract": {
      "en": "Crataegus, commonly called hawthorn, quickthorn, thornapple, May-tree, whitethorn, Mayflower or hawberry, is a genus of several hundred species of shrubs and trees in the family Rosaceae, native to temperate regions of the Northern Hemisphere in Europe, Asia, North Africa and North America. The name \"hawthorn\" was originally applied to the species native to northern Europe, especially the common hawthorn C. monogyna, and the unmodified name is often so used in Britain and Ireland. The name is now also applied to the entire genus and to the related Asian genus Rhaphiolepis.",
      "es": "Crataegus es un género de plantas fanerógamas de la familia Rosaceae, que incluye arbustos y árboles pequeños espinosos. Son naturales de las regiones templadas del Hemisferio Norte en Europa, Asia y Norteamérica. En español se suelen llamar majuelos o espinos. Es la flor del estado de Misuri."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus"
    ],
    "nplots": {
      "ifn2": {
        "count": 196
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus"
    },
    "vulgarName": [
      {
        "en": "Hawthorn"
      },
      {
        "es": "Crataegus"
      },
      {
        "es": "Majuelo"
      },
      {
        "de": "Weißdorne"
      },
      {
        "fr": "Aubépine"
      },
      {
        "pt": "Crataegus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132557",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus",
      "es": "https://es.wikipedia.org/wiki/Crataegus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Crataegus%2C_various_species%2C_fruit.jpg/330px-Crataegus%2C_various_species%2C_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus",
    "gbif": "https://www.gbif.org/species/3013395",
    "extract": {
      "en": "Crataegus, commonly called hawthorn, quickthorn, thornapple, May-tree, whitethorn, Mayflower or hawberry, is a genus of several hundred species of shrubs and trees in the family Rosaceae, native to temperate regions of the Northern Hemisphere in Europe, Asia, North Africa and North America. The name \"hawthorn\" was originally applied to the species native to northern Europe, especially the common hawthorn C. monogyna, and the unmodified name is often so used in Britain and Ireland. The name is now also applied to the entire genus and to the related Asian genus Rhaphiolepis.",
      "es": "Crataegus es un género de plantas fanerógamas de la familia Rosaceae, que incluye arbustos y árboles pequeños espinosos. Son naturales de las regiones templadas del Hemisferio Norte en Europa, Asia y Norteamérica. En español se suelen llamar majuelos o espinos. Es la flor del estado de Misuri."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 196
      },
      "ifn3": {
        "count": 340
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus"
    },
    "vulgarName": [
      {
        "en": "Hawthorn"
      },
      {
        "es": "Crataegus"
      },
      {
        "es": "Majuelo"
      },
      {
        "de": "Weißdorne"
      },
      {
        "fr": "Aubépine"
      },
      {
        "pt": "Crataegus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132557",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus",
      "es": "https://es.wikipedia.org/wiki/Crataegus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Crataegus%2C_various_species%2C_fruit.jpg/330px-Crataegus%2C_various_species%2C_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus",
    "gbif": "https://www.gbif.org/species/3013395",
    "extract": {
      "en": "Crataegus, commonly called hawthorn, quickthorn, thornapple, May-tree, whitethorn, Mayflower or hawberry, is a genus of several hundred species of shrubs and trees in the family Rosaceae, native to temperate regions of the Northern Hemisphere in Europe, Asia, North Africa and North America. The name \"hawthorn\" was originally applied to the species native to northern Europe, especially the common hawthorn C. monogyna, and the unmodified name is often so used in Britain and Ireland. The name is now also applied to the entire genus and to the related Asian genus Rhaphiolepis.",
      "es": "Crataegus es un género de plantas fanerógamas de la familia Rosaceae, que incluye arbustos y árboles pequeños espinosos. Son naturales de las regiones templadas del Hemisferio Norte en Europa, Asia y Norteamérica. En español se suelen llamar majuelos o espinos. Es la flor del estado de Misuri."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Crataegus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 340
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species15",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus"
    },
    "vulgarName": [
      {
        "en": "Hawthorn"
      },
      {
        "es": "Crataegus"
      },
      {
        "es": "Majuelo"
      },
      {
        "de": "Weißdorne"
      },
      {
        "fr": "Aubépine"
      },
      {
        "pt": "Crataegus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q132557",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus",
      "es": "https://es.wikipedia.org/wiki/Crataegus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Crataegus%2C_various_species%2C_fruit.jpg/330px-Crataegus%2C_various_species%2C_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus",
    "gbif": "https://www.gbif.org/species/3013395",
    "extract": {
      "en": "Crataegus, commonly called hawthorn, quickthorn, thornapple, May-tree, whitethorn, Mayflower or hawberry, is a genus of several hundred species of shrubs and trees in the family Rosaceae, native to temperate regions of the Northern Hemisphere in Europe, Asia, North Africa and North America. The name \"hawthorn\" was originally applied to the species native to northern Europe, especially the common hawthorn C. monogyna, and the unmodified name is often so used in Britain and Ireland. The name is now also applied to the entire genus and to the related Asian genus Rhaphiolepis.",
      "es": "Crataegus es un género de plantas fanerógamas de la familia Rosaceae, que incluye arbustos y árboles pequeños espinosos. Son naturales de las regiones templadas del Hemisferio Norte en Europa, Asia y Norteamérica. En español se suelen llamar majuelos o espinos. Es la flor del estado de Misuri."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 175
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus monogyna"
    },
    "vulgarName": [
      {
        "es": "Majuelo"
      },
      {
        "en": "Common hawthorn"
      },
      {
        "de": "Eingriffeliger Weißdorn"
      },
      {
        "fr": "Crataegus monogyna"
      },
      {
        "pt": "Crataegus monogyna"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161511",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_monogyna",
      "es": "https://es.wikipedia.org/wiki/Crataegus_monogyna"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Hawthorn_fruit.JPG/330px-Hawthorn_fruit.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_monogyna",
    "gbif": "https://www.gbif.org/species/9220780",
    "extract": {
      "en": "Crataegus monogyna, known as common hawthorn, whitethorn, one-seed hawthorn, or single-seeded hawthorn, is a species of flowering plant in the rose family, Rosaceae. It grows to about 10 metres tall, producing hermaphrodite flowers in late spring. The berry-like pomes contain a stone-encased seed.",
      "es": "El majuelo, espino albar o espino blanco es una planta fanerógama perteneciente a la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus laevigata"
    },
    "vulgarName": [
      {
        "en": "English hawthorn"
      },
      {
        "en": "Mayflower"
      },
      {
        "en": "Midland hawthorn"
      },
      {
        "en": "Woodland hawthorn"
      },
      {
        "es": "Espino majuelo"
      },
      {
        "de": "Zweigriffeliger Weißdorn"
      },
      {
        "fr": "Crataegus laevigata"
      },
      {
        "pt": "Crataegus laevigata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159553",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_laevigata",
      "es": "https://es.wikipedia.org/wiki/Crataegus_laevigata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Crataegus_laevigata-flowers.jpg/330px-Crataegus_laevigata-flowers.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Illustration_Crataegus_laevigata1.jpg/330px-Illustration_Crataegus_laevigata1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_laevigata",
    "gbif": "https://www.gbif.org/species/3015796",
    "extract": {
      "en": "Crataegus laevigata, known as the Midland hawthorn, English hawthorn, woodland hawthorn, or mayflower, is a species of hawthorn native to western and central Europe, from Great Britain and Spain, east to Romania and Ukraine. The species name is sometimes spelt C. levigata, but the original orthography is C. lævigata.",
      "es": "El espino navarro o majuelo de dos huesos es una especie de espino nativa del oeste y centro de Europa, este de España, la República Checa y Hungría."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus laciniata"
    },
    "vulgarName": [
      {
        "es": "Espino negro"
      },
      {
        "es": "Majoleto"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2013395",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_orientalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Crataegus_orientalis_fruit_a_PG.jpg/330px-Crataegus_orientalis_fruit_a_PG.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_orientalis",
    "gbif": "https://www.gbif.org/species/3013974",
    "extract": {
      "en": "Crataegus orientalis, known as oriental hawthorn, is a species of hawthorn native to the Mediterranean region, Turkey, Caucasia, Crimea, and western Iran, with fruits that are orange or various shades of red."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus azarolus"
    },
    "vulgarName": [
      {
        "en": "Azarole"
      },
      {
        "en": "Azerole"
      },
      {
        "en": "Mediterranean medlar"
      },
      {
        "es": "Espino"
      },
      {
        "de": "Azaroldorn"
      },
      {
        "fr": "Crataegus azarolus"
      },
      {
        "pt": "Crataegus azarolus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q793606",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_azarolus",
      "es": "https://es.wikipedia.org/wiki/Crataegus_azarolus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Hawthorn_in_blossom.jpg/330px-Hawthorn_in_blossom.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Crataegus_azarolus.jpg/330px-Crataegus_azarolus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_azarolus",
    "gbif": "https://www.gbif.org/species/3013739",
    "extract": {
      "en": "Crataegus azarolus is a species of hawthorn known by the common names azarole, azerole and Mediterranean medlar. It is native to the Mediterranean Basin and is a common plant there, growing on sites comparable to those the European common hawthorn grows on. In the Arab countries it is the most common hawthorn species. When growing in the wild, the azerole bears plentiful crops of haw fruits, which are similar to the haws of the European common hawthorn, but more plump.",
      "es": "El acerolo es un árbol o arbusto caducifolio de la familia de las Rosáceas oriundo del sur de Europa, Oriente Medio y el norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species515"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusAzarolus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus azarolus"
    },
    "vulgarName": [
      {
        "en": "Azarole"
      },
      {
        "en": "Azerole"
      },
      {
        "en": "Mediterranean medlar"
      },
      {
        "es": "Espino"
      },
      {
        "de": "Azaroldorn"
      },
      {
        "fr": "Crataegus azarolus"
      },
      {
        "pt": "Crataegus azarolus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q793606",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_azarolus",
      "es": "https://es.wikipedia.org/wiki/Crataegus_azarolus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Hawthorn_in_blossom.jpg/330px-Hawthorn_in_blossom.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Crataegus_azarolus.jpg/330px-Crataegus_azarolus.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_azarolus",
    "gbif": "https://www.gbif.org/species/3013739",
    "extract": {
      "en": "Crataegus azarolus is a species of hawthorn known by the common names azarole, azerole and Mediterranean medlar. It is native to the Mediterranean Basin and is a common plant there, growing on sites comparable to those the European common hawthorn grows on. In the Arab countries it is the most common hawthorn species. When growing in the wild, the azerole bears plentiful crops of haw fruits, which are similar to the haws of the European common hawthorn, but more plump.",
      "es": "El acerolo es un árbol o arbusto caducifolio de la familia de las Rosáceas oriundo del sur de Europa, Oriente Medio y el norte de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species415"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaciniata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus laciniata"
    },
    "vulgarName": [
      {
        "es": "Espino negro"
      },
      {
        "es": "Majoleto"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q2013395",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_orientalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Crataegus_orientalis_fruit_a_PG.jpg/330px-Crataegus_orientalis_fruit_a_PG.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_orientalis",
    "gbif": "https://www.gbif.org/species/3013974",
    "extract": {
      "en": "Crataegus orientalis, known as oriental hawthorn, is a species of hawthorn native to the Mediterranean region, Turkey, Caucasia, Crimea, and western Iran, with fruits that are orange or various shades of red."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species315"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusLaevigata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus laevigata"
    },
    "vulgarName": [
      {
        "en": "English hawthorn"
      },
      {
        "en": "Mayflower"
      },
      {
        "en": "Midland hawthorn"
      },
      {
        "en": "Woodland hawthorn"
      },
      {
        "es": "Espino majuelo"
      },
      {
        "de": "Zweigriffeliger Weißdorn"
      },
      {
        "fr": "Crataegus laevigata"
      },
      {
        "pt": "Crataegus laevigata"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159553",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_laevigata",
      "es": "https://es.wikipedia.org/wiki/Crataegus_laevigata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Crataegus_laevigata-flowers.jpg/330px-Crataegus_laevigata-flowers.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Illustration_Crataegus_laevigata1.jpg/330px-Illustration_Crataegus_laevigata1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_laevigata",
    "gbif": "https://www.gbif.org/species/3015796",
    "extract": {
      "en": "Crataegus laevigata, known as the Midland hawthorn, English hawthorn, woodland hawthorn, or mayflower, is a species of hawthorn native to western and central Europe, from Great Britain and Spain, east to Romania and Ukraine. The species name is sometimes spelt C. levigata, but the original orthography is C. lævigata.",
      "es": "El espino navarro o majuelo de dos huesos es una especie de espino nativa del oeste y centro de Europa, este de España, la República Checa y Hungría."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species215"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus492",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 175
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/CrataegusMonogyna",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Crataegus monogyna"
    },
    "vulgarName": [
      {
        "es": "Majuelo"
      },
      {
        "en": "Common hawthorn"
      },
      {
        "de": "Eingriffeliger Weißdorn"
      },
      {
        "fr": "Crataegus monogyna"
      },
      {
        "pt": "Crataegus monogyna"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161511",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Crataegus_monogyna",
      "es": "https://es.wikipedia.org/wiki/Crataegus_monogyna"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Hawthorn_fruit.JPG/330px-Hawthorn_fruit.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Crataegus_monogyna_-_Common_hawthorn.jpg/330px-Crataegus_monogyna_-_Common_hawthorn.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Crataegus_monogyna",
    "gbif": "https://www.gbif.org/species/9220780",
    "extract": {
      "en": "Crataegus monogyna, known as common hawthorn, whitethorn, one-seed hawthorn, or single-seeded hawthorn, is a species of flowering plant in the rose family, Rosaceae. It grows to about 10 metres tall, producing hermaphrodite flowers in late spring. The berry-like pomes contain a stone-encased seed.",
      "es": "El majuelo, espino albar o espino blanco es una planta fanerógama perteneciente a la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 5
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
    "isGenus": 1,
    "scientificName": {
      "la": "Malus"
    },
    "vulgarName": [
      {
        "en": "Apple trees"
      },
      {
        "es": "Manzanos"
      },
      {
        "de": "Äpfel"
      },
      {
        "fr": "Pommier"
      },
      {
        "pt": "Malus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q104819",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Malus",
      "es": "https://es.wikipedia.org/wiki/Malus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Purple_prince_crabapple_tree.JPG/330px-Purple_prince_crabapple_tree.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Malus_toringo_sargentii0.jpg/330px-Malus_toringo_sargentii0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Malus",
    "gbif": "https://www.gbif.org/species/3001068",
    "extract": {
      "en": "Malus is a genus of about 32–57 species of small deciduous trees or shrubs in the family Rosaceae, including the domesticated orchard apple, crab apples and wild apples.",
      "es": "Malus es un género de árboles y arbustos de la familia Rosaceae, que incluye varias especies cultivadas por sus frutos, como la manzana en diferentes variedades; recibe también nombres como pomera, sagarrondo, pumar, maciñeira, etc. El género tiene 35 especies aceptadas del centenar descritas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris"
    ],
    "nplots": {
      "ifn2": {
        "count": 5
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Malus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Crab apple"
      },
      {
        "es": "Manzano silvestre"
      },
      {
        "de": "Holzapfel"
      },
      {
        "fr": "Malus sylvestris"
      },
      {
        "pt": "Malus sylvestris"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q47161",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Malus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Malus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Malus_sylvestris_005.JPG/330px-Malus_sylvestris_005.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Maguillo_24J_01.jpg/330px-Maguillo_24J_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Malus_sylvestris",
    "gbif": "https://www.gbif.org/species/3001509",
    "extract": {
      "en": "Malus sylvestris, the European crab apple, also known as the European wild apple or simply the crab apple, is a species of the genus Malus. Its scientific name means \"forest apple\", reflecting its habitat. It is native to western Eurasia.",
      "es": "El manzano silvestre o manzano silvestre europeo es una de las especies del género Malus originario de la Europa central. Su nombre científico significa \"manzana del bosque\". En el pasado se pensó que pudiera ser un antepasado importante del manzano de cultivo, sin embargo ahora se sabe que aquél proviene principalmente de la especie Malus sieversii de Asia central. Por otra parte, estudios genéticos recientes confirman que M. sylvestris ha contribuido de manera secundaria, pero significativa, al genoma del manzano de cultivo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 5
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Malus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Crab apple"
      },
      {
        "es": "Manzano silvestre"
      },
      {
        "de": "Holzapfel"
      },
      {
        "fr": "Malus sylvestris"
      },
      {
        "pt": "Malus sylvestris"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q47161",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Malus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Malus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Malus_sylvestris_005.JPG/330px-Malus_sylvestris_005.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Maguillo_24J_01.jpg/330px-Maguillo_24J_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Malus_sylvestris",
    "gbif": "https://www.gbif.org/species/3001509",
    "extract": {
      "en": "Malus sylvestris, the European crab apple, also known as the European wild apple or simply the crab apple, is a species of the genus Malus. Its scientific name means \"forest apple\", reflecting its habitat. It is native to western Eurasia.",
      "es": "El manzano silvestre o manzano silvestre europeo es una de las especies del género Malus originario de la Europa central. Su nombre científico significa \"manzana del bosque\". En el pasado se pensó que pudiera ser un antepasado importante del manzano de cultivo, sin embargo ahora se sabe que aquél proviene principalmente de la especie Malus sieversii de Asia central. Por otra parte, estudios genéticos recientes confirman que M. sylvestris ha contribuido de manera secundaria, pero significativa, al genoma del manzano de cultivo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus493",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MalusSylvestris"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species12",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Malus sylvestris"
    },
    "vulgarName": [
      {
        "en": "Crab apple"
      },
      {
        "es": "Manzano silvestre"
      },
      {
        "de": "Holzapfel"
      },
      {
        "fr": "Malus sylvestris"
      },
      {
        "pt": "Malus sylvestris"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q47161",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Malus_sylvestris",
      "es": "https://es.wikipedia.org/wiki/Malus_sylvestris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Malus_sylvestris_005.JPG/330px-Malus_sylvestris_005.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Maguillo_24J_01.jpg/330px-Maguillo_24J_01.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Malus_sylvestris",
    "gbif": "https://www.gbif.org/species/3001509",
    "extract": {
      "en": "Malus sylvestris, the European crab apple, also known as the European wild apple or simply the crab apple, is a species of the genus Malus. Its scientific name means \"forest apple\", reflecting its habitat. It is native to western Eurasia.",
      "es": "El manzano silvestre o manzano silvestre europeo es una de las especies del género Malus originario de la Europa central. Su nombre científico significa \"manzana del bosque\". En el pasado se pensó que pudiera ser un antepasado importante del manzano de cultivo, sin embargo ahora se sabe que aquél proviene principalmente de la especie Malus sieversii de Asia central. Por otra parte, estudios genéticos recientes confirman que M. sylvestris ha contribuido de manera secundaria, pero significativa, al genoma del manzano de cultivo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 152
      },
      "ifn3": {
        "count": 75
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
    "isGenus": 1,
    "scientificName": {
      "la": "Prunus"
    },
    "vulgarName": [
      {
        "es": "Prunus"
      },
      {
        "de": "Prunus"
      },
      {
        "fr": "Prunus"
      },
      {
        "pt": "Prunus"
      },
      {
        "en": "Prunus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q190545",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus",
      "es": "https://es.wikipedia.org/wiki/Prunus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg/330px-Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Almendro.jpg/330px-Almendro.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus",
    "gbif": "https://www.gbif.org/species/3020559",
    "extract": {
      "en": "Prunus is a genus of flowering trees and shrubs from the family Rosaceae, with about 340 accepted species that include peaches and nectarines, apricots, plums, cherries and almonds. The genus has a cosmopolitan distribution, being native to the temperate regions of North America, the neotropics of South America, and temperate and tropical regions of Eurasia and Africa.",
      "es": "Prunus es un género de árboles y arbustos de la familia Rosaceae, que incluye varias especies cultivadas por sus frutos, como el ciruelo, el cerezo, el melocotonero o duraznero, el albaricoquero o damasco y el almendro. De los 700 taxones descritos, aproximadamente 100 son válidos y aceptados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus"
    ],
    "nplots": {
      "ifn2": {
        "count": 152
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus"
    },
    "vulgarName": [
      {
        "es": "Prunus"
      },
      {
        "de": "Prunus"
      },
      {
        "fr": "Prunus"
      },
      {
        "pt": "Prunus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q190545",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus",
      "es": "https://es.wikipedia.org/wiki/Prunus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg/330px-Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Almendro.jpg/330px-Almendro.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus",
    "gbif": "https://www.gbif.org/species/3020559",
    "extract": {
      "en": "Prunus is a genus of flowering trees and shrubs from the family Rosaceae, with about 340 accepted species that include peaches and nectarines, apricots, plums, cherries and almonds. The genus has a cosmopolitan distribution, being native to the temperate regions of North America, the neotropics of South America, and temperate and tropical regions of Eurasia and Africa.",
      "es": "Prunus es un género de árboles y arbustos de la familia Rosaceae, que incluye varias especies cultivadas por sus frutos, como el ciruelo, el cerezo, el melocotonero o duraznero, el albaricoquero o damasco y el almendro. De los 700 taxones descritos, aproximadamente 100 son válidos y aceptados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 152
      },
      "ifn3": {
        "count": 75
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus"
    },
    "vulgarName": [
      {
        "es": "Prunus"
      },
      {
        "de": "Prunus"
      },
      {
        "fr": "Prunus"
      },
      {
        "pt": "Prunus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q190545",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus",
      "es": "https://es.wikipedia.org/wiki/Prunus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg/330px-Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Almendro.jpg/330px-Almendro.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus",
    "gbif": "https://www.gbif.org/species/3020559",
    "extract": {
      "en": "Prunus is a genus of flowering trees and shrubs from the family Rosaceae, with about 340 accepted species that include peaches and nectarines, apricots, plums, cherries and almonds. The genus has a cosmopolitan distribution, being native to the temperate regions of North America, the neotropics of South America, and temperate and tropical regions of Eurasia and Africa.",
      "es": "Prunus es un género de árboles y arbustos de la familia Rosaceae, que incluye varias especies cultivadas por sus frutos, como el ciruelo, el cerezo, el melocotonero o duraznero, el albaricoquero o damasco y el almendro. De los 700 taxones descritos, aproximadamente 100 son válidos y aceptados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus spinosa"
    },
    "vulgarName": [
      {
        "en": "Blackthorn"
      },
      {
        "en": "Sloe"
      },
      {
        "es": "Espino negro"
      },
      {
        "de": "Schlehdorn"
      },
      {
        "fr": "Prunellier"
      },
      {
        "pt": "Prunus spinosa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q129018",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_spinosa",
      "es": "https://es.wikipedia.org/wiki/Prunus_spinosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Closeup_of_blackthorn_aka_sloe_aka_prunus_spinosa_sweden_20050924.jpg/330px-Closeup_of_blackthorn_aka_sloe_aka_prunus_spinosa_sweden_20050924.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Prunus_spinosa_range.svg/langes-330px-Prunus_spinosa_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_spinosa",
    "gbif": "https://www.gbif.org/species/3023221",
    "extract": {
      "en": "Prunus spinosa, called blackthorn or sloe, is a species of flowering plant in the rose family, Rosaceae. It is native to Europe and West Asia, and has been naturalized in parts of North America.",
      "es": "El endrino, es una especie de arbusto de la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus avium"
    },
    "vulgarName": [
      {
        "en": "Wild cherry"
      },
      {
        "es": "Cerezo silvestre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165137",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_avium",
      "es": "https://es.wikipedia.org/wiki/Prunus_avium"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Prunus_avium_fruit.jpg/330px-Prunus_avium_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Prunus_avium_range.svg/langes-330px-Prunus_avium_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_avium",
    "gbif": "https://www.gbif.org/species/3020791",
    "extract": {
      "en": "Prunus avium, commonly called wild cherry, sweet cherry or gean, is a species of cherry, a flowering plant in the rose family, Rosaceae. It is native to western Eurasia and naturalized elsewhere. It is an ancestor of P. cerasus.",
      "es": "Prunus avium, llamado comúnmente cerezo silvestre, cerezo dulce o cerezo de monte, es una especie de cerezo nativo de Europa y el occidente asiático, del cual se derivan la gran mayoría de los cultivares comerciales de cereza. Es un frutal apreciado en la cuenca mediterránea desde la Edad Antigua; griegos y romanos lo difundieron extensamente. Hoy se cultiva en buena parte de las regiones templadas del mundo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Portugal laurel"
      },
      {
        "es": "Hija"
      },
      {
        "es": "Loro"
      },
      {
        "de": "Portugiesischer Kirschlorbeer"
      },
      {
        "fr": "Laurier du Portugal"
      },
      {
        "pt": "Prunus lusitanica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1969110",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Prunus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Prunus-lusitanica-fruits.JPG/330px-Prunus-lusitanica-fruits.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_lusitanica",
    "gbif": "https://www.gbif.org/species/3020871",
    "extract": {
      "en": "Prunus lusitanica, the Portuguese laurel cherry or Portugal laurel, is a species of flowering plant in the rose family Rosaceae, native to the Iberian Peninsula, Morocco, the Macaronesian archipelagos, and the French Basque Country.",
      "es": "Prunus lusitanica, el lauroceraso de Portugal, laurel portugués, loro o hija, es una planta leñosa arbórea del género Prunus, nativa del sudoeste de Francia, península ibérica, Macaronesia y Marruecos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus padus"
    },
    "vulgarName": [
      {
        "en": "Hackberry"
      },
      {
        "en": "Bird cherry"
      },
      {
        "en": "Hagberry"
      },
      {
        "en": "Mayday tree"
      },
      {
        "es": "Cerezo de racimos"
      },
      {
        "de": "Gewöhnliche Traubenkirsche"
      },
      {
        "fr": "Prunus padus"
      },
      {
        "pt": "Prunus padus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165424",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_padus",
      "es": "https://es.wikipedia.org/wiki/Prunus_padus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Vogelkers_bloesem.jpg/330px-Vogelkers_bloesem.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Prunus_padus_habitat.jpg/330px-Prunus_padus_habitat.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_padus",
    "gbif": "https://www.gbif.org/species/3021037",
    "extract": {
      "en": "Prunus padus, known as bird cherry, hackberry, hagberry, or Mayday tree, is a flowering plant in the rose family. It is a species of cherry, a deciduous small tree or large shrub up to 16 metres (52 ft) tall. It is the type species of the subgenus Padus, which have flowers in racemes. It is native to northern Europe and northern and northeast Asia and is grown as an ornamental in North America.",
      "es": "El cerezo de racimos o cerezo aliso es una especie de árbol natural de Europa y que pertenece a la familia de las rosáceas. Crece en terrenos ácidos en los bosques húmedos. Otros nombres comunes son árbol de santa Lucía, cerisuela y cerezo pado."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Prunus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 75
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species95",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus"
    },
    "vulgarName": [
      {
        "es": "Prunus"
      },
      {
        "de": "Prunus"
      },
      {
        "fr": "Prunus"
      },
      {
        "pt": "Prunus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q190545",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus",
      "es": "https://es.wikipedia.org/wiki/Prunus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg/330px-Fr%C3%BChling_bl%C3%BChender_Kirschenbaum.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Almendro.jpg/330px-Almendro.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus",
    "gbif": "https://www.gbif.org/species/3020559",
    "extract": {
      "en": "Prunus is a genus of flowering trees and shrubs from the family Rosaceae, with about 340 accepted species that include peaches and nectarines, apricots, plums, cherries and almonds. The genus has a cosmopolitan distribution, being native to the temperate regions of North America, the neotropics of South America, and temperate and tropical regions of Eurasia and Africa.",
      "es": "Prunus es un género de árboles y arbustos de la familia Rosaceae, que incluye varias especies cultivadas por sus frutos, como el ciruelo, el cerezo, el melocotonero o duraznero, el albaricoquero o damasco y el almendro. De los 700 taxones descritos, aproximadamente 100 son válidos y aceptados."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species395"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusAvium",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus avium"
    },
    "vulgarName": [
      {
        "en": "Wild cherry"
      },
      {
        "es": "Cerezo silvestre"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165137",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_avium",
      "es": "https://es.wikipedia.org/wiki/Prunus_avium"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Prunus_avium_fruit.jpg/330px-Prunus_avium_fruit.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Prunus_avium_range.svg/langes-330px-Prunus_avium_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_avium",
    "gbif": "https://www.gbif.org/species/3020791",
    "extract": {
      "en": "Prunus avium, commonly called wild cherry, sweet cherry or gean, is a species of cherry, a flowering plant in the rose family, Rosaceae. It is native to western Eurasia and naturalized elsewhere. It is an ancestor of P. cerasus.",
      "es": "Prunus avium, llamado comúnmente cerezo silvestre, cerezo dulce o cerezo de monte, es una especie de cerezo nativo de Europa y el occidente asiático, del cual se derivan la gran mayoría de los cultivares comerciales de cereza. Es un frutal apreciado en la cuenca mediterránea desde la Edad Antigua; griegos y romanos lo difundieron extensamente. Hoy se cultiva en buena parte de las regiones templadas del mundo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species495"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusLusitanica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus lusitanica"
    },
    "vulgarName": [
      {
        "en": "Portugal laurel"
      },
      {
        "es": "Hija"
      },
      {
        "es": "Loro"
      },
      {
        "de": "Portugiesischer Kirschlorbeer"
      },
      {
        "fr": "Laurier du Portugal"
      },
      {
        "pt": "Prunus lusitanica"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1969110",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_lusitanica",
      "es": "https://es.wikipedia.org/wiki/Prunus_lusitanica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Prunus-lusitanica-fruits.JPG/330px-Prunus-lusitanica-fruits.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_lusitanica",
    "gbif": "https://www.gbif.org/species/3020871",
    "extract": {
      "en": "Prunus lusitanica, the Portuguese laurel cherry or Portugal laurel, is a species of flowering plant in the rose family Rosaceae, native to the Iberian Peninsula, Morocco, the Macaronesian archipelagos, and the French Basque Country.",
      "es": "Prunus lusitanica, el lauroceraso de Portugal, laurel portugués, loro o hija, es una planta leñosa arbórea del género Prunus, nativa del sudoeste de Francia, península ibérica, Macaronesia y Marruecos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species595"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusPadus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus padus"
    },
    "vulgarName": [
      {
        "en": "Hackberry"
      },
      {
        "en": "Bird cherry"
      },
      {
        "en": "Hagberry"
      },
      {
        "en": "Mayday tree"
      },
      {
        "es": "Cerezo de racimos"
      },
      {
        "de": "Gewöhnliche Traubenkirsche"
      },
      {
        "fr": "Prunus padus"
      },
      {
        "pt": "Prunus padus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q165424",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_padus",
      "es": "https://es.wikipedia.org/wiki/Prunus_padus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Vogelkers_bloesem.jpg/330px-Vogelkers_bloesem.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Prunus_padus_habitat.jpg/330px-Prunus_padus_habitat.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_padus",
    "gbif": "https://www.gbif.org/species/3021037",
    "extract": {
      "en": "Prunus padus, known as bird cherry, hackberry, hagberry, or Mayday tree, is a flowering plant in the rose family. It is a species of cherry, a deciduous small tree or large shrub up to 16 metres (52 ft) tall. It is the type species of the subgenus Padus, which have flowers in racemes. It is native to northern Europe and northern and northeast Asia and is grown as an ornamental in North America.",
      "es": "El cerezo de racimos o cerezo aliso es una especie de árbol natural de Europa y que pertenece a la familia de las rosáceas. Crece en terrenos ácidos en los bosques húmedos. Otros nombres comunes son árbol de santa Lucía, cerisuela y cerezo pado."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species295"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus494",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PrunusSpinosa",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Prunus spinosa"
    },
    "vulgarName": [
      {
        "en": "Blackthorn"
      },
      {
        "en": "Sloe"
      },
      {
        "es": "Espino negro"
      },
      {
        "de": "Schlehdorn"
      },
      {
        "fr": "Prunellier"
      },
      {
        "pt": "Prunus spinosa"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q129018",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Prunus_spinosa",
      "es": "https://es.wikipedia.org/wiki/Prunus_spinosa"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Closeup_of_blackthorn_aka_sloe_aka_prunus_spinosa_sweden_20050924.jpg/330px-Closeup_of_blackthorn_aka_sloe_aka_prunus_spinosa_sweden_20050924.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Prunus_spinosa_range.svg/langes-330px-Prunus_spinosa_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Prunus_spinosa",
    "gbif": "https://www.gbif.org/species/3023221",
    "extract": {
      "en": "Prunus spinosa, called blackthorn or sloe, is a species of flowering plant in the rose family, Rosaceae. It is native to Europe and West Asia, and has been naturalized in parts of North America.",
      "es": "El endrino, es una especie de arbusto de la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 7
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
    "isGenus": 1,
    "scientificName": {
      "la": "Pyrus"
    },
    "vulgarName": [
      {
        "en": "Pear trees"
      },
      {
        "es": "Perales"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q434",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pear",
      "es": "https://es.wikipedia.org/wiki/Pyrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pears.jpg/330px-Pears.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Pyrus_communis.jpg/330px-Pyrus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pyrus",
    "gbif": "https://www.gbif.org/species/2986532",
    "extract": {
      "en": "Pears are a genus of trees, Pyrus, in the family Rosaceae, that bear an edible apple-like fruit of the same name. Several species of pears are cultivated for their fruit and juices, while others are grown as ornamental flowering trees.",
      "es": "Los perales (Pyrus) son un género de árboles frutales perteneciente a la familia de las rosáceas, la misma que el manzano. El género tiene alrededor de 30 especies con frutos carnosos. Su cultivo está muy extendido, principalmente para la obtención del fruto, llamado pera. Es originario de la zona templada de Europa y Asia. A lo largo de los siglos se han ido seleccionando variedades a partir de los perales silvestres y las especies de perales asiáticos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 7
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pyrus"
    },
    "vulgarName": [
      {
        "en": "Pear tree"
      },
      {
        "es": "Peral silvestre"
      },
      {
        "de": "Birnen"
      },
      {
        "fr": "Pyrus"
      },
      {
        "pt": "Pera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q434",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pear",
      "es": "https://es.wikipedia.org/wiki/Pyrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pears.jpg/330px-Pears.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Pyrus_communis.jpg/330px-Pyrus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pyrus",
    "gbif": "https://www.gbif.org/species/2986532",
    "extract": {
      "en": "Pears are a genus of trees, Pyrus, in the family Rosaceae, that bear an edible apple-like fruit of the same name. Several species of pears are cultivated for their fruit and juices, while others are grown as ornamental flowering trees.",
      "es": "Los perales (Pyrus) son un género de árboles frutales perteneciente a la familia de las rosáceas, la misma que el manzano. El género tiene alrededor de 30 especies con frutos carnosos. Su cultivo está muy extendido, principalmente para la obtención del fruto, llamado pera. Es originario de la zona templada de Europa y Asia. A lo largo de los siglos se han ido seleccionando variedades a partir de los perales silvestres y las especies de perales asiáticos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 7
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pyrus"
    },
    "vulgarName": [
      {
        "en": "Pear tree"
      },
      {
        "es": "Peral silvestre"
      },
      {
        "de": "Birnen"
      },
      {
        "fr": "Pyrus"
      },
      {
        "pt": "Pera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q434",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pear",
      "es": "https://es.wikipedia.org/wiki/Pyrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pears.jpg/330px-Pears.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Pyrus_communis.jpg/330px-Pyrus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pyrus",
    "gbif": "https://www.gbif.org/species/2986532",
    "extract": {
      "en": "Pears are a genus of trees, Pyrus, in the family Rosaceae, that bear an edible apple-like fruit of the same name. Several species of pears are cultivated for their fruit and juices, while others are grown as ornamental flowering trees.",
      "es": "Los perales (Pyrus) son un género de árboles frutales perteneciente a la familia de las rosáceas, la misma que el manzano. El género tiene alrededor de 30 especies con frutos carnosos. Su cultivo está muy extendido, principalmente para la obtención del fruto, llamado pera. Es originario de la zona templada de Europa y Asia. A lo largo de los siglos se han ido seleccionando variedades a partir de los perales silvestres y las especies de perales asiáticos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus495",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Pyrus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species16",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pyrus"
    },
    "vulgarName": [
      {
        "en": "Pear tree"
      },
      {
        "es": "Peral silvestre"
      },
      {
        "de": "Birnen"
      },
      {
        "fr": "Pyrus"
      },
      {
        "pt": "Pera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q434",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pear",
      "es": "https://es.wikipedia.org/wiki/Pyrus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pears.jpg/330px-Pears.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Pyrus_communis.jpg/330px-Pyrus_communis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pyrus",
    "gbif": "https://www.gbif.org/species/2986532",
    "extract": {
      "en": "Pears are a genus of trees, Pyrus, in the family Rosaceae, that bear an edible apple-like fruit of the same name. Several species of pears are cultivated for their fruit and juices, while others are grown as ornamental flowering trees.",
      "es": "Los perales (Pyrus) son un género de árboles frutales perteneciente a la familia de las rosáceas, la misma que el manzano. El género tiene alrededor de 30 especies con frutos carnosos. Su cultivo está muy extendido, principalmente para la obtención del fruto, llamado pera. Es originario de la zona templada de Europa y Asia. A lo largo de los siglos se han ido seleccionando variedades a partir de los perales silvestres y las especies de perales asiáticos."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 437
      },
      "ifn3": {
        "count": 198
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
    "isGenus": 1,
    "scientificName": {
      "la": "Sorbus"
    },
    "vulgarName": [
      {
        "de": "Mehlbeeren"
      },
      {
        "fr": "Sorbus"
      },
      {
        "pt": "Sorbus"
      },
      {
        "es": "Serbales y mostajos"
      },
      {
        "en": "Whitebeams"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157964",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus",
      "es": "https://es.wikipedia.org/wiki/Sorbus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Sorbus_aucuparia_aka_rowan.jpg/330px-Sorbus_aucuparia_aka_rowan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus",
    "gbif": "https://www.gbif.org/species/3012146",
    "extract": {
      "en": "Sorbus is a genus of over 100 species of trees and shrubs in the rose family, Rosaceae. Species of Sorbus (s.str.) are commonly known as rowan or mountain-ash. The genus used to include species commonly known as whitebeam, chequer tree and service tree that are now classified in other genera. The genus Sorbus, as currently circumscribed, includes only the pinnate leaved species of former subgenus Sorbus.",
      "es": "Sorbus es un género de la familia de las rosáceas que abarca entre 100 y 200 especies de árboles y arbustos, comúnmente denominados serbales. Se suelen usar en parques y jardines como planta ornamental y sus frutos se utilizan en la fabricación del vodka ruso."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus"
    ],
    "nplots": {
      "ifn2": {
        "count": 437
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus"
    },
    "vulgarName": [
      {
        "en": "Mountain-ash"
      },
      {
        "en": "Rowan"
      },
      {
        "en": "Service tree"
      },
      {
        "en": "Whitebeam"
      },
      {
        "es": "Sorbus"
      },
      {
        "de": "Mehlbeeren"
      },
      {
        "fr": "Sorbus"
      },
      {
        "pt": "Sorbus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157964",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus",
      "es": "https://es.wikipedia.org/wiki/Sorbus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Sorbus_aucuparia_aka_rowan.jpg/330px-Sorbus_aucuparia_aka_rowan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus",
    "gbif": "https://www.gbif.org/species/3012146",
    "extract": {
      "en": "Sorbus is a genus of over 100 species of trees and shrubs in the rose family, Rosaceae. Species of Sorbus (s.str.) are commonly known as rowan or mountain-ash. The genus used to include species commonly known as whitebeam, chequer tree and service tree that are now classified in other genera. The genus Sorbus, as currently circumscribed, includes only the pinnate leaved species of former subgenus Sorbus.",
      "es": "Sorbus es un género de la familia de las rosáceas que abarca entre 100 y 200 especies de árboles y arbustos, comúnmente denominados serbales. Se suelen usar en parques y jardines como planta ornamental y sus frutos se utilizan en la fabricación del vodka ruso."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 437
      },
      "ifn3": {
        "count": 198
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus"
    },
    "vulgarName": [
      {
        "en": "Mountain-ash"
      },
      {
        "en": "Rowan"
      },
      {
        "en": "Service tree"
      },
      {
        "en": "Whitebeam"
      },
      {
        "es": "Sorbus"
      },
      {
        "de": "Mehlbeeren"
      },
      {
        "fr": "Sorbus"
      },
      {
        "pt": "Sorbus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157964",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus",
      "es": "https://es.wikipedia.org/wiki/Sorbus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Sorbus_aucuparia_aka_rowan.jpg/330px-Sorbus_aucuparia_aka_rowan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus",
    "gbif": "https://www.gbif.org/species/3012146",
    "extract": {
      "en": "Sorbus is a genus of over 100 species of trees and shrubs in the rose family, Rosaceae. Species of Sorbus (s.str.) are commonly known as rowan or mountain-ash. The genus used to include species commonly known as whitebeam, chequer tree and service tree that are now classified in other genera. The genus Sorbus, as currently circumscribed, includes only the pinnate leaved species of former subgenus Sorbus.",
      "es": "Sorbus es un género de la familia de las rosáceas que abarca entre 100 y 200 especies de árboles y arbustos, comúnmente denominados serbales. Se suelen usar en parques y jardines como planta ornamental y sus frutos se utilizan en la fabricación del vodka ruso."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus aria"
    },
    "vulgarName": [
      {
        "en": "Common whitebeam"
      },
      {
        "es": "Mostajo"
      },
      {
        "de": "Echte Mehlbeere"
      },
      {
        "fr": "Sorbus aria"
      },
      {
        "pt": "Sorbus aria"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157960",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_aria",
      "es": "https://es.wikipedia.org/wiki/Sorbus_aria"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Sorbus_aria-3420.jpg/330px-Sorbus_aria-3420.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_aria",
    "gbif": "https://www.gbif.org/species/3012680",
    "extract": {
      "en": "Aria edulis, the whitebeam or common whitebeam, is a species of deciduous tree in the family Rosaceae.",
      "es": "Sorbus aria, mostajo, serbal blanco, mostellar, mostajo común o blanco es un árbol de hasta 15 m de alto, de la familia de las rosáceas, propio de casi toda Europa, norte de África y Asia Menor."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus aucuparia"
    },
    "vulgarName": [
      {
        "en": "Rowan"
      },
      {
        "es": "Serbal de cazadores"
      },
      {
        "de": "Vogelbeere"
      },
      {
        "fr": "Sorbus aucuparia"
      },
      {
        "pt": "Sorbus aucuparia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146198",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_aucuparia",
      "es": "https://es.wikipedia.org/wiki/Sorbus_aucuparia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Rowan_tree_20081002b.jpg/330px-Rowan_tree_20081002b.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Ebereschebaum.jpg/330px-Ebereschebaum.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_aucuparia",
    "gbif": "https://www.gbif.org/species/3012167",
    "extract": {
      "en": "Sorbus aucuparia, commonly called rowan and mountain-ash, is a species of deciduous tree or shrub in the rose family.",
      "es": "Sorbus aucuparia, comúnmente llamado serbal de los cazadores, cerollo, acerollo o azarollo, es un árbol de tamaño mediano, perteneciente a la familia de las rosáceas. Se distribuye por toda Europa, de Islandia a Rusia y por la península ibérica. Es tolerante al frío y se puede encontrar en altitudes elevadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus domestica"
    },
    "vulgarName": [
      {
        "en": "Service tree"
      },
      {
        "en": "Sorb tree"
      },
      {
        "es": "Serbal común"
      },
      {
        "de": "Speierling"
      },
      {
        "fr": "Cormier"
      },
      {
        "pt": "Sorva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159558",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cormus_domestica",
      "es": "https://es.wikipedia.org/wiki/Sorbus_domestica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Sorbus_domestica_FruitsLeaves_BotGardBln0906a.JPG/330px-Sorbus_domestica_FruitsLeaves_BotGardBln0906a.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Sorbus_domestica_range.svg/langes-330px-Sorbus_domestica_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_domestica",
    "gbif": "https://www.gbif.org/species/3013206",
    "extract": {
      "en": "Cormus domestica, commonly known as service tree or sorb tree, is a species of tree native to western, central and southern Europe, northwest Africa, and southwest Asia. It may be called true service tree, to distinguish it from the wild service tree. It is the only species in the monotypic genus Cormus.",
      "es": "Sorbus domestica, el serbal común, azarollo, sorbo, sorbeira, zurbal, la silba, jerbo o jerbal es un árbol de hoja caduca que produce un fruto comestible llamado serba, zurba o jerba."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus torminalis"
    },
    "vulgarName": [
      {
        "en": "Checker tree"
      },
      {
        "en": "Chequers"
      },
      {
        "en": "Wild service tree"
      },
      {
        "es": "Serbal torminal"
      },
      {
        "de": "Elsbeere"
      },
      {
        "fr": "Sorbus torminalis"
      },
      {
        "pt": "Sorbus torminalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147459",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_torminalis",
      "es": "https://es.wikipedia.org/wiki/Sorbus_torminalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Sorbus_torminalis_fruits-001.jpg/330px-Sorbus_torminalis_fruits-001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Sorbus_torminalis_Trunk_and_canopy.jpg/330px-Sorbus_torminalis_Trunk_and_canopy.jpg"
    ],
    "gbif": "https://www.gbif.org/species/3012567",
    "extract": {
      "en": "Torminalis is a genus of plants in the rose family, Rosaceae. The genus was formerly included within the genus Sorbus as the section Torminaria, but the simple-leafed species traditionally classified in Sorbus are now considered to form a separate monophyletic group. It is monotypic, being represented by the single species Torminalis glaberrima, commonly known as wild service tree, chequers, and checker tree. This tree is native to Europe, parts of northern Africa and western Asia.",
      "es": "El sorbo silvestre, serbal silvestre o mostajo de perucos es un árbol de la familia de las rosáceas, distribuido por el oeste, centro y sur de Europa, norte de África y oeste de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus latifolia"
    },
    "vulgarName": [
      {
        "en": "Broad-leaved whitebeam"
      },
      {
        "es": "Serbal de hoja ancha"
      },
      {
        "de": "Breitblättrige Mehlbeere"
      },
      {
        "fr": "Sorbus latifolia"
      },
      {
        "pt": "Sorbus latifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163774",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Karpatiosorbus_latifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Sorbus_latifolia_Morton_261-93-5.jpg/330px-Sorbus_latifolia_Morton_261-93-5.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_latifolia",
    "gbif": "https://www.gbif.org/species/3012426",
    "extract": {
      "en": "Karpatiosorbus latifolia is a species of whitebeam that is endemic to the area around Fontainebleau, south of Paris in France, where it has been known since the early eighteenth century."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus chamaemespilus"
    },
    "vulgarName": [
      {
        "en": "Dwarf whitebeam"
      },
      {
        "en": "False medlar"
      },
      {
        "es": "Serbal chame"
      },
      {
        "de": "Zwerg-Mehlbeere"
      },
      {
        "fr": "Sorbus chamaemespilus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163546",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaemespilus",
      "es": "https://es.wikipedia.org/wiki/Sorbus_chamaemespilus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chamaemespilus_alpinus_%2813971826398%29.jpg/330px-Chamaemespilus_alpinus_%2813971826398%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Sorbus-chamaemespilus-habit.JPG/330px-Sorbus-chamaemespilus-habit.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_chamaemespilus",
    "gbif": "https://www.gbif.org/species/3012470",
    "extract": {
      "en": "Chamaemespilus is a genus of shrubs in the family Rosaceae. It is monotypic, being represented by the single species Chamaemespilus alpina, commonly known as false medlar or dwarf whitebeam. It is native to the mountains of central and southern Europe, from the Pyrenees east through the Alps to the Carpathians and the Balkans, growing at elevations of up to 2500 m.",
      "es": "Sorbus chamaemespilus, es un arbusto perteneciente a la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Sorbus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 198
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species78",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus"
    },
    "vulgarName": [
      {
        "en": "Mountain-ash"
      },
      {
        "en": "Rowan"
      },
      {
        "en": "Service tree"
      },
      {
        "en": "Whitebeam"
      },
      {
        "es": "Sorbus"
      },
      {
        "de": "Mehlbeeren"
      },
      {
        "fr": "Sorbus"
      },
      {
        "pt": "Sorbus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157964",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus",
      "es": "https://es.wikipedia.org/wiki/Sorbus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Sorbus_aucuparia_aka_rowan.jpg/330px-Sorbus_aucuparia_aka_rowan.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus",
    "gbif": "https://www.gbif.org/species/3012146",
    "extract": {
      "en": "Sorbus is a genus of over 100 species of trees and shrubs in the rose family, Rosaceae. Species of Sorbus (s.str.) are commonly known as rowan or mountain-ash. The genus used to include species commonly known as whitebeam, chequer tree and service tree that are now classified in other genera. The genus Sorbus, as currently circumscribed, includes only the pinnate leaved species of former subgenus Sorbus.",
      "es": "Sorbus es un género de la familia de las rosáceas que abarca entre 100 y 200 especies de árboles y arbustos, comúnmente denominados serbales. Se suelen usar en parques y jardines como planta ornamental y sus frutos se utilizan en la fabricación del vodka ruso."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species278"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAria",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus aria"
    },
    "vulgarName": [
      {
        "en": "Common whitebeam"
      },
      {
        "es": "Mostajo"
      },
      {
        "de": "Echte Mehlbeere"
      },
      {
        "fr": "Sorbus aria"
      },
      {
        "pt": "Sorbus aria"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157960",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_aria",
      "es": "https://es.wikipedia.org/wiki/Sorbus_aria"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Sorbus_aria-3420.jpg/330px-Sorbus_aria-3420.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Weilburg_-_Tiergarten_-_Mehlbeere.jpg/330px-Weilburg_-_Tiergarten_-_Mehlbeere.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_aria",
    "gbif": "https://www.gbif.org/species/3012680",
    "extract": {
      "en": "Aria edulis, the whitebeam or common whitebeam, is a species of deciduous tree in the family Rosaceae.",
      "es": "Sorbus aria, mostajo, serbal blanco, mostellar, mostajo común o blanco es un árbol de hasta 15 m de alto, de la familia de las rosáceas, propio de casi toda Europa, norte de África y Asia Menor."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species378"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusAucuparia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus aucuparia"
    },
    "vulgarName": [
      {
        "en": "Rowan"
      },
      {
        "es": "Serbal de cazadores"
      },
      {
        "de": "Vogelbeere"
      },
      {
        "fr": "Sorbus aucuparia"
      },
      {
        "pt": "Sorbus aucuparia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q146198",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_aucuparia",
      "es": "https://es.wikipedia.org/wiki/Sorbus_aucuparia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Rowan_tree_20081002b.jpg/330px-Rowan_tree_20081002b.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Ebereschebaum.jpg/330px-Ebereschebaum.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_aucuparia",
    "gbif": "https://www.gbif.org/species/3012167",
    "extract": {
      "en": "Sorbus aucuparia, commonly called rowan and mountain-ash, is a species of deciduous tree or shrub in the rose family.",
      "es": "Sorbus aucuparia, comúnmente llamado serbal de los cazadores, cerollo, acerollo o azarollo, es un árbol de tamaño mediano, perteneciente a la familia de las rosáceas. Se distribuye por toda Europa, de Islandia a Rusia y por la península ibérica. Es tolerante al frío y se puede encontrar en altitudes elevadas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species778"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusChamaemespilus",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus chamaemespilus"
    },
    "vulgarName": [
      {
        "en": "Dwarf whitebeam"
      },
      {
        "en": "False medlar"
      },
      {
        "es": "Serbal chame"
      },
      {
        "de": "Zwerg-Mehlbeere"
      },
      {
        "fr": "Sorbus chamaemespilus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163546",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaemespilus",
      "es": "https://es.wikipedia.org/wiki/Sorbus_chamaemespilus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Chamaemespilus_alpinus_%2813971826398%29.jpg/330px-Chamaemespilus_alpinus_%2813971826398%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Sorbus-chamaemespilus-habit.JPG/330px-Sorbus-chamaemespilus-habit.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_chamaemespilus",
    "gbif": "https://www.gbif.org/species/3012470",
    "extract": {
      "en": "Chamaemespilus is a genus of shrubs in the family Rosaceae. It is monotypic, being represented by the single species Chamaemespilus alpina, commonly known as false medlar or dwarf whitebeam. It is native to the mountains of central and southern Europe, from the Pyrenees east through the Alps to the Carpathians and the Balkans, growing at elevations of up to 2500 m.",
      "es": "Sorbus chamaemespilus, es un arbusto perteneciente a la familia de las rosáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species478"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusDomestica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus domestica"
    },
    "vulgarName": [
      {
        "en": "Service tree"
      },
      {
        "en": "Sorb tree"
      },
      {
        "es": "Serbal común"
      },
      {
        "de": "Speierling"
      },
      {
        "fr": "Cormier"
      },
      {
        "pt": "Sorva"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159558",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Cormus_domestica",
      "es": "https://es.wikipedia.org/wiki/Sorbus_domestica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Sorbus_domestica_FruitsLeaves_BotGardBln0906a.JPG/330px-Sorbus_domestica_FruitsLeaves_BotGardBln0906a.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Sorbus_domestica_range.svg/langes-330px-Sorbus_domestica_range.svg.png"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_domestica",
    "gbif": "https://www.gbif.org/species/3013206",
    "extract": {
      "en": "Cormus domestica, commonly known as service tree or sorb tree, is a species of tree native to western, central and southern Europe, northwest Africa, and southwest Asia. It may be called true service tree, to distinguish it from the wild service tree. It is the only species in the monotypic genus Cormus.",
      "es": "Sorbus domestica, el serbal común, azarollo, sorbo, sorbeira, zurbal, la silba, jerbo o jerbal es un árbol de hoja caduca que produce un fruto comestible llamado serba, zurba o jerba."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species678"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusLatifolia",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus latifolia"
    },
    "vulgarName": [
      {
        "en": "Broad-leaved whitebeam"
      },
      {
        "es": "Serbal de hoja ancha"
      },
      {
        "de": "Breitblättrige Mehlbeere"
      },
      {
        "fr": "Sorbus latifolia"
      },
      {
        "pt": "Sorbus latifolia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q163774",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Karpatiosorbus_latifolia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Sorbus_latifolia_Morton_261-93-5.jpg/330px-Sorbus_latifolia_Morton_261-93-5.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sorbus_latifolia",
    "gbif": "https://www.gbif.org/species/3012426",
    "extract": {
      "en": "Karpatiosorbus latifolia is a species of whitebeam that is endemic to the area around Fontainebleau, south of Paris in France, where it has been known since the early eighteenth century."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species578"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus496",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family49",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SorbusTorminalis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sorbus torminalis"
    },
    "vulgarName": [
      {
        "en": "Checker tree"
      },
      {
        "en": "Chequers"
      },
      {
        "en": "Wild service tree"
      },
      {
        "es": "Serbal torminal"
      },
      {
        "de": "Elsbeere"
      },
      {
        "fr": "Sorbus torminalis"
      },
      {
        "pt": "Sorbus torminalis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147459",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sorbus_torminalis",
      "es": "https://es.wikipedia.org/wiki/Sorbus_torminalis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Sorbus_torminalis_fruits-001.jpg/330px-Sorbus_torminalis_fruits-001.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Sorbus_torminalis_Trunk_and_canopy.jpg/330px-Sorbus_torminalis_Trunk_and_canopy.jpg"
    ],
    "gbif": "https://www.gbif.org/species/3012567",
    "extract": {
      "en": "Torminalis is a genus of plants in the rose family, Rosaceae. The genus was formerly included within the genus Sorbus as the section Torminaria, but the simple-leafed species traditionally classified in Sorbus are now considered to form a separate monophyletic group. It is monotypic, being represented by the single species Torminalis glaberrima, commonly known as wild service tree, chequers, and checker tree. This tree is native to Europe, parts of northern Africa and western Asia.",
      "es": "El sorbo silvestre, serbal silvestre o mostajo de perucos es un árbol de la familia de las rosáceas, distribuido por el oeste, centro y sur de Europa, norte de África y oeste de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
    "isGenus": 1,
    "scientificName": {
      "la": "Sideroxylon"
    },
    "vulgarName": [
      {
        "en": "Bully trees"
      },
      {
        "es": "Marmulanos"
      },
      {
        "fr": "Sideroxylon"
      },
      {
        "pt": "Sideroxylon"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1067086",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sideroxylon",
      "es": "https://es.wikipedia.org/wiki/Sideroxylon"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Starr_010330-0568_Sideroxylon_persimile.jpg/330px-Starr_010330-0568_Sideroxylon_persimile.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Sideroxylon_mirmulano_leaves.jpg/330px-Sideroxylon_mirmulano_leaves.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sideroxylon",
    "gbif": "https://www.gbif.org/species/2886817",
    "extract": {
      "en": "Sideroxylon is a genus of trees in the family Sapotaceae described as a genus by Linnaeus in 1753. They are collectively known as bully trees. The generic name is derived from the Greek words σιδηρος (sideros), meaning \"iron\", and ξύλον (xylon), meaning \"wood.\"",
      "es": "Sideroxylon es un género de plantas perteneciente a la familia Sapotaceae. Hay unas 70 especies distribuidas por los Neotrópicos, pero también en África, Madagascar y las islas Mascareñas. La única especie del sur de África es el árbol Sideroxylon inerme, está asociado con árboles de lugares históricos, y son declarados individualmente monumentos nacionales debido a su gran longevidad. El Sideroxylon grandiflorum de Isla Mauricio vivió en simbiosis con el dodo y ha sufrido con su desaparición."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sideroxylon mirmulano"
    },
    "vulgarName": {
      "es": "Marmulan"
    },
    "wikidata": "http://www.wikidata.org/entity/Q17234860",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sideroxylon_canariense",
      "es": "https://es.wikipedia.org/wiki/Sideroxylon_canariense"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Sideroxylon_canariense.jpg/330px-Sideroxylon_canariense.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sideroxylon_canariense",
    "gbif": "https://www.gbif.org/species/4014440",
    "extract": {
      "en": "Sideroxylon canariense is a species of flowering plant in the family Sapotaceae. It It is endemic to the Canary Islands.",
      "es": "Sideroxylon canariense, conocido en castellano como marmulano, es una especie de árbol perennifolio perteneciente a la familia Sapotaceae. Es originario de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sideroxylon mirmulano"
    },
    "vulgarName": {
      "es": "Marmulan"
    },
    "wikidata": "http://www.wikidata.org/entity/Q17234860",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sideroxylon_canariense",
      "es": "https://es.wikipedia.org/wiki/Sideroxylon_canariense"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Sideroxylon_canariense.jpg/330px-Sideroxylon_canariense.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sideroxylon_canariense",
    "gbif": "https://www.gbif.org/species/4014440",
    "extract": {
      "en": "Sideroxylon canariense is a species of flowering plant in the family Sapotaceae. It It is endemic to the Canary Islands.",
      "es": "Sideroxylon canariense, conocido en castellano como marmulano, es una especie de árbol perennifolio perteneciente a la familia Sapotaceae. Es originario de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus501",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family50",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/SideroxylonMirmulano"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species85",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sideroxylon mirmulano"
    },
    "vulgarName": {
      "es": "Marmulan"
    },
    "wikidata": "http://www.wikidata.org/entity/Q17234860",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sideroxylon_canariense",
      "es": "https://es.wikipedia.org/wiki/Sideroxylon_canariense"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Sideroxylon_canariense.jpg/330px-Sideroxylon_canariense.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sideroxylon_canariense",
    "gbif": "https://www.gbif.org/species/4014440",
    "extract": {
      "en": "Sideroxylon canariense is a species of flowering plant in the family Sapotaceae. It It is endemic to the Canary Islands.",
      "es": "Sideroxylon canariense, conocido en castellano como marmulano, es una especie de árbol perennifolio perteneciente a la familia Sapotaceae. Es originario de Macaronesia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
    "isGenus": 1,
    "scientificName": {
      "la": "Ailanthus"
    },
    "vulgarName": [
      {
        "en": "Ailanthus"
      },
      {
        "es": "Ailantos"
      },
      {
        "de": "Götterbäume"
      },
      {
        "fr": "Ailanthus"
      },
      {
        "pt": "Ailanthus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q160580",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ailanthus",
      "es": "https://es.wikipedia.org/wiki/Ailanthus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Ailanthus_altissima1.jpg/330px-Ailanthus_altissima1.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ailanthus",
    "gbif": "https://www.gbif.org/species/3190652",
    "extract": {
      "en": "Ailanthus is a genus of trees belonging to the family Simaroubaceae, in the order Sapindales. The genus is native from East Asia south to northern Australasia. One species, the tree of heaven, is considered a weed or invasive species in some parts of the world.",
      "es": "Ailanthus es un género de plantas con flor perteneciente a la familia Simaroubaceae, en el orden Sapindales. El género es nativo del este de Asia sur y norte de Australasia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ailanthus altissima"
    },
    "vulgarName": [
      {
        "en": "Tree of heaven"
      },
      {
        "es": "Ailanto"
      },
      {
        "de": "Götterbaum"
      },
      {
        "fr": "Ailanthus altissima"
      },
      {
        "pt": "Árvore-do-céu"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159570",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ailanthus_altissima",
      "es": "https://es.wikipedia.org/wiki/Ailanthus_altissima"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg/330px-G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Ailanthus_altissima_Arg.jpg/330px-Ailanthus_altissima_Arg.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ailanthus_altissima",
    "gbif": "https://www.gbif.org/species/3190653",
    "extract": {
      "en": "Ailanthus altissima, commonly known as tree of heaven or ailanthus tree, is a deciduous tree in the quassia family. It is native to northeast, central China, and Taiwan. Unlike other members of the genus Ailanthus, it is found in temperate climates rather than the tropics.",
      "es": "Ailanthus altissima, el ailanto, árbol del cielo, árbol de los dioses, malhuele o falso zumaque, es un árbol ornamental muy utilizado en jardines públicos en el sur de Europa, originario de China. De crecimiento rápido, es muy resistente a la contaminación."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ailanthus altissima"
    },
    "vulgarName": [
      {
        "en": "Tree of heaven"
      },
      {
        "es": "Ailanto"
      },
      {
        "de": "Götterbaum"
      },
      {
        "fr": "Ailanthus altissima"
      },
      {
        "pt": "Árvore-do-céu"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159570",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ailanthus_altissima",
      "es": "https://es.wikipedia.org/wiki/Ailanthus_altissima"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg/330px-G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Ailanthus_altissima_Arg.jpg/330px-Ailanthus_altissima_Arg.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ailanthus_altissima",
    "gbif": "https://www.gbif.org/species/3190653",
    "extract": {
      "en": "Ailanthus altissima, commonly known as tree of heaven or ailanthus tree, is a deciduous tree in the quassia family. It is native to northeast, central China, and Taiwan. Unlike other members of the genus Ailanthus, it is found in temperate climates rather than the tropics.",
      "es": "Ailanthus altissima, el ailanto, árbol del cielo, árbol de los dioses, malhuele o falso zumaque, es un árbol ornamental muy utilizado en jardines públicos en el sur de Europa, originario de China. De crecimiento rápido, es muy resistente a la contaminación."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus511",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family51",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/AilanthusAltissima"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species11",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ailanthus altissima"
    },
    "vulgarName": [
      {
        "en": "Tree of heaven"
      },
      {
        "es": "Ailanto"
      },
      {
        "de": "Götterbaum"
      },
      {
        "fr": "Ailanthus altissima"
      },
      {
        "pt": "Árvore-do-céu"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q159570",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ailanthus_altissima",
      "es": "https://es.wikipedia.org/wiki/Ailanthus_altissima"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg/330px-G%C3%B6tterbaum_%28Ailanthus_altissima%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Ailanthus_altissima_Arg.jpg/330px-Ailanthus_altissima_Arg.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ailanthus_altissima",
    "gbif": "https://www.gbif.org/species/3190653",
    "extract": {
      "en": "Ailanthus altissima, commonly known as tree of heaven or ailanthus tree, is a deciduous tree in the quassia family. It is native to northeast, central China, and Taiwan. Unlike other members of the genus Ailanthus, it is found in temperate climates rather than the tropics.",
      "es": "Ailanthus altissima, el ailanto, árbol del cielo, árbol de los dioses, malhuele o falso zumaque, es un árbol ornamental muy utilizado en jardines públicos en el sur de Europa, originario de China. De crecimiento rápido, es muy resistente a la contaminación."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 20
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
    "isGenus": 1,
    "scientificName": {
      "la": "Tamarix"
    },
    "vulgarName": [
      {
        "de": "Tamarisken"
      },
      {
        "fr": "Tamarix"
      },
      {
        "pt": "Tamarix"
      },
      {
        "en": "Salt cedars"
      },
      {
        "es": "Tarajes"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q164163",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix",
      "es": "https://es.wikipedia.org/wiki/Tamarix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Tamarix_aphylla.jpg/330px-Tamarix_aphylla.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tamarix",
    "gbif": "https://www.gbif.org/species/2874694",
    "extract": {
      "en": "The genus Tamarix is composed of about 50–60 species of flowering plants in the family Tamaricaceae, native to drier areas of Eurasia and Africa. The generic name originated in Latin and may refer to the Tamaris River in Hispania Tarraconensis (Spain).",
      "es": "El género Tamarix comprende 60 spp. de fanerógamas, de la familia Tamaricaceae, nativas de las áreas más secas de Eurasia y África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tamarix"
    },
    "vulgarName": [
      {
        "en": "Salt cedar"
      },
      {
        "en": "Tamarisk"
      },
      {
        "es": "Taraje"
      },
      {
        "de": "Tamarisken"
      },
      {
        "fr": "Tamarix"
      },
      {
        "pt": "Tamarix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q164163",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix",
      "es": "https://es.wikipedia.org/wiki/Tamarix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Tamarix_aphylla.jpg/330px-Tamarix_aphylla.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tamarix",
    "gbif": "https://www.gbif.org/species/2874694",
    "extract": {
      "en": "The genus Tamarix is composed of about 50–60 species of flowering plants in the family Tamaricaceae, native to drier areas of Eurasia and Africa. The generic name originated in Latin and may refer to the Tamaris River in Hispania Tarraconensis (Spain).",
      "es": "El género Tamarix comprende 60 spp. de fanerógamas, de la familia Tamaricaceae, nativas de las áreas más secas de Eurasia y África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn2/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 20
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tamarix"
    },
    "vulgarName": [
      {
        "en": "Salt cedar"
      },
      {
        "en": "Tamarisk"
      },
      {
        "es": "Taraje"
      },
      {
        "de": "Tamarisken"
      },
      {
        "fr": "Tamarix"
      },
      {
        "pt": "Tamarix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q164163",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix",
      "es": "https://es.wikipedia.org/wiki/Tamarix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Tamarix_aphylla.jpg/330px-Tamarix_aphylla.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tamarix",
    "gbif": "https://www.gbif.org/species/2874694",
    "extract": {
      "en": "The genus Tamarix is composed of about 50–60 species of flowering plants in the family Tamaricaceae, native to drier areas of Eurasia and Africa. The generic name originated in Latin and may refer to the Tamaris River in Hispania Tarraconensis (Spain).",
      "es": "El género Tamarix comprende 60 spp. de fanerógamas, de la familia Tamaricaceae, nativas de las áreas más secas de Eurasia y África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tamarix canariensis"
    },
    "vulgarName": [
      {
        "es": "Tarajal"
      },
      {
        "pt": "Tamarix canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5637949",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Tamarix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Tamarix_canariensis_kz5_adj.jpg/330px-Tamarix_canariensis_kz5_adj.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Tamarix_canariensis.JPG/330px-Tamarix_canariensis.JPG"
    ],
    "gbif": "https://www.gbif.org/species/2874701",
    "extract": {
      "en": "Tamarix canariensis is a species of flowering plant in the family Tamaricaceae. It is a shrub or small tree up to 4 m tall. It was previously said to be native to parts of Macaronesia, northern Africa and south-western Europe, but is now considered only to be found in the Canary Islands, the African and European species being Tamarix gallica. It was first described by Carl Ludwig Willdenow in 1816.",
      "es": "Tamarix canariensis, el tarajal, taraje o taray de Canarias, es un pequeño árbol de la familia de las tamaricáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Tamarix"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 20
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species53",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tamarix"
    },
    "vulgarName": [
      {
        "en": "Salt cedar"
      },
      {
        "en": "Tamarisk"
      },
      {
        "es": "Taraje"
      },
      {
        "de": "Tamarisken"
      },
      {
        "fr": "Tamarix"
      },
      {
        "pt": "Tamarix"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q164163",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix",
      "es": "https://es.wikipedia.org/wiki/Tamarix"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Tamarix_aphylla.jpg/330px-Tamarix_aphylla.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tamarix",
    "gbif": "https://www.gbif.org/species/2874694",
    "extract": {
      "en": "The genus Tamarix is composed of about 50–60 species of flowering plants in the family Tamaricaceae, native to drier areas of Eurasia and Africa. The generic name originated in Latin and may refer to the Tamaris River in Hispania Tarraconensis (Spain).",
      "es": "El género Tamarix comprende 60 spp. de fanerógamas, de la familia Tamaricaceae, nativas de las áreas más secas de Eurasia y África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species253"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus521",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family52",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TamarixCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tamarix canariensis"
    },
    "vulgarName": [
      {
        "es": "Tarajal"
      },
      {
        "pt": "Tamarix canariensis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q5637949",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tamarix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Tamarix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Tamarix_canariensis_kz5_adj.jpg/330px-Tamarix_canariensis_kz5_adj.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Tamarix_canariensis.JPG/330px-Tamarix_canariensis.JPG"
    ],
    "gbif": "https://www.gbif.org/species/2874701",
    "extract": {
      "en": "Tamarix canariensis is a species of flowering plant in the family Tamaricaceae. It is a shrub or small tree up to 4 m tall. It was previously said to be native to parts of Macaronesia, northern Africa and south-western Europe, but is now considered only to be found in the Canary Islands, the African and European species being Tamarix gallica. It was first described by Carl Ludwig Willdenow in 1816.",
      "es": "Tamarix canariensis, el tarajal, taraje o taray de Canarias, es un pequeño árbol de la familia de las tamaricáceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixChamaerops",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species69",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phoenix"
    },
    "vulgarName": [
      {
        "en": "Palm tree"
      },
      {
        "es": "Palmera"
      },
      {
        "de": "Dattelpalmen"
      },
      {
        "fr": "Phoenix (palmier)"
      },
      {
        "pt": "Phoenix (género)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27685",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_(plant)",
      "es": "https://es.wikipedia.org/wiki/Phoenix_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Phoenix_dactylifera100_4209.JPG/330px-Phoenix_dactylifera100_4209.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Phoenix_canariensis.jpg/330px-Phoenix_canariensis.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix",
    "gbif": "https://www.gbif.org/species/2732076",
    "extract": {
      "en": "Phoenix is a genus of 14 species of palms, native to an area starting from the Canary Islands in the west, across northern and central Africa, to the extreme southeast of Europe (Crete), and continuing throughout southern Asia, from Anatolia east to southern China and Malaysia. The diverse habitats they occupy include swamps, deserts, and mangrove sea coasts. Most Phoenix species originate in semi-arid regions, but usually occur near high groundwater levels, rivers, or springs. The genus is unusual among members of subfamily Coryphoideae in having pinnate, rather than palmate leaves; tribe Caryoteae also have pinnate or bipinnate leaves.\nThe palms were more numerous and widespread in the past than they are at present. Some Phoenix palms have become naturalised in other parts of the world; in particular, the date palm's long history of cultivation means that escaped plants in the past have long-since become ingrained into the native ecosystems of countries far from its original range in the Middle East.",
      "es": "Phoenix es un género con once especies de plantas con flores perteneciente a la familia de las palmeras (Arecaceae), distribuidas desde Canarias, pasando por el norte de África y el Sur de Asia, hasta el Extremo Oriente. Es el único género de la tribu Phoeniceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/RobiniaPseudacaciaSophoraJaponica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus144",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Sophora japonica"
    },
    "vulgarName": [
      {
        "en": "Japanese pagoda tree"
      },
      {
        "es": "Acacia sofora"
      },
      {
        "de": "Japanischer Schnurbaum"
      },
      {
        "fr": "Styphnolobium japonicum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q10881597"
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
    "isGenus": 1,
    "scientificName": {
      "la": "Gleditsia"
    },
    "vulgarName": [
      {
        "es": "Gleditsias"
      },
      {
        "en": "Honey locusts"
      },
      {
        "de": "Gleditschien"
      },
      {
        "fr": "Gleditsia"
      },
      {
        "pt": "Gleditsia"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161250",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Gleditsia",
      "es": "https://es.wikipedia.org/wiki/Gleditsia"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Gleditsia_triacanthos01.JPEG/330px-Gleditsia_triacanthos01.JPEG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Gleditsia",
    "gbif": "https://www.gbif.org/species/2959442",
    "extract": {
      "en": "Gleditsia is a genus of trees in the family Fabaceae, subfamily Caesalpinioideae, native to the Americas and Asia. The Latin name commemorates Johann Gottlieb Gleditsch, director of the Berlin Botanical Garden, who died in 1786.",
      "es": "Gleditsia es un género de árboles de la familia de las leguminosas, nativa de América y Asia. El nombre científico honra a Gottlieb Gleditsch, director del Jardín Botánico de Berlín, quien falleció en 1786."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gleditsia triacanthos"
    },
    "vulgarName": [
      {
        "en": "Honey locust"
      },
      {
        "es": "Acacia gleditsia"
      },
      {
        "de": "Amerikanische Gleditschie"
      },
      {
        "fr": "Févier d'Amérique"
      },
      {
        "pt": "Gleditsia triacanthos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157650",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Honey_locust",
      "es": "https://es.wikipedia.org/wiki/Gleditsia_triacanthos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Gleditsia_triacanthos_%28Honeylocust%29_%2838246396371%29.jpg/330px-Gleditsia_triacanthos_%28Honeylocust%29_%2838246396371%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Gleditsia_triacanthos01.JPEG/330px-Gleditsia_triacanthos01.JPEG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Gleditsia_triacanthos",
    "gbif": "https://www.gbif.org/species/2959443",
    "extract": {
      "en": "The honey locust, also known as the thorny locust or thorny honeylocust, is a deciduous tree in the family Fabaceae, native to central North America where it is mostly found in the moist soil of river valleys. Honey locust trees are highly adaptable to different environments, and the species has been introduced worldwide. Outside its natural range it can be an aggressive, damaging invasive species.",
      "es": "Gleditsia triacanthos, la acacia de tres espinas, gleditsia de tres espinas, “acacia” negra, o \"acacia\" o \"algarrobo\" de miel es una especie de árbol caducifolio de la familia Fabaceae. Se caracteriza por presentar la vaina de sus semillas una pulpa dulce, cuyo sabor y textura recuerda a la miel."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species392"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus143",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/GleditsiaTriacanthos",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Gleditsia triacanthos"
    },
    "vulgarName": [
      {
        "en": "Honey locust"
      },
      {
        "es": "Acacia gleditsia"
      },
      {
        "de": "Amerikanische Gleditschie"
      },
      {
        "fr": "Févier d'Amérique"
      },
      {
        "pt": "Gleditsia triacanthos"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157650",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Honey_locust",
      "es": "https://es.wikipedia.org/wiki/Gleditsia_triacanthos"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Gleditsia_triacanthos_%28Honeylocust%29_%2838246396371%29.jpg/330px-Gleditsia_triacanthos_%28Honeylocust%29_%2838246396371%29.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Gleditsia_triacanthos01.JPEG/330px-Gleditsia_triacanthos01.JPEG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Gleditsia_triacanthos",
    "gbif": "https://www.gbif.org/species/2959443",
    "extract": {
      "en": "The honey locust, also known as the thorny locust or thorny honeylocust, is a deciduous tree in the family Fabaceae, native to central North America where it is mostly found in the moist soil of river valleys. Honey locust trees are highly adaptable to different environments, and the species has been introduced worldwide. Outside its natural range it can be an aggressive, damaging invasive species.",
      "es": "Gleditsia triacanthos, la acacia de tres espinas, gleditsia de tres espinas, “acacia” negra, o \"acacia\" o \"algarrobo\" de miel es una especie de árbol caducifolio de la familia Fabaceae. Se caracteriza por presentar la vaina de sus semillas una pulpa dulce, cuyo sabor y textura recuerda a la miel."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species292"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family14",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus145",
    "isGenus": 1,
    "scientificName": {
      "la": "Sophora"
    },
    "vulgarName": [
      {
        "en": "Sophora"
      },
      {
        "es": "Sophora"
      },
      {
        "fr": "Sophora"
      },
      {
        "pt": "Sophora"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q309213",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Sophora",
      "es": "https://es.wikipedia.org/wiki/Sophora"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Starr_081014-0282_Sophora_chrysophylla.jpg/330px-Starr_081014-0282_Sophora_chrysophylla.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Starr_030222-0062_Sophora_chrysophylla.jpg/330px-Starr_030222-0062_Sophora_chrysophylla.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Sophora",
    "gbif": "https://www.gbif.org/species/2958901",
    "extract": {
      "en": "Sophora is a genus of about 45 species of small trees and shrubs in the pea family Fabaceae. The species have a pantropical distribution. The generic name is derived from sophera, an Arabic name for a pea-flowered tree.",
      "es": "Sophora es un género de plantas de la familia Fabaceae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
    "isGenus": 1,
    "scientificName": {
      "la": "Tetraclinis"
    },
    "vulgarName": [
      {
        "de": "Sandarakbaum"
      },
      {
        "fr": "Cyprès de l'Atlas"
      },
      {
        "pt": "Tetraclinis"
      },
      {
        "es": "Araares"
      },
      {
        "en": "Arars"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q13091238",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tetraclinis",
      "es": "https://es.wikipedia.org/wiki/Tetraclinis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Tetraclinis_articulata.JPG/330px-Tetraclinis_articulata.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Tetraclinis_articulata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-270.jpg/330px-Tetraclinis_articulata_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-270.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tetraclinis",
    "gbif": "https://www.gbif.org/species/2684183",
    "extract": {
      "en": "Tetraclinis is a genus of evergreen coniferous trees in the cypress family Cupressaceae, containing only one species, Tetraclinis articulata, also known as Thuja articulata, sandarac, sandarac tree or Barbary thuja, endemic to the western Mediterranean region, particularly in southern Europe and North Africa.",
      "es": "Tetraclinis es un género monoico de coníferas de la familia Cupressaceae, con solo una especie, Tetraclinis articulata, también conocida como, entre otros nombres, ciprés de Cartagena, alerce africano, araar y sabina (Melilla)."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tetraclinis articulata"
    },
    "vulgarName": [
      {
        "es": "Araar"
      },
      {
        "en": "Barbary thuja"
      },
      {
        "en": "Sandarac"
      },
      {
        "en": "Sandarac tree"
      },
      {
        "de": "Sandarakbaum"
      },
      {
        "fr": "Cyprès de l'Atlas"
      },
      {
        "pt": "Tetraclinis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q918555",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tetraclinis_articulata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Tetraclinis_articulata.JPG/330px-Tetraclinis_articulata.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tetraclinis_articulata",
    "gbif": "https://www.gbif.org/species/2684184",
    "extract": {
      "en": "Tetraclinis is a genus of evergreen coniferous trees in the cypress family Cupressaceae, containing only one species, Tetraclinis articulata, also known as Thuja articulata, sandarac, sandarac tree or Barbary thuja, endemic to the western Mediterranean region, particularly in southern Europe and North Africa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species219"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus223",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/TetraclinisArticulata",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Tetraclinis articulata"
    },
    "vulgarName": [
      {
        "es": "Araar"
      },
      {
        "en": "Barbary thuja"
      },
      {
        "en": "Sandarac"
      },
      {
        "en": "Sandarac tree"
      },
      {
        "de": "Sandarakbaum"
      },
      {
        "fr": "Cyprès de l'Atlas"
      },
      {
        "pt": "Tetraclinis"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q918555",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Tetraclinis_articulata"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Tetraclinis_articulata.JPG/330px-Tetraclinis_articulata.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Tetraclinis_articulata",
    "gbif": "https://www.gbif.org/species/2684184",
    "extract": {
      "en": "Tetraclinis is a genus of evergreen coniferous trees in the cypress family Cupressaceae, containing only one species, Tetraclinis articulata, also known as Thuja articulata, sandarac, sandarac tree or Barbary thuja, endemic to the western Mediterranean region, particularly in southern Europe and North Africa."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
    "isGenus": 1,
    "scientificName": {
      "la": "Thuja"
    },
    "vulgarName": [
      {
        "de": "Lebensbäume (Gattung)"
      },
      {
        "fr": "Thuya"
      },
      {
        "pt": "Thuja"
      },
      {
        "en": "Thujas"
      },
      {
        "es": "Thujas"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147255",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Thuja",
      "es": "https://es.wikipedia.org/wiki/Thuja"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Thuja_standishii.jpg/330px-Thuja_standishii.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Thuja",
    "gbif": "https://www.gbif.org/species/2684168",
    "extract": {
      "en": "Thuja is a genus of coniferous tree or shrub in the Cupressaceae. There are five species in the genus, two native to North America and three native to eastern Asia. The genus is monophyletic and sister to Thujopsis. Members are commonly known as arborvitaes, thujas, or New World false cedars.",
      "es": "Las tuyas (Thuja) forman un género de coníferas de la familia de los cipreses (Cupressaceae) originario de las regiones templadas del Hemisferio Norte. Hay cinco especies en el género, dos nativas de Norteamérica y tres del este asiático. El género es monofilético y hermano de Thujopsis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Thuja"
    },
    "vulgarName": [
      {
        "en": "Cedars"
      },
      {
        "en": "Thuja"
      },
      {
        "es": "Thuja"
      },
      {
        "de": "Lebensbäume (Gattung)"
      },
      {
        "fr": "Thuya"
      },
      {
        "pt": "Thuja"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147255",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Thuja",
      "es": "https://es.wikipedia.org/wiki/Thuja"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Thuja_standishii.jpg/330px-Thuja_standishii.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Thuja",
    "gbif": "https://www.gbif.org/species/2684168",
    "extract": {
      "en": "Thuja is a genus of coniferous tree or shrub in the Cupressaceae. There are five species in the genus, two native to North America and three native to eastern Asia. The genus is monophyletic and sister to Thujopsis. Members are commonly known as arborvitaes, thujas, or New World false cedars.",
      "es": "Las tuyas (Thuja) forman un género de coníferas de la familia de los cipreses (Cupressaceae) originario de las regiones templadas del Hemisferio Norte. Hay cinco especies en el género, dos nativas de Norteamérica y tres del este asiático. El género es monofilético y hermano de Thujopsis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species319"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus224",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family22",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class2",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Thuja",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Thuja"
    },
    "vulgarName": [
      {
        "en": "Cedars"
      },
      {
        "en": "Thuja"
      },
      {
        "es": "Thuja"
      },
      {
        "de": "Lebensbäume (Gattung)"
      },
      {
        "fr": "Thuya"
      },
      {
        "pt": "Thuja"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q147255",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Thuja",
      "es": "https://es.wikipedia.org/wiki/Thuja"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Thuja_standishii.jpg/330px-Thuja_standishii.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Thuja",
    "gbif": "https://www.gbif.org/species/2684168",
    "extract": {
      "en": "Thuja is a genus of coniferous tree or shrub in the Cupressaceae. There are five species in the genus, two native to North America and three native to eastern Asia. The genus is monophyletic and sister to Thujopsis. Members are commonly known as arborvitaes, thujas, or New World false cedars.",
      "es": "Las tuyas (Thuja) forman un género de coníferas de la familia de los cipreses (Cupressaceae) originario de las regiones templadas del Hemisferio Norte. Hay cinco especies en el género, dos nativas de Norteamérica y tres del este asiático. El género es monofilético y hermano de Thujopsis."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Chamaerops humilis"
    },
    "vulgarName": [
      {
        "en": "European fan palm"
      },
      {
        "es": "Palmito"
      },
      {
        "de": "Zwergpalme"
      },
      {
        "fr": "Chamaerops humilis"
      },
      {
        "pt": "Chamaerops"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161747",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaerops_humilis",
      "es": "https://es.wikipedia.org/wiki/Chamaerops_humilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Chamaerops_humilis_%28Zingaro%29015.jpg/330px-Chamaerops_humilis_%28Zingaro%29015.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Chamaerops_humilis_Torreblanca.jpg/330px-Chamaerops_humilis_Torreblanca.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaerops_humilis",
    "gbif": "https://www.gbif.org/species/2736625",
    "extract": {
      "en": "Chamaerops is a genus of flowering plants in the family Arecaceae. It contains only one species, Chamaerops humilis, variously called European fan palm or the Mediterranean dwarf palm. It is one of the most cold-hardy palms and is used in landscaping in temperate climates.",
      "es": "Chamaerops humilis, la única especie del género Chamaerops, se conoce popularmente como palmito o palmera enana. Es una de las dos especies, junto con Phoenix theophrasti, de la familia de las palmeras (Arecaceae) nativa de la Europa meridional. Se distribuye por el norte de África y el suroeste de Europa. Es la única especie de palmera autóctona de la península ibérica y las Islas Baleares."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species369"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus331",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/ChamaeropsHumilis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Chamaerops humilis"
    },
    "vulgarName": [
      {
        "en": "European fan palm"
      },
      {
        "es": "Palmito"
      },
      {
        "de": "Zwergpalme"
      },
      {
        "fr": "Chamaerops humilis"
      },
      {
        "pt": "Chamaerops"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161747",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Chamaerops_humilis",
      "es": "https://es.wikipedia.org/wiki/Chamaerops_humilis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Chamaerops_humilis_%28Zingaro%29015.jpg/330px-Chamaerops_humilis_%28Zingaro%29015.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Chamaerops_humilis_Torreblanca.jpg/330px-Chamaerops_humilis_Torreblanca.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Chamaerops_humilis",
    "gbif": "https://www.gbif.org/species/2736625",
    "extract": {
      "en": "Chamaerops is a genus of flowering plants in the family Arecaceae. It contains only one species, Chamaerops humilis, variously called European fan palm or the Mediterranean dwarf palm. It is one of the most cold-hardy palms and is used in landscaping in temperate climates.",
      "es": "Chamaerops humilis, la única especie del género Chamaerops, se conoce popularmente como palmito o palmera enana. Es una de las dos especies, junto con Phoenix theophrasti, de la familia de las palmeras (Arecaceae) nativa de la Europa meridional. Se distribuye por el norte de África y el suroeste de Europa. Es la única especie de palmera autóctona de la península ibérica y las Islas Baleares."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phoenix canariensis"
    },
    "vulgarName": [
      {
        "es": "Palmera"
      },
      {
        "en": "Canary Island date palm"
      },
      {
        "de": "Kanarische Dattelpalme"
      },
      {
        "pt": "Palmeira-das-canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27657",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Phoenix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Phoenix_canariensis_%28Puntallana%29_01.jpg/330px-Phoenix_canariensis_%28Puntallana%29_01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Palmera001.jpg/330px-Palmera001.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix_canariensis",
    "gbif": "https://www.gbif.org/species/6109529",
    "extract": {
      "en": "Phoenix canariensis, the Canary Island date palm, is a species of flowering plant in the palm family Arecaceae, native to the Canary Islands off the coast of Northwestern Africa. It is a relative of Phoenix dactylifera, the true date palm. It is the natural symbol of the Canary Islands, together with the canary Serinus canaria.",
      "es": "Phoenix canariensis, la palma fénix o palmera canaria, es una especie de palmera nativa de Canarias. Debido a su belleza, facilidad de adaptación y resistencia al frío es una de las palmeras que más se usa en jardinería. Es una especie protegida en las islas de origen. La palmera canaria se considera, según una ley del Gobierno de Canarias, el símbolo natural del archipiélago canario, conjuntamente con el canario."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species469"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus332",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family33",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 25
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PhoenixCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Phoenix canariensis"
    },
    "vulgarName": [
      {
        "es": "Palmera"
      },
      {
        "en": "Canary Island date palm"
      },
      {
        "de": "Kanarische Dattelpalme"
      },
      {
        "pt": "Palmeira-das-canárias"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q27657",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Phoenix_canariensis",
      "es": "https://es.wikipedia.org/wiki/Phoenix_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Phoenix_canariensis_%28Puntallana%29_01.jpg/330px-Phoenix_canariensis_%28Puntallana%29_01.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Palmera001.jpg/330px-Palmera001.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Phoenix_canariensis",
    "gbif": "https://www.gbif.org/species/6109529",
    "extract": {
      "en": "Phoenix canariensis, the Canary Island date palm, is a species of flowering plant in the palm family Arecaceae, native to the Canary Islands off the coast of Northwestern Africa. It is a relative of Phoenix dactylifera, the true date palm. It is the natural symbol of the Canary Islands, together with the canary Serinus canaria.",
      "es": "Phoenix canariensis, la palma fénix o palmera canaria, es una especie de palmera nativa de Canarias. Debido a su belleza, facilidad de adaptación y resistencia al frío es una de las palmeras que más se usa en jardinería. Es una especie protegida en las islas de origen. La palmera canaria se considera, según una ley del Gobierno de Canarias, el símbolo natural del archipiélago canario, conjuntamente con el canario."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
    "isGenus": 1,
    "scientificName": {
      "la": "Dracaena"
    },
    "vulgarName": [
      {
        "en": "Dragon trees"
      },
      {
        "es": "Dragos"
      },
      {
        "fr": "Dracaena"
      },
      {
        "pt": "Dracaena (desambiguação)"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q158009",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Dracaena_(plant)",
      "es": "https://es.wikipedia.org/wiki/Dracaena"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Dracaena_draco.jpg/330px-Dracaena_draco.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Dracaena_(Asparagaceae)",
    "gbif": "https://www.gbif.org/species/2752062",
    "extract": {
      "en": "Dracaena is a genus of about 200–220 species of trees and succulent shrubs. The formerly accepted genera Pleomele and Sansevieria are now included in Dracaena. In the APG IV classification system, it is placed in the family Asparagaceae, subfamily Convallarioideae. It has also formerly been separated into the family Dracaenaceae or kept in the Agavaceae.",
      "es": "Dracaena Vand. ex L. es un género de plantas espermatofitas de la clase de las monocotiledóneas que incluye especies desde árboles a hierbas rizomatosas/estoloníferas. Se incluye en la familia Asparagaceae según el sistema de clasificación APG IV."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Dracaena draco"
    },
    "vulgarName": [
      {
        "en": "Canary Islands dragon tree"
      },
      {
        "en": "Drago"
      },
      {
        "es": "Drago"
      },
      {
        "de": "Kanarischer Drachenbaum"
      },
      {
        "fr": "Dragonnier des Canaries"
      },
      {
        "pt": "Dracaena draco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157952",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Dracaena_draco",
      "es": "https://es.wikipedia.org/wiki/Dracaena_draco"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Dracaena_draco.jpg/330px-Dracaena_draco.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Dracaena_draco",
    "gbif": "https://www.gbif.org/species/5304469",
    "extract": {
      "en": "Dracaena draco, the Canary Islands dragon tree or drago, is a subtropical tree in the genus Dracaena, native to the Macaronesia archipelago and northwestern mainland Africa.",
      "es": "Dracaena draco (L.) L., conocido en castellano como drago o drago de Canarias, es una especie de planta perenne de porte arbóreo de la familia Asparagaceae. Es originario de la Macaronesia y el noroeste de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species569"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus341",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family34",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/DracaenaDraco",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Dracaena draco"
    },
    "vulgarName": [
      {
        "en": "Canary Islands dragon tree"
      },
      {
        "en": "Drago"
      },
      {
        "es": "Drago"
      },
      {
        "de": "Kanarischer Drachenbaum"
      },
      {
        "fr": "Dragonnier des Canaries"
      },
      {
        "pt": "Dracaena draco"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157952",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Dracaena_draco",
      "es": "https://es.wikipedia.org/wiki/Dracaena_draco"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Dracaena_draco.jpg/330px-Dracaena_draco.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Dracaena_draco",
    "gbif": "https://www.gbif.org/species/5304469",
    "extract": {
      "en": "Dracaena draco, the Canary Islands dragon tree or drago, is a subtropical tree in the genus Dracaena, native to the Macaronesia archipelago and northwestern mainland Africa.",
      "es": "Dracaena draco (L.) L., conocido en castellano como drago o drago de Canarias, es una especie de planta perenne de porte arbóreo de la familia Asparagaceae. Es originario de la Macaronesia y el noroeste de África."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
    "isGenus": 1,
    "scientificName": {
      "la": "Ficus"
    },
    "vulgarName": [
      {
        "en": "Fig trees"
      },
      {
        "es": "Higueras"
      },
      {
        "de": "Feigen"
      },
      {
        "fr": "Ficus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q59798",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Ficus",
      "es": "https://es.wikipedia.org/wiki/Ficus"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Sycomoros_old.jpg/330px-Sycomoros_old.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Ficus_elastica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-206.jpg/330px-Ficus_elastica_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-206.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ficus",
    "gbif": "https://www.gbif.org/species/2984588",
    "extract": {
      "en": "Ficus is a genus of about 850 species of woody trees, shrubs, vines, epiphytes and hemiepiphytes in the family Moraceae. Collectively known as fig trees or figs, they are native throughout the tropics with a few species extending into the semi-warm temperate zone. Many Ficus species are grown for their fruits, though only two species, the common fig and sycamore fig, are cultivated to any extent, with common fig being the type species and by far the most important. The fruit of most other species are also edible though they are usually of only local economic importance or eaten as bushfood. However, they are extremely important food resources for wildlife. Figs are also of considerable cultural importance throughout the tropics, both as objects of worship and for their many practical uses.",
      "es": "El género Ficus contiene alrededor de 900 taxones específicos e infraespecíficos aceptados de árboles, arbustos y trepadoras de la familia Moraceae, tribu monogenérica Ficeae, oriundas de la zona intertropical, con algunas de ellas distribuidas por las regiones templadas. La mayoría son perennes, excepto las que vegetan en latitudes no tropicales y zonas con una larga estación seca."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ficus carica"
    },
    "vulgarName": [
      {
        "en": "Fig tree"
      },
      {
        "es": "Higuera"
      },
      {
        "de": "Echte Feige"
      },
      {
        "fr": "Ficus carica"
      },
      {
        "pt": "Figueira-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36146",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fig",
      "es": "https://es.wikipedia.org/wiki/Ficus_carica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Ficus_carica_L%2C_1771.jpg/330px-Ficus_carica_L%2C_1771.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Illustration_Ficus_carica0_clean.jpg/330px-Illustration_Ficus_carica0_clean.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ficus_carica",
    "gbif": "https://www.gbif.org/species/5361909",
    "extract": {
      "en": "The fig is the edible fruit of Ficus carica, a species of tree or shrub in the flowering plant family Moraceae, native to the Mediterranean region, and to western and southern Asia. It has been cultivated since ancient times and is now widely grown throughout the world. Ficus carica is the type species of the genus Ficus, which comprises over 800 tropical and subtropical plant species.",
      "es": "Ficus carica, de nombre común higuera, es una de las numerosísimas especies del género Ficus, de la familia de las moráceas, cuya infrutescencia es el higo. Originario de Asia sudoccidental, crece ahora espontáneamente en torno al Mediterráneo y en otras regiones del mundo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species299"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus421",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/FicusCarica",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Ficus carica"
    },
    "vulgarName": [
      {
        "en": "Fig tree"
      },
      {
        "es": "Higuera"
      },
      {
        "de": "Echte Feige"
      },
      {
        "fr": "Ficus carica"
      },
      {
        "pt": "Figueira-comum"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q36146",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Fig",
      "es": "https://es.wikipedia.org/wiki/Ficus_carica"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Ficus_carica_L%2C_1771.jpg/330px-Ficus_carica_L%2C_1771.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Illustration_Ficus_carica0_clean.jpg/330px-Illustration_Ficus_carica0_clean.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Ficus_carica",
    "gbif": "https://www.gbif.org/species/5361909",
    "extract": {
      "en": "The fig is the edible fruit of Ficus carica, a species of tree or shrub in the flowering plant family Moraceae, native to the Mediterranean region, and to western and southern Asia. It has been cultivated since ancient times and is now widely grown throughout the world. Ficus carica is the type species of the genus Ficus, which comprises over 800 tropical and subtropical plant species.",
      "es": "Ficus carica, de nombre común higuera, es una de las numerosísimas especies del género Ficus, de la familia de las moráceas, cuya infrutescencia es el higo. Originario de Asia sudoccidental, crece ahora espontáneamente en torno al Mediterráneo y en otras regiones del mundo."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
    "isGenus": 1,
    "scientificName": {
      "la": "Morus"
    },
    "vulgarName": [
      {
        "de": "Maulbeeren"
      },
      {
        "fr": "Mûrier"
      },
      {
        "pt": "Morus"
      },
      {
        "es": "Moreras"
      },
      {
        "en": "Mulberry trees"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q44789",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_(plant)",
      "es": "https://es.wikipedia.org/wiki/Morus_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Morus_alba_FrJPG.jpg/330px-Morus_alba_FrJPG.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Morus_nigra0.jpg/330px-Illustration_Morus_nigra0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_(Moraceae)",
    "gbif": "https://www.gbif.org/species/2984545",
    "extract": {
      "en": "Morus, a genus of flowering plants in the family Moraceae, consists of 19 species of deciduous trees commonly known as mulberries, growing wild and under cultivation in many temperate world regions. Generally, the genus has 64 subordinate taxa, though the three most common are referred to as white, red, and black, originating from the color of their dormant buds and not necessarily the fruit color, with numerous cultivars and some taxa currently unchecked and awaiting taxonomic scrutiny. M. alba is native to South Asia, but is widely distributed across Europe, Southern Africa, South America, and North America. M. alba is also the species most preferred by the silkworm. It is regarded as an invasive species in Brazil, the United States and some states of Australia.",
      "es": "Morus es un género de entre diez y dieciséis especies de árboles caducifolios nativos de regiones cálidas y templadas de Asia, África y Norteamérica, siendo la mayoría nativas de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus"
    },
    "vulgarName": [
      {
        "en": "Mulberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Maulbeeren"
      },
      {
        "fr": "Mûrier"
      },
      {
        "pt": "Morus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q44789",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_(plant)",
      "es": "https://es.wikipedia.org/wiki/Morus_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Morus_alba_FrJPG.jpg/330px-Morus_alba_FrJPG.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Morus_nigra0.jpg/330px-Illustration_Morus_nigra0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_(Moraceae)",
    "gbif": "https://www.gbif.org/species/2984545",
    "extract": {
      "en": "Morus, a genus of flowering plants in the family Moraceae, consists of 19 species of deciduous trees commonly known as mulberries, growing wild and under cultivation in many temperate world regions. Generally, the genus has 64 subordinate taxa, though the three most common are referred to as white, red, and black, originating from the color of their dormant buds and not necessarily the fruit color, with numerous cultivars and some taxa currently unchecked and awaiting taxonomic scrutiny. M. alba is native to South Asia, but is widely distributed across Europe, Southern Africa, South America, and North America. M. alba is also the species most preferred by the silkworm. It is regarded as an invasive species in Brazil, the United States and some states of Australia.",
      "es": "Morus es un género de entre diez y dieciséis especies de árboles caducifolios nativos de regiones cálidas y templadas de Asia, África y Norteamérica, siendo la mayoría nativas de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus alba"
    },
    "vulgarName": [
      {
        "en": "White mulberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Weiße Maulbeere"
      },
      {
        "fr": "Mûrier blanc"
      },
      {
        "pt": "Morus alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157307",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_alba",
      "es": "https://es.wikipedia.org/wiki/Morus_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Rosales_-_Morus_alba_-_3.jpg/330px-Rosales_-_Morus_alba_-_3.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Morus-alba.jpg/330px-Morus-alba.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_alba",
    "gbif": "https://www.gbif.org/species/5361889",
    "extract": {
      "en": "Morus alba, known as white mulberry, common mulberry and silkworm mulberry, is a fast-growing, small to medium-sized mulberry tree which grows to 10–20 m (33–66 ft) tall. It is native to China and is widely cultivated and naturalized elsewhere. The species is widely cultivated to feed the silkworms employed in the commercial production of silk. It is also notable for the rapid release of its pollen, which is launched at greater than half the speed of sound.",
      "es": "Morus alba, comúnmente morera blanca, es una especie de árbol del género Morus, familia de las moráceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus nigra"
    },
    "vulgarName": [
      {
        "en": "Black mulberry"
      },
      {
        "en": "Blackberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Schwarze Maulbeere"
      },
      {
        "fr": "Mûrier noir"
      },
      {
        "pt": "Morus nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161040",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_nigra",
      "es": "https://es.wikipedia.org/wiki/Morus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Morus_nigra0.jpg/330px-Illustration_Morus_nigra0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Moru%C5%A1a_%C4%8Dierna_%28dozrievaj%C3%BAce_plody%29.JPG/330px-Moru%C5%A1a_%C4%8Dierna_%28dozrievaj%C3%BAce_plody%29.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_nigra",
    "gbif": "https://www.gbif.org/species/5361888",
    "extract": {
      "en": "Morus nigra, or the black mulberry, is a species of flowering plant in the family Moraceae that is native to southwestern Asia, where it has been cultivated for so long that its precise natural range is unknown. The black mulberry is known for its large number of chromosomes.",
      "es": "Morus nigra, morera negra o moral negro es una especie de árbol perteneciente a la familia de las moráceas, nativa del sudoeste de Asia, siendo cultivada por tan largo periodo que su rango natural preciso es desconocido."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species399"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/Morus",
    "isTaxonSet": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus"
    },
    "vulgarName": [
      {
        "en": "Mulberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Maulbeeren"
      },
      {
        "fr": "Mûrier"
      },
      {
        "pt": "Morus"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q44789",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_(plant)",
      "es": "https://es.wikipedia.org/wiki/Morus_(planta)"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Morus_alba_FrJPG.jpg/330px-Morus_alba_FrJPG.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Morus_nigra0.jpg/330px-Illustration_Morus_nigra0.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_(Moraceae)",
    "gbif": "https://www.gbif.org/species/2984545",
    "extract": {
      "en": "Morus, a genus of flowering plants in the family Moraceae, consists of 19 species of deciduous trees commonly known as mulberries, growing wild and under cultivation in many temperate world regions. Generally, the genus has 64 subordinate taxa, though the three most common are referred to as white, red, and black, originating from the color of their dormant buds and not necessarily the fruit color, with numerous cultivars and some taxa currently unchecked and awaiting taxonomic scrutiny. M. alba is native to South Asia, but is widely distributed across Europe, Southern Africa, South America, and North America. M. alba is also the species most preferred by the silkworm. It is regarded as an invasive species in Brazil, the United States and some states of Australia.",
      "es": "Morus es un género de entre diez y dieciséis especies de árboles caducifolios nativos de regiones cálidas y templadas de Asia, África y Norteamérica, siendo la mayoría nativas de Asia."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species499"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusAlba",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus alba"
    },
    "vulgarName": [
      {
        "en": "White mulberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Weiße Maulbeere"
      },
      {
        "fr": "Mûrier blanc"
      },
      {
        "pt": "Morus alba"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q157307",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_alba",
      "es": "https://es.wikipedia.org/wiki/Morus_alba"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Rosales_-_Morus_alba_-_3.jpg/330px-Rosales_-_Morus_alba_-_3.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Morus-alba.jpg/330px-Morus-alba.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_alba",
    "gbif": "https://www.gbif.org/species/5361889",
    "extract": {
      "en": "Morus alba, known as white mulberry, common mulberry and silkworm mulberry, is a fast-growing, small to medium-sized mulberry tree which grows to 10–20 m (33–66 ft) tall. It is native to China and is widely cultivated and naturalized elsewhere. The species is widely cultivated to feed the silkworms employed in the commercial production of silk. It is also notable for the rapid release of its pollen, which is launched at greater than half the speed of sound.",
      "es": "Morus alba, comúnmente morera blanca, es una especie de árbol del género Morus, familia de las moráceas."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species599"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus422",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family42",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/MorusNigra",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Morus nigra"
    },
    "vulgarName": [
      {
        "en": "Black mulberry"
      },
      {
        "en": "Blackberry"
      },
      {
        "es": "Morera"
      },
      {
        "de": "Schwarze Maulbeere"
      },
      {
        "fr": "Mûrier noir"
      },
      {
        "pt": "Morus nigra"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q161040",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Morus_nigra",
      "es": "https://es.wikipedia.org/wiki/Morus_nigra"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Illustration_Morus_nigra0.jpg/330px-Illustration_Morus_nigra0.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Moru%C5%A1a_%C4%8Dierna_%28dozrievaj%C3%BAce_plody%29.JPG/330px-Moru%C5%A1a_%C4%8Dierna_%28dozrievaj%C3%BAce_plody%29.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Morus_nigra",
    "gbif": "https://www.gbif.org/species/5361888",
    "extract": {
      "en": "Morus nigra, or the black mulberry, is a species of flowering plant in the family Moraceae that is native to southwestern Asia, where it has been cultivated for so long that its precise natural range is unknown. The black mulberry is known for its large number of chromosomes.",
      "es": "Morus nigra, morera negra o moral negro es una especie de árbol perteneciente a la familia de las moráceas, nativa del sudoeste de Asia, siendo cultivada por tan largo periodo que su rango natural preciso es desconocido."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
    "isGenus": 1,
    "scientificName": {
      "la": "Visnea"
    },
    "vulgarName": [
      {
        "es": "Mocanes"
      },
      {
        "en": "Visnea"
      },
      {
        "pt": "Visnea"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q7936377",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Visnea"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Visnea_mocanera.jpg/330px-Visnea_mocanera.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Visnea",
    "gbif": "https://www.gbif.org/species/7313968",
    "extract": {
      "en": "Visnea is a monotypic genus of flowering plants in family Pentaphylacaceae. The genus contains a single species, Visnea mocanera a tree native to the Canary Islands and Madeira."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Visnea mocanera"
    },
    "vulgarName": [
      {
        "es": "Mocán"
      },
      {
        "fr": "Visnea mocanera"
      },
      {
        "pt": "Visnea mocanera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1939285",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Visnea_mocanera",
      "es": "https://es.wikipedia.org/wiki/Visnea_mocanera"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Visnea_mocanera.jpg/330px-Visnea_mocanera.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Visnea_mocanera_02.jpg/330px-Visnea_mocanera_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Visnea_mocanera",
    "gbif": "https://www.gbif.org/species/7793182",
    "extract": {
      "en": "Visnea is a monotypic genus of flowering plants in family Pentaphylacaceae. The genus contains a single species, Visnea mocanera a tree native to the Canary Islands and Madeira.",
      "es": "Visnea mocanera L.f., conocida en castellano como mocán, es una especie de árbol perenne originario de la Macaronesia. Es el único representante de su género, incluyéndose en la familia Pentaphylacaceae según el sistema de clasificación APG IV."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species489"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus451",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family45",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/VisneaMocanera",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Visnea mocanera"
    },
    "vulgarName": [
      {
        "es": "Mocán"
      },
      {
        "fr": "Visnea mocanera"
      },
      {
        "pt": "Visnea mocanera"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1939285",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Visnea_mocanera",
      "es": "https://es.wikipedia.org/wiki/Visnea_mocanera"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Visnea_mocanera.jpg/330px-Visnea_mocanera.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Visnea_mocanera_02.jpg/330px-Visnea_mocanera_02.jpg"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Visnea_mocanera",
    "gbif": "https://www.gbif.org/species/7793182",
    "extract": {
      "en": "Visnea is a monotypic genus of flowering plants in family Pentaphylacaceae. The genus contains a single species, Visnea mocanera a tree native to the Canary Islands and Madeira.",
      "es": "Visnea mocanera L.f., conocida en castellano como mocán, es una especie de árbol perenne originario de la Macaronesia. Es el único representante de su género, incluyéndose en la familia Pentaphylacaceae según el sistema de clasificación APG IV."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
    "isGenus": 1,
    "scientificName": {
      "la": "Pleiomeris"
    },
    "vulgarName": [
      {
        "en": "Pleiomeris"
      },
      {
        "es": "Pleiomeris"
      },
      {
        "pt": "Pleiomeris"
      }
    ],
    "wikidata": "http://www.wikidata.org/entity/Q1327740",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pleiomeris",
      "es": "https://es.wikipedia.org/wiki/Pleiomeris"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Pleiomeris_canariensis.JPG/330px-Pleiomeris_canariensis.JPG"
    ],
    "wikispecies": "https://species.wikimedia.org/wiki/Pleiomeris",
    "gbif": "https://www.gbif.org/species/7331030",
    "extract": {
      "en": "Pleiomeris is a genus of plants in the family Primulaceae. It contains the following species :Pleiomeris canariensis (Willd.) A.DC.",
      "es": "Pleiomeris canariensis (Willd.) A.DC. es una especie de fanerógama perteneciente a la antigua familia Myrsinaceae, ahora subfamilia Myrsinoideae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
    "subclasses": [],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pleiomeris canariensis"
    },
    "vulgarName": {
      "es": "Delfino"
    },
    "wikidata": "http://www.wikidata.org/entity/Q5462359",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pleiomeris_canariensis",
      "es": "https://es.wikipedia.org/wiki/Pleiomeris_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Pleiomeris_canariensis.JPG/330px-Pleiomeris_canariensis.JPG"
    ],
    "gbif": "https://www.gbif.org/species/3721091",
    "extract": {
      "en": "Pleiomeris canariensis is a species of plant in the family Primulaceae. It is endemic to Canary Islands, Spain.",
      "es": "Pleiomeris canariensis (Willd.) A.DC. es una especie de fanerógama perteneciente a la antigua familia Myrsinaceae, ahora subfamilia Myrsinoideae."
    }
  },
  "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis": {
    "uri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
    "subclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289"
    ],
    "superclasses": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472"
    ],
    "expuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifn3/taxon/Species289"
    ],
    "superexpuris": [
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Genus472",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Family47",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Class1",
      "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnTop/taxon/Plantae"
    ],
    "nplots": {
      "ifn2": {
        "count": 0
      },
      "ifn3": {
        "count": 0
      }
    },
    "iri": "https://datos.iepnb.es/kos/sector-publico/medio-ambiente/ifnUp23/taxon/PleiomerisCanariensis",
    "isSpecies": 1,
    "isTreeSpecies": 1,
    "scientificName": {
      "nolang": "Pleiomeris canariensis"
    },
    "vulgarName": {
      "es": "Delfino"
    },
    "wikidata": "http://www.wikidata.org/entity/Q5462359",
    "wikipedia": {
      "en": "https://en.wikipedia.org/wiki/Pleiomeris_canariensis",
      "es": "https://es.wikipedia.org/wiki/Pleiomeris_canariensis"
    },
    "images": [
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Pleiomeris_canariensis.JPG/330px-Pleiomeris_canariensis.JPG"
    ],
    "gbif": "https://www.gbif.org/species/3721091",
    "extract": {
      "en": "Pleiomeris canariensis is a species of plant in the family Primulaceae. It is endemic to Canary Islands, Spain.",
      "es": "Pleiomeris canariensis (Willd.) A.DC. es una especie de fanerógama perteneciente a la antigua familia Myrsinaceae, ahora subfamilia Myrsinoideae."
    }
  }
}